import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  KPIChartCancellationRate: { input: any; output: any; }
  KPIChartVisitTypeMap: { input: any; output: any; }
};

export type ActivePatientOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  dateOfBirth: InputMaybe<InnerOrder>;
  firstName: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  lastName: InputMaybe<InnerOrder>;
  nextVisitStartTime: InputMaybe<InnerOrder>;
  phone: InputMaybe<InnerOrder>;
};

export enum ApiKeyAlgorithmEnum {
  HmacEc = 'hmac_ec',
  SshEd25519 = 'ssh_ed25519',
  SshRsa = 'ssh_rsa'
}

export type ApiKeyAlgorithmFilters = {
  OR: InputMaybe<Array<ApiKeyAlgorithmfiltersOr>>;
  eq: InputMaybe<ApiKeyAlgorithmEnum>;
  gt: InputMaybe<ApiKeyAlgorithmEnum>;
  gte: InputMaybe<ApiKeyAlgorithmEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ApiKeyAlgorithmEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ApiKeyAlgorithmEnum>;
  lte: InputMaybe<ApiKeyAlgorithmEnum>;
  ne: InputMaybe<ApiKeyAlgorithmEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ApiKeyAlgorithmEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyAlgorithmfiltersOr = {
  eq: InputMaybe<ApiKeyAlgorithmEnum>;
  gt: InputMaybe<ApiKeyAlgorithmEnum>;
  gte: InputMaybe<ApiKeyAlgorithmEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ApiKeyAlgorithmEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ApiKeyAlgorithmEnum>;
  lte: InputMaybe<ApiKeyAlgorithmEnum>;
  ne: InputMaybe<ApiKeyAlgorithmEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ApiKeyAlgorithmEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyApiKeyFilters = {
  OR: InputMaybe<Array<ApiKeyApiKeyfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyApiKeyfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyCreatedAtFilters = {
  OR: InputMaybe<Array<ApiKeyCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyCreatedByFilters = {
  OR: InputMaybe<Array<ApiKeyCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyDeletedFilters = {
  OR: InputMaybe<Array<ApiKeyDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyExpiresAtFilters = {
  OR: InputMaybe<Array<ApiKeyExpiresAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyExpiresAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyFilters = {
  OR: InputMaybe<Array<ApiKeyFiltersOr>>;
  algorithm: InputMaybe<ApiKeyAlgorithmFilters>;
  apiKey: InputMaybe<ApiKeyApiKeyFilters>;
  createdAt: InputMaybe<ApiKeyCreatedAtFilters>;
  createdBy: InputMaybe<ApiKeyCreatedByFilters>;
  deleted: InputMaybe<ApiKeyDeletedFilters>;
  expiresAt: InputMaybe<ApiKeyExpiresAtFilters>;
  id: InputMaybe<ApiKeyIdFilters>;
  keyPurpose: InputMaybe<ApiKeyKeyPurposeFilters>;
  organizationId: InputMaybe<ApiKeyOrganizationIdFilters>;
  organizationUserId: InputMaybe<ApiKeyOrganizationUserIdFilters>;
  updatedAt: InputMaybe<ApiKeyUpdatedAtFilters>;
  updatedBy: InputMaybe<ApiKeyUpdatedByFilters>;
};

export type ApiKeyFiltersOr = {
  algorithm: InputMaybe<ApiKeyAlgorithmFilters>;
  apiKey: InputMaybe<ApiKeyApiKeyFilters>;
  createdAt: InputMaybe<ApiKeyCreatedAtFilters>;
  createdBy: InputMaybe<ApiKeyCreatedByFilters>;
  deleted: InputMaybe<ApiKeyDeletedFilters>;
  expiresAt: InputMaybe<ApiKeyExpiresAtFilters>;
  id: InputMaybe<ApiKeyIdFilters>;
  keyPurpose: InputMaybe<ApiKeyKeyPurposeFilters>;
  organizationId: InputMaybe<ApiKeyOrganizationIdFilters>;
  organizationUserId: InputMaybe<ApiKeyOrganizationUserIdFilters>;
  updatedAt: InputMaybe<ApiKeyUpdatedAtFilters>;
  updatedBy: InputMaybe<ApiKeyUpdatedByFilters>;
};

export type ApiKeyIdFilters = {
  OR: InputMaybe<Array<ApiKeyIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum ApiKeyKeyPurposeEnum {
  Endpoint = 'endpoint',
  Sftp = 'sftp',
  Webhook = 'webhook'
}

export type ApiKeyKeyPurposeFilters = {
  OR: InputMaybe<Array<ApiKeyKeyPurposefiltersOr>>;
  eq: InputMaybe<ApiKeyKeyPurposeEnum>;
  gt: InputMaybe<ApiKeyKeyPurposeEnum>;
  gte: InputMaybe<ApiKeyKeyPurposeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ApiKeyKeyPurposeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ApiKeyKeyPurposeEnum>;
  lte: InputMaybe<ApiKeyKeyPurposeEnum>;
  ne: InputMaybe<ApiKeyKeyPurposeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ApiKeyKeyPurposeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyKeyPurposefiltersOr = {
  eq: InputMaybe<ApiKeyKeyPurposeEnum>;
  gt: InputMaybe<ApiKeyKeyPurposeEnum>;
  gte: InputMaybe<ApiKeyKeyPurposeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ApiKeyKeyPurposeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ApiKeyKeyPurposeEnum>;
  lte: InputMaybe<ApiKeyKeyPurposeEnum>;
  ne: InputMaybe<ApiKeyKeyPurposeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ApiKeyKeyPurposeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyOrderBy = {
  algorithm: InputMaybe<InnerOrder>;
  apiKey: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  expiresAt: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  keyPurpose: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  organizationUserId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ApiKeyOrganizationIdFilters = {
  OR: InputMaybe<Array<ApiKeyOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyOrganizationUserIdFilters = {
  OR: InputMaybe<Array<ApiKeyOrganizationUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyOrganizationUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum ApiKeyPurpose {
  Endpoint = 'endpoint',
  Sftp = 'sftp'
}

export type ApiKeyRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ApiKeyRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ApiKeyRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryFilters = {
  OR: InputMaybe<Array<ApiKeyRevisionHistoryFiltersOr>>;
  action: InputMaybe<ApiKeyRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ApiKeyRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ApiKeyRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ApiKeyRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ApiKeyRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ApiKeyRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ApiKeyRevisionHistoryUpdatedByFilters>;
};

export type ApiKeyRevisionHistoryFiltersOr = {
  action: InputMaybe<ApiKeyRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ApiKeyRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ApiKeyRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ApiKeyRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ApiKeyRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ApiKeyRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ApiKeyRevisionHistoryUpdatedByFilters>;
};

export type ApiKeyRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ApiKeyRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ApiKeyRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ApiKeyRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ApiKeyRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ApiKeyRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ApiKeyRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyUpdatedAtFilters = {
  OR: InputMaybe<Array<ApiKeyUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyUpdatedByFilters = {
  OR: InputMaybe<Array<ApiKeyUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ApiKeyUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum AvailTzHandling {
  UseCalendarTime = 'useCalendarTime',
  UseProviderTZs = 'useProviderTZs'
}

export type AvailabilityAddressCityFilters = {
  OR: InputMaybe<Array<AvailabilityAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressCoordinatesFilters = {
  OR: InputMaybe<Array<AvailabilityAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressLineTwoFilters = {
  OR: InputMaybe<Array<AvailabilityAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressStateFilters = {
  OR: InputMaybe<Array<AvailabilityAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressStreetFilters = {
  OR: InputMaybe<Array<AvailabilityAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressTimezoneFilters = {
  OR: InputMaybe<Array<AvailabilityAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressZipFilters = {
  OR: InputMaybe<Array<AvailabilityAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityBlockFiltersFilters = {
  OR: InputMaybe<Array<AvailabilityBlockFiltersfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityBlockFiltersfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum AvailabilityBlockTypeEnum {
  Break = 'break',
  Facility = 'facility',
  Meeting = 'meeting',
  VisitType = 'visit_type'
}

export type AvailabilityBlockTypeFilters = {
  OR: InputMaybe<Array<AvailabilityBlockTypefiltersOr>>;
  eq: InputMaybe<AvailabilityBlockTypeEnum>;
  gt: InputMaybe<AvailabilityBlockTypeEnum>;
  gte: InputMaybe<AvailabilityBlockTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<AvailabilityBlockTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<AvailabilityBlockTypeEnum>;
  lte: InputMaybe<AvailabilityBlockTypeEnum>;
  ne: InputMaybe<AvailabilityBlockTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<AvailabilityBlockTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityBlockTypefiltersOr = {
  eq: InputMaybe<AvailabilityBlockTypeEnum>;
  gt: InputMaybe<AvailabilityBlockTypeEnum>;
  gte: InputMaybe<AvailabilityBlockTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<AvailabilityBlockTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<AvailabilityBlockTypeEnum>;
  lte: InputMaybe<AvailabilityBlockTypeEnum>;
  ne: InputMaybe<AvailabilityBlockTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<AvailabilityBlockTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityCreatedAtFilters = {
  OR: InputMaybe<Array<AvailabilityCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityCreatedByFilters = {
  OR: InputMaybe<Array<AvailabilityCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityDeletedFilters = {
  OR: InputMaybe<Array<AvailabilityDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityEndTimeFilters = {
  OR: InputMaybe<Array<AvailabilityEndTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityEndTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityFilters = {
  OR: InputMaybe<Array<AvailabilityFiltersOr>>;
  addressCity: InputMaybe<AvailabilityAddressCityFilters>;
  addressCoordinates: InputMaybe<AvailabilityAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<AvailabilityAddressLineTwoFilters>;
  addressState: InputMaybe<AvailabilityAddressStateFilters>;
  addressStreet: InputMaybe<AvailabilityAddressStreetFilters>;
  addressTimezone: InputMaybe<AvailabilityAddressTimezoneFilters>;
  addressZip: InputMaybe<AvailabilityAddressZipFilters>;
  blockFilters: InputMaybe<AvailabilityBlockFiltersFilters>;
  blockType: InputMaybe<AvailabilityBlockTypeFilters>;
  createdAt: InputMaybe<AvailabilityCreatedAtFilters>;
  createdBy: InputMaybe<AvailabilityCreatedByFilters>;
  deleted: InputMaybe<AvailabilityDeletedFilters>;
  endTime: InputMaybe<AvailabilityEndTimeFilters>;
  id: InputMaybe<AvailabilityIdFilters>;
  note: InputMaybe<AvailabilityNoteFilters>;
  organizationId: InputMaybe<AvailabilityOrganizationIdFilters>;
  overflowShift: InputMaybe<AvailabilityOverflowShiftFilters>;
  providerId: InputMaybe<AvailabilityProviderIdFilters>;
  providerTravel: InputMaybe<AvailabilityProviderTravelFilters>;
  rruleByweekday: InputMaybe<AvailabilityRruleByweekdayFilters>;
  rruleDtstart: InputMaybe<AvailabilityRruleDtstartFilters>;
  rruleFreq: InputMaybe<AvailabilityRruleFreqFilters>;
  rruleInterval: InputMaybe<AvailabilityRruleIntervalFilters>;
  rruleUntil: InputMaybe<AvailabilityRruleUntilFilters>;
  shiftCenterId: InputMaybe<AvailabilityShiftCenterIdFilters>;
  startTime: InputMaybe<AvailabilityStartTimeFilters>;
  type: InputMaybe<AvailabilityTypeFilters>;
  updatedAt: InputMaybe<AvailabilityUpdatedAtFilters>;
  updatedBy: InputMaybe<AvailabilityUpdatedByFilters>;
  useShiftCenterDriveTimes: InputMaybe<AvailabilityUseShiftCenterDriveTimesFilters>;
};

export type AvailabilityFiltersOr = {
  addressCity: InputMaybe<AvailabilityAddressCityFilters>;
  addressCoordinates: InputMaybe<AvailabilityAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<AvailabilityAddressLineTwoFilters>;
  addressState: InputMaybe<AvailabilityAddressStateFilters>;
  addressStreet: InputMaybe<AvailabilityAddressStreetFilters>;
  addressTimezone: InputMaybe<AvailabilityAddressTimezoneFilters>;
  addressZip: InputMaybe<AvailabilityAddressZipFilters>;
  blockFilters: InputMaybe<AvailabilityBlockFiltersFilters>;
  blockType: InputMaybe<AvailabilityBlockTypeFilters>;
  createdAt: InputMaybe<AvailabilityCreatedAtFilters>;
  createdBy: InputMaybe<AvailabilityCreatedByFilters>;
  deleted: InputMaybe<AvailabilityDeletedFilters>;
  endTime: InputMaybe<AvailabilityEndTimeFilters>;
  id: InputMaybe<AvailabilityIdFilters>;
  note: InputMaybe<AvailabilityNoteFilters>;
  organizationId: InputMaybe<AvailabilityOrganizationIdFilters>;
  overflowShift: InputMaybe<AvailabilityOverflowShiftFilters>;
  providerId: InputMaybe<AvailabilityProviderIdFilters>;
  providerTravel: InputMaybe<AvailabilityProviderTravelFilters>;
  rruleByweekday: InputMaybe<AvailabilityRruleByweekdayFilters>;
  rruleDtstart: InputMaybe<AvailabilityRruleDtstartFilters>;
  rruleFreq: InputMaybe<AvailabilityRruleFreqFilters>;
  rruleInterval: InputMaybe<AvailabilityRruleIntervalFilters>;
  rruleUntil: InputMaybe<AvailabilityRruleUntilFilters>;
  shiftCenterId: InputMaybe<AvailabilityShiftCenterIdFilters>;
  startTime: InputMaybe<AvailabilityStartTimeFilters>;
  type: InputMaybe<AvailabilityTypeFilters>;
  updatedAt: InputMaybe<AvailabilityUpdatedAtFilters>;
  updatedBy: InputMaybe<AvailabilityUpdatedByFilters>;
  useShiftCenterDriveTimes: InputMaybe<AvailabilityUseShiftCenterDriveTimesFilters>;
};

export type AvailabilityIdFilters = {
  OR: InputMaybe<Array<AvailabilityIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityNoteFilters = {
  OR: InputMaybe<Array<AvailabilityNotefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityNotefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  blockFilters: InputMaybe<InnerOrder>;
  blockType: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  endTime: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  note: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  overflowShift: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  providerTravel: InputMaybe<InnerOrder>;
  rruleByweekday: InputMaybe<InnerOrder>;
  rruleDtstart: InputMaybe<InnerOrder>;
  rruleFreq: InputMaybe<InnerOrder>;
  rruleInterval: InputMaybe<InnerOrder>;
  rruleUntil: InputMaybe<InnerOrder>;
  shiftCenterId: InputMaybe<InnerOrder>;
  startTime: InputMaybe<InnerOrder>;
  type: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  useShiftCenterDriveTimes: InputMaybe<InnerOrder>;
};

export type AvailabilityOrganizationIdFilters = {
  OR: InputMaybe<Array<AvailabilityOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityOverflowShiftFilters = {
  OR: InputMaybe<Array<AvailabilityOverflowShiftfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityOverflowShiftfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityProviderIdFilters = {
  OR: InputMaybe<Array<AvailabilityProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum AvailabilityProviderTravelEnum {
  Either = 'either',
  InHomeOnly = 'inHomeOnly',
  VirtualOnly = 'virtualOnly'
}

export type AvailabilityProviderTravelFilters = {
  OR: InputMaybe<Array<AvailabilityProviderTravelfiltersOr>>;
  eq: InputMaybe<AvailabilityProviderTravelEnum>;
  gt: InputMaybe<AvailabilityProviderTravelEnum>;
  gte: InputMaybe<AvailabilityProviderTravelEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<AvailabilityProviderTravelEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<AvailabilityProviderTravelEnum>;
  lte: InputMaybe<AvailabilityProviderTravelEnum>;
  ne: InputMaybe<AvailabilityProviderTravelEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<AvailabilityProviderTravelEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityProviderTravelfiltersOr = {
  eq: InputMaybe<AvailabilityProviderTravelEnum>;
  gt: InputMaybe<AvailabilityProviderTravelEnum>;
  gte: InputMaybe<AvailabilityProviderTravelEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<AvailabilityProviderTravelEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<AvailabilityProviderTravelEnum>;
  lte: InputMaybe<AvailabilityProviderTravelEnum>;
  ne: InputMaybe<AvailabilityProviderTravelEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<AvailabilityProviderTravelEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<AvailabilityRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<AvailabilityRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryFilters = {
  OR: InputMaybe<Array<AvailabilityRevisionHistoryFiltersOr>>;
  action: InputMaybe<AvailabilityRevisionHistoryActionFilters>;
  changedFields: InputMaybe<AvailabilityRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<AvailabilityRevisionHistoryIdFilters>;
  organizationId: InputMaybe<AvailabilityRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<AvailabilityRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<AvailabilityRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<AvailabilityRevisionHistoryUpdatedByFilters>;
};

export type AvailabilityRevisionHistoryFiltersOr = {
  action: InputMaybe<AvailabilityRevisionHistoryActionFilters>;
  changedFields: InputMaybe<AvailabilityRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<AvailabilityRevisionHistoryIdFilters>;
  organizationId: InputMaybe<AvailabilityRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<AvailabilityRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<AvailabilityRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<AvailabilityRevisionHistoryUpdatedByFilters>;
};

export type AvailabilityRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<AvailabilityRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type AvailabilityRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<AvailabilityRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<AvailabilityRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<AvailabilityRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<AvailabilityRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleByweekdayFilters = {
  OR: InputMaybe<Array<AvailabilityRruleByweekdayfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleByweekdayfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleDtstartFilters = {
  OR: InputMaybe<Array<AvailabilityRruleDtstartfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleDtstartfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum AvailabilityRruleFreqEnum {
  Daily = 'daily',
  Weekly = 'weekly'
}

export type AvailabilityRruleFreqFilters = {
  OR: InputMaybe<Array<AvailabilityRruleFreqfiltersOr>>;
  eq: InputMaybe<AvailabilityRruleFreqEnum>;
  gt: InputMaybe<AvailabilityRruleFreqEnum>;
  gte: InputMaybe<AvailabilityRruleFreqEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<AvailabilityRruleFreqEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<AvailabilityRruleFreqEnum>;
  lte: InputMaybe<AvailabilityRruleFreqEnum>;
  ne: InputMaybe<AvailabilityRruleFreqEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<AvailabilityRruleFreqEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleFreqfiltersOr = {
  eq: InputMaybe<AvailabilityRruleFreqEnum>;
  gt: InputMaybe<AvailabilityRruleFreqEnum>;
  gte: InputMaybe<AvailabilityRruleFreqEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<AvailabilityRruleFreqEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<AvailabilityRruleFreqEnum>;
  lte: InputMaybe<AvailabilityRruleFreqEnum>;
  ne: InputMaybe<AvailabilityRruleFreqEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<AvailabilityRruleFreqEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleIntervalFilters = {
  OR: InputMaybe<Array<AvailabilityRruleIntervalfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleIntervalfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleUntilFilters = {
  OR: InputMaybe<Array<AvailabilityRruleUntilfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityRruleUntilfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityShiftCenterIdFilters = {
  OR: InputMaybe<Array<AvailabilityShiftCenterIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityShiftCenterIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityStartTimeFilters = {
  OR: InputMaybe<Array<AvailabilityStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum AvailabilityTypeEnum {
  Available = 'available',
  CalendarBlock = 'calendar_block',
  Unavailable = 'unavailable'
}

export type AvailabilityTypeFilters = {
  OR: InputMaybe<Array<AvailabilityTypefiltersOr>>;
  eq: InputMaybe<AvailabilityTypeEnum>;
  gt: InputMaybe<AvailabilityTypeEnum>;
  gte: InputMaybe<AvailabilityTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<AvailabilityTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<AvailabilityTypeEnum>;
  lte: InputMaybe<AvailabilityTypeEnum>;
  ne: InputMaybe<AvailabilityTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<AvailabilityTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityTypefiltersOr = {
  eq: InputMaybe<AvailabilityTypeEnum>;
  gt: InputMaybe<AvailabilityTypeEnum>;
  gte: InputMaybe<AvailabilityTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<AvailabilityTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<AvailabilityTypeEnum>;
  lte: InputMaybe<AvailabilityTypeEnum>;
  ne: InputMaybe<AvailabilityTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<AvailabilityTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityUpdatedAtFilters = {
  OR: InputMaybe<Array<AvailabilityUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityUpdatedByFilters = {
  OR: InputMaybe<Array<AvailabilityUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityUseShiftCenterDriveTimesFilters = {
  OR: InputMaybe<Array<AvailabilityUseShiftCenterDriveTimesfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityUseShiftCenterDriveTimesfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum BarcodeTypeEnum {
  Aztec = 'aztec',
  Codabar = 'codabar',
  Code39 = 'code39',
  Code93 = 'code93',
  Code128 = 'code128',
  Datamatrix = 'datamatrix',
  Ean8 = 'ean8',
  Ean13 = 'ean13',
  Itf14 = 'itf14',
  Pdf417 = 'pdf417',
  Qr = 'qr',
  UpcA = 'upc_a',
  UpcE = 'upc_e'
}

export type CalendarBlockAddressCityFilters = {
  OR: InputMaybe<Array<CalendarBlockAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressCoordinatesFilters = {
  OR: InputMaybe<Array<CalendarBlockAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressLineTwoFilters = {
  OR: InputMaybe<Array<CalendarBlockAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressStateFilters = {
  OR: InputMaybe<Array<CalendarBlockAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressStreetFilters = {
  OR: InputMaybe<Array<CalendarBlockAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressTimezoneFilters = {
  OR: InputMaybe<Array<CalendarBlockAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressZipFilters = {
  OR: InputMaybe<Array<CalendarBlockAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAvailabilityIdFilters = {
  OR: InputMaybe<Array<CalendarBlockAvailabilityIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockAvailabilityIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum CalendarBlockBlockTypeEnum {
  Break = 'break',
  Facility = 'facility',
  Meeting = 'meeting',
  VisitType = 'visit_type'
}

export type CalendarBlockBlockTypeFilters = {
  OR: InputMaybe<Array<CalendarBlockBlockTypefiltersOr>>;
  eq: InputMaybe<CalendarBlockBlockTypeEnum>;
  gt: InputMaybe<CalendarBlockBlockTypeEnum>;
  gte: InputMaybe<CalendarBlockBlockTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CalendarBlockBlockTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CalendarBlockBlockTypeEnum>;
  lte: InputMaybe<CalendarBlockBlockTypeEnum>;
  ne: InputMaybe<CalendarBlockBlockTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CalendarBlockBlockTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockBlockTypefiltersOr = {
  eq: InputMaybe<CalendarBlockBlockTypeEnum>;
  gt: InputMaybe<CalendarBlockBlockTypeEnum>;
  gte: InputMaybe<CalendarBlockBlockTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CalendarBlockBlockTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CalendarBlockBlockTypeEnum>;
  lte: InputMaybe<CalendarBlockBlockTypeEnum>;
  ne: InputMaybe<CalendarBlockBlockTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CalendarBlockBlockTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockCreatedAtFilters = {
  OR: InputMaybe<Array<CalendarBlockCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockCreatedByFilters = {
  OR: InputMaybe<Array<CalendarBlockCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockDeletedFilters = {
  OR: InputMaybe<Array<CalendarBlockDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockEndOfShiftDriveTimeFilters = {
  OR: InputMaybe<Array<CalendarBlockEndOfShiftDriveTimefiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockEndOfShiftDriveTimefiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockEndTimeFilters = {
  OR: InputMaybe<Array<CalendarBlockEndTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockEndTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum CalendarBlockEventStatusEnum {
  Canceled = 'canceled',
  Scheduled = 'scheduled'
}

export type CalendarBlockEventStatusFilters = {
  OR: InputMaybe<Array<CalendarBlockEventStatusfiltersOr>>;
  eq: InputMaybe<CalendarBlockEventStatusEnum>;
  gt: InputMaybe<CalendarBlockEventStatusEnum>;
  gte: InputMaybe<CalendarBlockEventStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CalendarBlockEventStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CalendarBlockEventStatusEnum>;
  lte: InputMaybe<CalendarBlockEventStatusEnum>;
  ne: InputMaybe<CalendarBlockEventStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CalendarBlockEventStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockEventStatusfiltersOr = {
  eq: InputMaybe<CalendarBlockEventStatusEnum>;
  gt: InputMaybe<CalendarBlockEventStatusEnum>;
  gte: InputMaybe<CalendarBlockEventStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CalendarBlockEventStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CalendarBlockEventStatusEnum>;
  lte: InputMaybe<CalendarBlockEventStatusEnum>;
  ne: InputMaybe<CalendarBlockEventStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CalendarBlockEventStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockFilterInput = {
  visitTypeIds: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CalendarBlockFilters = {
  OR: InputMaybe<Array<CalendarBlockFiltersOr>>;
  addressCity: InputMaybe<CalendarBlockAddressCityFilters>;
  addressCoordinates: InputMaybe<CalendarBlockAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<CalendarBlockAddressLineTwoFilters>;
  addressState: InputMaybe<CalendarBlockAddressStateFilters>;
  addressStreet: InputMaybe<CalendarBlockAddressStreetFilters>;
  addressTimezone: InputMaybe<CalendarBlockAddressTimezoneFilters>;
  addressZip: InputMaybe<CalendarBlockAddressZipFilters>;
  availabilityId: InputMaybe<CalendarBlockAvailabilityIdFilters>;
  blockType: InputMaybe<CalendarBlockBlockTypeFilters>;
  createdAt: InputMaybe<CalendarBlockCreatedAtFilters>;
  createdBy: InputMaybe<CalendarBlockCreatedByFilters>;
  deleted: InputMaybe<CalendarBlockDeletedFilters>;
  endOfShiftDriveTime: InputMaybe<CalendarBlockEndOfShiftDriveTimeFilters>;
  endTime: InputMaybe<CalendarBlockEndTimeFilters>;
  eventStatus: InputMaybe<CalendarBlockEventStatusFilters>;
  filters: InputMaybe<CalendarBlockFiltersFilters>;
  id: InputMaybe<CalendarBlockIdFilters>;
  interVisitDriveTime: InputMaybe<CalendarBlockInterVisitDriveTimeFilters>;
  manualEdits: InputMaybe<CalendarBlockManualEditsFilters>;
  organizationId: InputMaybe<CalendarBlockOrganizationIdFilters>;
  providerId: InputMaybe<CalendarBlockProviderIdFilters>;
  startOfShiftDriveTime: InputMaybe<CalendarBlockStartOfShiftDriveTimeFilters>;
  startTime: InputMaybe<CalendarBlockStartTimeFilters>;
  title: InputMaybe<CalendarBlockTitleFilters>;
  updatedAt: InputMaybe<CalendarBlockUpdatedAtFilters>;
  updatedBy: InputMaybe<CalendarBlockUpdatedByFilters>;
};

export type CalendarBlockFiltersFilters = {
  OR: InputMaybe<Array<CalendarBlockFiltersfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockFiltersOr = {
  addressCity: InputMaybe<CalendarBlockAddressCityFilters>;
  addressCoordinates: InputMaybe<CalendarBlockAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<CalendarBlockAddressLineTwoFilters>;
  addressState: InputMaybe<CalendarBlockAddressStateFilters>;
  addressStreet: InputMaybe<CalendarBlockAddressStreetFilters>;
  addressTimezone: InputMaybe<CalendarBlockAddressTimezoneFilters>;
  addressZip: InputMaybe<CalendarBlockAddressZipFilters>;
  availabilityId: InputMaybe<CalendarBlockAvailabilityIdFilters>;
  blockType: InputMaybe<CalendarBlockBlockTypeFilters>;
  createdAt: InputMaybe<CalendarBlockCreatedAtFilters>;
  createdBy: InputMaybe<CalendarBlockCreatedByFilters>;
  deleted: InputMaybe<CalendarBlockDeletedFilters>;
  endOfShiftDriveTime: InputMaybe<CalendarBlockEndOfShiftDriveTimeFilters>;
  endTime: InputMaybe<CalendarBlockEndTimeFilters>;
  eventStatus: InputMaybe<CalendarBlockEventStatusFilters>;
  filters: InputMaybe<CalendarBlockFiltersFilters>;
  id: InputMaybe<CalendarBlockIdFilters>;
  interVisitDriveTime: InputMaybe<CalendarBlockInterVisitDriveTimeFilters>;
  manualEdits: InputMaybe<CalendarBlockManualEditsFilters>;
  organizationId: InputMaybe<CalendarBlockOrganizationIdFilters>;
  providerId: InputMaybe<CalendarBlockProviderIdFilters>;
  startOfShiftDriveTime: InputMaybe<CalendarBlockStartOfShiftDriveTimeFilters>;
  startTime: InputMaybe<CalendarBlockStartTimeFilters>;
  title: InputMaybe<CalendarBlockTitleFilters>;
  updatedAt: InputMaybe<CalendarBlockUpdatedAtFilters>;
  updatedBy: InputMaybe<CalendarBlockUpdatedByFilters>;
};

export type CalendarBlockFiltersfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockIdFilters = {
  OR: InputMaybe<Array<CalendarBlockIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockInput = {
  addressCoordinates: InputMaybe<Scalars['String']['input']>;
  endOfShiftDriveTime: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  eventKey: InputMaybe<Scalars['String']['input']>;
  eventStatus: CalendarBlockEventStatusEnum;
  id: Scalars['Int']['input'];
  interVisitDriveTime: Scalars['Int']['input'];
  providerId: Scalars['Int']['input'];
  startOfShiftDriveTime: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type CalendarBlockInterVisitDriveTimeFilters = {
  OR: InputMaybe<Array<CalendarBlockInterVisitDriveTimefiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockInterVisitDriveTimefiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockManualEditsFilters = {
  OR: InputMaybe<Array<CalendarBlockManualEditsfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockManualEditsfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  availabilityId: InputMaybe<InnerOrder>;
  blockType: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  endOfShiftDriveTime: InputMaybe<InnerOrder>;
  endTime: InputMaybe<InnerOrder>;
  eventStatus: InputMaybe<InnerOrder>;
  filters: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  interVisitDriveTime: InputMaybe<InnerOrder>;
  manualEdits: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  startOfShiftDriveTime: InputMaybe<InnerOrder>;
  startTime: InputMaybe<InnerOrder>;
  title: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CalendarBlockOrganizationIdFilters = {
  OR: InputMaybe<Array<CalendarBlockOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockProviderIdFilters = {
  OR: InputMaybe<Array<CalendarBlockProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<CalendarBlockRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<CalendarBlockRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryFilters = {
  OR: InputMaybe<Array<CalendarBlockRevisionHistoryFiltersOr>>;
  action: InputMaybe<CalendarBlockRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CalendarBlockRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CalendarBlockRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CalendarBlockRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CalendarBlockRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CalendarBlockRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CalendarBlockRevisionHistoryUpdatedByFilters>;
};

export type CalendarBlockRevisionHistoryFiltersOr = {
  action: InputMaybe<CalendarBlockRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CalendarBlockRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CalendarBlockRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CalendarBlockRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CalendarBlockRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CalendarBlockRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CalendarBlockRevisionHistoryUpdatedByFilters>;
};

export type CalendarBlockRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<CalendarBlockRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CalendarBlockRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<CalendarBlockRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<CalendarBlockRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<CalendarBlockRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<CalendarBlockRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockStartOfShiftDriveTimeFilters = {
  OR: InputMaybe<Array<CalendarBlockStartOfShiftDriveTimefiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockStartOfShiftDriveTimefiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockStartTimeFilters = {
  OR: InputMaybe<Array<CalendarBlockStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockTitleFilters = {
  OR: InputMaybe<Array<CalendarBlockTitlefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockTitlefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockUpdatedAtFilters = {
  OR: InputMaybe<Array<CalendarBlockUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockUpdatedByFilters = {
  OR: InputMaybe<Array<CalendarBlockUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBlockUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignedToIdFilters = {
  OR: InputMaybe<Array<CandidacyAssignedToIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignedToIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleAssignedToIdFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleAssignedToIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleAssignedToIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleCreatedAtFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleCreatedByFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleDeletedFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleFhirLocationIdFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleFhirLocationIdfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleFhirLocationIdfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleFhirOrganizationIdFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleFhirOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleFhirOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleFiltersOr>>;
  assignedToId: InputMaybe<CandidacyAssignmentRuleAssignedToIdFilters>;
  createdAt: InputMaybe<CandidacyAssignmentRuleCreatedAtFilters>;
  createdBy: InputMaybe<CandidacyAssignmentRuleCreatedByFilters>;
  deleted: InputMaybe<CandidacyAssignmentRuleDeletedFilters>;
  fhirLocationId: InputMaybe<CandidacyAssignmentRuleFhirLocationIdFilters>;
  fhirOrganizationId: InputMaybe<CandidacyAssignmentRuleFhirOrganizationIdFilters>;
  id: InputMaybe<CandidacyAssignmentRuleIdFilters>;
  organizationId: InputMaybe<CandidacyAssignmentRuleOrganizationIdFilters>;
  updatedAt: InputMaybe<CandidacyAssignmentRuleUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidacyAssignmentRuleUpdatedByFilters>;
};

export type CandidacyAssignmentRuleFiltersOr = {
  assignedToId: InputMaybe<CandidacyAssignmentRuleAssignedToIdFilters>;
  createdAt: InputMaybe<CandidacyAssignmentRuleCreatedAtFilters>;
  createdBy: InputMaybe<CandidacyAssignmentRuleCreatedByFilters>;
  deleted: InputMaybe<CandidacyAssignmentRuleDeletedFilters>;
  fhirLocationId: InputMaybe<CandidacyAssignmentRuleFhirLocationIdFilters>;
  fhirOrganizationId: InputMaybe<CandidacyAssignmentRuleFhirOrganizationIdFilters>;
  id: InputMaybe<CandidacyAssignmentRuleIdFilters>;
  organizationId: InputMaybe<CandidacyAssignmentRuleOrganizationIdFilters>;
  updatedAt: InputMaybe<CandidacyAssignmentRuleUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidacyAssignmentRuleUpdatedByFilters>;
};

export type CandidacyAssignmentRuleIdFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleOrderBy = {
  assignedToId: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  fhirLocationId: InputMaybe<InnerOrder>;
  fhirOrganizationId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CandidacyAssignmentRuleOrganizationIdFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleUpdatedAtFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleUpdatedByFilters = {
  OR: InputMaybe<Array<CandidacyAssignmentRuleUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyAssignmentRuleUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum CandidacyCandidateStatusEnum {
  Acceptance = 'acceptance',
  Admitted = 'admitted',
  Disqualified = 'disqualified',
  Eligibility = 'eligibility',
  Transition = 'transition',
  Triage = 'triage'
}

export type CandidacyCandidateStatusFilters = {
  OR: InputMaybe<Array<CandidacyCandidateStatusfiltersOr>>;
  eq: InputMaybe<CandidacyCandidateStatusEnum>;
  gt: InputMaybe<CandidacyCandidateStatusEnum>;
  gte: InputMaybe<CandidacyCandidateStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CandidacyCandidateStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CandidacyCandidateStatusEnum>;
  lte: InputMaybe<CandidacyCandidateStatusEnum>;
  ne: InputMaybe<CandidacyCandidateStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CandidacyCandidateStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyCandidateStatusfiltersOr = {
  eq: InputMaybe<CandidacyCandidateStatusEnum>;
  gt: InputMaybe<CandidacyCandidateStatusEnum>;
  gte: InputMaybe<CandidacyCandidateStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CandidacyCandidateStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CandidacyCandidateStatusEnum>;
  lte: InputMaybe<CandidacyCandidateStatusEnum>;
  ne: InputMaybe<CandidacyCandidateStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CandidacyCandidateStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyChosenProgramIdFilters = {
  OR: InputMaybe<Array<CandidacyChosenProgramIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyChosenProgramIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyCreatedAtFilters = {
  OR: InputMaybe<Array<CandidacyCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyCreatedByFilters = {
  OR: InputMaybe<Array<CandidacyCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyDeletedFilters = {
  OR: InputMaybe<Array<CandidacyDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyEpisodeIdFilters = {
  OR: InputMaybe<Array<CandidacyEpisodeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyEpisodeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyFhirServerIdFilters = {
  OR: InputMaybe<Array<CandidacyFhirServerIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyFhirServerIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyFilters = {
  OR: InputMaybe<Array<CandidacyFiltersOr>>;
  assignedToId: InputMaybe<CandidacyAssignedToIdFilters>;
  candidateStatus: InputMaybe<CandidacyCandidateStatusFilters>;
  chosenProgramId: InputMaybe<CandidacyChosenProgramIdFilters>;
  createdAt: InputMaybe<CandidacyCreatedAtFilters>;
  createdBy: InputMaybe<CandidacyCreatedByFilters>;
  deleted: InputMaybe<CandidacyDeletedFilters>;
  episodeId: InputMaybe<CandidacyEpisodeIdFilters>;
  fhirServerId: InputMaybe<CandidacyFhirServerIdFilters>;
  id: InputMaybe<CandidacyIdFilters>;
  organizationId: InputMaybe<CandidacyOrganizationIdFilters>;
  patientId: InputMaybe<CandidacyPatientIdFilters>;
  updatedAt: InputMaybe<CandidacyUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidacyUpdatedByFilters>;
};

export type CandidacyFiltersOr = {
  assignedToId: InputMaybe<CandidacyAssignedToIdFilters>;
  candidateStatus: InputMaybe<CandidacyCandidateStatusFilters>;
  chosenProgramId: InputMaybe<CandidacyChosenProgramIdFilters>;
  createdAt: InputMaybe<CandidacyCreatedAtFilters>;
  createdBy: InputMaybe<CandidacyCreatedByFilters>;
  deleted: InputMaybe<CandidacyDeletedFilters>;
  episodeId: InputMaybe<CandidacyEpisodeIdFilters>;
  fhirServerId: InputMaybe<CandidacyFhirServerIdFilters>;
  id: InputMaybe<CandidacyIdFilters>;
  organizationId: InputMaybe<CandidacyOrganizationIdFilters>;
  patientId: InputMaybe<CandidacyPatientIdFilters>;
  updatedAt: InputMaybe<CandidacyUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidacyUpdatedByFilters>;
};

export type CandidacyIdFilters = {
  OR: InputMaybe<Array<CandidacyIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyOrderBy = {
  assignedToId: InputMaybe<InnerOrder>;
  candidateStatus: InputMaybe<InnerOrder>;
  chosenProgramId: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  episodeId: InputMaybe<InnerOrder>;
  fhirServerId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  patientId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CandidacyOrganizationIdFilters = {
  OR: InputMaybe<Array<CandidacyOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyPatientIdFilters = {
  OR: InputMaybe<Array<CandidacyPatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyPatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<CandidacyRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<CandidacyRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryFilters = {
  OR: InputMaybe<Array<CandidacyRevisionHistoryFiltersOr>>;
  action: InputMaybe<CandidacyRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CandidacyRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CandidacyRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CandidacyRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CandidacyRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CandidacyRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidacyRevisionHistoryUpdatedByFilters>;
};

export type CandidacyRevisionHistoryFiltersOr = {
  action: InputMaybe<CandidacyRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CandidacyRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CandidacyRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CandidacyRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CandidacyRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CandidacyRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidacyRevisionHistoryUpdatedByFilters>;
};

export type CandidacyRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<CandidacyRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CandidacyRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<CandidacyRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<CandidacyRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<CandidacyRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<CandidacyRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyUpdatedAtFilters = {
  OR: InputMaybe<Array<CandidacyUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyUpdatedByFilters = {
  OR: InputMaybe<Array<CandidacyUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidacyUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeCandidacyIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeCandidacyIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeCandidacyIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeCandidateStatusChangeReasonIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeCandidateStatusChangeReasonIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeCandidateStatusChangeReasonIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeCreatedAtFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeCreatedByFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeDeletedFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeFiltersOr>>;
  candidacyId: InputMaybe<CandidateStatusChangeCandidacyIdFilters>;
  candidateStatusChangeReasonId: InputMaybe<CandidateStatusChangeCandidateStatusChangeReasonIdFilters>;
  createdAt: InputMaybe<CandidateStatusChangeCreatedAtFilters>;
  createdBy: InputMaybe<CandidateStatusChangeCreatedByFilters>;
  deleted: InputMaybe<CandidateStatusChangeDeletedFilters>;
  id: InputMaybe<CandidateStatusChangeIdFilters>;
  newCandidateStatus: InputMaybe<CandidateStatusChangeNewCandidateStatusFilters>;
  organizationId: InputMaybe<CandidateStatusChangeOrganizationIdFilters>;
  originalCandidateStatus: InputMaybe<CandidateStatusChangeOriginalCandidateStatusFilters>;
  updatedAt: InputMaybe<CandidateStatusChangeUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidateStatusChangeUpdatedByFilters>;
};

export type CandidateStatusChangeFiltersOr = {
  candidacyId: InputMaybe<CandidateStatusChangeCandidacyIdFilters>;
  candidateStatusChangeReasonId: InputMaybe<CandidateStatusChangeCandidateStatusChangeReasonIdFilters>;
  createdAt: InputMaybe<CandidateStatusChangeCreatedAtFilters>;
  createdBy: InputMaybe<CandidateStatusChangeCreatedByFilters>;
  deleted: InputMaybe<CandidateStatusChangeDeletedFilters>;
  id: InputMaybe<CandidateStatusChangeIdFilters>;
  newCandidateStatus: InputMaybe<CandidateStatusChangeNewCandidateStatusFilters>;
  organizationId: InputMaybe<CandidateStatusChangeOrganizationIdFilters>;
  originalCandidateStatus: InputMaybe<CandidateStatusChangeOriginalCandidateStatusFilters>;
  updatedAt: InputMaybe<CandidateStatusChangeUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidateStatusChangeUpdatedByFilters>;
};

export type CandidateStatusChangeIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum CandidateStatusChangeNewCandidateStatusEnum {
  Acceptance = 'acceptance',
  Admitted = 'admitted',
  Disqualified = 'disqualified',
  Eligibility = 'eligibility',
  Transition = 'transition',
  Triage = 'triage'
}

export type CandidateStatusChangeNewCandidateStatusFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeNewCandidateStatusfiltersOr>>;
  eq: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  gt: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  gte: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CandidateStatusChangeNewCandidateStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  lte: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  ne: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CandidateStatusChangeNewCandidateStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeNewCandidateStatusfiltersOr = {
  eq: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  gt: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  gte: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CandidateStatusChangeNewCandidateStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  lte: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  ne: InputMaybe<CandidateStatusChangeNewCandidateStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CandidateStatusChangeNewCandidateStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeOrderBy = {
  candidacyId: InputMaybe<InnerOrder>;
  candidateStatusChangeReasonId: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  newCandidateStatus: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  originalCandidateStatus: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CandidateStatusChangeOrganizationIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum CandidateStatusChangeOriginalCandidateStatusEnum {
  Acceptance = 'acceptance',
  Admitted = 'admitted',
  Disqualified = 'disqualified',
  Eligibility = 'eligibility',
  Transition = 'transition',
  Triage = 'triage'
}

export type CandidateStatusChangeOriginalCandidateStatusFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeOriginalCandidateStatusfiltersOr>>;
  eq: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  gt: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  gte: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CandidateStatusChangeOriginalCandidateStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  lte: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  ne: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CandidateStatusChangeOriginalCandidateStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeOriginalCandidateStatusfiltersOr = {
  eq: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  gt: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  gte: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CandidateStatusChangeOriginalCandidateStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  lte: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  ne: InputMaybe<CandidateStatusChangeOriginalCandidateStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CandidateStatusChangeOriginalCandidateStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonCreatedAtFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonCreatedByFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonDeletedFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonFiltersOr>>;
  createdAt: InputMaybe<CandidateStatusChangeReasonCreatedAtFilters>;
  createdBy: InputMaybe<CandidateStatusChangeReasonCreatedByFilters>;
  deleted: InputMaybe<CandidateStatusChangeReasonDeletedFilters>;
  id: InputMaybe<CandidateStatusChangeReasonIdFilters>;
  organizationId: InputMaybe<CandidateStatusChangeReasonOrganizationIdFilters>;
  reason: InputMaybe<CandidateStatusChangeReasonReasonFilters>;
  updatedAt: InputMaybe<CandidateStatusChangeReasonUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidateStatusChangeReasonUpdatedByFilters>;
};

export type CandidateStatusChangeReasonFiltersOr = {
  createdAt: InputMaybe<CandidateStatusChangeReasonCreatedAtFilters>;
  createdBy: InputMaybe<CandidateStatusChangeReasonCreatedByFilters>;
  deleted: InputMaybe<CandidateStatusChangeReasonDeletedFilters>;
  id: InputMaybe<CandidateStatusChangeReasonIdFilters>;
  organizationId: InputMaybe<CandidateStatusChangeReasonOrganizationIdFilters>;
  reason: InputMaybe<CandidateStatusChangeReasonReasonFilters>;
  updatedAt: InputMaybe<CandidateStatusChangeReasonUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidateStatusChangeReasonUpdatedByFilters>;
};

export type CandidateStatusChangeReasonIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  reason: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CandidateStatusChangeReasonOrganizationIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonReasonFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonReasonfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonReasonfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonRevisionHistoryFiltersOr>>;
  action: InputMaybe<CandidateStatusChangeReasonRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CandidateStatusChangeReasonRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CandidateStatusChangeReasonRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CandidateStatusChangeReasonRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CandidateStatusChangeReasonRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CandidateStatusChangeReasonRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidateStatusChangeReasonRevisionHistoryUpdatedByFilters>;
};

export type CandidateStatusChangeReasonRevisionHistoryFiltersOr = {
  action: InputMaybe<CandidateStatusChangeReasonRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CandidateStatusChangeReasonRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CandidateStatusChangeReasonRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CandidateStatusChangeReasonRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CandidateStatusChangeReasonRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CandidateStatusChangeReasonRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidateStatusChangeReasonRevisionHistoryUpdatedByFilters>;
};

export type CandidateStatusChangeReasonRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CandidateStatusChangeReasonRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonUpdatedAtFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonUpdatedByFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeReasonUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeReasonUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeRevisionHistoryFiltersOr>>;
  action: InputMaybe<CandidateStatusChangeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CandidateStatusChangeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CandidateStatusChangeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CandidateStatusChangeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CandidateStatusChangeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CandidateStatusChangeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidateStatusChangeRevisionHistoryUpdatedByFilters>;
};

export type CandidateStatusChangeRevisionHistoryFiltersOr = {
  action: InputMaybe<CandidateStatusChangeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CandidateStatusChangeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CandidateStatusChangeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CandidateStatusChangeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CandidateStatusChangeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CandidateStatusChangeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CandidateStatusChangeRevisionHistoryUpdatedByFilters>;
};

export type CandidateStatusChangeRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CandidateStatusChangeRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeUpdatedAtFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeUpdatedByFilters = {
  OR: InputMaybe<Array<CandidateStatusChangeUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CandidateStatusChangeUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementCreatedAtFilters = {
  OR: InputMaybe<Array<CareRequirementCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementCreatedByFilters = {
  OR: InputMaybe<Array<CareRequirementCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementDayOfAdmissionFilters = {
  OR: InputMaybe<Array<CareRequirementDayOfAdmissionfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementDayOfAdmissionfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementDeletedFilters = {
  OR: InputMaybe<Array<CareRequirementDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementDurationFilters = {
  OR: InputMaybe<Array<CareRequirementDurationfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementDurationfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementEarliestStartTimeFilters = {
  OR: InputMaybe<Array<CareRequirementEarliestStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementEarliestStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementEpisodeIdFilters = {
  OR: InputMaybe<Array<CareRequirementEpisodeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementEpisodeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementFilters = {
  OR: InputMaybe<Array<CareRequirementFiltersOr>>;
  createdAt: InputMaybe<CareRequirementCreatedAtFilters>;
  createdBy: InputMaybe<CareRequirementCreatedByFilters>;
  dayOfAdmission: InputMaybe<CareRequirementDayOfAdmissionFilters>;
  deleted: InputMaybe<CareRequirementDeletedFilters>;
  duration: InputMaybe<CareRequirementDurationFilters>;
  earliestStartTime: InputMaybe<CareRequirementEarliestStartTimeFilters>;
  episodeId: InputMaybe<CareRequirementEpisodeIdFilters>;
  id: InputMaybe<CareRequirementIdFilters>;
  latestStartTime: InputMaybe<CareRequirementLatestStartTimeFilters>;
  maxTimeFromLastVisit: InputMaybe<CareRequirementMaxTimeFromLastVisitFilters>;
  minTimeFromLastVisit: InputMaybe<CareRequirementMinTimeFromLastVisitFilters>;
  organizationId: InputMaybe<CareRequirementOrganizationIdFilters>;
  rruleByweekday: InputMaybe<CareRequirementRruleByweekdayFilters>;
  rruleDtstart: InputMaybe<CareRequirementRruleDtstartFilters>;
  rruleFreq: InputMaybe<CareRequirementRruleFreqFilters>;
  rruleInterval: InputMaybe<CareRequirementRruleIntervalFilters>;
  rruleUntil: InputMaybe<CareRequirementRruleUntilFilters>;
  updatedAt: InputMaybe<CareRequirementUpdatedAtFilters>;
  updatedBy: InputMaybe<CareRequirementUpdatedByFilters>;
  visitTypeId: InputMaybe<CareRequirementVisitTypeIdFilters>;
};

export type CareRequirementFiltersOr = {
  createdAt: InputMaybe<CareRequirementCreatedAtFilters>;
  createdBy: InputMaybe<CareRequirementCreatedByFilters>;
  dayOfAdmission: InputMaybe<CareRequirementDayOfAdmissionFilters>;
  deleted: InputMaybe<CareRequirementDeletedFilters>;
  duration: InputMaybe<CareRequirementDurationFilters>;
  earliestStartTime: InputMaybe<CareRequirementEarliestStartTimeFilters>;
  episodeId: InputMaybe<CareRequirementEpisodeIdFilters>;
  id: InputMaybe<CareRequirementIdFilters>;
  latestStartTime: InputMaybe<CareRequirementLatestStartTimeFilters>;
  maxTimeFromLastVisit: InputMaybe<CareRequirementMaxTimeFromLastVisitFilters>;
  minTimeFromLastVisit: InputMaybe<CareRequirementMinTimeFromLastVisitFilters>;
  organizationId: InputMaybe<CareRequirementOrganizationIdFilters>;
  rruleByweekday: InputMaybe<CareRequirementRruleByweekdayFilters>;
  rruleDtstart: InputMaybe<CareRequirementRruleDtstartFilters>;
  rruleFreq: InputMaybe<CareRequirementRruleFreqFilters>;
  rruleInterval: InputMaybe<CareRequirementRruleIntervalFilters>;
  rruleUntil: InputMaybe<CareRequirementRruleUntilFilters>;
  updatedAt: InputMaybe<CareRequirementUpdatedAtFilters>;
  updatedBy: InputMaybe<CareRequirementUpdatedByFilters>;
  visitTypeId: InputMaybe<CareRequirementVisitTypeIdFilters>;
};

export type CareRequirementIdFilters = {
  OR: InputMaybe<Array<CareRequirementIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementInput = {
  dayOfAdmission: InputMaybe<Scalars['Boolean']['input']>;
  duration: Scalars['Int']['input'];
  earliestStartTime: InputMaybe<Scalars['String']['input']>;
  latestStartTime: InputMaybe<Scalars['String']['input']>;
  maxTimeFromLastVisit: InputMaybe<Scalars['Int']['input']>;
  minTimeFromLastVisit: InputMaybe<Scalars['Int']['input']>;
  rruleByweekday: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rruleDtstart: Scalars['String']['input'];
  rruleFreq: Scalars['String']['input'];
  rruleInterval: InputMaybe<Scalars['Int']['input']>;
  rruleUntil: InputMaybe<Scalars['String']['input']>;
  serviceIds: Array<Scalars['Int']['input']>;
  visitTypeId: Scalars['Int']['input'];
};

export type CareRequirementLatestStartTimeFilters = {
  OR: InputMaybe<Array<CareRequirementLatestStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementLatestStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementMaxTimeFromLastVisitFilters = {
  OR: InputMaybe<Array<CareRequirementMaxTimeFromLastVisitfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementMaxTimeFromLastVisitfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementMinTimeFromLastVisitFilters = {
  OR: InputMaybe<Array<CareRequirementMinTimeFromLastVisitfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementMinTimeFromLastVisitfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  dayOfAdmission: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  duration: InputMaybe<InnerOrder>;
  earliestStartTime: InputMaybe<InnerOrder>;
  episodeId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  latestStartTime: InputMaybe<InnerOrder>;
  maxTimeFromLastVisit: InputMaybe<InnerOrder>;
  minTimeFromLastVisit: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  rruleByweekday: InputMaybe<InnerOrder>;
  rruleDtstart: InputMaybe<InnerOrder>;
  rruleFreq: InputMaybe<InnerOrder>;
  rruleInterval: InputMaybe<InnerOrder>;
  rruleUntil: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitTypeId: InputMaybe<InnerOrder>;
};

export type CareRequirementOrganizationIdFilters = {
  OR: InputMaybe<Array<CareRequirementOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<CareRequirementRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<CareRequirementRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryFilters = {
  OR: InputMaybe<Array<CareRequirementRevisionHistoryFiltersOr>>;
  action: InputMaybe<CareRequirementRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CareRequirementRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CareRequirementRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CareRequirementRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CareRequirementRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CareRequirementRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CareRequirementRevisionHistoryUpdatedByFilters>;
};

export type CareRequirementRevisionHistoryFiltersOr = {
  action: InputMaybe<CareRequirementRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CareRequirementRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CareRequirementRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CareRequirementRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CareRequirementRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CareRequirementRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CareRequirementRevisionHistoryUpdatedByFilters>;
};

export type CareRequirementRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<CareRequirementRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CareRequirementRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<CareRequirementRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<CareRequirementRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<CareRequirementRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<CareRequirementRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleByweekdayFilters = {
  OR: InputMaybe<Array<CareRequirementRruleByweekdayfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleByweekdayfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleDtstartFilters = {
  OR: InputMaybe<Array<CareRequirementRruleDtstartfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleDtstartfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum CareRequirementRruleFreqEnum {
  Daily = 'daily',
  Weekly = 'weekly'
}

export type CareRequirementRruleFreqFilters = {
  OR: InputMaybe<Array<CareRequirementRruleFreqfiltersOr>>;
  eq: InputMaybe<CareRequirementRruleFreqEnum>;
  gt: InputMaybe<CareRequirementRruleFreqEnum>;
  gte: InputMaybe<CareRequirementRruleFreqEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CareRequirementRruleFreqEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CareRequirementRruleFreqEnum>;
  lte: InputMaybe<CareRequirementRruleFreqEnum>;
  ne: InputMaybe<CareRequirementRruleFreqEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CareRequirementRruleFreqEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleFreqfiltersOr = {
  eq: InputMaybe<CareRequirementRruleFreqEnum>;
  gt: InputMaybe<CareRequirementRruleFreqEnum>;
  gte: InputMaybe<CareRequirementRruleFreqEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<CareRequirementRruleFreqEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<CareRequirementRruleFreqEnum>;
  lte: InputMaybe<CareRequirementRruleFreqEnum>;
  ne: InputMaybe<CareRequirementRruleFreqEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<CareRequirementRruleFreqEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleIntervalFilters = {
  OR: InputMaybe<Array<CareRequirementRruleIntervalfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleIntervalfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleUntilFilters = {
  OR: InputMaybe<Array<CareRequirementRruleUntilfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementRruleUntilfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceCareRequirementIdFilters = {
  OR: InputMaybe<Array<CareRequirementServiceCareRequirementIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceCareRequirementIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceCreatedAtFilters = {
  OR: InputMaybe<Array<CareRequirementServiceCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceCreatedByFilters = {
  OR: InputMaybe<Array<CareRequirementServiceCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceDeletedFilters = {
  OR: InputMaybe<Array<CareRequirementServiceDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceFilters = {
  OR: InputMaybe<Array<CareRequirementServiceFiltersOr>>;
  careRequirementId: InputMaybe<CareRequirementServiceCareRequirementIdFilters>;
  createdAt: InputMaybe<CareRequirementServiceCreatedAtFilters>;
  createdBy: InputMaybe<CareRequirementServiceCreatedByFilters>;
  deleted: InputMaybe<CareRequirementServiceDeletedFilters>;
  id: InputMaybe<CareRequirementServiceIdFilters>;
  organizationId: InputMaybe<CareRequirementServiceOrganizationIdFilters>;
  serviceId: InputMaybe<CareRequirementServiceServiceIdFilters>;
  updatedAt: InputMaybe<CareRequirementServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<CareRequirementServiceUpdatedByFilters>;
};

export type CareRequirementServiceFiltersOr = {
  careRequirementId: InputMaybe<CareRequirementServiceCareRequirementIdFilters>;
  createdAt: InputMaybe<CareRequirementServiceCreatedAtFilters>;
  createdBy: InputMaybe<CareRequirementServiceCreatedByFilters>;
  deleted: InputMaybe<CareRequirementServiceDeletedFilters>;
  id: InputMaybe<CareRequirementServiceIdFilters>;
  organizationId: InputMaybe<CareRequirementServiceOrganizationIdFilters>;
  serviceId: InputMaybe<CareRequirementServiceServiceIdFilters>;
  updatedAt: InputMaybe<CareRequirementServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<CareRequirementServiceUpdatedByFilters>;
};

export type CareRequirementServiceIdFilters = {
  OR: InputMaybe<Array<CareRequirementServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceOrderBy = {
  careRequirementId: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  serviceId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CareRequirementServiceOrganizationIdFilters = {
  OR: InputMaybe<Array<CareRequirementServiceOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<CareRequirementServiceRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<CareRequirementServiceRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryFilters = {
  OR: InputMaybe<Array<CareRequirementServiceRevisionHistoryFiltersOr>>;
  action: InputMaybe<CareRequirementServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CareRequirementServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CareRequirementServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CareRequirementServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CareRequirementServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CareRequirementServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CareRequirementServiceRevisionHistoryUpdatedByFilters>;
};

export type CareRequirementServiceRevisionHistoryFiltersOr = {
  action: InputMaybe<CareRequirementServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<CareRequirementServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<CareRequirementServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<CareRequirementServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<CareRequirementServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<CareRequirementServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<CareRequirementServiceRevisionHistoryUpdatedByFilters>;
};

export type CareRequirementServiceRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<CareRequirementServiceRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type CareRequirementServiceRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<CareRequirementServiceRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<CareRequirementServiceRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<CareRequirementServiceRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<CareRequirementServiceRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceServiceIdFilters = {
  OR: InputMaybe<Array<CareRequirementServiceServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceUpdatedAtFilters = {
  OR: InputMaybe<Array<CareRequirementServiceUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceUpdatedByFilters = {
  OR: InputMaybe<Array<CareRequirementServiceUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementServiceUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementUpdatedAtFilters = {
  OR: InputMaybe<Array<CareRequirementUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementUpdatedByFilters = {
  OR: InputMaybe<Array<CareRequirementUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementUpsertInput = {
  dayOfAdmission: InputMaybe<Scalars['Boolean']['input']>;
  duration: Scalars['Int']['input'];
  earliestStartTime: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  latestStartTime: InputMaybe<Scalars['String']['input']>;
  maxTimeFromLastVisit: InputMaybe<Scalars['Int']['input']>;
  minTimeFromLastVisit: InputMaybe<Scalars['Int']['input']>;
  rruleByweekday: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rruleDtstart: Scalars['String']['input'];
  rruleFreq: Scalars['String']['input'];
  rruleInterval: InputMaybe<Scalars['Int']['input']>;
  rruleUntil: InputMaybe<Scalars['String']['input']>;
  serviceIds: Array<Scalars['Int']['input']>;
  visitTypeId: Scalars['Int']['input'];
};

export type CareRequirementVisitTypeIdFilters = {
  OR: InputMaybe<Array<CareRequirementVisitTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CareRequirementVisitTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateCreatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateCreatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateDeletedFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateDescriptionFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateDescriptionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateDescriptionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateDurationDaysFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateDurationDaysfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateDurationDaysfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateFiltersOr>>;
  createdAt: InputMaybe<ClinicalConstraintTemplateCreatedAtFilters>;
  createdBy: InputMaybe<ClinicalConstraintTemplateCreatedByFilters>;
  deleted: InputMaybe<ClinicalConstraintTemplateDeletedFilters>;
  description: InputMaybe<ClinicalConstraintTemplateDescriptionFilters>;
  durationDays: InputMaybe<ClinicalConstraintTemplateDurationDaysFilters>;
  firstVisitDuration: InputMaybe<ClinicalConstraintTemplateFirstVisitDurationFilters>;
  firstVisitServiceIds: InputMaybe<ClinicalConstraintTemplateFirstVisitServiceIdsFilters>;
  firstVisitTypeId: InputMaybe<ClinicalConstraintTemplateFirstVisitTypeIdFilters>;
  id: InputMaybe<ClinicalConstraintTemplateIdFilters>;
  name: InputMaybe<ClinicalConstraintTemplateNameFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateOrganizationIdFilters>;
  rruleFreq: InputMaybe<ClinicalConstraintTemplateRruleFreqFilters>;
  serviceLineId: InputMaybe<ClinicalConstraintTemplateServiceLineIdFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateUpdatedByFilters>;
};

export type ClinicalConstraintTemplateFiltersOr = {
  createdAt: InputMaybe<ClinicalConstraintTemplateCreatedAtFilters>;
  createdBy: InputMaybe<ClinicalConstraintTemplateCreatedByFilters>;
  deleted: InputMaybe<ClinicalConstraintTemplateDeletedFilters>;
  description: InputMaybe<ClinicalConstraintTemplateDescriptionFilters>;
  durationDays: InputMaybe<ClinicalConstraintTemplateDurationDaysFilters>;
  firstVisitDuration: InputMaybe<ClinicalConstraintTemplateFirstVisitDurationFilters>;
  firstVisitServiceIds: InputMaybe<ClinicalConstraintTemplateFirstVisitServiceIdsFilters>;
  firstVisitTypeId: InputMaybe<ClinicalConstraintTemplateFirstVisitTypeIdFilters>;
  id: InputMaybe<ClinicalConstraintTemplateIdFilters>;
  name: InputMaybe<ClinicalConstraintTemplateNameFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateOrganizationIdFilters>;
  rruleFreq: InputMaybe<ClinicalConstraintTemplateRruleFreqFilters>;
  serviceLineId: InputMaybe<ClinicalConstraintTemplateServiceLineIdFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateUpdatedByFilters>;
};

export type ClinicalConstraintTemplateFirstVisitDurationFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateFirstVisitDurationfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateFirstVisitDurationfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateFirstVisitServiceIdsFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateFirstVisitServiceIdsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateFirstVisitServiceIdsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateFirstVisitTypeIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateFirstVisitTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateFirstVisitTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateNameFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  description: InputMaybe<InnerOrder>;
  durationDays: InputMaybe<InnerOrder>;
  firstVisitDuration: InputMaybe<InnerOrder>;
  firstVisitServiceIds: InputMaybe<InnerOrder>;
  firstVisitTypeId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  rruleFreq: InputMaybe<InnerOrder>;
  serviceLineId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ClinicalConstraintTemplateOrganizationIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementCreatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementCreatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementDeletedFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementDurationFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementDurationfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementDurationfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementEarliestStartTimeFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementEarliestStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementEarliestStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementFiltersOr>>;
  createdAt: InputMaybe<ClinicalConstraintTemplateRequirementCreatedAtFilters>;
  createdBy: InputMaybe<ClinicalConstraintTemplateRequirementCreatedByFilters>;
  deleted: InputMaybe<ClinicalConstraintTemplateRequirementDeletedFilters>;
  duration: InputMaybe<ClinicalConstraintTemplateRequirementDurationFilters>;
  earliestStartTime: InputMaybe<ClinicalConstraintTemplateRequirementEarliestStartTimeFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRequirementIdFilters>;
  latestStartTime: InputMaybe<ClinicalConstraintTemplateRequirementLatestStartTimeFilters>;
  maxTimeFromLastVisit: InputMaybe<ClinicalConstraintTemplateRequirementMaxTimeFromLastVisitFilters>;
  minTimeFromLastVisit: InputMaybe<ClinicalConstraintTemplateRequirementMinTimeFromLastVisitFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRequirementOrganizationIdFilters>;
  rruleByweekday: InputMaybe<ClinicalConstraintTemplateRequirementRruleByweekdayFilters>;
  rruleInterval: InputMaybe<ClinicalConstraintTemplateRequirementRruleIntervalFilters>;
  serviceIds: InputMaybe<ClinicalConstraintTemplateRequirementServiceIdsFilters>;
  templateId: InputMaybe<ClinicalConstraintTemplateRequirementTemplateIdFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRequirementUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRequirementUpdatedByFilters>;
  visitTypeId: InputMaybe<ClinicalConstraintTemplateRequirementVisitTypeIdFilters>;
};

export type ClinicalConstraintTemplateRequirementFiltersOr = {
  createdAt: InputMaybe<ClinicalConstraintTemplateRequirementCreatedAtFilters>;
  createdBy: InputMaybe<ClinicalConstraintTemplateRequirementCreatedByFilters>;
  deleted: InputMaybe<ClinicalConstraintTemplateRequirementDeletedFilters>;
  duration: InputMaybe<ClinicalConstraintTemplateRequirementDurationFilters>;
  earliestStartTime: InputMaybe<ClinicalConstraintTemplateRequirementEarliestStartTimeFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRequirementIdFilters>;
  latestStartTime: InputMaybe<ClinicalConstraintTemplateRequirementLatestStartTimeFilters>;
  maxTimeFromLastVisit: InputMaybe<ClinicalConstraintTemplateRequirementMaxTimeFromLastVisitFilters>;
  minTimeFromLastVisit: InputMaybe<ClinicalConstraintTemplateRequirementMinTimeFromLastVisitFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRequirementOrganizationIdFilters>;
  rruleByweekday: InputMaybe<ClinicalConstraintTemplateRequirementRruleByweekdayFilters>;
  rruleInterval: InputMaybe<ClinicalConstraintTemplateRequirementRruleIntervalFilters>;
  serviceIds: InputMaybe<ClinicalConstraintTemplateRequirementServiceIdsFilters>;
  templateId: InputMaybe<ClinicalConstraintTemplateRequirementTemplateIdFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRequirementUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRequirementUpdatedByFilters>;
  visitTypeId: InputMaybe<ClinicalConstraintTemplateRequirementVisitTypeIdFilters>;
};

export type ClinicalConstraintTemplateRequirementIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementInput = {
  duration: Scalars['Int']['input'];
  earliestStartTime: InputMaybe<Scalars['String']['input']>;
  latestStartTime: InputMaybe<Scalars['String']['input']>;
  maxTimeFromLastVisit: InputMaybe<Scalars['Int']['input']>;
  minTimeFromLastVisit: InputMaybe<Scalars['Int']['input']>;
  rruleByweekday: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rruleInterval: InputMaybe<Scalars['Int']['input']>;
  serviceIds: Array<Scalars['Int']['input']>;
  visitTypeId: Scalars['Int']['input'];
};

export type ClinicalConstraintTemplateRequirementLatestStartTimeFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementLatestStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementLatestStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementMaxTimeFromLastVisitFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementMaxTimeFromLastVisitfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementMaxTimeFromLastVisitfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementMinTimeFromLastVisitFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementMinTimeFromLastVisitfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementMinTimeFromLastVisitfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  duration: InputMaybe<InnerOrder>;
  earliestStartTime: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  latestStartTime: InputMaybe<InnerOrder>;
  maxTimeFromLastVisit: InputMaybe<InnerOrder>;
  minTimeFromLastVisit: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  rruleByweekday: InputMaybe<InnerOrder>;
  rruleInterval: InputMaybe<InnerOrder>;
  serviceIds: InputMaybe<InnerOrder>;
  templateId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitTypeId: InputMaybe<InnerOrder>;
};

export type ClinicalConstraintTemplateRequirementOrganizationIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRevisionHistoryFiltersOr>>;
  action: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedByFilters>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryFiltersOr = {
  action: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedByFilters>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRruleByweekdayFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRruleByweekdayfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRruleByweekdayfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRruleIntervalFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementRruleIntervalfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementRruleIntervalfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceClinicalConstraintTemplateRequirementIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceClinicalConstraintTemplateRequirementIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceClinicalConstraintTemplateRequirementIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceCreatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceCreatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceDeletedFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceFiltersOr>>;
  clinicalConstraintTemplateRequirementId: InputMaybe<ClinicalConstraintTemplateRequirementServiceClinicalConstraintTemplateRequirementIdFilters>;
  createdAt: InputMaybe<ClinicalConstraintTemplateRequirementServiceCreatedAtFilters>;
  createdBy: InputMaybe<ClinicalConstraintTemplateRequirementServiceCreatedByFilters>;
  deleted: InputMaybe<ClinicalConstraintTemplateRequirementServiceDeletedFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRequirementServiceIdFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRequirementServiceOrganizationIdFilters>;
  serviceId: InputMaybe<ClinicalConstraintTemplateRequirementServiceServiceIdFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRequirementServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRequirementServiceUpdatedByFilters>;
};

export type ClinicalConstraintTemplateRequirementServiceFiltersOr = {
  clinicalConstraintTemplateRequirementId: InputMaybe<ClinicalConstraintTemplateRequirementServiceClinicalConstraintTemplateRequirementIdFilters>;
  createdAt: InputMaybe<ClinicalConstraintTemplateRequirementServiceCreatedAtFilters>;
  createdBy: InputMaybe<ClinicalConstraintTemplateRequirementServiceCreatedByFilters>;
  deleted: InputMaybe<ClinicalConstraintTemplateRequirementServiceDeletedFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRequirementServiceIdFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRequirementServiceOrganizationIdFilters>;
  serviceId: InputMaybe<ClinicalConstraintTemplateRequirementServiceServiceIdFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRequirementServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRequirementServiceUpdatedByFilters>;
};

export type ClinicalConstraintTemplateRequirementServiceIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceIdsFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceIdsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceIdsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceOrderBy = {
  clinicalConstraintTemplateRequirementId: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  serviceId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ClinicalConstraintTemplateRequirementServiceOrganizationIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceRevisionHistoryFiltersOr>>;
  action: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedByFilters>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryFiltersOr = {
  action: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedByFilters>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceServiceIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceUpdatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceUpdatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementServiceUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementServiceUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementTemplateIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementTemplateIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementTemplateIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementUpdatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementUpdatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementUpsertInput = {
  duration: Scalars['Int']['input'];
  earliestStartTime: InputMaybe<Scalars['String']['input']>;
  id: InputMaybe<Scalars['Int']['input']>;
  latestStartTime: InputMaybe<Scalars['String']['input']>;
  maxTimeFromLastVisit: InputMaybe<Scalars['Int']['input']>;
  minTimeFromLastVisit: InputMaybe<Scalars['Int']['input']>;
  rruleByweekday: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rruleInterval: InputMaybe<Scalars['Int']['input']>;
  serviceIds: Array<Scalars['Int']['input']>;
  visitTypeId: Scalars['Int']['input'];
};

export type ClinicalConstraintTemplateRequirementVisitTypeIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRequirementVisitTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRequirementVisitTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRevisionHistoryFiltersOr>>;
  action: InputMaybe<ClinicalConstraintTemplateRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ClinicalConstraintTemplateRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ClinicalConstraintTemplateRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRevisionHistoryUpdatedByFilters>;
};

export type ClinicalConstraintTemplateRevisionHistoryFiltersOr = {
  action: InputMaybe<ClinicalConstraintTemplateRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ClinicalConstraintTemplateRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ClinicalConstraintTemplateRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ClinicalConstraintTemplateRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ClinicalConstraintTemplateRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ClinicalConstraintTemplateRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ClinicalConstraintTemplateRevisionHistoryUpdatedByFilters>;
};

export type ClinicalConstraintTemplateRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ClinicalConstraintTemplateRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum ClinicalConstraintTemplateRruleFreqEnum {
  Daily = 'daily',
  Weekly = 'weekly'
}

export type ClinicalConstraintTemplateRruleFreqFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateRruleFreqfiltersOr>>;
  eq: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  gt: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  gte: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ClinicalConstraintTemplateRruleFreqEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  lte: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  ne: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ClinicalConstraintTemplateRruleFreqEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateRruleFreqfiltersOr = {
  eq: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  gt: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  gte: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ClinicalConstraintTemplateRruleFreqEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  lte: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  ne: InputMaybe<ClinicalConstraintTemplateRruleFreqEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ClinicalConstraintTemplateRruleFreqEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateServiceLineIdFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateUpdatedAtFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateUpdatedByFilters = {
  OR: InputMaybe<Array<ClinicalConstraintTemplateUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ClinicalConstraintTemplateUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type Constraints = {
  earliestStartTime: InputMaybe<Scalars['String']['input']>;
  latestStartTime: InputMaybe<Scalars['String']['input']>;
  preferredTime: InputMaybe<Scalars['String']['input']>;
};

export type CreateAnswerOption = {
  answer: Scalars['String']['input'];
};

export type DataImportCreatedAtFilters = {
  OR: InputMaybe<Array<DataImportCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportCreatedByFilters = {
  OR: InputMaybe<Array<DataImportCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportDeletedFilters = {
  OR: InputMaybe<Array<DataImportDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportFilePathToS3Filters = {
  OR: InputMaybe<Array<DataImportFilePathToS3filtersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportFilePathToS3filtersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportFilenameFilters = {
  OR: InputMaybe<Array<DataImportFilenamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportFilenamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportFilters = {
  OR: InputMaybe<Array<DataImportFiltersOr>>;
  createdAt: InputMaybe<DataImportCreatedAtFilters>;
  createdBy: InputMaybe<DataImportCreatedByFilters>;
  deleted: InputMaybe<DataImportDeletedFilters>;
  filePathToS3: InputMaybe<DataImportFilePathToS3Filters>;
  filename: InputMaybe<DataImportFilenameFilters>;
  id: InputMaybe<DataImportIdFilters>;
  metadata: InputMaybe<DataImportMetadataFilters>;
  organizationId: InputMaybe<DataImportOrganizationIdFilters>;
  resourceType: InputMaybe<DataImportResourceTypeFilters>;
  status: InputMaybe<DataImportStatusFilters>;
  updatedAt: InputMaybe<DataImportUpdatedAtFilters>;
  updatedBy: InputMaybe<DataImportUpdatedByFilters>;
};

export type DataImportFiltersOr = {
  createdAt: InputMaybe<DataImportCreatedAtFilters>;
  createdBy: InputMaybe<DataImportCreatedByFilters>;
  deleted: InputMaybe<DataImportDeletedFilters>;
  filePathToS3: InputMaybe<DataImportFilePathToS3Filters>;
  filename: InputMaybe<DataImportFilenameFilters>;
  id: InputMaybe<DataImportIdFilters>;
  metadata: InputMaybe<DataImportMetadataFilters>;
  organizationId: InputMaybe<DataImportOrganizationIdFilters>;
  resourceType: InputMaybe<DataImportResourceTypeFilters>;
  status: InputMaybe<DataImportStatusFilters>;
  updatedAt: InputMaybe<DataImportUpdatedAtFilters>;
  updatedBy: InputMaybe<DataImportUpdatedByFilters>;
};

export type DataImportIdFilters = {
  OR: InputMaybe<Array<DataImportIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportMetadataFilters = {
  OR: InputMaybe<Array<DataImportMetadatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportMetadatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  filePathToS3: InputMaybe<InnerOrder>;
  filename: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  metadata: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  resourceType: InputMaybe<InnerOrder>;
  status: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type DataImportOrganizationIdFilters = {
  OR: InputMaybe<Array<DataImportOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportResourceTypeFilters = {
  OR: InputMaybe<Array<DataImportResourceTypefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportResourceTypefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<DataImportRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<DataImportRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryFilters = {
  OR: InputMaybe<Array<DataImportRevisionHistoryFiltersOr>>;
  action: InputMaybe<DataImportRevisionHistoryActionFilters>;
  changedFields: InputMaybe<DataImportRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<DataImportRevisionHistoryIdFilters>;
  organizationId: InputMaybe<DataImportRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<DataImportRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<DataImportRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<DataImportRevisionHistoryUpdatedByFilters>;
};

export type DataImportRevisionHistoryFiltersOr = {
  action: InputMaybe<DataImportRevisionHistoryActionFilters>;
  changedFields: InputMaybe<DataImportRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<DataImportRevisionHistoryIdFilters>;
  organizationId: InputMaybe<DataImportRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<DataImportRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<DataImportRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<DataImportRevisionHistoryUpdatedByFilters>;
};

export type DataImportRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<DataImportRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type DataImportRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<DataImportRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<DataImportRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<DataImportRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<DataImportRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum DataImportStatusEnum {
  Failed = 'failed',
  InProgress = 'in_progress',
  Pending = 'pending',
  Successful = 'successful',
  Uploaded = 'uploaded'
}

export type DataImportStatusFilters = {
  OR: InputMaybe<Array<DataImportStatusfiltersOr>>;
  eq: InputMaybe<DataImportStatusEnum>;
  gt: InputMaybe<DataImportStatusEnum>;
  gte: InputMaybe<DataImportStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<DataImportStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<DataImportStatusEnum>;
  lte: InputMaybe<DataImportStatusEnum>;
  ne: InputMaybe<DataImportStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<DataImportStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportStatusfiltersOr = {
  eq: InputMaybe<DataImportStatusEnum>;
  gt: InputMaybe<DataImportStatusEnum>;
  gte: InputMaybe<DataImportStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<DataImportStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<DataImportStatusEnum>;
  lte: InputMaybe<DataImportStatusEnum>;
  ne: InputMaybe<DataImportStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<DataImportStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportUpdatedAtFilters = {
  OR: InputMaybe<Array<DataImportUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportUpdatedByFilters = {
  OR: InputMaybe<Array<DataImportUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DataImportUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type DriveTimeOptimizerBreakInput = {
  endTime: Scalars['String']['input'];
  providerId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type DriveTimeOptimizerChangeFrictionInput = {
  assignmentFriction: OptimizerFriction;
  currentShiftIds: Array<Scalars['Int']['input']>;
  currentStartTime: InputMaybe<Scalars['String']['input']>;
  startTimeFriction: OptimizerFriction;
};

export type DriveTimeOptimizerFilterBlockInput = {
  endTime: Scalars['String']['input'];
  excludedIds: Array<InputMaybe<Scalars['Int']['input']>>;
  includedIds: Array<InputMaybe<Scalars['Int']['input']>>;
  location: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type DriveTimeOptimizerInput = {
  breaks: Array<DriveTimeOptimizerBreakInput>;
  filterBlocks: Array<DriveTimeOptimizerFilterBlockInput>;
  proximityConstraints: InputMaybe<Array<DriveTimeOptimizerProximityConstraintInput>>;
  shifts: Array<DriveTimeOptimizerShiftInput>;
  visits: Array<DriveTimeOptimizerVisitRequestInput>;
};

export type DriveTimeOptimizerOffsetInput = {
  offsetMinutes: Scalars['Int']['input'];
  visitResourceId: Scalars['Int']['input'];
};

export type DriveTimeOptimizerProximityConstraintInput = {
  earlierVisitResourceId: Scalars['Int']['input'];
  laterVisitResourceId: Scalars['Int']['input'];
  maxProximityMinutes: InputMaybe<Scalars['Int']['input']>;
  minProximityMinutes: InputMaybe<Scalars['Int']['input']>;
};

export type DriveTimeOptimizerShiftInput = {
  endLocation: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  endsShift: Scalars['Boolean']['input'];
  ignoreDriveTimeShiftEnd: Scalars['Boolean']['input'];
  ignoreDriveTimeShiftStart: Scalars['Boolean']['input'];
  internal: Scalars['Boolean']['input'];
  overflow: Scalars['Boolean']['input'];
  providerId: Scalars['Int']['input'];
  providerTypeId: Scalars['Int']['input'];
  shiftId: Scalars['Int']['input'];
  startLocation: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  startsShift: Scalars['Boolean']['input'];
};

export type DriveTimeOptimizerVisitRequestInput = {
  allowedShiftIds: Array<InputMaybe<Scalars['Int']['input']>>;
  anchorResourceId: InputMaybe<Scalars['Int']['input']>;
  arrivalWindowEnd: Scalars['String']['input'];
  arrivalWindowStart: Scalars['String']['input'];
  changeFriction: InputMaybe<DriveTimeOptimizerChangeFrictionInput>;
  endTime: Scalars['String']['input'];
  locations: Array<VisitLocationInput>;
  locked: Scalars['Boolean']['input'];
  offsets: Array<DriveTimeOptimizerOffsetInput>;
  preSkipReason: InputMaybe<Scalars['String']['input']>;
  precedingResourceId: InputMaybe<Scalars['Int']['input']>;
  preferredShiftIds: Array<InputMaybe<Scalars['Int']['input']>>;
  preserveGroup: InputMaybe<Scalars['Boolean']['input']>;
  priorityLevel: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  tagGroup: InputMaybe<Scalars['Int']['input']>;
  visitResourceId: Scalars['Int']['input'];
};

export type EligibilityAnswerOptionAnswerFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionAnswerfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionAnswerfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionCreatedAtFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionCreatedByFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionDeletedFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionEligibilityQuestionIdFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionEligibilityQuestionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionEligibilityQuestionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionFiltersOr>>;
  answer: InputMaybe<EligibilityAnswerOptionAnswerFilters>;
  createdAt: InputMaybe<EligibilityAnswerOptionCreatedAtFilters>;
  createdBy: InputMaybe<EligibilityAnswerOptionCreatedByFilters>;
  deleted: InputMaybe<EligibilityAnswerOptionDeletedFilters>;
  eligibilityQuestionId: InputMaybe<EligibilityAnswerOptionEligibilityQuestionIdFilters>;
  id: InputMaybe<EligibilityAnswerOptionIdFilters>;
  organizationId: InputMaybe<EligibilityAnswerOptionOrganizationIdFilters>;
  updatedAt: InputMaybe<EligibilityAnswerOptionUpdatedAtFilters>;
  updatedBy: InputMaybe<EligibilityAnswerOptionUpdatedByFilters>;
};

export type EligibilityAnswerOptionFiltersOr = {
  answer: InputMaybe<EligibilityAnswerOptionAnswerFilters>;
  createdAt: InputMaybe<EligibilityAnswerOptionCreatedAtFilters>;
  createdBy: InputMaybe<EligibilityAnswerOptionCreatedByFilters>;
  deleted: InputMaybe<EligibilityAnswerOptionDeletedFilters>;
  eligibilityQuestionId: InputMaybe<EligibilityAnswerOptionEligibilityQuestionIdFilters>;
  id: InputMaybe<EligibilityAnswerOptionIdFilters>;
  organizationId: InputMaybe<EligibilityAnswerOptionOrganizationIdFilters>;
  updatedAt: InputMaybe<EligibilityAnswerOptionUpdatedAtFilters>;
  updatedBy: InputMaybe<EligibilityAnswerOptionUpdatedByFilters>;
};

export type EligibilityAnswerOptionIdFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionOrderBy = {
  answer: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  eligibilityQuestionId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EligibilityAnswerOptionOrganizationIdFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionRevisionHistoryFiltersOr>>;
  action: InputMaybe<EligibilityAnswerOptionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EligibilityAnswerOptionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EligibilityAnswerOptionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EligibilityAnswerOptionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EligibilityAnswerOptionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EligibilityAnswerOptionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EligibilityAnswerOptionRevisionHistoryUpdatedByFilters>;
};

export type EligibilityAnswerOptionRevisionHistoryFiltersOr = {
  action: InputMaybe<EligibilityAnswerOptionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EligibilityAnswerOptionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EligibilityAnswerOptionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EligibilityAnswerOptionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EligibilityAnswerOptionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EligibilityAnswerOptionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EligibilityAnswerOptionRevisionHistoryUpdatedByFilters>;
};

export type EligibilityAnswerOptionRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EligibilityAnswerOptionRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionUpdatedAtFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionUpdatedByFilters = {
  OR: InputMaybe<Array<EligibilityAnswerOptionUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityAnswerOptionUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum EligibilityQuestionAnswerFormatTypeEnum {
  Boolean = 'boolean',
  FreeText = 'free_text',
  MultiSelectOptions = 'multi_select_options',
  Numeric = 'numeric',
  SelectedOption = 'selected_option'
}

export type EligibilityQuestionAnswerFormatTypeFilters = {
  OR: InputMaybe<Array<EligibilityQuestionAnswerFormatTypefiltersOr>>;
  eq: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  gt: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  gte: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<EligibilityQuestionAnswerFormatTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  lte: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  ne: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<EligibilityQuestionAnswerFormatTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionAnswerFormatTypefiltersOr = {
  eq: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  gt: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  gte: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<EligibilityQuestionAnswerFormatTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  lte: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  ne: InputMaybe<EligibilityQuestionAnswerFormatTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<EligibilityQuestionAnswerFormatTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum EligibilityQuestionAnswerModuleEnum {
  DevAlwaysFalse = 'DEV_always_false',
  DevAlwaysTrue = 'DEV_always_true',
  DevEchoPredicate = 'DEV_echo_predicate',
  DevEchoPredicateNumber = 'DEV_echo_predicate_number',
  DevSelectAll = 'DEV_select_all',
  DevSelectFirst = 'DEV_select_first',
  DevSelectNone = 'DEV_select_none'
}

export type EligibilityQuestionAnswerModuleFilters = {
  OR: InputMaybe<Array<EligibilityQuestionAnswerModulefiltersOr>>;
  eq: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  gt: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  gte: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<EligibilityQuestionAnswerModuleEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  lte: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  ne: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<EligibilityQuestionAnswerModuleEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionAnswerModulePredicateFilters = {
  OR: InputMaybe<Array<EligibilityQuestionAnswerModulePredicatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionAnswerModulePredicatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionAnswerModulefiltersOr = {
  eq: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  gt: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  gte: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<EligibilityQuestionAnswerModuleEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  lte: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  ne: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<EligibilityQuestionAnswerModuleEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionCreatedAtFilters = {
  OR: InputMaybe<Array<EligibilityQuestionCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionCreatedByFilters = {
  OR: InputMaybe<Array<EligibilityQuestionCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionDeletedFilters = {
  OR: InputMaybe<Array<EligibilityQuestionDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionFilters = {
  OR: InputMaybe<Array<EligibilityQuestionFiltersOr>>;
  answerFormatType: InputMaybe<EligibilityQuestionAnswerFormatTypeFilters>;
  answerModule: InputMaybe<EligibilityQuestionAnswerModuleFilters>;
  answerModulePredicate: InputMaybe<EligibilityQuestionAnswerModulePredicateFilters>;
  createdAt: InputMaybe<EligibilityQuestionCreatedAtFilters>;
  createdBy: InputMaybe<EligibilityQuestionCreatedByFilters>;
  deleted: InputMaybe<EligibilityQuestionDeletedFilters>;
  id: InputMaybe<EligibilityQuestionIdFilters>;
  organizationId: InputMaybe<EligibilityQuestionOrganizationIdFilters>;
  question: InputMaybe<EligibilityQuestionQuestionFilters>;
  updatedAt: InputMaybe<EligibilityQuestionUpdatedAtFilters>;
  updatedBy: InputMaybe<EligibilityQuestionUpdatedByFilters>;
  useForPreScoreCheck: InputMaybe<EligibilityQuestionUseForPreScoreCheckFilters>;
};

export type EligibilityQuestionFiltersOr = {
  answerFormatType: InputMaybe<EligibilityQuestionAnswerFormatTypeFilters>;
  answerModule: InputMaybe<EligibilityQuestionAnswerModuleFilters>;
  answerModulePredicate: InputMaybe<EligibilityQuestionAnswerModulePredicateFilters>;
  createdAt: InputMaybe<EligibilityQuestionCreatedAtFilters>;
  createdBy: InputMaybe<EligibilityQuestionCreatedByFilters>;
  deleted: InputMaybe<EligibilityQuestionDeletedFilters>;
  id: InputMaybe<EligibilityQuestionIdFilters>;
  organizationId: InputMaybe<EligibilityQuestionOrganizationIdFilters>;
  question: InputMaybe<EligibilityQuestionQuestionFilters>;
  updatedAt: InputMaybe<EligibilityQuestionUpdatedAtFilters>;
  updatedBy: InputMaybe<EligibilityQuestionUpdatedByFilters>;
  useForPreScoreCheck: InputMaybe<EligibilityQuestionUseForPreScoreCheckFilters>;
};

export type EligibilityQuestionIdFilters = {
  OR: InputMaybe<Array<EligibilityQuestionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionOrderBy = {
  answerFormatType: InputMaybe<InnerOrder>;
  answerModule: InputMaybe<InnerOrder>;
  answerModulePredicate: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  question: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  useForPreScoreCheck: InputMaybe<InnerOrder>;
};

export type EligibilityQuestionOrganizationIdFilters = {
  OR: InputMaybe<Array<EligibilityQuestionOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionQuestionFilters = {
  OR: InputMaybe<Array<EligibilityQuestionQuestionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionQuestionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<EligibilityQuestionRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<EligibilityQuestionRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryFilters = {
  OR: InputMaybe<Array<EligibilityQuestionRevisionHistoryFiltersOr>>;
  action: InputMaybe<EligibilityQuestionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EligibilityQuestionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EligibilityQuestionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EligibilityQuestionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EligibilityQuestionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EligibilityQuestionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EligibilityQuestionRevisionHistoryUpdatedByFilters>;
};

export type EligibilityQuestionRevisionHistoryFiltersOr = {
  action: InputMaybe<EligibilityQuestionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EligibilityQuestionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EligibilityQuestionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EligibilityQuestionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EligibilityQuestionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EligibilityQuestionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EligibilityQuestionRevisionHistoryUpdatedByFilters>;
};

export type EligibilityQuestionRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<EligibilityQuestionRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EligibilityQuestionRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<EligibilityQuestionRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<EligibilityQuestionRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<EligibilityQuestionRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<EligibilityQuestionRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionUpdatedAtFilters = {
  OR: InputMaybe<Array<EligibilityQuestionUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionUpdatedByFilters = {
  OR: InputMaybe<Array<EligibilityQuestionUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionUseForPreScoreCheckFilters = {
  OR: InputMaybe<Array<EligibilityQuestionUseForPreScoreCheckfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EligibilityQuestionUseForPreScoreCheckfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeActiveFilters = {
  OR: InputMaybe<Array<EpisodeActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeAutoschedulerGroupFilters = {
  OR: InputMaybe<Array<EpisodeAutoschedulerGroupfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeAutoschedulerGroupfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeCreatedAtFilters = {
  OR: InputMaybe<Array<EpisodeCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeCreatedByFilters = {
  OR: InputMaybe<Array<EpisodeCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeDeletedFilters = {
  OR: InputMaybe<Array<EpisodeDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeFilters = {
  OR: InputMaybe<Array<EpisodeFiltersOr>>;
  active: InputMaybe<EpisodeActiveFilters>;
  autoschedulerGroup: InputMaybe<EpisodeAutoschedulerGroupFilters>;
  createdAt: InputMaybe<EpisodeCreatedAtFilters>;
  createdBy: InputMaybe<EpisodeCreatedByFilters>;
  deleted: InputMaybe<EpisodeDeletedFilters>;
  id: InputMaybe<EpisodeIdFilters>;
  organizationId: InputMaybe<EpisodeOrganizationIdFilters>;
  organizationalUnitId: InputMaybe<EpisodeOrganizationalUnitIdFilters>;
  patientId: InputMaybe<EpisodePatientIdFilters>;
  serviceLineId: InputMaybe<EpisodeServiceLineIdFilters>;
  updatedAt: InputMaybe<EpisodeUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeUpdatedByFilters>;
};

export type EpisodeFiltersOr = {
  active: InputMaybe<EpisodeActiveFilters>;
  autoschedulerGroup: InputMaybe<EpisodeAutoschedulerGroupFilters>;
  createdAt: InputMaybe<EpisodeCreatedAtFilters>;
  createdBy: InputMaybe<EpisodeCreatedByFilters>;
  deleted: InputMaybe<EpisodeDeletedFilters>;
  id: InputMaybe<EpisodeIdFilters>;
  organizationId: InputMaybe<EpisodeOrganizationIdFilters>;
  organizationalUnitId: InputMaybe<EpisodeOrganizationalUnitIdFilters>;
  patientId: InputMaybe<EpisodePatientIdFilters>;
  serviceLineId: InputMaybe<EpisodeServiceLineIdFilters>;
  updatedAt: InputMaybe<EpisodeUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeUpdatedByFilters>;
};

export type EpisodeIdFilters = {
  OR: InputMaybe<Array<EpisodeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeOrderBy = {
  active: InputMaybe<InnerOrder>;
  autoschedulerGroup: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  organizationalUnitId: InputMaybe<InnerOrder>;
  patientId: InputMaybe<InnerOrder>;
  serviceLineId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EpisodeOrganizationIdFilters = {
  OR: InputMaybe<Array<EpisodeOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeOrganizationalUnitIdFilters = {
  OR: InputMaybe<Array<EpisodeOrganizationalUnitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeOrganizationalUnitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePatientIdFilters = {
  OR: InputMaybe<Array<EpisodePatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionCreatedAtFilters = {
  OR: InputMaybe<Array<EpisodePrecautionCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionCreatedByFilters = {
  OR: InputMaybe<Array<EpisodePrecautionCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionDeletedFilters = {
  OR: InputMaybe<Array<EpisodePrecautionDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionEpisodeIdFilters = {
  OR: InputMaybe<Array<EpisodePrecautionEpisodeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionEpisodeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionFilters = {
  OR: InputMaybe<Array<EpisodePrecautionFiltersOr>>;
  createdAt: InputMaybe<EpisodePrecautionCreatedAtFilters>;
  createdBy: InputMaybe<EpisodePrecautionCreatedByFilters>;
  deleted: InputMaybe<EpisodePrecautionDeletedFilters>;
  episodeId: InputMaybe<EpisodePrecautionEpisodeIdFilters>;
  id: InputMaybe<EpisodePrecautionIdFilters>;
  organizationId: InputMaybe<EpisodePrecautionOrganizationIdFilters>;
  precautionId: InputMaybe<EpisodePrecautionPrecautionIdFilters>;
  updatedAt: InputMaybe<EpisodePrecautionUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodePrecautionUpdatedByFilters>;
};

export type EpisodePrecautionFiltersOr = {
  createdAt: InputMaybe<EpisodePrecautionCreatedAtFilters>;
  createdBy: InputMaybe<EpisodePrecautionCreatedByFilters>;
  deleted: InputMaybe<EpisodePrecautionDeletedFilters>;
  episodeId: InputMaybe<EpisodePrecautionEpisodeIdFilters>;
  id: InputMaybe<EpisodePrecautionIdFilters>;
  organizationId: InputMaybe<EpisodePrecautionOrganizationIdFilters>;
  precautionId: InputMaybe<EpisodePrecautionPrecautionIdFilters>;
  updatedAt: InputMaybe<EpisodePrecautionUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodePrecautionUpdatedByFilters>;
};

export type EpisodePrecautionIdFilters = {
  OR: InputMaybe<Array<EpisodePrecautionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  episodeId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  precautionId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EpisodePrecautionOrganizationIdFilters = {
  OR: InputMaybe<Array<EpisodePrecautionOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionPrecautionIdFilters = {
  OR: InputMaybe<Array<EpisodePrecautionPrecautionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionPrecautionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<EpisodePrecautionRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<EpisodePrecautionRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryFilters = {
  OR: InputMaybe<Array<EpisodePrecautionRevisionHistoryFiltersOr>>;
  action: InputMaybe<EpisodePrecautionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EpisodePrecautionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EpisodePrecautionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EpisodePrecautionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EpisodePrecautionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EpisodePrecautionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodePrecautionRevisionHistoryUpdatedByFilters>;
};

export type EpisodePrecautionRevisionHistoryFiltersOr = {
  action: InputMaybe<EpisodePrecautionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EpisodePrecautionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EpisodePrecautionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EpisodePrecautionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EpisodePrecautionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EpisodePrecautionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodePrecautionRevisionHistoryUpdatedByFilters>;
};

export type EpisodePrecautionRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<EpisodePrecautionRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EpisodePrecautionRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<EpisodePrecautionRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<EpisodePrecautionRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<EpisodePrecautionRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<EpisodePrecautionRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionUpdatedAtFilters = {
  OR: InputMaybe<Array<EpisodePrecautionUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionUpdatedByFilters = {
  OR: InputMaybe<Array<EpisodePrecautionUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodePrecautionUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<EpisodeRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<EpisodeRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryFilters = {
  OR: InputMaybe<Array<EpisodeRevisionHistoryFiltersOr>>;
  action: InputMaybe<EpisodeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EpisodeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EpisodeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EpisodeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EpisodeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EpisodeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeRevisionHistoryUpdatedByFilters>;
};

export type EpisodeRevisionHistoryFiltersOr = {
  action: InputMaybe<EpisodeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EpisodeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EpisodeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EpisodeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EpisodeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EpisodeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeRevisionHistoryUpdatedByFilters>;
};

export type EpisodeRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<EpisodeRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EpisodeRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<EpisodeRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<EpisodeRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<EpisodeRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<EpisodeRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeServiceLineIdFilters = {
  OR: InputMaybe<Array<EpisodeServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventCreatedAtFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventCreatedByFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventDeletedFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventEpisodeSupplyItemIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventEpisodeSupplyItemIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventEpisodeSupplyItemIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum EpisodeSupplyEventEventEnum {
  Canceled = 'canceled',
  Delivered = 'delivered',
  PickedUp = 'picked_up',
  Requested = 'requested'
}

export type EpisodeSupplyEventEventFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventEventfiltersOr>>;
  eq: InputMaybe<EpisodeSupplyEventEventEnum>;
  gt: InputMaybe<EpisodeSupplyEventEventEnum>;
  gte: InputMaybe<EpisodeSupplyEventEventEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<EpisodeSupplyEventEventEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<EpisodeSupplyEventEventEnum>;
  lte: InputMaybe<EpisodeSupplyEventEventEnum>;
  ne: InputMaybe<EpisodeSupplyEventEventEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<EpisodeSupplyEventEventEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventEventfiltersOr = {
  eq: InputMaybe<EpisodeSupplyEventEventEnum>;
  gt: InputMaybe<EpisodeSupplyEventEventEnum>;
  gte: InputMaybe<EpisodeSupplyEventEventEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<EpisodeSupplyEventEventEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<EpisodeSupplyEventEventEnum>;
  lte: InputMaybe<EpisodeSupplyEventEventEnum>;
  ne: InputMaybe<EpisodeSupplyEventEventEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<EpisodeSupplyEventEventEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventFiltersOr>>;
  createdAt: InputMaybe<EpisodeSupplyEventCreatedAtFilters>;
  createdBy: InputMaybe<EpisodeSupplyEventCreatedByFilters>;
  deleted: InputMaybe<EpisodeSupplyEventDeletedFilters>;
  episodeSupplyItemId: InputMaybe<EpisodeSupplyEventEpisodeSupplyItemIdFilters>;
  event: InputMaybe<EpisodeSupplyEventEventFilters>;
  id: InputMaybe<EpisodeSupplyEventIdFilters>;
  organizationId: InputMaybe<EpisodeSupplyEventOrganizationIdFilters>;
  updatedAt: InputMaybe<EpisodeSupplyEventUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeSupplyEventUpdatedByFilters>;
};

export type EpisodeSupplyEventFiltersOr = {
  createdAt: InputMaybe<EpisodeSupplyEventCreatedAtFilters>;
  createdBy: InputMaybe<EpisodeSupplyEventCreatedByFilters>;
  deleted: InputMaybe<EpisodeSupplyEventDeletedFilters>;
  episodeSupplyItemId: InputMaybe<EpisodeSupplyEventEpisodeSupplyItemIdFilters>;
  event: InputMaybe<EpisodeSupplyEventEventFilters>;
  id: InputMaybe<EpisodeSupplyEventIdFilters>;
  organizationId: InputMaybe<EpisodeSupplyEventOrganizationIdFilters>;
  updatedAt: InputMaybe<EpisodeSupplyEventUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeSupplyEventUpdatedByFilters>;
};

export type EpisodeSupplyEventIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  episodeSupplyItemId: InputMaybe<InnerOrder>;
  event: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EpisodeSupplyEventOrganizationIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventUpdatedAtFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventUpdatedByFilters = {
  OR: InputMaybe<Array<EpisodeSupplyEventUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyEventUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemAmountFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemAmountfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemAmountfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemCreatedAtFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemCreatedByFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemDeletedFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemEpisodeIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemEpisodeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemEpisodeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemFiltersOr>>;
  amount: InputMaybe<EpisodeSupplyItemAmountFilters>;
  createdAt: InputMaybe<EpisodeSupplyItemCreatedAtFilters>;
  createdBy: InputMaybe<EpisodeSupplyItemCreatedByFilters>;
  deleted: InputMaybe<EpisodeSupplyItemDeletedFilters>;
  episodeId: InputMaybe<EpisodeSupplyItemEpisodeIdFilters>;
  id: InputMaybe<EpisodeSupplyItemIdFilters>;
  organizationId: InputMaybe<EpisodeSupplyItemOrganizationIdFilters>;
  status: InputMaybe<EpisodeSupplyItemStatusFilters>;
  supplyItemId: InputMaybe<EpisodeSupplyItemSupplyItemIdFilters>;
  updatedAt: InputMaybe<EpisodeSupplyItemUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeSupplyItemUpdatedByFilters>;
};

export type EpisodeSupplyItemFiltersOr = {
  amount: InputMaybe<EpisodeSupplyItemAmountFilters>;
  createdAt: InputMaybe<EpisodeSupplyItemCreatedAtFilters>;
  createdBy: InputMaybe<EpisodeSupplyItemCreatedByFilters>;
  deleted: InputMaybe<EpisodeSupplyItemDeletedFilters>;
  episodeId: InputMaybe<EpisodeSupplyItemEpisodeIdFilters>;
  id: InputMaybe<EpisodeSupplyItemIdFilters>;
  organizationId: InputMaybe<EpisodeSupplyItemOrganizationIdFilters>;
  status: InputMaybe<EpisodeSupplyItemStatusFilters>;
  supplyItemId: InputMaybe<EpisodeSupplyItemSupplyItemIdFilters>;
  updatedAt: InputMaybe<EpisodeSupplyItemUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeSupplyItemUpdatedByFilters>;
};

export type EpisodeSupplyItemIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemOrderBy = {
  amount: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  episodeId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  status: InputMaybe<InnerOrder>;
  supplyItemId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EpisodeSupplyItemOrganizationIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemRevisionHistoryFiltersOr>>;
  action: InputMaybe<EpisodeSupplyItemRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EpisodeSupplyItemRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EpisodeSupplyItemRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EpisodeSupplyItemRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EpisodeSupplyItemRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EpisodeSupplyItemRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeSupplyItemRevisionHistoryUpdatedByFilters>;
};

export type EpisodeSupplyItemRevisionHistoryFiltersOr = {
  action: InputMaybe<EpisodeSupplyItemRevisionHistoryActionFilters>;
  changedFields: InputMaybe<EpisodeSupplyItemRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<EpisodeSupplyItemRevisionHistoryIdFilters>;
  organizationId: InputMaybe<EpisodeSupplyItemRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<EpisodeSupplyItemRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<EpisodeSupplyItemRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<EpisodeSupplyItemRevisionHistoryUpdatedByFilters>;
};

export type EpisodeSupplyItemRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type EpisodeSupplyItemRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum EpisodeSupplyItemStatusEnum {
  Canceled = 'canceled',
  Delivered = 'delivered',
  PickedUp = 'picked_up',
  Requested = 'requested'
}

export type EpisodeSupplyItemStatusFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemStatusfiltersOr>>;
  eq: InputMaybe<EpisodeSupplyItemStatusEnum>;
  gt: InputMaybe<EpisodeSupplyItemStatusEnum>;
  gte: InputMaybe<EpisodeSupplyItemStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<EpisodeSupplyItemStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<EpisodeSupplyItemStatusEnum>;
  lte: InputMaybe<EpisodeSupplyItemStatusEnum>;
  ne: InputMaybe<EpisodeSupplyItemStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<EpisodeSupplyItemStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemStatusfiltersOr = {
  eq: InputMaybe<EpisodeSupplyItemStatusEnum>;
  gt: InputMaybe<EpisodeSupplyItemStatusEnum>;
  gte: InputMaybe<EpisodeSupplyItemStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<EpisodeSupplyItemStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<EpisodeSupplyItemStatusEnum>;
  lte: InputMaybe<EpisodeSupplyItemStatusEnum>;
  ne: InputMaybe<EpisodeSupplyItemStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<EpisodeSupplyItemStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemSupplyItemIdFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemSupplyItemIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemSupplyItemIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemUpdatedAtFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemUpdatedByFilters = {
  OR: InputMaybe<Array<EpisodeSupplyItemUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeSupplyItemUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeUpdatedAtFilters = {
  OR: InputMaybe<Array<EpisodeUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeUpdatedByFilters = {
  OR: InputMaybe<Array<EpisodeUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type EpisodeUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressCityFilters = {
  OR: InputMaybe<Array<ErrandLocationAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressCoordinatesFilters = {
  OR: InputMaybe<Array<ErrandLocationAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressLineTwoFilters = {
  OR: InputMaybe<Array<ErrandLocationAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressStateFilters = {
  OR: InputMaybe<Array<ErrandLocationAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressStreetFilters = {
  OR: InputMaybe<Array<ErrandLocationAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressTimezoneFilters = {
  OR: InputMaybe<Array<ErrandLocationAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressZipFilters = {
  OR: InputMaybe<Array<ErrandLocationAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationCreatedAtFilters = {
  OR: InputMaybe<Array<ErrandLocationCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationCreatedByFilters = {
  OR: InputMaybe<Array<ErrandLocationCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationDeletedFilters = {
  OR: InputMaybe<Array<ErrandLocationDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationDescriptionFilters = {
  OR: InputMaybe<Array<ErrandLocationDescriptionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationDescriptionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationErrandTypeIdFilters = {
  OR: InputMaybe<Array<ErrandLocationErrandTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationErrandTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationFilters = {
  OR: InputMaybe<Array<ErrandLocationFiltersOr>>;
  addressCity: InputMaybe<ErrandLocationAddressCityFilters>;
  addressCoordinates: InputMaybe<ErrandLocationAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<ErrandLocationAddressLineTwoFilters>;
  addressState: InputMaybe<ErrandLocationAddressStateFilters>;
  addressStreet: InputMaybe<ErrandLocationAddressStreetFilters>;
  addressTimezone: InputMaybe<ErrandLocationAddressTimezoneFilters>;
  addressZip: InputMaybe<ErrandLocationAddressZipFilters>;
  createdAt: InputMaybe<ErrandLocationCreatedAtFilters>;
  createdBy: InputMaybe<ErrandLocationCreatedByFilters>;
  deleted: InputMaybe<ErrandLocationDeletedFilters>;
  description: InputMaybe<ErrandLocationDescriptionFilters>;
  errandTypeId: InputMaybe<ErrandLocationErrandTypeIdFilters>;
  id: InputMaybe<ErrandLocationIdFilters>;
  name: InputMaybe<ErrandLocationNameFilters>;
  organizationId: InputMaybe<ErrandLocationOrganizationIdFilters>;
  organizationalUnitId: InputMaybe<ErrandLocationOrganizationalUnitIdFilters>;
  updatedAt: InputMaybe<ErrandLocationUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandLocationUpdatedByFilters>;
};

export type ErrandLocationFiltersOr = {
  addressCity: InputMaybe<ErrandLocationAddressCityFilters>;
  addressCoordinates: InputMaybe<ErrandLocationAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<ErrandLocationAddressLineTwoFilters>;
  addressState: InputMaybe<ErrandLocationAddressStateFilters>;
  addressStreet: InputMaybe<ErrandLocationAddressStreetFilters>;
  addressTimezone: InputMaybe<ErrandLocationAddressTimezoneFilters>;
  addressZip: InputMaybe<ErrandLocationAddressZipFilters>;
  createdAt: InputMaybe<ErrandLocationCreatedAtFilters>;
  createdBy: InputMaybe<ErrandLocationCreatedByFilters>;
  deleted: InputMaybe<ErrandLocationDeletedFilters>;
  description: InputMaybe<ErrandLocationDescriptionFilters>;
  errandTypeId: InputMaybe<ErrandLocationErrandTypeIdFilters>;
  id: InputMaybe<ErrandLocationIdFilters>;
  name: InputMaybe<ErrandLocationNameFilters>;
  organizationId: InputMaybe<ErrandLocationOrganizationIdFilters>;
  organizationalUnitId: InputMaybe<ErrandLocationOrganizationalUnitIdFilters>;
  updatedAt: InputMaybe<ErrandLocationUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandLocationUpdatedByFilters>;
};

export type ErrandLocationIdFilters = {
  OR: InputMaybe<Array<ErrandLocationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationNameFilters = {
  OR: InputMaybe<Array<ErrandLocationNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  description: InputMaybe<InnerOrder>;
  errandTypeId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  organizationalUnitId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ErrandLocationOrganizationIdFilters = {
  OR: InputMaybe<Array<ErrandLocationOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationOrganizationalUnitIdFilters = {
  OR: InputMaybe<Array<ErrandLocationOrganizationalUnitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationOrganizationalUnitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ErrandLocationRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ErrandLocationRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryFilters = {
  OR: InputMaybe<Array<ErrandLocationRevisionHistoryFiltersOr>>;
  action: InputMaybe<ErrandLocationRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ErrandLocationRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ErrandLocationRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ErrandLocationRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ErrandLocationRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ErrandLocationRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandLocationRevisionHistoryUpdatedByFilters>;
};

export type ErrandLocationRevisionHistoryFiltersOr = {
  action: InputMaybe<ErrandLocationRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ErrandLocationRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ErrandLocationRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ErrandLocationRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ErrandLocationRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ErrandLocationRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandLocationRevisionHistoryUpdatedByFilters>;
};

export type ErrandLocationRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ErrandLocationRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ErrandLocationRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ErrandLocationRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ErrandLocationRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ErrandLocationRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ErrandLocationRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationUpdatedAtFilters = {
  OR: InputMaybe<Array<ErrandLocationUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationUpdatedByFilters = {
  OR: InputMaybe<Array<ErrandLocationUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandLocationUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeActiveFilters = {
  OR: InputMaybe<Array<ErrandTypeActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeCreatedAtFilters = {
  OR: InputMaybe<Array<ErrandTypeCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeCreatedByFilters = {
  OR: InputMaybe<Array<ErrandTypeCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeDeletedFilters = {
  OR: InputMaybe<Array<ErrandTypeDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeDescriptionFilters = {
  OR: InputMaybe<Array<ErrandTypeDescriptionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeDescriptionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeFilters = {
  OR: InputMaybe<Array<ErrandTypeFiltersOr>>;
  active: InputMaybe<ErrandTypeActiveFilters>;
  createdAt: InputMaybe<ErrandTypeCreatedAtFilters>;
  createdBy: InputMaybe<ErrandTypeCreatedByFilters>;
  deleted: InputMaybe<ErrandTypeDeletedFilters>;
  description: InputMaybe<ErrandTypeDescriptionFilters>;
  id: InputMaybe<ErrandTypeIdFilters>;
  name: InputMaybe<ErrandTypeNameFilters>;
  organizationId: InputMaybe<ErrandTypeOrganizationIdFilters>;
  relativeToVisit: InputMaybe<ErrandTypeRelativeToVisitFilters>;
  updatedAt: InputMaybe<ErrandTypeUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandTypeUpdatedByFilters>;
};

export type ErrandTypeFiltersOr = {
  active: InputMaybe<ErrandTypeActiveFilters>;
  createdAt: InputMaybe<ErrandTypeCreatedAtFilters>;
  createdBy: InputMaybe<ErrandTypeCreatedByFilters>;
  deleted: InputMaybe<ErrandTypeDeletedFilters>;
  description: InputMaybe<ErrandTypeDescriptionFilters>;
  id: InputMaybe<ErrandTypeIdFilters>;
  name: InputMaybe<ErrandTypeNameFilters>;
  organizationId: InputMaybe<ErrandTypeOrganizationIdFilters>;
  relativeToVisit: InputMaybe<ErrandTypeRelativeToVisitFilters>;
  updatedAt: InputMaybe<ErrandTypeUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandTypeUpdatedByFilters>;
};

export type ErrandTypeIdFilters = {
  OR: InputMaybe<Array<ErrandTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeNameFilters = {
  OR: InputMaybe<Array<ErrandTypeNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeOrderBy = {
  active: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  description: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  relativeToVisit: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ErrandTypeOrganizationIdFilters = {
  OR: InputMaybe<Array<ErrandTypeOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum ErrandTypeRelativeToVisitEnum {
  After = 'after',
  Before = 'before'
}

export type ErrandTypeRelativeToVisitFilters = {
  OR: InputMaybe<Array<ErrandTypeRelativeToVisitfiltersOr>>;
  eq: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  gt: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  gte: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ErrandTypeRelativeToVisitEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  lte: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  ne: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ErrandTypeRelativeToVisitEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRelativeToVisitfiltersOr = {
  eq: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  gt: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  gte: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ErrandTypeRelativeToVisitEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  lte: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  ne: InputMaybe<ErrandTypeRelativeToVisitEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ErrandTypeRelativeToVisitEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ErrandTypeRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ErrandTypeRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryFilters = {
  OR: InputMaybe<Array<ErrandTypeRevisionHistoryFiltersOr>>;
  action: InputMaybe<ErrandTypeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ErrandTypeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ErrandTypeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ErrandTypeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ErrandTypeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ErrandTypeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandTypeRevisionHistoryUpdatedByFilters>;
};

export type ErrandTypeRevisionHistoryFiltersOr = {
  action: InputMaybe<ErrandTypeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ErrandTypeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ErrandTypeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ErrandTypeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ErrandTypeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ErrandTypeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandTypeRevisionHistoryUpdatedByFilters>;
};

export type ErrandTypeRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ErrandTypeRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ErrandTypeRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ErrandTypeRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ErrandTypeRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ErrandTypeRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ErrandTypeRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineCreatedAtFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineCreatedByFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineDeletedFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineErrandTypeIdFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineErrandTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineErrandTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineFiltersOr>>;
  createdAt: InputMaybe<ErrandTypeServiceLineCreatedAtFilters>;
  createdBy: InputMaybe<ErrandTypeServiceLineCreatedByFilters>;
  deleted: InputMaybe<ErrandTypeServiceLineDeletedFilters>;
  errandTypeId: InputMaybe<ErrandTypeServiceLineErrandTypeIdFilters>;
  id: InputMaybe<ErrandTypeServiceLineIdFilters>;
  organizationId: InputMaybe<ErrandTypeServiceLineOrganizationIdFilters>;
  serviceLineId: InputMaybe<ErrandTypeServiceLineServiceLineIdFilters>;
  updatedAt: InputMaybe<ErrandTypeServiceLineUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandTypeServiceLineUpdatedByFilters>;
};

export type ErrandTypeServiceLineFiltersOr = {
  createdAt: InputMaybe<ErrandTypeServiceLineCreatedAtFilters>;
  createdBy: InputMaybe<ErrandTypeServiceLineCreatedByFilters>;
  deleted: InputMaybe<ErrandTypeServiceLineDeletedFilters>;
  errandTypeId: InputMaybe<ErrandTypeServiceLineErrandTypeIdFilters>;
  id: InputMaybe<ErrandTypeServiceLineIdFilters>;
  organizationId: InputMaybe<ErrandTypeServiceLineOrganizationIdFilters>;
  serviceLineId: InputMaybe<ErrandTypeServiceLineServiceLineIdFilters>;
  updatedAt: InputMaybe<ErrandTypeServiceLineUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandTypeServiceLineUpdatedByFilters>;
};

export type ErrandTypeServiceLineIdFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  errandTypeId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  serviceLineId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ErrandTypeServiceLineOrganizationIdFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineRevisionHistoryFiltersOr>>;
  action: InputMaybe<ErrandTypeServiceLineRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ErrandTypeServiceLineRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ErrandTypeServiceLineRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ErrandTypeServiceLineRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ErrandTypeServiceLineRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ErrandTypeServiceLineRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandTypeServiceLineRevisionHistoryUpdatedByFilters>;
};

export type ErrandTypeServiceLineRevisionHistoryFiltersOr = {
  action: InputMaybe<ErrandTypeServiceLineRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ErrandTypeServiceLineRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ErrandTypeServiceLineRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ErrandTypeServiceLineRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ErrandTypeServiceLineRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ErrandTypeServiceLineRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ErrandTypeServiceLineRevisionHistoryUpdatedByFilters>;
};

export type ErrandTypeServiceLineRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ErrandTypeServiceLineRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineServiceLineIdFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineUpdatedAtFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineUpdatedByFilters = {
  OR: InputMaybe<Array<ErrandTypeServiceLineUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeServiceLineUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeUpdatedAtFilters = {
  OR: InputMaybe<Array<ErrandTypeUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeUpdatedByFilters = {
  OR: InputMaybe<Array<ErrandTypeUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ErrandTypeUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryCreatedAtFilters = {
  OR: InputMaybe<Array<FhirQueryCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryCreatedByFilters = {
  OR: InputMaybe<Array<FhirQueryCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryDeletedFilters = {
  OR: InputMaybe<Array<FhirQueryDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryErrorDetailsFilters = {
  OR: InputMaybe<Array<FhirQueryErrorDetailsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryErrorDetailsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryFilters = {
  OR: InputMaybe<Array<FhirQueryFiltersOr>>;
  createdAt: InputMaybe<FhirQueryCreatedAtFilters>;
  createdBy: InputMaybe<FhirQueryCreatedByFilters>;
  deleted: InputMaybe<FhirQueryDeletedFilters>;
  errorDetails: InputMaybe<FhirQueryErrorDetailsFilters>;
  id: InputMaybe<FhirQueryIdFilters>;
  organizationId: InputMaybe<FhirQueryOrganizationIdFilters>;
  patientId: InputMaybe<FhirQueryPatientIdFilters>;
  queryText: InputMaybe<FhirQueryQueryTextFilters>;
  rawResponse: InputMaybe<FhirQueryRawResponseFilters>;
  sourceSystem: InputMaybe<FhirQuerySourceSystemFilters>;
  success: InputMaybe<FhirQuerySuccessFilters>;
  updatedAt: InputMaybe<FhirQueryUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirQueryUpdatedByFilters>;
};

export type FhirQueryFiltersOr = {
  createdAt: InputMaybe<FhirQueryCreatedAtFilters>;
  createdBy: InputMaybe<FhirQueryCreatedByFilters>;
  deleted: InputMaybe<FhirQueryDeletedFilters>;
  errorDetails: InputMaybe<FhirQueryErrorDetailsFilters>;
  id: InputMaybe<FhirQueryIdFilters>;
  organizationId: InputMaybe<FhirQueryOrganizationIdFilters>;
  patientId: InputMaybe<FhirQueryPatientIdFilters>;
  queryText: InputMaybe<FhirQueryQueryTextFilters>;
  rawResponse: InputMaybe<FhirQueryRawResponseFilters>;
  sourceSystem: InputMaybe<FhirQuerySourceSystemFilters>;
  success: InputMaybe<FhirQuerySuccessFilters>;
  updatedAt: InputMaybe<FhirQueryUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirQueryUpdatedByFilters>;
};

export type FhirQueryIdFilters = {
  OR: InputMaybe<Array<FhirQueryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  errorDetails: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  patientId: InputMaybe<InnerOrder>;
  queryText: InputMaybe<InnerOrder>;
  rawResponse: InputMaybe<InnerOrder>;
  sourceSystem: InputMaybe<InnerOrder>;
  success: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type FhirQueryOrganizationIdFilters = {
  OR: InputMaybe<Array<FhirQueryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryPatientIdFilters = {
  OR: InputMaybe<Array<FhirQueryPatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryPatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryQueryTextFilters = {
  OR: InputMaybe<Array<FhirQueryQueryTextfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryQueryTextfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryRawResponseFilters = {
  OR: InputMaybe<Array<FhirQueryRawResponsefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryRawResponsefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQuerySourceSystemFilters = {
  OR: InputMaybe<Array<FhirQuerySourceSystemfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQuerySourceSystemfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQuerySuccessFilters = {
  OR: InputMaybe<Array<FhirQuerySuccessfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQuerySuccessfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryUpdatedAtFilters = {
  OR: InputMaybe<Array<FhirQueryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryUpdatedByFilters = {
  OR: InputMaybe<Array<FhirQueryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirQueryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceCreatedAtFilters = {
  OR: InputMaybe<Array<FhirResourceCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceCreatedByFilters = {
  OR: InputMaybe<Array<FhirResourceCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceDeletedFilters = {
  OR: InputMaybe<Array<FhirResourceDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceFhirQueryIdFilters = {
  OR: InputMaybe<Array<FhirResourceFhirQueryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceFhirQueryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceFilters = {
  OR: InputMaybe<Array<FhirResourceFiltersOr>>;
  createdAt: InputMaybe<FhirResourceCreatedAtFilters>;
  createdBy: InputMaybe<FhirResourceCreatedByFilters>;
  deleted: InputMaybe<FhirResourceDeletedFilters>;
  fhirQueryId: InputMaybe<FhirResourceFhirQueryIdFilters>;
  id: InputMaybe<FhirResourceIdFilters>;
  organizationId: InputMaybe<FhirResourceOrganizationIdFilters>;
  resourceData: InputMaybe<FhirResourceResourceDataFilters>;
  resourceHash: InputMaybe<FhirResourceResourceHashFilters>;
  resourceId: InputMaybe<FhirResourceResourceIdFilters>;
  resourceType: InputMaybe<FhirResourceResourceTypeFilters>;
  sourceSystem: InputMaybe<FhirResourceSourceSystemFilters>;
  updatedAt: InputMaybe<FhirResourceUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirResourceUpdatedByFilters>;
};

export type FhirResourceFiltersOr = {
  createdAt: InputMaybe<FhirResourceCreatedAtFilters>;
  createdBy: InputMaybe<FhirResourceCreatedByFilters>;
  deleted: InputMaybe<FhirResourceDeletedFilters>;
  fhirQueryId: InputMaybe<FhirResourceFhirQueryIdFilters>;
  id: InputMaybe<FhirResourceIdFilters>;
  organizationId: InputMaybe<FhirResourceOrganizationIdFilters>;
  resourceData: InputMaybe<FhirResourceResourceDataFilters>;
  resourceHash: InputMaybe<FhirResourceResourceHashFilters>;
  resourceId: InputMaybe<FhirResourceResourceIdFilters>;
  resourceType: InputMaybe<FhirResourceResourceTypeFilters>;
  sourceSystem: InputMaybe<FhirResourceSourceSystemFilters>;
  updatedAt: InputMaybe<FhirResourceUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirResourceUpdatedByFilters>;
};

export type FhirResourceIdFilters = {
  OR: InputMaybe<Array<FhirResourceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexAncestorFhirIdsFilters = {
  OR: InputMaybe<Array<FhirResourceIndexAncestorFhirIdsfiltersOr>>;
  eq: InputMaybe<Array<Scalars['String']['input']>>;
  gt: InputMaybe<Array<Scalars['String']['input']>>;
  gte: InputMaybe<Array<Scalars['String']['input']>>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Array<Scalars['String']['input']>>;
  lte: InputMaybe<Array<Scalars['String']['input']>>;
  ne: InputMaybe<Array<Scalars['String']['input']>>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexAncestorFhirIdsfiltersOr = {
  eq: InputMaybe<Array<Scalars['String']['input']>>;
  gt: InputMaybe<Array<Scalars['String']['input']>>;
  gte: InputMaybe<Array<Scalars['String']['input']>>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Array<Scalars['String']['input']>>;
  lte: InputMaybe<Array<Scalars['String']['input']>>;
  ne: InputMaybe<Array<Scalars['String']['input']>>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexCreatedAtFilters = {
  OR: InputMaybe<Array<FhirResourceIndexCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexCreatedByFilters = {
  OR: InputMaybe<Array<FhirResourceIndexCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexDeletedFilters = {
  OR: InputMaybe<Array<FhirResourceIndexDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexDisplayTextFilters = {
  OR: InputMaybe<Array<FhirResourceIndexDisplayTextfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexDisplayTextfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexFhirIdFilters = {
  OR: InputMaybe<Array<FhirResourceIndexFhirIdfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexFhirIdfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexFhirResourceFilters = {
  OR: InputMaybe<Array<FhirResourceIndexFhirResourcefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexFhirResourcefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexFilters = {
  OR: InputMaybe<Array<FhirResourceIndexFiltersOr>>;
  ancestorFhirIds: InputMaybe<FhirResourceIndexAncestorFhirIdsFilters>;
  createdAt: InputMaybe<FhirResourceIndexCreatedAtFilters>;
  createdBy: InputMaybe<FhirResourceIndexCreatedByFilters>;
  deleted: InputMaybe<FhirResourceIndexDeletedFilters>;
  displayText: InputMaybe<FhirResourceIndexDisplayTextFilters>;
  fhirId: InputMaybe<FhirResourceIndexFhirIdFilters>;
  fhirResource: InputMaybe<FhirResourceIndexFhirResourceFilters>;
  id: InputMaybe<FhirResourceIndexIdFilters>;
  organizationId: InputMaybe<FhirResourceIndexOrganizationIdFilters>;
  resourceType: InputMaybe<FhirResourceIndexResourceTypeFilters>;
  updatedAt: InputMaybe<FhirResourceIndexUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirResourceIndexUpdatedByFilters>;
};

export type FhirResourceIndexFiltersOr = {
  ancestorFhirIds: InputMaybe<FhirResourceIndexAncestorFhirIdsFilters>;
  createdAt: InputMaybe<FhirResourceIndexCreatedAtFilters>;
  createdBy: InputMaybe<FhirResourceIndexCreatedByFilters>;
  deleted: InputMaybe<FhirResourceIndexDeletedFilters>;
  displayText: InputMaybe<FhirResourceIndexDisplayTextFilters>;
  fhirId: InputMaybe<FhirResourceIndexFhirIdFilters>;
  fhirResource: InputMaybe<FhirResourceIndexFhirResourceFilters>;
  id: InputMaybe<FhirResourceIndexIdFilters>;
  organizationId: InputMaybe<FhirResourceIndexOrganizationIdFilters>;
  resourceType: InputMaybe<FhirResourceIndexResourceTypeFilters>;
  updatedAt: InputMaybe<FhirResourceIndexUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirResourceIndexUpdatedByFilters>;
};

export type FhirResourceIndexIdFilters = {
  OR: InputMaybe<Array<FhirResourceIndexIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexOrderBy = {
  ancestorFhirIds: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  displayText: InputMaybe<InnerOrder>;
  fhirId: InputMaybe<InnerOrder>;
  fhirResource: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  resourceType: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type FhirResourceIndexOrganizationIdFilters = {
  OR: InputMaybe<Array<FhirResourceIndexOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexResourceTypeFilters = {
  OR: InputMaybe<Array<FhirResourceIndexResourceTypefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexResourceTypefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexUpdatedAtFilters = {
  OR: InputMaybe<Array<FhirResourceIndexUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexUpdatedByFilters = {
  OR: InputMaybe<Array<FhirResourceIndexUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceIndexUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  fhirQueryId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  resourceData: InputMaybe<InnerOrder>;
  resourceHash: InputMaybe<InnerOrder>;
  resourceId: InputMaybe<InnerOrder>;
  resourceType: InputMaybe<InnerOrder>;
  sourceSystem: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type FhirResourceOrganizationIdFilters = {
  OR: InputMaybe<Array<FhirResourceOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceResourceDataFilters = {
  OR: InputMaybe<Array<FhirResourceResourceDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceResourceDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceResourceHashFilters = {
  OR: InputMaybe<Array<FhirResourceResourceHashfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceResourceHashfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceResourceIdFilters = {
  OR: InputMaybe<Array<FhirResourceResourceIdfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceResourceIdfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceResourceTypeFilters = {
  OR: InputMaybe<Array<FhirResourceResourceTypefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceResourceTypefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<FhirResourceRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<FhirResourceRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryFilters = {
  OR: InputMaybe<Array<FhirResourceRevisionHistoryFiltersOr>>;
  action: InputMaybe<FhirResourceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<FhirResourceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<FhirResourceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<FhirResourceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<FhirResourceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<FhirResourceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirResourceRevisionHistoryUpdatedByFilters>;
};

export type FhirResourceRevisionHistoryFiltersOr = {
  action: InputMaybe<FhirResourceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<FhirResourceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<FhirResourceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<FhirResourceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<FhirResourceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<FhirResourceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirResourceRevisionHistoryUpdatedByFilters>;
};

export type FhirResourceRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<FhirResourceRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type FhirResourceRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<FhirResourceRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<FhirResourceRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<FhirResourceRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<FhirResourceRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceSourceSystemFilters = {
  OR: InputMaybe<Array<FhirResourceSourceSystemfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceSourceSystemfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceUpdatedAtFilters = {
  OR: InputMaybe<Array<FhirResourceUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceUpdatedByFilters = {
  OR: InputMaybe<Array<FhirResourceUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirResourceUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerActiveFilters = {
  OR: InputMaybe<Array<FhirServerActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerCreatedAtFilters = {
  OR: InputMaybe<Array<FhirServerCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerCreatedByFilters = {
  OR: InputMaybe<Array<FhirServerCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerDeletedFilters = {
  OR: InputMaybe<Array<FhirServerDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum FhirServerFhirProviderEnum {
  DevSmartDemoLauncher = 'DEV_smart_demo_launcher',
  Epic = 'Epic'
}

export type FhirServerFhirProviderFilters = {
  OR: InputMaybe<Array<FhirServerFhirProviderfiltersOr>>;
  eq: InputMaybe<FhirServerFhirProviderEnum>;
  gt: InputMaybe<FhirServerFhirProviderEnum>;
  gte: InputMaybe<FhirServerFhirProviderEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<FhirServerFhirProviderEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<FhirServerFhirProviderEnum>;
  lte: InputMaybe<FhirServerFhirProviderEnum>;
  ne: InputMaybe<FhirServerFhirProviderEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<FhirServerFhirProviderEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerFhirProviderfiltersOr = {
  eq: InputMaybe<FhirServerFhirProviderEnum>;
  gt: InputMaybe<FhirServerFhirProviderEnum>;
  gte: InputMaybe<FhirServerFhirProviderEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<FhirServerFhirProviderEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<FhirServerFhirProviderEnum>;
  lte: InputMaybe<FhirServerFhirProviderEnum>;
  ne: InputMaybe<FhirServerFhirProviderEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<FhirServerFhirProviderEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerFilters = {
  OR: InputMaybe<Array<FhirServerFiltersOr>>;
  active: InputMaybe<FhirServerActiveFilters>;
  createdAt: InputMaybe<FhirServerCreatedAtFilters>;
  createdBy: InputMaybe<FhirServerCreatedByFilters>;
  deleted: InputMaybe<FhirServerDeletedFilters>;
  fhirProvider: InputMaybe<FhirServerFhirProviderFilters>;
  hl7Folder: InputMaybe<FhirServerHl7FolderFilters>;
  id: InputMaybe<FhirServerIdFilters>;
  organizationId: InputMaybe<FhirServerOrganizationIdFilters>;
  updatedAt: InputMaybe<FhirServerUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirServerUpdatedByFilters>;
  url: InputMaybe<FhirServerUrlFilters>;
  useForLogin: InputMaybe<FhirServerUseForLoginFilters>;
};

export type FhirServerFiltersOr = {
  active: InputMaybe<FhirServerActiveFilters>;
  createdAt: InputMaybe<FhirServerCreatedAtFilters>;
  createdBy: InputMaybe<FhirServerCreatedByFilters>;
  deleted: InputMaybe<FhirServerDeletedFilters>;
  fhirProvider: InputMaybe<FhirServerFhirProviderFilters>;
  hl7Folder: InputMaybe<FhirServerHl7FolderFilters>;
  id: InputMaybe<FhirServerIdFilters>;
  organizationId: InputMaybe<FhirServerOrganizationIdFilters>;
  updatedAt: InputMaybe<FhirServerUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirServerUpdatedByFilters>;
  url: InputMaybe<FhirServerUrlFilters>;
  useForLogin: InputMaybe<FhirServerUseForLoginFilters>;
};

export type FhirServerHl7FolderFilters = {
  OR: InputMaybe<Array<FhirServerHl7FolderfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerHl7FolderfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerIdFilters = {
  OR: InputMaybe<Array<FhirServerIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerOrderBy = {
  active: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  fhirProvider: InputMaybe<InnerOrder>;
  hl7Folder: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  url: InputMaybe<InnerOrder>;
  useForLogin: InputMaybe<InnerOrder>;
};

export type FhirServerOrganizationIdFilters = {
  OR: InputMaybe<Array<FhirServerOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<FhirServerRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<FhirServerRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryFilters = {
  OR: InputMaybe<Array<FhirServerRevisionHistoryFiltersOr>>;
  action: InputMaybe<FhirServerRevisionHistoryActionFilters>;
  changedFields: InputMaybe<FhirServerRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<FhirServerRevisionHistoryIdFilters>;
  organizationId: InputMaybe<FhirServerRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<FhirServerRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<FhirServerRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirServerRevisionHistoryUpdatedByFilters>;
};

export type FhirServerRevisionHistoryFiltersOr = {
  action: InputMaybe<FhirServerRevisionHistoryActionFilters>;
  changedFields: InputMaybe<FhirServerRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<FhirServerRevisionHistoryIdFilters>;
  organizationId: InputMaybe<FhirServerRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<FhirServerRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<FhirServerRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<FhirServerRevisionHistoryUpdatedByFilters>;
};

export type FhirServerRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<FhirServerRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type FhirServerRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<FhirServerRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<FhirServerRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<FhirServerRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<FhirServerRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerUpdatedAtFilters = {
  OR: InputMaybe<Array<FhirServerUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerUpdatedByFilters = {
  OR: InputMaybe<Array<FhirServerUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerUrlFilters = {
  OR: InputMaybe<Array<FhirServerUrlfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerUrlfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerUseForLoginFilters = {
  OR: InputMaybe<Array<FhirServerUseForLoginfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type FhirServerUseForLoginfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type HoursOfDayQueryInput = {
  endHour: Scalars['Int']['input'];
  startHour: Scalars['Int']['input'];
};

export type InnerOrder = {
  direction: OrderDirection;
  priority: Scalars['Int']['input'];
};

export type KpiQueryInputArgs = {
  endTime: Scalars['String']['input'];
  providerId: InputMaybe<Scalars['Int']['input']>;
  serviceLineId: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['String']['input'];
};

export type LocationAccuracyFilters = {
  OR: InputMaybe<Array<LocationAccuracyfiltersOr>>;
  eq: InputMaybe<Scalars['Float']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationAccuracyfiltersOr = {
  eq: InputMaybe<Scalars['Float']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum LocationActivityEnum {
  InVehicle = 'in_vehicle',
  OnBicycle = 'on_bicycle',
  OnFoot = 'on_foot',
  Running = 'running',
  Still = 'still',
  Unknown = 'unknown',
  Walking = 'walking'
}

export type LocationActivityFilters = {
  OR: InputMaybe<Array<LocationActivityfiltersOr>>;
  eq: InputMaybe<LocationActivityEnum>;
  gt: InputMaybe<LocationActivityEnum>;
  gte: InputMaybe<LocationActivityEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<LocationActivityEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<LocationActivityEnum>;
  lte: InputMaybe<LocationActivityEnum>;
  ne: InputMaybe<LocationActivityEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<LocationActivityEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationActivityfiltersOr = {
  eq: InputMaybe<LocationActivityEnum>;
  gt: InputMaybe<LocationActivityEnum>;
  gte: InputMaybe<LocationActivityEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<LocationActivityEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<LocationActivityEnum>;
  lte: InputMaybe<LocationActivityEnum>;
  ne: InputMaybe<LocationActivityEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<LocationActivityEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationCreatedAtFilters = {
  OR: InputMaybe<Array<LocationCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationCreatedByFilters = {
  OR: InputMaybe<Array<LocationCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationDeletedFilters = {
  OR: InputMaybe<Array<LocationDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationFilters = {
  OR: InputMaybe<Array<LocationFiltersOr>>;
  accuracy: InputMaybe<LocationAccuracyFilters>;
  activity: InputMaybe<LocationActivityFilters>;
  createdAt: InputMaybe<LocationCreatedAtFilters>;
  createdBy: InputMaybe<LocationCreatedByFilters>;
  deleted: InputMaybe<LocationDeletedFilters>;
  id: InputMaybe<LocationIdFilters>;
  isMoving: InputMaybe<LocationIsMovingFilters>;
  latitude: InputMaybe<LocationLatitudeFilters>;
  longitude: InputMaybe<LocationLongitudeFilters>;
  mock: InputMaybe<LocationMockFilters>;
  organizationId: InputMaybe<LocationOrganizationIdFilters>;
  providerId: InputMaybe<LocationProviderIdFilters>;
  speed: InputMaybe<LocationSpeedFilters>;
  timestamp: InputMaybe<LocationTimestampFilters>;
  updatedAt: InputMaybe<LocationUpdatedAtFilters>;
  updatedBy: InputMaybe<LocationUpdatedByFilters>;
};

export type LocationFiltersOr = {
  accuracy: InputMaybe<LocationAccuracyFilters>;
  activity: InputMaybe<LocationActivityFilters>;
  createdAt: InputMaybe<LocationCreatedAtFilters>;
  createdBy: InputMaybe<LocationCreatedByFilters>;
  deleted: InputMaybe<LocationDeletedFilters>;
  id: InputMaybe<LocationIdFilters>;
  isMoving: InputMaybe<LocationIsMovingFilters>;
  latitude: InputMaybe<LocationLatitudeFilters>;
  longitude: InputMaybe<LocationLongitudeFilters>;
  mock: InputMaybe<LocationMockFilters>;
  organizationId: InputMaybe<LocationOrganizationIdFilters>;
  providerId: InputMaybe<LocationProviderIdFilters>;
  speed: InputMaybe<LocationSpeedFilters>;
  timestamp: InputMaybe<LocationTimestampFilters>;
  updatedAt: InputMaybe<LocationUpdatedAtFilters>;
  updatedBy: InputMaybe<LocationUpdatedByFilters>;
};

export type LocationIdFilters = {
  OR: InputMaybe<Array<LocationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationIsMovingFilters = {
  OR: InputMaybe<Array<LocationIsMovingfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationIsMovingfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationLatitudeFilters = {
  OR: InputMaybe<Array<LocationLatitudefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationLatitudefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationLongitudeFilters = {
  OR: InputMaybe<Array<LocationLongitudefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationLongitudefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationMockFilters = {
  OR: InputMaybe<Array<LocationMockfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationMockfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationOrderBy = {
  accuracy: InputMaybe<InnerOrder>;
  activity: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  isMoving: InputMaybe<InnerOrder>;
  latitude: InputMaybe<InnerOrder>;
  longitude: InputMaybe<InnerOrder>;
  mock: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  speed: InputMaybe<InnerOrder>;
  timestamp: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type LocationOrganizationIdFilters = {
  OR: InputMaybe<Array<LocationOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationProviderIdFilters = {
  OR: InputMaybe<Array<LocationProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationSpeedFilters = {
  OR: InputMaybe<Array<LocationSpeedfiltersOr>>;
  eq: InputMaybe<Scalars['Float']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationSpeedfiltersOr = {
  eq: InputMaybe<Scalars['Float']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationTimestampFilters = {
  OR: InputMaybe<Array<LocationTimestampfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationTimestampfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationUpdatedAtFilters = {
  OR: InputMaybe<Array<LocationUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationUpdatedByFilters = {
  OR: InputMaybe<Array<LocationUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type LocationUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ManagePatientIdentifier = {
  identifier: Scalars['String']['input'];
  identifier_type: Scalars['String']['input'];
};

export enum MobileUnlockMethodEnum {
  Device = 'device',
  Pin = 'pin'
}

export type NewOverrideVisitResourceInput = {
  duration: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  providerId: Scalars['Int']['input'];
  resourceRequirementId: InputMaybe<Scalars['Int']['input']>;
  shiftId: InputMaybe<Scalars['Int']['input']>;
};

export type NewVisitResourceInput = {
  providerId: Scalars['Int']['input'];
  raceConditionHash: Scalars['String']['input'];
  shiftId: Scalars['Int']['input'];
};

export enum OptimizerFriction {
  AlreadyFiltered = 'already_filtered',
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  None = 'none'
}

export type OptimizerLogCreatedAtFilters = {
  OR: InputMaybe<Array<OptimizerLogCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogCreatedByFilters = {
  OR: InputMaybe<Array<OptimizerLogCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogDeletedFilters = {
  OR: InputMaybe<Array<OptimizerLogDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogFilters = {
  OR: InputMaybe<Array<OptimizerLogFiltersOr>>;
  createdAt: InputMaybe<OptimizerLogCreatedAtFilters>;
  createdBy: InputMaybe<OptimizerLogCreatedByFilters>;
  deleted: InputMaybe<OptimizerLogDeletedFilters>;
  id: InputMaybe<OptimizerLogIdFilters>;
  logData: InputMaybe<OptimizerLogLogDataFilters>;
  organizationId: InputMaybe<OptimizerLogOrganizationIdFilters>;
  updatedAt: InputMaybe<OptimizerLogUpdatedAtFilters>;
  updatedBy: InputMaybe<OptimizerLogUpdatedByFilters>;
};

export type OptimizerLogFiltersOr = {
  createdAt: InputMaybe<OptimizerLogCreatedAtFilters>;
  createdBy: InputMaybe<OptimizerLogCreatedByFilters>;
  deleted: InputMaybe<OptimizerLogDeletedFilters>;
  id: InputMaybe<OptimizerLogIdFilters>;
  logData: InputMaybe<OptimizerLogLogDataFilters>;
  organizationId: InputMaybe<OptimizerLogOrganizationIdFilters>;
  updatedAt: InputMaybe<OptimizerLogUpdatedAtFilters>;
  updatedBy: InputMaybe<OptimizerLogUpdatedByFilters>;
};

export type OptimizerLogIdFilters = {
  OR: InputMaybe<Array<OptimizerLogIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogLogDataFilters = {
  OR: InputMaybe<Array<OptimizerLogLogDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogLogDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  logData: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OptimizerLogOrganizationIdFilters = {
  OR: InputMaybe<Array<OptimizerLogOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogUpdatedAtFilters = {
  OR: InputMaybe<Array<OptimizerLogUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogUpdatedByFilters = {
  OR: InputMaybe<Array<OptimizerLogUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OptimizerLogUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrganizationCreatedAtFilters = {
  OR: InputMaybe<Array<OrganizationCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreatedByFilters = {
  OR: InputMaybe<Array<OrganizationCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationDeletedFilters = {
  OR: InputMaybe<Array<OrganizationDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationFilters = {
  OR: InputMaybe<Array<OrganizationFiltersOr>>;
  createdAt: InputMaybe<OrganizationCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationCreatedByFilters>;
  deleted: InputMaybe<OrganizationDeletedFilters>;
  name: InputMaybe<OrganizationNameFilters>;
  organizationId: InputMaybe<OrganizationOrganizationIdFilters>;
  settings: InputMaybe<OrganizationSettingsFilters>;
  updatedAt: InputMaybe<OrganizationUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUpdatedByFilters>;
};

export type OrganizationFiltersOr = {
  createdAt: InputMaybe<OrganizationCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationCreatedByFilters>;
  deleted: InputMaybe<OrganizationDeletedFilters>;
  name: InputMaybe<OrganizationNameFilters>;
  organizationId: InputMaybe<OrganizationOrganizationIdFilters>;
  settings: InputMaybe<OrganizationSettingsFilters>;
  updatedAt: InputMaybe<OrganizationUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUpdatedByFilters>;
};

export type OrganizationNameFilters = {
  OR: InputMaybe<Array<OrganizationNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  settings: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<OrganizationRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<OrganizationRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryFilters = {
  OR: InputMaybe<Array<OrganizationRevisionHistoryFiltersOr>>;
  action: InputMaybe<OrganizationRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationRevisionHistoryChangedFieldsFilters>;
  organizationId: InputMaybe<OrganizationRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationRevisionHistoryUpdatedByFilters>;
};

export type OrganizationRevisionHistoryFiltersOr = {
  action: InputMaybe<OrganizationRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationRevisionHistoryChangedFieldsFilters>;
  organizationId: InputMaybe<OrganizationRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationRevisionHistoryUpdatedByFilters>;
};

export type OrganizationRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<OrganizationRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSettingsFilters = {
  OR: InputMaybe<Array<OrganizationSettingsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationSettingsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserCreatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUserCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserCreatedByFilters = {
  OR: InputMaybe<Array<OrganizationUserCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserDeletedFilters = {
  OR: InputMaybe<Array<OrganizationUserDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventCreatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUserEventCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventCreatedByFilters = {
  OR: InputMaybe<Array<OrganizationUserEventCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventDeletedFilters = {
  OR: InputMaybe<Array<OrganizationUserEventDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationUserEventEventTypeEnum {
  ClockIn = 'clock_in',
  ClockOut = 'clock_out'
}

export type OrganizationUserEventEventTypeFilters = {
  OR: InputMaybe<Array<OrganizationUserEventEventTypefiltersOr>>;
  eq: InputMaybe<OrganizationUserEventEventTypeEnum>;
  gt: InputMaybe<OrganizationUserEventEventTypeEnum>;
  gte: InputMaybe<OrganizationUserEventEventTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<OrganizationUserEventEventTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<OrganizationUserEventEventTypeEnum>;
  lte: InputMaybe<OrganizationUserEventEventTypeEnum>;
  ne: InputMaybe<OrganizationUserEventEventTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<OrganizationUserEventEventTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventEventTypefiltersOr = {
  eq: InputMaybe<OrganizationUserEventEventTypeEnum>;
  gt: InputMaybe<OrganizationUserEventEventTypeEnum>;
  gte: InputMaybe<OrganizationUserEventEventTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<OrganizationUserEventEventTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<OrganizationUserEventEventTypeEnum>;
  lte: InputMaybe<OrganizationUserEventEventTypeEnum>;
  ne: InputMaybe<OrganizationUserEventEventTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<OrganizationUserEventEventTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventFilters = {
  OR: InputMaybe<Array<OrganizationUserEventFiltersOr>>;
  createdAt: InputMaybe<OrganizationUserEventCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationUserEventCreatedByFilters>;
  deleted: InputMaybe<OrganizationUserEventDeletedFilters>;
  eventType: InputMaybe<OrganizationUserEventEventTypeFilters>;
  id: InputMaybe<OrganizationUserEventIdFilters>;
  metadata: InputMaybe<OrganizationUserEventMetadataFilters>;
  organizationId: InputMaybe<OrganizationUserEventOrganizationIdFilters>;
  providerId: InputMaybe<OrganizationUserEventProviderIdFilters>;
  updatedAt: InputMaybe<OrganizationUserEventUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserEventUpdatedByFilters>;
};

export type OrganizationUserEventFiltersOr = {
  createdAt: InputMaybe<OrganizationUserEventCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationUserEventCreatedByFilters>;
  deleted: InputMaybe<OrganizationUserEventDeletedFilters>;
  eventType: InputMaybe<OrganizationUserEventEventTypeFilters>;
  id: InputMaybe<OrganizationUserEventIdFilters>;
  metadata: InputMaybe<OrganizationUserEventMetadataFilters>;
  organizationId: InputMaybe<OrganizationUserEventOrganizationIdFilters>;
  providerId: InputMaybe<OrganizationUserEventProviderIdFilters>;
  updatedAt: InputMaybe<OrganizationUserEventUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserEventUpdatedByFilters>;
};

export type OrganizationUserEventIdFilters = {
  OR: InputMaybe<Array<OrganizationUserEventIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventMetadataFilters = {
  OR: InputMaybe<Array<OrganizationUserEventMetadatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventMetadataInput = {
  geolocationAuthorizationStatus: InputMaybe<Scalars['String']['input']>;
  geolocationPrecision: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventMetadatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  eventType: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  metadata: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationUserEventOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationUserEventOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventProviderIdFilters = {
  OR: InputMaybe<Array<OrganizationUserEventProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUserEventUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationUserEventUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserEventUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserFhirExternalIdFilters = {
  OR: InputMaybe<Array<OrganizationUserFhirExternalIdfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserFhirExternalIdfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserFilters = {
  OR: InputMaybe<Array<OrganizationUserFiltersOr>>;
  createdAt: InputMaybe<OrganizationUserCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationUserCreatedByFilters>;
  deleted: InputMaybe<OrganizationUserDeletedFilters>;
  fhirExternalId: InputMaybe<OrganizationUserFhirExternalIdFilters>;
  id: InputMaybe<OrganizationUserIdFilters>;
  organizationId: InputMaybe<OrganizationUserOrganizationIdFilters>;
  updatedAt: InputMaybe<OrganizationUserUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserUpdatedByFilters>;
  userId: InputMaybe<OrganizationUserUserIdFilters>;
};

export type OrganizationUserFiltersOr = {
  createdAt: InputMaybe<OrganizationUserCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationUserCreatedByFilters>;
  deleted: InputMaybe<OrganizationUserDeletedFilters>;
  fhirExternalId: InputMaybe<OrganizationUserFhirExternalIdFilters>;
  id: InputMaybe<OrganizationUserIdFilters>;
  organizationId: InputMaybe<OrganizationUserOrganizationIdFilters>;
  updatedAt: InputMaybe<OrganizationUserUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserUpdatedByFilters>;
  userId: InputMaybe<OrganizationUserUserIdFilters>;
};

export type OrganizationUserIdFilters = {
  OR: InputMaybe<Array<OrganizationUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  fhirExternalId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  userId: InputMaybe<InnerOrder>;
};

export type OrganizationUserOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationUserOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<OrganizationUserRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<OrganizationUserRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryFilters = {
  OR: InputMaybe<Array<OrganizationUserRevisionHistoryFiltersOr>>;
  action: InputMaybe<OrganizationUserRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationUserRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<OrganizationUserRevisionHistoryIdFilters>;
  organizationId: InputMaybe<OrganizationUserRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationUserRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationUserRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserRevisionHistoryUpdatedByFilters>;
};

export type OrganizationUserRevisionHistoryFiltersOr = {
  action: InputMaybe<OrganizationUserRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationUserRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<OrganizationUserRevisionHistoryIdFilters>;
  organizationId: InputMaybe<OrganizationUserRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationUserRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationUserRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserRevisionHistoryUpdatedByFilters>;
};

export type OrganizationUserRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<OrganizationUserRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationUserRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationUserRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<OrganizationUserRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUserRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationUserRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleCreatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleCreatedByFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleDeletedFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleFiltersOr>>;
  createdAt: InputMaybe<OrganizationUserRoleCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationUserRoleCreatedByFilters>;
  deleted: InputMaybe<OrganizationUserRoleDeletedFilters>;
  globalUserRole: InputMaybe<OrganizationUserRoleGlobalUserRoleFilters>;
  id: InputMaybe<OrganizationUserRoleIdFilters>;
  organizationId: InputMaybe<OrganizationUserRoleOrganizationIdFilters>;
  organizationUserId: InputMaybe<OrganizationUserRoleOrganizationUserIdFilters>;
  updatedAt: InputMaybe<OrganizationUserRoleUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserRoleUpdatedByFilters>;
  userRoleId: InputMaybe<OrganizationUserRoleUserRoleIdFilters>;
};

export type OrganizationUserRoleFiltersOr = {
  createdAt: InputMaybe<OrganizationUserRoleCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationUserRoleCreatedByFilters>;
  deleted: InputMaybe<OrganizationUserRoleDeletedFilters>;
  globalUserRole: InputMaybe<OrganizationUserRoleGlobalUserRoleFilters>;
  id: InputMaybe<OrganizationUserRoleIdFilters>;
  organizationId: InputMaybe<OrganizationUserRoleOrganizationIdFilters>;
  organizationUserId: InputMaybe<OrganizationUserRoleOrganizationUserIdFilters>;
  updatedAt: InputMaybe<OrganizationUserRoleUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserRoleUpdatedByFilters>;
  userRoleId: InputMaybe<OrganizationUserRoleUserRoleIdFilters>;
};

export enum OrganizationUserRoleGlobalUserRoleEnum {
  MedarriveDeveloper = 'medarriveDeveloper',
  SampleDataGenerator = 'sampleDataGenerator',
  SelfScheduleProvider = 'selfScheduleProvider'
}

export type OrganizationUserRoleGlobalUserRoleFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleGlobalUserRolefiltersOr>>;
  eq: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  gt: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  gte: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<OrganizationUserRoleGlobalUserRoleEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  lte: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  ne: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<OrganizationUserRoleGlobalUserRoleEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleGlobalUserRolefiltersOr = {
  eq: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  gt: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  gte: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<OrganizationUserRoleGlobalUserRoleEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  lte: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  ne: InputMaybe<OrganizationUserRoleGlobalUserRoleEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<OrganizationUserRoleGlobalUserRoleEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleIdFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  globalUserRole: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  organizationUserId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  userRoleId: InputMaybe<InnerOrder>;
};

export type OrganizationUserRoleOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleOrganizationUserIdFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleOrganizationUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleOrganizationUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleRevisionHistoryFiltersOr>>;
  action: InputMaybe<OrganizationUserRoleRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationUserRoleRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<OrganizationUserRoleRevisionHistoryIdFilters>;
  organizationId: InputMaybe<OrganizationUserRoleRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationUserRoleRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationUserRoleRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserRoleRevisionHistoryUpdatedByFilters>;
};

export type OrganizationUserRoleRevisionHistoryFiltersOr = {
  action: InputMaybe<OrganizationUserRoleRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationUserRoleRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<OrganizationUserRoleRevisionHistoryIdFilters>;
  organizationId: InputMaybe<OrganizationUserRoleRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationUserRoleRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationUserRoleRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationUserRoleRevisionHistoryUpdatedByFilters>;
};

export type OrganizationUserRoleRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationUserRoleRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleUserRoleIdFilters = {
  OR: InputMaybe<Array<OrganizationUserRoleUserRoleIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserRoleUserRoleIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationUserUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationUserUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserUserIdFilters = {
  OR: InputMaybe<Array<OrganizationUserUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationUserUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitActiveFilters = {
  OR: InputMaybe<Array<OrganizationalUnitActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitCreatedAtFilters = {
  OR: InputMaybe<Array<OrganizationalUnitCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitCreatedByFilters = {
  OR: InputMaybe<Array<OrganizationalUnitCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitDeletedFilters = {
  OR: InputMaybe<Array<OrganizationalUnitDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitFilters = {
  OR: InputMaybe<Array<OrganizationalUnitFiltersOr>>;
  active: InputMaybe<OrganizationalUnitActiveFilters>;
  createdAt: InputMaybe<OrganizationalUnitCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationalUnitCreatedByFilters>;
  deleted: InputMaybe<OrganizationalUnitDeletedFilters>;
  id: InputMaybe<OrganizationalUnitIdFilters>;
  name: InputMaybe<OrganizationalUnitNameFilters>;
  organizationId: InputMaybe<OrganizationalUnitOrganizationIdFilters>;
  updatedAt: InputMaybe<OrganizationalUnitUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationalUnitUpdatedByFilters>;
};

export type OrganizationalUnitFiltersOr = {
  active: InputMaybe<OrganizationalUnitActiveFilters>;
  createdAt: InputMaybe<OrganizationalUnitCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationalUnitCreatedByFilters>;
  deleted: InputMaybe<OrganizationalUnitDeletedFilters>;
  id: InputMaybe<OrganizationalUnitIdFilters>;
  name: InputMaybe<OrganizationalUnitNameFilters>;
  organizationId: InputMaybe<OrganizationalUnitOrganizationIdFilters>;
  updatedAt: InputMaybe<OrganizationalUnitUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationalUnitUpdatedByFilters>;
};

export type OrganizationalUnitIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitNameFilters = {
  OR: InputMaybe<Array<OrganizationalUnitNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrderBy = {
  active: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationalUnitOrgUserCreatedAtFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserCreatedByFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserDeletedFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserFiltersOr>>;
  createdAt: InputMaybe<OrganizationalUnitOrgUserCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationalUnitOrgUserCreatedByFilters>;
  deleted: InputMaybe<OrganizationalUnitOrgUserDeletedFilters>;
  id: InputMaybe<OrganizationalUnitOrgUserIdFilters>;
  organizationId: InputMaybe<OrganizationalUnitOrgUserOrganizationIdFilters>;
  organizationUserId: InputMaybe<OrganizationalUnitOrgUserOrganizationUserIdFilters>;
  organizationalUnitId: InputMaybe<OrganizationalUnitOrgUserOrganizationalUnitIdFilters>;
  updatedAt: InputMaybe<OrganizationalUnitOrgUserUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationalUnitOrgUserUpdatedByFilters>;
};

export type OrganizationalUnitOrgUserFiltersOr = {
  createdAt: InputMaybe<OrganizationalUnitOrgUserCreatedAtFilters>;
  createdBy: InputMaybe<OrganizationalUnitOrgUserCreatedByFilters>;
  deleted: InputMaybe<OrganizationalUnitOrgUserDeletedFilters>;
  id: InputMaybe<OrganizationalUnitOrgUserIdFilters>;
  organizationId: InputMaybe<OrganizationalUnitOrgUserOrganizationIdFilters>;
  organizationUserId: InputMaybe<OrganizationalUnitOrgUserOrganizationUserIdFilters>;
  organizationalUnitId: InputMaybe<OrganizationalUnitOrgUserOrganizationalUnitIdFilters>;
  updatedAt: InputMaybe<OrganizationalUnitOrgUserUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationalUnitOrgUserUpdatedByFilters>;
};

export type OrganizationalUnitOrgUserIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  organizationUserId: InputMaybe<InnerOrder>;
  organizationalUnitId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationalUnitOrgUserOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserOrganizationUserIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserOrganizationUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserOrganizationUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserOrganizationalUnitIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserOrganizationalUnitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserOrganizationalUnitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserRevisionHistoryFiltersOr>>;
  action: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryIdFilters>;
  organizationId: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryUpdatedByFilters>;
};

export type OrganizationalUnitOrgUserRevisionHistoryFiltersOr = {
  action: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryIdFilters>;
  organizationId: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationalUnitOrgUserRevisionHistoryUpdatedByFilters>;
};

export type OrganizationalUnitOrgUserRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationalUnitOrgUserRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrgUserUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrgUserUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<OrganizationalUnitRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<OrganizationalUnitRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryFilters = {
  OR: InputMaybe<Array<OrganizationalUnitRevisionHistoryFiltersOr>>;
  action: InputMaybe<OrganizationalUnitRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationalUnitRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<OrganizationalUnitRevisionHistoryIdFilters>;
  organizationId: InputMaybe<OrganizationalUnitRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationalUnitRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationalUnitRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationalUnitRevisionHistoryUpdatedByFilters>;
};

export type OrganizationalUnitRevisionHistoryFiltersOr = {
  action: InputMaybe<OrganizationalUnitRevisionHistoryActionFilters>;
  changedFields: InputMaybe<OrganizationalUnitRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<OrganizationalUnitRevisionHistoryIdFilters>;
  organizationId: InputMaybe<OrganizationalUnitRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<OrganizationalUnitRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<OrganizationalUnitRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<OrganizationalUnitRevisionHistoryUpdatedByFilters>;
};

export type OrganizationalUnitRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type OrganizationalUnitRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<OrganizationalUnitRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<OrganizationalUnitRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationalUnitRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationalUnitRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitUpdatedAtFilters = {
  OR: InputMaybe<Array<OrganizationalUnitUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitUpdatedByFilters = {
  OR: InputMaybe<Array<OrganizationalUnitUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationalUnitUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressCityFilters = {
  OR: InputMaybe<Array<PatientAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressCoordinatesFilters = {
  OR: InputMaybe<Array<PatientAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressLineTwoFilters = {
  OR: InputMaybe<Array<PatientAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressStateFilters = {
  OR: InputMaybe<Array<PatientAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressStreetFilters = {
  OR: InputMaybe<Array<PatientAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressTimezoneFilters = {
  OR: InputMaybe<Array<PatientAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressZipFilters = {
  OR: InputMaybe<Array<PatientAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamAllowAutomaticUpdatesFilters = {
  OR: InputMaybe<Array<PatientCareTeamAllowAutomaticUpdatesfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamAllowAutomaticUpdatesfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamCreatedAtFilters = {
  OR: InputMaybe<Array<PatientCareTeamCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamCreatedByFilters = {
  OR: InputMaybe<Array<PatientCareTeamCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamDeletedFilters = {
  OR: InputMaybe<Array<PatientCareTeamDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamFilters = {
  OR: InputMaybe<Array<PatientCareTeamFiltersOr>>;
  allowAutomaticUpdates: InputMaybe<PatientCareTeamAllowAutomaticUpdatesFilters>;
  createdAt: InputMaybe<PatientCareTeamCreatedAtFilters>;
  createdBy: InputMaybe<PatientCareTeamCreatedByFilters>;
  deleted: InputMaybe<PatientCareTeamDeletedFilters>;
  id: InputMaybe<PatientCareTeamIdFilters>;
  organizationId: InputMaybe<PatientCareTeamOrganizationIdFilters>;
  patientId: InputMaybe<PatientCareTeamPatientIdFilters>;
  providerId: InputMaybe<PatientCareTeamProviderIdFilters>;
  providerTypeId: InputMaybe<PatientCareTeamProviderTypeIdFilters>;
  updatedAt: InputMaybe<PatientCareTeamUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientCareTeamUpdatedByFilters>;
};

export type PatientCareTeamFiltersOr = {
  allowAutomaticUpdates: InputMaybe<PatientCareTeamAllowAutomaticUpdatesFilters>;
  createdAt: InputMaybe<PatientCareTeamCreatedAtFilters>;
  createdBy: InputMaybe<PatientCareTeamCreatedByFilters>;
  deleted: InputMaybe<PatientCareTeamDeletedFilters>;
  id: InputMaybe<PatientCareTeamIdFilters>;
  organizationId: InputMaybe<PatientCareTeamOrganizationIdFilters>;
  patientId: InputMaybe<PatientCareTeamPatientIdFilters>;
  providerId: InputMaybe<PatientCareTeamProviderIdFilters>;
  providerTypeId: InputMaybe<PatientCareTeamProviderTypeIdFilters>;
  updatedAt: InputMaybe<PatientCareTeamUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientCareTeamUpdatedByFilters>;
};

export type PatientCareTeamIdFilters = {
  OR: InputMaybe<Array<PatientCareTeamIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamOrderBy = {
  allowAutomaticUpdates: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  patientId: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  providerTypeId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type PatientCareTeamOrganizationIdFilters = {
  OR: InputMaybe<Array<PatientCareTeamOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamPatientIdFilters = {
  OR: InputMaybe<Array<PatientCareTeamPatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamPatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamProviderIdFilters = {
  OR: InputMaybe<Array<PatientCareTeamProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamProviderTypeIdFilters = {
  OR: InputMaybe<Array<PatientCareTeamProviderTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamProviderTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<PatientCareTeamRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<PatientCareTeamRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryFilters = {
  OR: InputMaybe<Array<PatientCareTeamRevisionHistoryFiltersOr>>;
  action: InputMaybe<PatientCareTeamRevisionHistoryActionFilters>;
  changedFields: InputMaybe<PatientCareTeamRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<PatientCareTeamRevisionHistoryIdFilters>;
  organizationId: InputMaybe<PatientCareTeamRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<PatientCareTeamRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<PatientCareTeamRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientCareTeamRevisionHistoryUpdatedByFilters>;
};

export type PatientCareTeamRevisionHistoryFiltersOr = {
  action: InputMaybe<PatientCareTeamRevisionHistoryActionFilters>;
  changedFields: InputMaybe<PatientCareTeamRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<PatientCareTeamRevisionHistoryIdFilters>;
  organizationId: InputMaybe<PatientCareTeamRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<PatientCareTeamRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<PatientCareTeamRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientCareTeamRevisionHistoryUpdatedByFilters>;
};

export type PatientCareTeamRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<PatientCareTeamRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type PatientCareTeamRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<PatientCareTeamRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<PatientCareTeamRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<PatientCareTeamRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<PatientCareTeamRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamUpdatedAtFilters = {
  OR: InputMaybe<Array<PatientCareTeamUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamUpdatedByFilters = {
  OR: InputMaybe<Array<PatientCareTeamUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCareTeamUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCreatedAtFilters = {
  OR: InputMaybe<Array<PatientCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCreatedByFilters = {
  OR: InputMaybe<Array<PatientCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientDateOfBirthFilters = {
  OR: InputMaybe<Array<PatientDateOfBirthfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientDateOfBirthfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientDeletedFilters = {
  OR: InputMaybe<Array<PatientDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientFilters = {
  OR: InputMaybe<Array<PatientFiltersOr>>;
  addressCity: InputMaybe<PatientAddressCityFilters>;
  addressCoordinates: InputMaybe<PatientAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<PatientAddressLineTwoFilters>;
  addressState: InputMaybe<PatientAddressStateFilters>;
  addressStreet: InputMaybe<PatientAddressStreetFilters>;
  addressTimezone: InputMaybe<PatientAddressTimezoneFilters>;
  addressZip: InputMaybe<PatientAddressZipFilters>;
  createdAt: InputMaybe<PatientCreatedAtFilters>;
  createdBy: InputMaybe<PatientCreatedByFilters>;
  dateOfBirth: InputMaybe<PatientDateOfBirthFilters>;
  deleted: InputMaybe<PatientDeletedFilters>;
  firstName: InputMaybe<PatientFirstNameFilters>;
  id: InputMaybe<PatientIdFilters>;
  lastName: InputMaybe<PatientLastNameFilters>;
  organizationId: InputMaybe<PatientOrganizationIdFilters>;
  patientNotes: InputMaybe<PatientPatientNotesFilters>;
  phone: InputMaybe<PatientPhoneFilters>;
  preferredLanguage: InputMaybe<PatientPreferredLanguageFilters>;
  serviceInstructions: InputMaybe<PatientServiceInstructionsFilters>;
  sex: InputMaybe<PatientSexFilters>;
  updatedAt: InputMaybe<PatientUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientUpdatedByFilters>;
};

export type PatientFiltersOr = {
  addressCity: InputMaybe<PatientAddressCityFilters>;
  addressCoordinates: InputMaybe<PatientAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<PatientAddressLineTwoFilters>;
  addressState: InputMaybe<PatientAddressStateFilters>;
  addressStreet: InputMaybe<PatientAddressStreetFilters>;
  addressTimezone: InputMaybe<PatientAddressTimezoneFilters>;
  addressZip: InputMaybe<PatientAddressZipFilters>;
  createdAt: InputMaybe<PatientCreatedAtFilters>;
  createdBy: InputMaybe<PatientCreatedByFilters>;
  dateOfBirth: InputMaybe<PatientDateOfBirthFilters>;
  deleted: InputMaybe<PatientDeletedFilters>;
  firstName: InputMaybe<PatientFirstNameFilters>;
  id: InputMaybe<PatientIdFilters>;
  lastName: InputMaybe<PatientLastNameFilters>;
  organizationId: InputMaybe<PatientOrganizationIdFilters>;
  patientNotes: InputMaybe<PatientPatientNotesFilters>;
  phone: InputMaybe<PatientPhoneFilters>;
  preferredLanguage: InputMaybe<PatientPreferredLanguageFilters>;
  serviceInstructions: InputMaybe<PatientServiceInstructionsFilters>;
  sex: InputMaybe<PatientSexFilters>;
  updatedAt: InputMaybe<PatientUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientUpdatedByFilters>;
};

export type PatientFirstNameFilters = {
  OR: InputMaybe<Array<PatientFirstNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientFirstNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdFilters = {
  OR: InputMaybe<Array<PatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierCreatedAtFilters = {
  OR: InputMaybe<Array<PatientIdentifierCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierCreatedByFilters = {
  OR: InputMaybe<Array<PatientIdentifierCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierDeletedFilters = {
  OR: InputMaybe<Array<PatientIdentifierDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierFilters = {
  OR: InputMaybe<Array<PatientIdentifierFiltersOr>>;
  createdAt: InputMaybe<PatientIdentifierCreatedAtFilters>;
  createdBy: InputMaybe<PatientIdentifierCreatedByFilters>;
  deleted: InputMaybe<PatientIdentifierDeletedFilters>;
  id: InputMaybe<PatientIdentifierIdFilters>;
  identifier: InputMaybe<PatientIdentifierIdentifierFilters>;
  identifier_type: InputMaybe<PatientIdentifierIdentifier_TypeFilters>;
  organizationId: InputMaybe<PatientIdentifierOrganizationIdFilters>;
  patientId: InputMaybe<PatientIdentifierPatientIdFilters>;
  updatedAt: InputMaybe<PatientIdentifierUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientIdentifierUpdatedByFilters>;
};

export type PatientIdentifierFiltersOr = {
  createdAt: InputMaybe<PatientIdentifierCreatedAtFilters>;
  createdBy: InputMaybe<PatientIdentifierCreatedByFilters>;
  deleted: InputMaybe<PatientIdentifierDeletedFilters>;
  id: InputMaybe<PatientIdentifierIdFilters>;
  identifier: InputMaybe<PatientIdentifierIdentifierFilters>;
  identifier_type: InputMaybe<PatientIdentifierIdentifier_TypeFilters>;
  organizationId: InputMaybe<PatientIdentifierOrganizationIdFilters>;
  patientId: InputMaybe<PatientIdentifierPatientIdFilters>;
  updatedAt: InputMaybe<PatientIdentifierUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientIdentifierUpdatedByFilters>;
};

export type PatientIdentifierIdFilters = {
  OR: InputMaybe<Array<PatientIdentifierIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierIdentifierFilters = {
  OR: InputMaybe<Array<PatientIdentifierIdentifierfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierIdentifier_TypeFilters = {
  OR: InputMaybe<Array<PatientIdentifierIdentifier_TypefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierIdentifier_TypefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierIdentifierfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  identifier: InputMaybe<InnerOrder>;
  identifier_type: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  patientId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type PatientIdentifierOrganizationIdFilters = {
  OR: InputMaybe<Array<PatientIdentifierOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierPatientIdFilters = {
  OR: InputMaybe<Array<PatientIdentifierPatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierPatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<PatientIdentifierRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<PatientIdentifierRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryFilters = {
  OR: InputMaybe<Array<PatientIdentifierRevisionHistoryFiltersOr>>;
  action: InputMaybe<PatientIdentifierRevisionHistoryActionFilters>;
  changedFields: InputMaybe<PatientIdentifierRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<PatientIdentifierRevisionHistoryIdFilters>;
  organizationId: InputMaybe<PatientIdentifierRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<PatientIdentifierRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<PatientIdentifierRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientIdentifierRevisionHistoryUpdatedByFilters>;
};

export type PatientIdentifierRevisionHistoryFiltersOr = {
  action: InputMaybe<PatientIdentifierRevisionHistoryActionFilters>;
  changedFields: InputMaybe<PatientIdentifierRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<PatientIdentifierRevisionHistoryIdFilters>;
  organizationId: InputMaybe<PatientIdentifierRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<PatientIdentifierRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<PatientIdentifierRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientIdentifierRevisionHistoryUpdatedByFilters>;
};

export type PatientIdentifierRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<PatientIdentifierRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type PatientIdentifierRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<PatientIdentifierRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<PatientIdentifierRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<PatientIdentifierRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<PatientIdentifierRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierUpdatedAtFilters = {
  OR: InputMaybe<Array<PatientIdentifierUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierUpdatedByFilters = {
  OR: InputMaybe<Array<PatientIdentifierUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdentifierUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientLastNameFilters = {
  OR: InputMaybe<Array<PatientLastNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientLastNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  dateOfBirth: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  firstName: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  lastName: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  patientNotes: InputMaybe<InnerOrder>;
  phone: InputMaybe<InnerOrder>;
  preferredLanguage: InputMaybe<InnerOrder>;
  serviceInstructions: InputMaybe<InnerOrder>;
  sex: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type PatientOrganizationIdFilters = {
  OR: InputMaybe<Array<PatientOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientPatientNotesFilters = {
  OR: InputMaybe<Array<PatientPatientNotesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientPatientNotesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientPhoneFilters = {
  OR: InputMaybe<Array<PatientPhonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientPhonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientPreferredLanguageFilters = {
  OR: InputMaybe<Array<PatientPreferredLanguagefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientPreferredLanguagefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<PatientRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<PatientRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryFilters = {
  OR: InputMaybe<Array<PatientRevisionHistoryFiltersOr>>;
  action: InputMaybe<PatientRevisionHistoryActionFilters>;
  changedFields: InputMaybe<PatientRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<PatientRevisionHistoryIdFilters>;
  organizationId: InputMaybe<PatientRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<PatientRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<PatientRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientRevisionHistoryUpdatedByFilters>;
};

export type PatientRevisionHistoryFiltersOr = {
  action: InputMaybe<PatientRevisionHistoryActionFilters>;
  changedFields: InputMaybe<PatientRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<PatientRevisionHistoryIdFilters>;
  organizationId: InputMaybe<PatientRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<PatientRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<PatientRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<PatientRevisionHistoryUpdatedByFilters>;
};

export type PatientRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<PatientRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type PatientRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<PatientRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<PatientRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<PatientRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<PatientRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientServiceInstructionsFilters = {
  OR: InputMaybe<Array<PatientServiceInstructionsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientServiceInstructionsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum PatientSexEnum {
  Female = 'female',
  Male = 'male',
  Other = 'other',
  PreferNotToSay = 'prefer_not_to_say',
  Unknown = 'unknown'
}

export type PatientSexFilters = {
  OR: InputMaybe<Array<PatientSexfiltersOr>>;
  eq: InputMaybe<PatientSexEnum>;
  gt: InputMaybe<PatientSexEnum>;
  gte: InputMaybe<PatientSexEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<PatientSexEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<PatientSexEnum>;
  lte: InputMaybe<PatientSexEnum>;
  ne: InputMaybe<PatientSexEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<PatientSexEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientSexfiltersOr = {
  eq: InputMaybe<PatientSexEnum>;
  gt: InputMaybe<PatientSexEnum>;
  gte: InputMaybe<PatientSexEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<PatientSexEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<PatientSexEnum>;
  lte: InputMaybe<PatientSexEnum>;
  ne: InputMaybe<PatientSexEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<PatientSexEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientUpdatedAtFilters = {
  OR: InputMaybe<Array<PatientUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientUpdatedByFilters = {
  OR: InputMaybe<Array<PatientUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PatientUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum PermissionCheckEnum {
  UserInEpisodeServiceLine = 'userInEpisodeServiceLine',
  UserInServiceLine = 'userInServiceLine',
  UserInVisitServiceLine = 'userInVisitServiceLine',
  UserIsProvider = 'userIsProvider',
  UserIsProviderOnSosAlert = 'userIsProviderOnSosAlert',
  UserIsProviderOnVisit = 'userIsProviderOnVisit',
  UserIsSelf = 'userIsSelf'
}

export enum PermissionEnum {
  AssignCandidacy = 'assignCandidacy',
  CopyDemoData = 'copyDemoData',
  CreateDragEvents = 'createDragEvents',
  CreateOverrideVisits = 'createOverrideVisits',
  DebugApps = 'debugApps',
  ImpersonateAnyProvider = 'impersonateAnyProvider',
  ImportPatients = 'importPatients',
  ImportUsers = 'importUsers',
  IsAuthenticated = 'isAuthenticated',
  ManageAnyVisit = 'manageAnyVisit',
  ManageApiKeys = 'manageApiKeys',
  ManageCalendarBlocks = 'manageCalendarBlocks',
  ManageOrgConfig = 'manageOrgConfig',
  ManageOwnAvailability = 'manageOwnAvailability',
  ManagePatients = 'managePatients',
  ManageProviderShifts = 'manageProviderShifts',
  ManageSosAlerts = 'manageSosAlerts',
  ManageSupplies = 'manageSupplies',
  ManageTeams = 'manageTeams',
  ManageUsers = 'manageUsers',
  ManageVisitStatus = 'manageVisitStatus',
  OptimizeSchedule = 'optimizeSchedule',
  ScheduleVisits = 'scheduleVisits',
  SwitchOrganization = 'switchOrganization',
  TakeCandidacy = 'takeCandidacy',
  ToggleManageOwnAvailability = 'toggleManageOwnAvailability',
  UseMobile = 'useMobile',
  UseSupplies = 'useSupplies',
  UseVisitWorklist = 'useVisitWorklist',
  UseWebApp = 'useWebApp',
  ViewKpIs = 'viewKPIs',
  ViewProviderLocations = 'viewProviderLocations'
}

export type PrecautionActiveFilters = {
  OR: InputMaybe<Array<PrecautionActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionColorFilters = {
  OR: InputMaybe<Array<PrecautionColorfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionColorfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionCreatedAtFilters = {
  OR: InputMaybe<Array<PrecautionCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionCreatedByFilters = {
  OR: InputMaybe<Array<PrecautionCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionDeletedFilters = {
  OR: InputMaybe<Array<PrecautionDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionDescriptionFilters = {
  OR: InputMaybe<Array<PrecautionDescriptionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionDescriptionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionFilters = {
  OR: InputMaybe<Array<PrecautionFiltersOr>>;
  active: InputMaybe<PrecautionActiveFilters>;
  color: InputMaybe<PrecautionColorFilters>;
  createdAt: InputMaybe<PrecautionCreatedAtFilters>;
  createdBy: InputMaybe<PrecautionCreatedByFilters>;
  deleted: InputMaybe<PrecautionDeletedFilters>;
  description: InputMaybe<PrecautionDescriptionFilters>;
  id: InputMaybe<PrecautionIdFilters>;
  name: InputMaybe<PrecautionNameFilters>;
  organizationId: InputMaybe<PrecautionOrganizationIdFilters>;
  updatedAt: InputMaybe<PrecautionUpdatedAtFilters>;
  updatedBy: InputMaybe<PrecautionUpdatedByFilters>;
};

export type PrecautionFiltersOr = {
  active: InputMaybe<PrecautionActiveFilters>;
  color: InputMaybe<PrecautionColorFilters>;
  createdAt: InputMaybe<PrecautionCreatedAtFilters>;
  createdBy: InputMaybe<PrecautionCreatedByFilters>;
  deleted: InputMaybe<PrecautionDeletedFilters>;
  description: InputMaybe<PrecautionDescriptionFilters>;
  id: InputMaybe<PrecautionIdFilters>;
  name: InputMaybe<PrecautionNameFilters>;
  organizationId: InputMaybe<PrecautionOrganizationIdFilters>;
  updatedAt: InputMaybe<PrecautionUpdatedAtFilters>;
  updatedBy: InputMaybe<PrecautionUpdatedByFilters>;
};

export type PrecautionIdFilters = {
  OR: InputMaybe<Array<PrecautionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionNameFilters = {
  OR: InputMaybe<Array<PrecautionNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionOrderBy = {
  active: InputMaybe<InnerOrder>;
  color: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  description: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type PrecautionOrganizationIdFilters = {
  OR: InputMaybe<Array<PrecautionOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<PrecautionRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<PrecautionRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryFilters = {
  OR: InputMaybe<Array<PrecautionRevisionHistoryFiltersOr>>;
  action: InputMaybe<PrecautionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<PrecautionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<PrecautionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<PrecautionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<PrecautionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<PrecautionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<PrecautionRevisionHistoryUpdatedByFilters>;
};

export type PrecautionRevisionHistoryFiltersOr = {
  action: InputMaybe<PrecautionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<PrecautionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<PrecautionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<PrecautionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<PrecautionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<PrecautionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<PrecautionRevisionHistoryUpdatedByFilters>;
};

export type PrecautionRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<PrecautionRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type PrecautionRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<PrecautionRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<PrecautionRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<PrecautionRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<PrecautionRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionUpdatedAtFilters = {
  OR: InputMaybe<Array<PrecautionUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionUpdatedByFilters = {
  OR: InputMaybe<Array<PrecautionUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PrecautionUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PredictCandidacyOrderBy = {
  assignedToFirstName: InputMaybe<InnerOrder>;
  assignedToLastName: InputMaybe<InnerOrder>;
  candidateStatus: InputMaybe<InnerOrder>;
  patientFirstName: InputMaybe<InnerOrder>;
  patientLastName: InputMaybe<InnerOrder>;
  programName: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
};

export type ProgramCreatedAtFilters = {
  OR: InputMaybe<Array<ProgramCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramCreatedByFilters = {
  OR: InputMaybe<Array<ProgramCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramDeletedFilters = {
  OR: InputMaybe<Array<ProgramDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerBooleanFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerAnswerBooleanfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerBooleanfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerFreeTextFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerAnswerFreeTextfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerFreeTextfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerMultiSelectOptionIdsFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerAnswerMultiSelectOptionIdsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerMultiSelectOptionIdsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerNumericFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerAnswerNumericfiltersOr>>;
  eq: InputMaybe<Scalars['Float']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerNumericfiltersOr = {
  eq: InputMaybe<Scalars['Float']['input']>;
  gt: InputMaybe<Scalars['Float']['input']>;
  gte: InputMaybe<Scalars['Float']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Float']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Float']['input']>;
  lte: InputMaybe<Scalars['Float']['input']>;
  ne: InputMaybe<Scalars['Float']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Float']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerSelectedOptionIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerAnswerSelectedOptionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerAnswerSelectedOptionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerCandidacyIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerCandidacyIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerCandidacyIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerCreatedAtFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerCreatedByFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerDeletedFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerEligibilityQuestionIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerEligibilityQuestionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerEligibilityQuestionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerFiltersOr>>;
  answerBoolean: InputMaybe<ProgramEligibilityAnswerAnswerBooleanFilters>;
  answerFreeText: InputMaybe<ProgramEligibilityAnswerAnswerFreeTextFilters>;
  answerMultiSelectOptionIds: InputMaybe<ProgramEligibilityAnswerAnswerMultiSelectOptionIdsFilters>;
  answerNumeric: InputMaybe<ProgramEligibilityAnswerAnswerNumericFilters>;
  answerSelectedOptionId: InputMaybe<ProgramEligibilityAnswerAnswerSelectedOptionIdFilters>;
  candidacyId: InputMaybe<ProgramEligibilityAnswerCandidacyIdFilters>;
  createdAt: InputMaybe<ProgramEligibilityAnswerCreatedAtFilters>;
  createdBy: InputMaybe<ProgramEligibilityAnswerCreatedByFilters>;
  deleted: InputMaybe<ProgramEligibilityAnswerDeletedFilters>;
  eligibilityQuestionId: InputMaybe<ProgramEligibilityAnswerEligibilityQuestionIdFilters>;
  id: InputMaybe<ProgramEligibilityAnswerIdFilters>;
  organizationId: InputMaybe<ProgramEligibilityAnswerOrganizationIdFilters>;
  updatedAt: InputMaybe<ProgramEligibilityAnswerUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramEligibilityAnswerUpdatedByFilters>;
};

export type ProgramEligibilityAnswerFiltersOr = {
  answerBoolean: InputMaybe<ProgramEligibilityAnswerAnswerBooleanFilters>;
  answerFreeText: InputMaybe<ProgramEligibilityAnswerAnswerFreeTextFilters>;
  answerMultiSelectOptionIds: InputMaybe<ProgramEligibilityAnswerAnswerMultiSelectOptionIdsFilters>;
  answerNumeric: InputMaybe<ProgramEligibilityAnswerAnswerNumericFilters>;
  answerSelectedOptionId: InputMaybe<ProgramEligibilityAnswerAnswerSelectedOptionIdFilters>;
  candidacyId: InputMaybe<ProgramEligibilityAnswerCandidacyIdFilters>;
  createdAt: InputMaybe<ProgramEligibilityAnswerCreatedAtFilters>;
  createdBy: InputMaybe<ProgramEligibilityAnswerCreatedByFilters>;
  deleted: InputMaybe<ProgramEligibilityAnswerDeletedFilters>;
  eligibilityQuestionId: InputMaybe<ProgramEligibilityAnswerEligibilityQuestionIdFilters>;
  id: InputMaybe<ProgramEligibilityAnswerIdFilters>;
  organizationId: InputMaybe<ProgramEligibilityAnswerOrganizationIdFilters>;
  updatedAt: InputMaybe<ProgramEligibilityAnswerUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramEligibilityAnswerUpdatedByFilters>;
};

export type ProgramEligibilityAnswerIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerOrderBy = {
  answerBoolean: InputMaybe<InnerOrder>;
  answerFreeText: InputMaybe<InnerOrder>;
  answerMultiSelectOptionIds: InputMaybe<InnerOrder>;
  answerNumeric: InputMaybe<InnerOrder>;
  answerSelectedOptionId: InputMaybe<InnerOrder>;
  candidacyId: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  eligibilityQuestionId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProgramEligibilityAnswerOrganizationIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerRevisionHistoryFiltersOr>>;
  action: InputMaybe<ProgramEligibilityAnswerRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProgramEligibilityAnswerRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProgramEligibilityAnswerRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProgramEligibilityAnswerRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProgramEligibilityAnswerRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProgramEligibilityAnswerRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramEligibilityAnswerRevisionHistoryUpdatedByFilters>;
};

export type ProgramEligibilityAnswerRevisionHistoryFiltersOr = {
  action: InputMaybe<ProgramEligibilityAnswerRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProgramEligibilityAnswerRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProgramEligibilityAnswerRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProgramEligibilityAnswerRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProgramEligibilityAnswerRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProgramEligibilityAnswerRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramEligibilityAnswerRevisionHistoryUpdatedByFilters>;
};

export type ProgramEligibilityAnswerRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProgramEligibilityAnswerRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerUpdatedAtFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerUpdatedByFilters = {
  OR: InputMaybe<Array<ProgramEligibilityAnswerUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityAnswerUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionCreatedAtFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionCreatedByFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionDeletedFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionDisqualifyingAnswersFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionDisqualifyingAnswersfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionDisqualifyingAnswersfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionEligibilityQuestionIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionEligibilityQuestionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionEligibilityQuestionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionFiltersOr>>;
  createdAt: InputMaybe<ProgramEligibilityQuestionCreatedAtFilters>;
  createdBy: InputMaybe<ProgramEligibilityQuestionCreatedByFilters>;
  deleted: InputMaybe<ProgramEligibilityQuestionDeletedFilters>;
  disqualifyingAnswers: InputMaybe<ProgramEligibilityQuestionDisqualifyingAnswersFilters>;
  eligibilityQuestionId: InputMaybe<ProgramEligibilityQuestionEligibilityQuestionIdFilters>;
  id: InputMaybe<ProgramEligibilityQuestionIdFilters>;
  organizationId: InputMaybe<ProgramEligibilityQuestionOrganizationIdFilters>;
  programId: InputMaybe<ProgramEligibilityQuestionProgramIdFilters>;
  updatedAt: InputMaybe<ProgramEligibilityQuestionUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramEligibilityQuestionUpdatedByFilters>;
};

export type ProgramEligibilityQuestionFiltersOr = {
  createdAt: InputMaybe<ProgramEligibilityQuestionCreatedAtFilters>;
  createdBy: InputMaybe<ProgramEligibilityQuestionCreatedByFilters>;
  deleted: InputMaybe<ProgramEligibilityQuestionDeletedFilters>;
  disqualifyingAnswers: InputMaybe<ProgramEligibilityQuestionDisqualifyingAnswersFilters>;
  eligibilityQuestionId: InputMaybe<ProgramEligibilityQuestionEligibilityQuestionIdFilters>;
  id: InputMaybe<ProgramEligibilityQuestionIdFilters>;
  organizationId: InputMaybe<ProgramEligibilityQuestionOrganizationIdFilters>;
  programId: InputMaybe<ProgramEligibilityQuestionProgramIdFilters>;
  updatedAt: InputMaybe<ProgramEligibilityQuestionUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramEligibilityQuestionUpdatedByFilters>;
};

export type ProgramEligibilityQuestionIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  disqualifyingAnswers: InputMaybe<InnerOrder>;
  eligibilityQuestionId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  programId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProgramEligibilityQuestionOrganizationIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionProgramIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionProgramIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionProgramIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionProgramInput = {
  disqualifyingAnswers: Array<Scalars['Int']['input']>;
  programId: Scalars['Int']['input'];
};

export type ProgramEligibilityQuestionRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionRevisionHistoryFiltersOr>>;
  action: InputMaybe<ProgramEligibilityQuestionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProgramEligibilityQuestionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProgramEligibilityQuestionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProgramEligibilityQuestionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProgramEligibilityQuestionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProgramEligibilityQuestionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramEligibilityQuestionRevisionHistoryUpdatedByFilters>;
};

export type ProgramEligibilityQuestionRevisionHistoryFiltersOr = {
  action: InputMaybe<ProgramEligibilityQuestionRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProgramEligibilityQuestionRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProgramEligibilityQuestionRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProgramEligibilityQuestionRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProgramEligibilityQuestionRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProgramEligibilityQuestionRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramEligibilityQuestionRevisionHistoryUpdatedByFilters>;
};

export type ProgramEligibilityQuestionRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProgramEligibilityQuestionRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionUpdatedAtFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionUpdatedByFilters = {
  OR: InputMaybe<Array<ProgramEligibilityQuestionUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEligibilityQuestionUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramFilters = {
  OR: InputMaybe<Array<ProgramFiltersOr>>;
  createdAt: InputMaybe<ProgramCreatedAtFilters>;
  createdBy: InputMaybe<ProgramCreatedByFilters>;
  deleted: InputMaybe<ProgramDeletedFilters>;
  id: InputMaybe<ProgramIdFilters>;
  name: InputMaybe<ProgramNameFilters>;
  organizationId: InputMaybe<ProgramOrganizationIdFilters>;
  serviceLineId: InputMaybe<ProgramServiceLineIdFilters>;
  updatedAt: InputMaybe<ProgramUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramUpdatedByFilters>;
};

export type ProgramFiltersOr = {
  createdAt: InputMaybe<ProgramCreatedAtFilters>;
  createdBy: InputMaybe<ProgramCreatedByFilters>;
  deleted: InputMaybe<ProgramDeletedFilters>;
  id: InputMaybe<ProgramIdFilters>;
  name: InputMaybe<ProgramNameFilters>;
  organizationId: InputMaybe<ProgramOrganizationIdFilters>;
  serviceLineId: InputMaybe<ProgramServiceLineIdFilters>;
  updatedAt: InputMaybe<ProgramUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramUpdatedByFilters>;
};

export type ProgramIdFilters = {
  OR: InputMaybe<Array<ProgramIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramNameFilters = {
  OR: InputMaybe<Array<ProgramNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  serviceLineId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProgramOrganizationIdFilters = {
  OR: InputMaybe<Array<ProgramOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ProgramRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ProgramRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryFilters = {
  OR: InputMaybe<Array<ProgramRevisionHistoryFiltersOr>>;
  action: InputMaybe<ProgramRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProgramRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProgramRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProgramRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProgramRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProgramRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramRevisionHistoryUpdatedByFilters>;
};

export type ProgramRevisionHistoryFiltersOr = {
  action: InputMaybe<ProgramRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProgramRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProgramRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProgramRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProgramRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProgramRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProgramRevisionHistoryUpdatedByFilters>;
};

export type ProgramRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ProgramRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProgramRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ProgramRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ProgramRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ProgramRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ProgramRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramServiceLineIdFilters = {
  OR: InputMaybe<Array<ProgramServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramUpdatedAtFilters = {
  OR: InputMaybe<Array<ProgramUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramUpdatedByFilters = {
  OR: InputMaybe<Array<ProgramUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProgramUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProvideTraitQueryInput = {
  trait: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ProviderActiveFilters = {
  OR: InputMaybe<Array<ProviderActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddress = {
  addressCoordinates: Scalars['String']['input'];
};

export type ProviderAddressCityFilters = {
  OR: InputMaybe<Array<ProviderAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressCoordinatesFilters = {
  OR: InputMaybe<Array<ProviderAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressLineTwoFilters = {
  OR: InputMaybe<Array<ProviderAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressStateFilters = {
  OR: InputMaybe<Array<ProviderAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressStreetFilters = {
  OR: InputMaybe<Array<ProviderAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressTimezoneFilters = {
  OR: InputMaybe<Array<ProviderAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressZipFilters = {
  OR: InputMaybe<Array<ProviderAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreatedAtFilters = {
  OR: InputMaybe<Array<ProviderCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreatedByFilters = {
  OR: InputMaybe<Array<ProviderCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderDeletedFilters = {
  OR: InputMaybe<Array<ProviderDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderExternalFilters = {
  OR: InputMaybe<Array<ProviderExternalfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderExternalfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderFilters = {
  OR: InputMaybe<Array<ProviderFiltersOr>>;
  active: InputMaybe<ProviderActiveFilters>;
  addressCity: InputMaybe<ProviderAddressCityFilters>;
  addressCoordinates: InputMaybe<ProviderAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<ProviderAddressLineTwoFilters>;
  addressState: InputMaybe<ProviderAddressStateFilters>;
  addressStreet: InputMaybe<ProviderAddressStreetFilters>;
  addressTimezone: InputMaybe<ProviderAddressTimezoneFilters>;
  addressZip: InputMaybe<ProviderAddressZipFilters>;
  createdAt: InputMaybe<ProviderCreatedAtFilters>;
  createdBy: InputMaybe<ProviderCreatedByFilters>;
  deleted: InputMaybe<ProviderDeletedFilters>;
  external: InputMaybe<ProviderExternalFilters>;
  firstName: InputMaybe<ProviderFirstNameFilters>;
  id: InputMaybe<ProviderIdFilters>;
  identifier: InputMaybe<ProviderIdentifierFilters>;
  lastName: InputMaybe<ProviderLastNameFilters>;
  organizationId: InputMaybe<ProviderOrganizationIdFilters>;
  organizationUserId: InputMaybe<ProviderOrganizationUserIdFilters>;
  providerTypeId: InputMaybe<ProviderProviderTypeIdFilters>;
  updatedAt: InputMaybe<ProviderUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderUpdatedByFilters>;
};

export type ProviderFiltersOr = {
  active: InputMaybe<ProviderActiveFilters>;
  addressCity: InputMaybe<ProviderAddressCityFilters>;
  addressCoordinates: InputMaybe<ProviderAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<ProviderAddressLineTwoFilters>;
  addressState: InputMaybe<ProviderAddressStateFilters>;
  addressStreet: InputMaybe<ProviderAddressStreetFilters>;
  addressTimezone: InputMaybe<ProviderAddressTimezoneFilters>;
  addressZip: InputMaybe<ProviderAddressZipFilters>;
  createdAt: InputMaybe<ProviderCreatedAtFilters>;
  createdBy: InputMaybe<ProviderCreatedByFilters>;
  deleted: InputMaybe<ProviderDeletedFilters>;
  external: InputMaybe<ProviderExternalFilters>;
  firstName: InputMaybe<ProviderFirstNameFilters>;
  id: InputMaybe<ProviderIdFilters>;
  identifier: InputMaybe<ProviderIdentifierFilters>;
  lastName: InputMaybe<ProviderLastNameFilters>;
  organizationId: InputMaybe<ProviderOrganizationIdFilters>;
  organizationUserId: InputMaybe<ProviderOrganizationUserIdFilters>;
  providerTypeId: InputMaybe<ProviderProviderTypeIdFilters>;
  updatedAt: InputMaybe<ProviderUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderUpdatedByFilters>;
};

export type ProviderFirstNameFilters = {
  OR: InputMaybe<Array<ProviderFirstNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderFirstNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderIdFilters = {
  OR: InputMaybe<Array<ProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderIdentifierFilters = {
  OR: InputMaybe<Array<ProviderIdentifierfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderIdentifierfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderLastNameFilters = {
  OR: InputMaybe<Array<ProviderLastNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderLastNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderOrderBy = {
  active: InputMaybe<InnerOrder>;
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  external: InputMaybe<InnerOrder>;
  firstName: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  identifier: InputMaybe<InnerOrder>;
  lastName: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  organizationUserId: InputMaybe<InnerOrder>;
  providerTypeId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProviderOrganizationIdFilters = {
  OR: InputMaybe<Array<ProviderOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderOrganizationUserIdFilters = {
  OR: InputMaybe<Array<ProviderOrganizationUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderOrganizationUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderProviderTypeIdFilters = {
  OR: InputMaybe<Array<ProviderProviderTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderProviderTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ProviderRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ProviderRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryFilters = {
  OR: InputMaybe<Array<ProviderRevisionHistoryFiltersOr>>;
  action: InputMaybe<ProviderRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProviderRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProviderRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProviderRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProviderRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProviderRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderRevisionHistoryUpdatedByFilters>;
};

export type ProviderRevisionHistoryFiltersOr = {
  action: InputMaybe<ProviderRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProviderRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProviderRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProviderRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProviderRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProviderRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderRevisionHistoryUpdatedByFilters>;
};

export type ProviderRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ProviderRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProviderRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ProviderRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ProviderRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ProviderRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ProviderRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitCreatedAtFilters = {
  OR: InputMaybe<Array<ProviderTraitCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitCreatedByFilters = {
  OR: InputMaybe<Array<ProviderTraitCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitDeletedFilters = {
  OR: InputMaybe<Array<ProviderTraitDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitFilters = {
  OR: InputMaybe<Array<ProviderTraitFiltersOr>>;
  createdAt: InputMaybe<ProviderTraitCreatedAtFilters>;
  createdBy: InputMaybe<ProviderTraitCreatedByFilters>;
  deleted: InputMaybe<ProviderTraitDeletedFilters>;
  id: InputMaybe<ProviderTraitIdFilters>;
  organizationId: InputMaybe<ProviderTraitOrganizationIdFilters>;
  providerId: InputMaybe<ProviderTraitProviderIdFilters>;
  trait: InputMaybe<ProviderTraitTraitFilters>;
  updatedAt: InputMaybe<ProviderTraitUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderTraitUpdatedByFilters>;
  value: InputMaybe<ProviderTraitValueFilters>;
};

export type ProviderTraitFiltersOr = {
  createdAt: InputMaybe<ProviderTraitCreatedAtFilters>;
  createdBy: InputMaybe<ProviderTraitCreatedByFilters>;
  deleted: InputMaybe<ProviderTraitDeletedFilters>;
  id: InputMaybe<ProviderTraitIdFilters>;
  organizationId: InputMaybe<ProviderTraitOrganizationIdFilters>;
  providerId: InputMaybe<ProviderTraitProviderIdFilters>;
  trait: InputMaybe<ProviderTraitTraitFilters>;
  updatedAt: InputMaybe<ProviderTraitUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderTraitUpdatedByFilters>;
  value: InputMaybe<ProviderTraitValueFilters>;
};

export type ProviderTraitIdFilters = {
  OR: InputMaybe<Array<ProviderTraitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  trait: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  value: InputMaybe<InnerOrder>;
};

export type ProviderTraitOrganizationIdFilters = {
  OR: InputMaybe<Array<ProviderTraitOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitProviderIdFilters = {
  OR: InputMaybe<Array<ProviderTraitProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ProviderTraitRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ProviderTraitRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryFilters = {
  OR: InputMaybe<Array<ProviderTraitRevisionHistoryFiltersOr>>;
  action: InputMaybe<ProviderTraitRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProviderTraitRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProviderTraitRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProviderTraitRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProviderTraitRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProviderTraitRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderTraitRevisionHistoryUpdatedByFilters>;
};

export type ProviderTraitRevisionHistoryFiltersOr = {
  action: InputMaybe<ProviderTraitRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProviderTraitRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProviderTraitRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProviderTraitRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProviderTraitRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProviderTraitRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderTraitRevisionHistoryUpdatedByFilters>;
};

export type ProviderTraitRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ProviderTraitRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProviderTraitRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ProviderTraitRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ProviderTraitRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ProviderTraitRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ProviderTraitRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitTraitFilters = {
  OR: InputMaybe<Array<ProviderTraitTraitfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitTraitfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitUpdatedAtFilters = {
  OR: InputMaybe<Array<ProviderTraitUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitUpdatedByFilters = {
  OR: InputMaybe<Array<ProviderTraitUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitValueFilters = {
  OR: InputMaybe<Array<ProviderTraitValuefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTraitValuefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeCreatedAtFilters = {
  OR: InputMaybe<Array<ProviderTypeCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeCreatedByFilters = {
  OR: InputMaybe<Array<ProviderTypeCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeDeletedFilters = {
  OR: InputMaybe<Array<ProviderTypeDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeFilters = {
  OR: InputMaybe<Array<ProviderTypeFiltersOr>>;
  createdAt: InputMaybe<ProviderTypeCreatedAtFilters>;
  createdBy: InputMaybe<ProviderTypeCreatedByFilters>;
  deleted: InputMaybe<ProviderTypeDeletedFilters>;
  id: InputMaybe<ProviderTypeIdFilters>;
  name: InputMaybe<ProviderTypeNameFilters>;
  organizationId: InputMaybe<ProviderTypeOrganizationIdFilters>;
  requireStateLicense: InputMaybe<ProviderTypeRequireStateLicenseFilters>;
  updatedAt: InputMaybe<ProviderTypeUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderTypeUpdatedByFilters>;
};

export type ProviderTypeFiltersOr = {
  createdAt: InputMaybe<ProviderTypeCreatedAtFilters>;
  createdBy: InputMaybe<ProviderTypeCreatedByFilters>;
  deleted: InputMaybe<ProviderTypeDeletedFilters>;
  id: InputMaybe<ProviderTypeIdFilters>;
  name: InputMaybe<ProviderTypeNameFilters>;
  organizationId: InputMaybe<ProviderTypeOrganizationIdFilters>;
  requireStateLicense: InputMaybe<ProviderTypeRequireStateLicenseFilters>;
  updatedAt: InputMaybe<ProviderTypeUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderTypeUpdatedByFilters>;
};

export type ProviderTypeIdFilters = {
  OR: InputMaybe<Array<ProviderTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeNameFilters = {
  OR: InputMaybe<Array<ProviderTypeNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  requireStateLicense: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProviderTypeOrganizationIdFilters = {
  OR: InputMaybe<Array<ProviderTypeOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRequireStateLicenseFilters = {
  OR: InputMaybe<Array<ProviderTypeRequireStateLicensefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRequireStateLicensefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ProviderTypeRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ProviderTypeRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryFilters = {
  OR: InputMaybe<Array<ProviderTypeRevisionHistoryFiltersOr>>;
  action: InputMaybe<ProviderTypeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProviderTypeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProviderTypeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProviderTypeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProviderTypeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProviderTypeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderTypeRevisionHistoryUpdatedByFilters>;
};

export type ProviderTypeRevisionHistoryFiltersOr = {
  action: InputMaybe<ProviderTypeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ProviderTypeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ProviderTypeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ProviderTypeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ProviderTypeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ProviderTypeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ProviderTypeRevisionHistoryUpdatedByFilters>;
};

export type ProviderTypeRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ProviderTypeRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ProviderTypeRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ProviderTypeRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ProviderTypeRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ProviderTypeRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ProviderTypeRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeUpdatedAtFilters = {
  OR: InputMaybe<Array<ProviderTypeUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeUpdatedByFilters = {
  OR: InputMaybe<Array<ProviderTypeUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderTypeUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderUpdatedAtFilters = {
  OR: InputMaybe<Array<ProviderUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderUpdatedByFilters = {
  OR: InputMaybe<Array<ProviderUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ProviderUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenCreatedAtFilters = {
  OR: InputMaybe<Array<PushTokenCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenCreatedByFilters = {
  OR: InputMaybe<Array<PushTokenCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenDeletedFilters = {
  OR: InputMaybe<Array<PushTokenDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenDeviceIdFilters = {
  OR: InputMaybe<Array<PushTokenDeviceIdfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenDeviceIdfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenExpiresAtFilters = {
  OR: InputMaybe<Array<PushTokenExpiresAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenExpiresAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenExpoPushTokenFilters = {
  OR: InputMaybe<Array<PushTokenExpoPushTokenfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenExpoPushTokenfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenFilters = {
  OR: InputMaybe<Array<PushTokenFiltersOr>>;
  createdAt: InputMaybe<PushTokenCreatedAtFilters>;
  createdBy: InputMaybe<PushTokenCreatedByFilters>;
  deleted: InputMaybe<PushTokenDeletedFilters>;
  deviceId: InputMaybe<PushTokenDeviceIdFilters>;
  expiresAt: InputMaybe<PushTokenExpiresAtFilters>;
  expoPushToken: InputMaybe<PushTokenExpoPushTokenFilters>;
  id: InputMaybe<PushTokenIdFilters>;
  organizationId: InputMaybe<PushTokenOrganizationIdFilters>;
  platform: InputMaybe<PushTokenPlatformFilters>;
  updatedAt: InputMaybe<PushTokenUpdatedAtFilters>;
  updatedBy: InputMaybe<PushTokenUpdatedByFilters>;
  userId: InputMaybe<PushTokenUserIdFilters>;
};

export type PushTokenFiltersOr = {
  createdAt: InputMaybe<PushTokenCreatedAtFilters>;
  createdBy: InputMaybe<PushTokenCreatedByFilters>;
  deleted: InputMaybe<PushTokenDeletedFilters>;
  deviceId: InputMaybe<PushTokenDeviceIdFilters>;
  expiresAt: InputMaybe<PushTokenExpiresAtFilters>;
  expoPushToken: InputMaybe<PushTokenExpoPushTokenFilters>;
  id: InputMaybe<PushTokenIdFilters>;
  organizationId: InputMaybe<PushTokenOrganizationIdFilters>;
  platform: InputMaybe<PushTokenPlatformFilters>;
  updatedAt: InputMaybe<PushTokenUpdatedAtFilters>;
  updatedBy: InputMaybe<PushTokenUpdatedByFilters>;
  userId: InputMaybe<PushTokenUserIdFilters>;
};

export type PushTokenIdFilters = {
  OR: InputMaybe<Array<PushTokenIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  deviceId: InputMaybe<InnerOrder>;
  expiresAt: InputMaybe<InnerOrder>;
  expoPushToken: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  platform: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  userId: InputMaybe<InnerOrder>;
};

export type PushTokenOrganizationIdFilters = {
  OR: InputMaybe<Array<PushTokenOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum PushTokenPlatformEnum {
  Android = 'android',
  Ios = 'ios'
}

export type PushTokenPlatformFilters = {
  OR: InputMaybe<Array<PushTokenPlatformfiltersOr>>;
  eq: InputMaybe<PushTokenPlatformEnum>;
  gt: InputMaybe<PushTokenPlatformEnum>;
  gte: InputMaybe<PushTokenPlatformEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<PushTokenPlatformEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<PushTokenPlatformEnum>;
  lte: InputMaybe<PushTokenPlatformEnum>;
  ne: InputMaybe<PushTokenPlatformEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<PushTokenPlatformEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenPlatformfiltersOr = {
  eq: InputMaybe<PushTokenPlatformEnum>;
  gt: InputMaybe<PushTokenPlatformEnum>;
  gte: InputMaybe<PushTokenPlatformEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<PushTokenPlatformEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<PushTokenPlatformEnum>;
  lte: InputMaybe<PushTokenPlatformEnum>;
  ne: InputMaybe<PushTokenPlatformEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<PushTokenPlatformEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenUpdatedAtFilters = {
  OR: InputMaybe<Array<PushTokenUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenUpdatedByFilters = {
  OR: InputMaybe<Array<PushTokenUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenUserIdFilters = {
  OR: InputMaybe<Array<PushTokenUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type PushTokenUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum ResourceType {
  Patient = 'patient',
  User = 'user'
}

export type SchedulerLogChosenOptionIndexFilters = {
  OR: InputMaybe<Array<SchedulerLogChosenOptionIndexfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogChosenOptionIndexfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogCreatedAtFilters = {
  OR: InputMaybe<Array<SchedulerLogCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogCreatedByFilters = {
  OR: InputMaybe<Array<SchedulerLogCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogDeletedFilters = {
  OR: InputMaybe<Array<SchedulerLogDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogFilters = {
  OR: InputMaybe<Array<SchedulerLogFiltersOr>>;
  chosenOptionIndex: InputMaybe<SchedulerLogChosenOptionIndexFilters>;
  createdAt: InputMaybe<SchedulerLogCreatedAtFilters>;
  createdBy: InputMaybe<SchedulerLogCreatedByFilters>;
  deleted: InputMaybe<SchedulerLogDeletedFilters>;
  id: InputMaybe<SchedulerLogIdFilters>;
  logData: InputMaybe<SchedulerLogLogDataFilters>;
  organizationId: InputMaybe<SchedulerLogOrganizationIdFilters>;
  patientId: InputMaybe<SchedulerLogPatientIdFilters>;
  runId: InputMaybe<SchedulerLogRunIdFilters>;
  updatedAt: InputMaybe<SchedulerLogUpdatedAtFilters>;
  updatedBy: InputMaybe<SchedulerLogUpdatedByFilters>;
  visitId: InputMaybe<SchedulerLogVisitIdFilters>;
};

export type SchedulerLogFiltersOr = {
  chosenOptionIndex: InputMaybe<SchedulerLogChosenOptionIndexFilters>;
  createdAt: InputMaybe<SchedulerLogCreatedAtFilters>;
  createdBy: InputMaybe<SchedulerLogCreatedByFilters>;
  deleted: InputMaybe<SchedulerLogDeletedFilters>;
  id: InputMaybe<SchedulerLogIdFilters>;
  logData: InputMaybe<SchedulerLogLogDataFilters>;
  organizationId: InputMaybe<SchedulerLogOrganizationIdFilters>;
  patientId: InputMaybe<SchedulerLogPatientIdFilters>;
  runId: InputMaybe<SchedulerLogRunIdFilters>;
  updatedAt: InputMaybe<SchedulerLogUpdatedAtFilters>;
  updatedBy: InputMaybe<SchedulerLogUpdatedByFilters>;
  visitId: InputMaybe<SchedulerLogVisitIdFilters>;
};

export type SchedulerLogIdFilters = {
  OR: InputMaybe<Array<SchedulerLogIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogLogDataFilters = {
  OR: InputMaybe<Array<SchedulerLogLogDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogLogDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogOrderBy = {
  chosenOptionIndex: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  logData: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  patientId: InputMaybe<InnerOrder>;
  runId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitId: InputMaybe<InnerOrder>;
};

export type SchedulerLogOrganizationIdFilters = {
  OR: InputMaybe<Array<SchedulerLogOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogPatientIdFilters = {
  OR: InputMaybe<Array<SchedulerLogPatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogPatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogRunIdFilters = {
  OR: InputMaybe<Array<SchedulerLogRunIdfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogRunIdfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogUpdatedAtFilters = {
  OR: InputMaybe<Array<SchedulerLogUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogUpdatedByFilters = {
  OR: InputMaybe<Array<SchedulerLogUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogVisitIdFilters = {
  OR: InputMaybe<Array<SchedulerLogVisitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SchedulerLogVisitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceActiveFilters = {
  OR: InputMaybe<Array<ServiceActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCreatedAtFilters = {
  OR: InputMaybe<Array<ServiceCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCreatedByFilters = {
  OR: InputMaybe<Array<ServiceCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceDeletedFilters = {
  OR: InputMaybe<Array<ServiceDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceDescriptionFilters = {
  OR: InputMaybe<Array<ServiceDescriptionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceDescriptionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceDurationFilters = {
  OR: InputMaybe<Array<ServiceDurationfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceDurationfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceFilters = {
  OR: InputMaybe<Array<ServiceFiltersOr>>;
  active: InputMaybe<ServiceActiveFilters>;
  createdAt: InputMaybe<ServiceCreatedAtFilters>;
  createdBy: InputMaybe<ServiceCreatedByFilters>;
  deleted: InputMaybe<ServiceDeletedFilters>;
  description: InputMaybe<ServiceDescriptionFilters>;
  duration: InputMaybe<ServiceDurationFilters>;
  id: InputMaybe<ServiceIdFilters>;
  name: InputMaybe<ServiceNameFilters>;
  organizationId: InputMaybe<ServiceOrganizationIdFilters>;
  updatedAt: InputMaybe<ServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceUpdatedByFilters>;
};

export type ServiceFiltersOr = {
  active: InputMaybe<ServiceActiveFilters>;
  createdAt: InputMaybe<ServiceCreatedAtFilters>;
  createdBy: InputMaybe<ServiceCreatedByFilters>;
  deleted: InputMaybe<ServiceDeletedFilters>;
  description: InputMaybe<ServiceDescriptionFilters>;
  duration: InputMaybe<ServiceDurationFilters>;
  id: InputMaybe<ServiceIdFilters>;
  name: InputMaybe<ServiceNameFilters>;
  organizationId: InputMaybe<ServiceOrganizationIdFilters>;
  updatedAt: InputMaybe<ServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceUpdatedByFilters>;
};

export type ServiceIdFilters = {
  OR: InputMaybe<Array<ServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineCreatedAtFilters = {
  OR: InputMaybe<Array<ServiceLineCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineCreatedByFilters = {
  OR: InputMaybe<Array<ServiceLineCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineDeletedFilters = {
  OR: InputMaybe<Array<ServiceLineDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineFilters = {
  OR: InputMaybe<Array<ServiceLineFiltersOr>>;
  createdAt: InputMaybe<ServiceLineCreatedAtFilters>;
  createdBy: InputMaybe<ServiceLineCreatedByFilters>;
  deleted: InputMaybe<ServiceLineDeletedFilters>;
  id: InputMaybe<ServiceLineIdFilters>;
  name: InputMaybe<ServiceLineNameFilters>;
  organizationId: InputMaybe<ServiceLineOrganizationIdFilters>;
  schedulingConfig: InputMaybe<ServiceLineSchedulingConfigFilters>;
  updatedAt: InputMaybe<ServiceLineUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceLineUpdatedByFilters>;
};

export type ServiceLineFiltersOr = {
  createdAt: InputMaybe<ServiceLineCreatedAtFilters>;
  createdBy: InputMaybe<ServiceLineCreatedByFilters>;
  deleted: InputMaybe<ServiceLineDeletedFilters>;
  id: InputMaybe<ServiceLineIdFilters>;
  name: InputMaybe<ServiceLineNameFilters>;
  organizationId: InputMaybe<ServiceLineOrganizationIdFilters>;
  schedulingConfig: InputMaybe<ServiceLineSchedulingConfigFilters>;
  updatedAt: InputMaybe<ServiceLineUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceLineUpdatedByFilters>;
};

export type ServiceLineIdFilters = {
  OR: InputMaybe<Array<ServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineNameFilters = {
  OR: InputMaybe<Array<ServiceLineNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  schedulingConfig: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ServiceLineOrgUserCreatedAtFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserCreatedByFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserDeletedFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserFiltersOr>>;
  createdAt: InputMaybe<ServiceLineOrgUserCreatedAtFilters>;
  createdBy: InputMaybe<ServiceLineOrgUserCreatedByFilters>;
  deleted: InputMaybe<ServiceLineOrgUserDeletedFilters>;
  id: InputMaybe<ServiceLineOrgUserIdFilters>;
  organizationId: InputMaybe<ServiceLineOrgUserOrganizationIdFilters>;
  organizationUserId: InputMaybe<ServiceLineOrgUserOrganizationUserIdFilters>;
  serviceLineId: InputMaybe<ServiceLineOrgUserServiceLineIdFilters>;
  updatedAt: InputMaybe<ServiceLineOrgUserUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceLineOrgUserUpdatedByFilters>;
};

export type ServiceLineOrgUserFiltersOr = {
  createdAt: InputMaybe<ServiceLineOrgUserCreatedAtFilters>;
  createdBy: InputMaybe<ServiceLineOrgUserCreatedByFilters>;
  deleted: InputMaybe<ServiceLineOrgUserDeletedFilters>;
  id: InputMaybe<ServiceLineOrgUserIdFilters>;
  organizationId: InputMaybe<ServiceLineOrgUserOrganizationIdFilters>;
  organizationUserId: InputMaybe<ServiceLineOrgUserOrganizationUserIdFilters>;
  serviceLineId: InputMaybe<ServiceLineOrgUserServiceLineIdFilters>;
  updatedAt: InputMaybe<ServiceLineOrgUserUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceLineOrgUserUpdatedByFilters>;
};

export type ServiceLineOrgUserIdFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  organizationUserId: InputMaybe<InnerOrder>;
  serviceLineId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ServiceLineOrgUserOrganizationIdFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserOrganizationUserIdFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserOrganizationUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserOrganizationUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserRevisionHistoryFiltersOr>>;
  action: InputMaybe<ServiceLineOrgUserRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ServiceLineOrgUserRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ServiceLineOrgUserRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ServiceLineOrgUserRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ServiceLineOrgUserRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ServiceLineOrgUserRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceLineOrgUserRevisionHistoryUpdatedByFilters>;
};

export type ServiceLineOrgUserRevisionHistoryFiltersOr = {
  action: InputMaybe<ServiceLineOrgUserRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ServiceLineOrgUserRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ServiceLineOrgUserRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ServiceLineOrgUserRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ServiceLineOrgUserRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ServiceLineOrgUserRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceLineOrgUserRevisionHistoryUpdatedByFilters>;
};

export type ServiceLineOrgUserRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ServiceLineOrgUserRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserServiceLineIdFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserUpdatedAtFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserUpdatedByFilters = {
  OR: InputMaybe<Array<ServiceLineOrgUserUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrgUserUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrganizationIdFilters = {
  OR: InputMaybe<Array<ServiceLineOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ServiceLineRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ServiceLineRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryFilters = {
  OR: InputMaybe<Array<ServiceLineRevisionHistoryFiltersOr>>;
  action: InputMaybe<ServiceLineRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ServiceLineRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ServiceLineRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ServiceLineRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ServiceLineRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ServiceLineRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceLineRevisionHistoryUpdatedByFilters>;
};

export type ServiceLineRevisionHistoryFiltersOr = {
  action: InputMaybe<ServiceLineRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ServiceLineRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ServiceLineRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ServiceLineRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ServiceLineRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ServiceLineRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceLineRevisionHistoryUpdatedByFilters>;
};

export type ServiceLineRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ServiceLineRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ServiceLineRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ServiceLineRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ServiceLineRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ServiceLineRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ServiceLineRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineSchedulingConfig = {
  autoschedulerGroups: InputMaybe<Scalars['Int']['input']>;
  ignoreDriveTimeShiftEnd: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDriveTimeShiftStart: InputMaybe<Scalars['Boolean']['input']>;
  minutesOfBufferTime: InputMaybe<Scalars['Int']['input']>;
  scoreWeights: InputMaybe<ServiceLineSchedulingConfigScoreWeights>;
  showClinicalConstraintsDialog: InputMaybe<Scalars['Boolean']['input']>;
  useAutoscheduler: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServiceLineSchedulingConfigFilters = {
  OR: InputMaybe<Array<ServiceLineSchedulingConfigfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineSchedulingConfigScoreWeights = {
  driveWeight: InputMaybe<Scalars['Int']['input']>;
  proximityWeight: InputMaybe<Scalars['Int']['input']>;
  shiftShorteningPenaltyWeight: InputMaybe<Scalars['Int']['input']>;
  utilizationWeight: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceLineSchedulingConfigfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineUpdatedAtFilters = {
  OR: InputMaybe<Array<ServiceLineUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineUpdatedByFilters = {
  OR: InputMaybe<Array<ServiceLineUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceLineUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceNameFilters = {
  OR: InputMaybe<Array<ServiceNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceOrderBy = {
  active: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  description: InputMaybe<InnerOrder>;
  duration: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ServiceOrganizationIdFilters = {
  OR: InputMaybe<Array<ServiceOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ServiceRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ServiceRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryFilters = {
  OR: InputMaybe<Array<ServiceRevisionHistoryFiltersOr>>;
  action: InputMaybe<ServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceRevisionHistoryUpdatedByFilters>;
};

export type ServiceRevisionHistoryFiltersOr = {
  action: InputMaybe<ServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ServiceRevisionHistoryUpdatedByFilters>;
};

export type ServiceRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ServiceRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ServiceRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ServiceRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ServiceRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ServiceRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ServiceRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceUpdatedAtFilters = {
  OR: InputMaybe<Array<ServiceUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceUpdatedByFilters = {
  OR: InputMaybe<Array<ServiceUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ServiceUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type Shift = {
  addressCoordinates: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  providerId: Scalars['Int']['input'];
  shiftCenter: InputMaybe<ShiftShiftCenter>;
  startTime: Scalars['String']['input'];
  useShiftCenterDriveTimes: Scalars['Boolean']['input'];
};

export type ShiftAddressCityFilters = {
  OR: InputMaybe<Array<ShiftAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressCoordinatesFilters = {
  OR: InputMaybe<Array<ShiftAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressLineTwoFilters = {
  OR: InputMaybe<Array<ShiftAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressStateFilters = {
  OR: InputMaybe<Array<ShiftAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressStreetFilters = {
  OR: InputMaybe<Array<ShiftAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressTimezoneFilters = {
  OR: InputMaybe<Array<ShiftAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressZipFilters = {
  OR: InputMaybe<Array<ShiftAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressCityFilters = {
  OR: InputMaybe<Array<ShiftCenterAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressCoordinatesFilters = {
  OR: InputMaybe<Array<ShiftCenterAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressLineTwoFilters = {
  OR: InputMaybe<Array<ShiftCenterAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressStateFilters = {
  OR: InputMaybe<Array<ShiftCenterAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressStreetFilters = {
  OR: InputMaybe<Array<ShiftCenterAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressTimezoneFilters = {
  OR: InputMaybe<Array<ShiftCenterAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressZipFilters = {
  OR: InputMaybe<Array<ShiftCenterAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterCreatedAtFilters = {
  OR: InputMaybe<Array<ShiftCenterCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterCreatedByFilters = {
  OR: InputMaybe<Array<ShiftCenterCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterDeletedFilters = {
  OR: InputMaybe<Array<ShiftCenterDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterFilters = {
  OR: InputMaybe<Array<ShiftCenterFiltersOr>>;
  addressCity: InputMaybe<ShiftCenterAddressCityFilters>;
  addressCoordinates: InputMaybe<ShiftCenterAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<ShiftCenterAddressLineTwoFilters>;
  addressState: InputMaybe<ShiftCenterAddressStateFilters>;
  addressStreet: InputMaybe<ShiftCenterAddressStreetFilters>;
  addressTimezone: InputMaybe<ShiftCenterAddressTimezoneFilters>;
  addressZip: InputMaybe<ShiftCenterAddressZipFilters>;
  createdAt: InputMaybe<ShiftCenterCreatedAtFilters>;
  createdBy: InputMaybe<ShiftCenterCreatedByFilters>;
  deleted: InputMaybe<ShiftCenterDeletedFilters>;
  id: InputMaybe<ShiftCenterIdFilters>;
  name: InputMaybe<ShiftCenterNameFilters>;
  organizationId: InputMaybe<ShiftCenterOrganizationIdFilters>;
  organizationalUnitId: InputMaybe<ShiftCenterOrganizationalUnitIdFilters>;
  shiftOptimizerSector: InputMaybe<ShiftCenterShiftOptimizerSectorFilters>;
  updatedAt: InputMaybe<ShiftCenterUpdatedAtFilters>;
  updatedBy: InputMaybe<ShiftCenterUpdatedByFilters>;
};

export type ShiftCenterFiltersOr = {
  addressCity: InputMaybe<ShiftCenterAddressCityFilters>;
  addressCoordinates: InputMaybe<ShiftCenterAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<ShiftCenterAddressLineTwoFilters>;
  addressState: InputMaybe<ShiftCenterAddressStateFilters>;
  addressStreet: InputMaybe<ShiftCenterAddressStreetFilters>;
  addressTimezone: InputMaybe<ShiftCenterAddressTimezoneFilters>;
  addressZip: InputMaybe<ShiftCenterAddressZipFilters>;
  createdAt: InputMaybe<ShiftCenterCreatedAtFilters>;
  createdBy: InputMaybe<ShiftCenterCreatedByFilters>;
  deleted: InputMaybe<ShiftCenterDeletedFilters>;
  id: InputMaybe<ShiftCenterIdFilters>;
  name: InputMaybe<ShiftCenterNameFilters>;
  organizationId: InputMaybe<ShiftCenterOrganizationIdFilters>;
  organizationalUnitId: InputMaybe<ShiftCenterOrganizationalUnitIdFilters>;
  shiftOptimizerSector: InputMaybe<ShiftCenterShiftOptimizerSectorFilters>;
  updatedAt: InputMaybe<ShiftCenterUpdatedAtFilters>;
  updatedBy: InputMaybe<ShiftCenterUpdatedByFilters>;
};

export type ShiftCenterIdFilters = {
  OR: InputMaybe<Array<ShiftCenterIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterNameFilters = {
  OR: InputMaybe<Array<ShiftCenterNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  organizationalUnitId: InputMaybe<InnerOrder>;
  shiftOptimizerSector: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ShiftCenterOrganizationIdFilters = {
  OR: InputMaybe<Array<ShiftCenterOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterOrganizationalUnitIdFilters = {
  OR: InputMaybe<Array<ShiftCenterOrganizationalUnitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterOrganizationalUnitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ShiftCenterRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ShiftCenterRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryFilters = {
  OR: InputMaybe<Array<ShiftCenterRevisionHistoryFiltersOr>>;
  action: InputMaybe<ShiftCenterRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ShiftCenterRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ShiftCenterRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ShiftCenterRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ShiftCenterRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ShiftCenterRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ShiftCenterRevisionHistoryUpdatedByFilters>;
};

export type ShiftCenterRevisionHistoryFiltersOr = {
  action: InputMaybe<ShiftCenterRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ShiftCenterRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ShiftCenterRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ShiftCenterRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ShiftCenterRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ShiftCenterRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ShiftCenterRevisionHistoryUpdatedByFilters>;
};

export type ShiftCenterRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ShiftCenterRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ShiftCenterRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ShiftCenterRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ShiftCenterRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ShiftCenterRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ShiftCenterRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterShiftOptimizerSectorFilters = {
  OR: InputMaybe<Array<ShiftCenterShiftOptimizerSectorfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterShiftOptimizerSectorfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterUpdatedAtFilters = {
  OR: InputMaybe<Array<ShiftCenterUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterUpdatedByFilters = {
  OR: InputMaybe<Array<ShiftCenterUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCenterUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCreatedAtFilters = {
  OR: InputMaybe<Array<ShiftCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCreatedByFilters = {
  OR: InputMaybe<Array<ShiftCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftDeletedFilters = {
  OR: InputMaybe<Array<ShiftDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftEndTimeFilters = {
  OR: InputMaybe<Array<ShiftEndTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftEndTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftFilters = {
  OR: InputMaybe<Array<ShiftFiltersOr>>;
  addressCity: InputMaybe<ShiftAddressCityFilters>;
  addressCoordinates: InputMaybe<ShiftAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<ShiftAddressLineTwoFilters>;
  addressState: InputMaybe<ShiftAddressStateFilters>;
  addressStreet: InputMaybe<ShiftAddressStreetFilters>;
  addressTimezone: InputMaybe<ShiftAddressTimezoneFilters>;
  addressZip: InputMaybe<ShiftAddressZipFilters>;
  createdAt: InputMaybe<ShiftCreatedAtFilters>;
  createdBy: InputMaybe<ShiftCreatedByFilters>;
  deleted: InputMaybe<ShiftDeletedFilters>;
  endTime: InputMaybe<ShiftEndTimeFilters>;
  id: InputMaybe<ShiftIdFilters>;
  manualEdits: InputMaybe<ShiftManualEditsFilters>;
  organizationId: InputMaybe<ShiftOrganizationIdFilters>;
  overflowShift: InputMaybe<ShiftOverflowShiftFilters>;
  providerId: InputMaybe<ShiftProviderIdFilters>;
  providerTravel: InputMaybe<ShiftProviderTravelFilters>;
  shiftCenterId: InputMaybe<ShiftShiftCenterIdFilters>;
  shiftOptimizerSector: InputMaybe<ShiftShiftOptimizerSectorFilters>;
  startTime: InputMaybe<ShiftStartTimeFilters>;
  status: InputMaybe<ShiftStatusFilters>;
  updatedAt: InputMaybe<ShiftUpdatedAtFilters>;
  updatedBy: InputMaybe<ShiftUpdatedByFilters>;
  useShiftCenterDriveTimes: InputMaybe<ShiftUseShiftCenterDriveTimesFilters>;
};

export type ShiftFiltersOr = {
  addressCity: InputMaybe<ShiftAddressCityFilters>;
  addressCoordinates: InputMaybe<ShiftAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<ShiftAddressLineTwoFilters>;
  addressState: InputMaybe<ShiftAddressStateFilters>;
  addressStreet: InputMaybe<ShiftAddressStreetFilters>;
  addressTimezone: InputMaybe<ShiftAddressTimezoneFilters>;
  addressZip: InputMaybe<ShiftAddressZipFilters>;
  createdAt: InputMaybe<ShiftCreatedAtFilters>;
  createdBy: InputMaybe<ShiftCreatedByFilters>;
  deleted: InputMaybe<ShiftDeletedFilters>;
  endTime: InputMaybe<ShiftEndTimeFilters>;
  id: InputMaybe<ShiftIdFilters>;
  manualEdits: InputMaybe<ShiftManualEditsFilters>;
  organizationId: InputMaybe<ShiftOrganizationIdFilters>;
  overflowShift: InputMaybe<ShiftOverflowShiftFilters>;
  providerId: InputMaybe<ShiftProviderIdFilters>;
  providerTravel: InputMaybe<ShiftProviderTravelFilters>;
  shiftCenterId: InputMaybe<ShiftShiftCenterIdFilters>;
  shiftOptimizerSector: InputMaybe<ShiftShiftOptimizerSectorFilters>;
  startTime: InputMaybe<ShiftStartTimeFilters>;
  status: InputMaybe<ShiftStatusFilters>;
  updatedAt: InputMaybe<ShiftUpdatedAtFilters>;
  updatedBy: InputMaybe<ShiftUpdatedByFilters>;
  useShiftCenterDriveTimes: InputMaybe<ShiftUseShiftCenterDriveTimesFilters>;
};

export type ShiftIdFilters = {
  OR: InputMaybe<Array<ShiftIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftManualEditsFilters = {
  OR: InputMaybe<Array<ShiftManualEditsfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftManualEditsfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  endTime: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  manualEdits: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  overflowShift: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  providerTravel: InputMaybe<InnerOrder>;
  shiftCenterId: InputMaybe<InnerOrder>;
  shiftOptimizerSector: InputMaybe<InnerOrder>;
  startTime: InputMaybe<InnerOrder>;
  status: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  useShiftCenterDriveTimes: InputMaybe<InnerOrder>;
};

export type ShiftOrganizationIdFilters = {
  OR: InputMaybe<Array<ShiftOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftOverflowShiftFilters = {
  OR: InputMaybe<Array<ShiftOverflowShiftfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftOverflowShiftfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftProviderIdFilters = {
  OR: InputMaybe<Array<ShiftProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum ShiftProviderTravelEnum {
  Either = 'either',
  InHomeOnly = 'inHomeOnly',
  VirtualOnly = 'virtualOnly'
}

export type ShiftProviderTravelFilters = {
  OR: InputMaybe<Array<ShiftProviderTravelfiltersOr>>;
  eq: InputMaybe<ShiftProviderTravelEnum>;
  gt: InputMaybe<ShiftProviderTravelEnum>;
  gte: InputMaybe<ShiftProviderTravelEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ShiftProviderTravelEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ShiftProviderTravelEnum>;
  lte: InputMaybe<ShiftProviderTravelEnum>;
  ne: InputMaybe<ShiftProviderTravelEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ShiftProviderTravelEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftProviderTravelfiltersOr = {
  eq: InputMaybe<ShiftProviderTravelEnum>;
  gt: InputMaybe<ShiftProviderTravelEnum>;
  gte: InputMaybe<ShiftProviderTravelEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ShiftProviderTravelEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ShiftProviderTravelEnum>;
  lte: InputMaybe<ShiftProviderTravelEnum>;
  ne: InputMaybe<ShiftProviderTravelEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ShiftProviderTravelEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<ShiftRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<ShiftRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryFilters = {
  OR: InputMaybe<Array<ShiftRevisionHistoryFiltersOr>>;
  action: InputMaybe<ShiftRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ShiftRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ShiftRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ShiftRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ShiftRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ShiftRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ShiftRevisionHistoryUpdatedByFilters>;
};

export type ShiftRevisionHistoryFiltersOr = {
  action: InputMaybe<ShiftRevisionHistoryActionFilters>;
  changedFields: InputMaybe<ShiftRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<ShiftRevisionHistoryIdFilters>;
  organizationId: InputMaybe<ShiftRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<ShiftRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<ShiftRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<ShiftRevisionHistoryUpdatedByFilters>;
};

export type ShiftRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<ShiftRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type ShiftRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<ShiftRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<ShiftRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<ShiftRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<ShiftRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftShiftCenter = {
  addressCoordinates: Scalars['String']['input'];
};

export type ShiftShiftCenterIdFilters = {
  OR: InputMaybe<Array<ShiftShiftCenterIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftShiftCenterIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftShiftOptimizerSectorFilters = {
  OR: InputMaybe<Array<ShiftShiftOptimizerSectorfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftShiftOptimizerSectorfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftStartTimeFilters = {
  OR: InputMaybe<Array<ShiftStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum ShiftStatusEnum {
  Canceled = 'canceled',
  Confirmed = 'confirmed'
}

export type ShiftStatusFilters = {
  OR: InputMaybe<Array<ShiftStatusfiltersOr>>;
  eq: InputMaybe<ShiftStatusEnum>;
  gt: InputMaybe<ShiftStatusEnum>;
  gte: InputMaybe<ShiftStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ShiftStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ShiftStatusEnum>;
  lte: InputMaybe<ShiftStatusEnum>;
  ne: InputMaybe<ShiftStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ShiftStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftStatusfiltersOr = {
  eq: InputMaybe<ShiftStatusEnum>;
  gt: InputMaybe<ShiftStatusEnum>;
  gte: InputMaybe<ShiftStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<ShiftStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<ShiftStatusEnum>;
  lte: InputMaybe<ShiftStatusEnum>;
  ne: InputMaybe<ShiftStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<ShiftStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftUpdatedAtFilters = {
  OR: InputMaybe<Array<ShiftUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftUpdatedByFilters = {
  OR: InputMaybe<Array<ShiftUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftUseShiftCenterDriveTimesFilters = {
  OR: InputMaybe<Array<ShiftUseShiftCenterDriveTimesfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type ShiftUseShiftCenterDriveTimesfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressCityFilters = {
  OR: InputMaybe<Array<SosAlertAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressCoordinatesFilters = {
  OR: InputMaybe<Array<SosAlertAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressLineTwoFilters = {
  OR: InputMaybe<Array<SosAlertAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressStateFilters = {
  OR: InputMaybe<Array<SosAlertAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressStreetFilters = {
  OR: InputMaybe<Array<SosAlertAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressTimezoneFilters = {
  OR: InputMaybe<Array<SosAlertAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressZipFilters = {
  OR: InputMaybe<Array<SosAlertAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertCreatedAtFilters = {
  OR: InputMaybe<Array<SosAlertCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertCreatedByFilters = {
  OR: InputMaybe<Array<SosAlertCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertDeletedFilters = {
  OR: InputMaybe<Array<SosAlertDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventCreatedAtFilters = {
  OR: InputMaybe<Array<SosAlertEventCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventCreatedByFilters = {
  OR: InputMaybe<Array<SosAlertEventCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventDeletedFilters = {
  OR: InputMaybe<Array<SosAlertEventDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum SosAlertEventEventTypeEnum {
  Acknowledged = 'acknowledged',
  Canceled = 'canceled',
  Created = 'created',
  NoteAdded = 'note_added',
  Resolved = 'resolved'
}

export type SosAlertEventEventTypeFilters = {
  OR: InputMaybe<Array<SosAlertEventEventTypefiltersOr>>;
  eq: InputMaybe<SosAlertEventEventTypeEnum>;
  gt: InputMaybe<SosAlertEventEventTypeEnum>;
  gte: InputMaybe<SosAlertEventEventTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<SosAlertEventEventTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<SosAlertEventEventTypeEnum>;
  lte: InputMaybe<SosAlertEventEventTypeEnum>;
  ne: InputMaybe<SosAlertEventEventTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<SosAlertEventEventTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventEventTypefiltersOr = {
  eq: InputMaybe<SosAlertEventEventTypeEnum>;
  gt: InputMaybe<SosAlertEventEventTypeEnum>;
  gte: InputMaybe<SosAlertEventEventTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<SosAlertEventEventTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<SosAlertEventEventTypeEnum>;
  lte: InputMaybe<SosAlertEventEventTypeEnum>;
  ne: InputMaybe<SosAlertEventEventTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<SosAlertEventEventTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventFilters = {
  OR: InputMaybe<Array<SosAlertEventFiltersOr>>;
  createdAt: InputMaybe<SosAlertEventCreatedAtFilters>;
  createdBy: InputMaybe<SosAlertEventCreatedByFilters>;
  deleted: InputMaybe<SosAlertEventDeletedFilters>;
  eventType: InputMaybe<SosAlertEventEventTypeFilters>;
  id: InputMaybe<SosAlertEventIdFilters>;
  note: InputMaybe<SosAlertEventNoteFilters>;
  organizationId: InputMaybe<SosAlertEventOrganizationIdFilters>;
  sosAlertId: InputMaybe<SosAlertEventSosAlertIdFilters>;
  updatedAt: InputMaybe<SosAlertEventUpdatedAtFilters>;
  updatedBy: InputMaybe<SosAlertEventUpdatedByFilters>;
};

export type SosAlertEventFiltersOr = {
  createdAt: InputMaybe<SosAlertEventCreatedAtFilters>;
  createdBy: InputMaybe<SosAlertEventCreatedByFilters>;
  deleted: InputMaybe<SosAlertEventDeletedFilters>;
  eventType: InputMaybe<SosAlertEventEventTypeFilters>;
  id: InputMaybe<SosAlertEventIdFilters>;
  note: InputMaybe<SosAlertEventNoteFilters>;
  organizationId: InputMaybe<SosAlertEventOrganizationIdFilters>;
  sosAlertId: InputMaybe<SosAlertEventSosAlertIdFilters>;
  updatedAt: InputMaybe<SosAlertEventUpdatedAtFilters>;
  updatedBy: InputMaybe<SosAlertEventUpdatedByFilters>;
};

export type SosAlertEventIdFilters = {
  OR: InputMaybe<Array<SosAlertEventIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventNoteFilters = {
  OR: InputMaybe<Array<SosAlertEventNotefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventNotefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  eventType: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  note: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  sosAlertId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type SosAlertEventOrganizationIdFilters = {
  OR: InputMaybe<Array<SosAlertEventOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventSosAlertIdFilters = {
  OR: InputMaybe<Array<SosAlertEventSosAlertIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventSosAlertIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventUpdatedAtFilters = {
  OR: InputMaybe<Array<SosAlertEventUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventUpdatedByFilters = {
  OR: InputMaybe<Array<SosAlertEventUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertEventUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertFilters = {
  OR: InputMaybe<Array<SosAlertFiltersOr>>;
  addressCity: InputMaybe<SosAlertAddressCityFilters>;
  addressCoordinates: InputMaybe<SosAlertAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<SosAlertAddressLineTwoFilters>;
  addressState: InputMaybe<SosAlertAddressStateFilters>;
  addressStreet: InputMaybe<SosAlertAddressStreetFilters>;
  addressTimezone: InputMaybe<SosAlertAddressTimezoneFilters>;
  addressZip: InputMaybe<SosAlertAddressZipFilters>;
  createdAt: InputMaybe<SosAlertCreatedAtFilters>;
  createdBy: InputMaybe<SosAlertCreatedByFilters>;
  deleted: InputMaybe<SosAlertDeletedFilters>;
  id: InputMaybe<SosAlertIdFilters>;
  latitude: InputMaybe<SosAlertLatitudeFilters>;
  longitude: InputMaybe<SosAlertLongitudeFilters>;
  organizationId: InputMaybe<SosAlertOrganizationIdFilters>;
  providerId: InputMaybe<SosAlertProviderIdFilters>;
  providerStatus: InputMaybe<SosAlertProviderStatusFilters>;
  status: InputMaybe<SosAlertStatusFilters>;
  updatedAt: InputMaybe<SosAlertUpdatedAtFilters>;
  updatedBy: InputMaybe<SosAlertUpdatedByFilters>;
  visitId: InputMaybe<SosAlertVisitIdFilters>;
};

export type SosAlertFiltersOr = {
  addressCity: InputMaybe<SosAlertAddressCityFilters>;
  addressCoordinates: InputMaybe<SosAlertAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<SosAlertAddressLineTwoFilters>;
  addressState: InputMaybe<SosAlertAddressStateFilters>;
  addressStreet: InputMaybe<SosAlertAddressStreetFilters>;
  addressTimezone: InputMaybe<SosAlertAddressTimezoneFilters>;
  addressZip: InputMaybe<SosAlertAddressZipFilters>;
  createdAt: InputMaybe<SosAlertCreatedAtFilters>;
  createdBy: InputMaybe<SosAlertCreatedByFilters>;
  deleted: InputMaybe<SosAlertDeletedFilters>;
  id: InputMaybe<SosAlertIdFilters>;
  latitude: InputMaybe<SosAlertLatitudeFilters>;
  longitude: InputMaybe<SosAlertLongitudeFilters>;
  organizationId: InputMaybe<SosAlertOrganizationIdFilters>;
  providerId: InputMaybe<SosAlertProviderIdFilters>;
  providerStatus: InputMaybe<SosAlertProviderStatusFilters>;
  status: InputMaybe<SosAlertStatusFilters>;
  updatedAt: InputMaybe<SosAlertUpdatedAtFilters>;
  updatedBy: InputMaybe<SosAlertUpdatedByFilters>;
  visitId: InputMaybe<SosAlertVisitIdFilters>;
};

export type SosAlertIdFilters = {
  OR: InputMaybe<Array<SosAlertIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertLatitudeFilters = {
  OR: InputMaybe<Array<SosAlertLatitudefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertLatitudefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertLongitudeFilters = {
  OR: InputMaybe<Array<SosAlertLongitudefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertLongitudefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  latitude: InputMaybe<InnerOrder>;
  longitude: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  providerStatus: InputMaybe<InnerOrder>;
  status: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitId: InputMaybe<InnerOrder>;
};

export type SosAlertOrganizationIdFilters = {
  OR: InputMaybe<Array<SosAlertOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertProviderIdFilters = {
  OR: InputMaybe<Array<SosAlertProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum SosAlertProviderStatusEnum {
  Arrived = 'arrived',
  Canceled = 'canceled',
  Complete = 'complete',
  EnRoute = 'en_route',
  InProgress = 'in_progress',
  Scheduled = 'scheduled'
}

export type SosAlertProviderStatusFilters = {
  OR: InputMaybe<Array<SosAlertProviderStatusfiltersOr>>;
  eq: InputMaybe<SosAlertProviderStatusEnum>;
  gt: InputMaybe<SosAlertProviderStatusEnum>;
  gte: InputMaybe<SosAlertProviderStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<SosAlertProviderStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<SosAlertProviderStatusEnum>;
  lte: InputMaybe<SosAlertProviderStatusEnum>;
  ne: InputMaybe<SosAlertProviderStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<SosAlertProviderStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertProviderStatusfiltersOr = {
  eq: InputMaybe<SosAlertProviderStatusEnum>;
  gt: InputMaybe<SosAlertProviderStatusEnum>;
  gte: InputMaybe<SosAlertProviderStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<SosAlertProviderStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<SosAlertProviderStatusEnum>;
  lte: InputMaybe<SosAlertProviderStatusEnum>;
  ne: InputMaybe<SosAlertProviderStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<SosAlertProviderStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum SosAlertStatusEnum {
  Acknowledged = 'acknowledged',
  Active = 'active',
  Canceled = 'canceled',
  Resolved = 'resolved'
}

export type SosAlertStatusFilters = {
  OR: InputMaybe<Array<SosAlertStatusfiltersOr>>;
  eq: InputMaybe<SosAlertStatusEnum>;
  gt: InputMaybe<SosAlertStatusEnum>;
  gte: InputMaybe<SosAlertStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<SosAlertStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<SosAlertStatusEnum>;
  lte: InputMaybe<SosAlertStatusEnum>;
  ne: InputMaybe<SosAlertStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<SosAlertStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertStatusfiltersOr = {
  eq: InputMaybe<SosAlertStatusEnum>;
  gt: InputMaybe<SosAlertStatusEnum>;
  gte: InputMaybe<SosAlertStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<SosAlertStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<SosAlertStatusEnum>;
  lte: InputMaybe<SosAlertStatusEnum>;
  ne: InputMaybe<SosAlertStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<SosAlertStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertUpdatedAtFilters = {
  OR: InputMaybe<Array<SosAlertUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertUpdatedByFilters = {
  OR: InputMaybe<Array<SosAlertUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertVisitIdFilters = {
  OR: InputMaybe<Array<SosAlertVisitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SosAlertVisitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonActiveFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonCreatedAtFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonCreatedByFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonDeletedFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum SupplyChangeReasonEventTypeEnum {
  Deposit = 'deposit',
  Recount = 'recount',
  Withdrawal = 'withdrawal'
}

export type SupplyChangeReasonEventTypeFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonEventTypefiltersOr>>;
  eq: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  gt: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  gte: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<SupplyChangeReasonEventTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  lte: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  ne: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<SupplyChangeReasonEventTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonEventTypefiltersOr = {
  eq: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  gt: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  gte: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<SupplyChangeReasonEventTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  lte: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  ne: InputMaybe<SupplyChangeReasonEventTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<SupplyChangeReasonEventTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonFiltersOr>>;
  active: InputMaybe<SupplyChangeReasonActiveFilters>;
  createdAt: InputMaybe<SupplyChangeReasonCreatedAtFilters>;
  createdBy: InputMaybe<SupplyChangeReasonCreatedByFilters>;
  deleted: InputMaybe<SupplyChangeReasonDeletedFilters>;
  eventType: InputMaybe<SupplyChangeReasonEventTypeFilters>;
  id: InputMaybe<SupplyChangeReasonIdFilters>;
  label: InputMaybe<SupplyChangeReasonLabelFilters>;
  organizationId: InputMaybe<SupplyChangeReasonOrganizationIdFilters>;
  updatedAt: InputMaybe<SupplyChangeReasonUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyChangeReasonUpdatedByFilters>;
};

export type SupplyChangeReasonFiltersOr = {
  active: InputMaybe<SupplyChangeReasonActiveFilters>;
  createdAt: InputMaybe<SupplyChangeReasonCreatedAtFilters>;
  createdBy: InputMaybe<SupplyChangeReasonCreatedByFilters>;
  deleted: InputMaybe<SupplyChangeReasonDeletedFilters>;
  eventType: InputMaybe<SupplyChangeReasonEventTypeFilters>;
  id: InputMaybe<SupplyChangeReasonIdFilters>;
  label: InputMaybe<SupplyChangeReasonLabelFilters>;
  organizationId: InputMaybe<SupplyChangeReasonOrganizationIdFilters>;
  updatedAt: InputMaybe<SupplyChangeReasonUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyChangeReasonUpdatedByFilters>;
};

export type SupplyChangeReasonIdFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonLabelFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonLabelfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonLabelfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonOrderBy = {
  active: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  eventType: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  label: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type SupplyChangeReasonOrganizationIdFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonRevisionHistoryFiltersOr>>;
  action: InputMaybe<SupplyChangeReasonRevisionHistoryActionFilters>;
  changedFields: InputMaybe<SupplyChangeReasonRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<SupplyChangeReasonRevisionHistoryIdFilters>;
  organizationId: InputMaybe<SupplyChangeReasonRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<SupplyChangeReasonRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<SupplyChangeReasonRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyChangeReasonRevisionHistoryUpdatedByFilters>;
};

export type SupplyChangeReasonRevisionHistoryFiltersOr = {
  action: InputMaybe<SupplyChangeReasonRevisionHistoryActionFilters>;
  changedFields: InputMaybe<SupplyChangeReasonRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<SupplyChangeReasonRevisionHistoryIdFilters>;
  organizationId: InputMaybe<SupplyChangeReasonRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<SupplyChangeReasonRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<SupplyChangeReasonRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyChangeReasonRevisionHistoryUpdatedByFilters>;
};

export type SupplyChangeReasonRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type SupplyChangeReasonRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonUpdatedAtFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonUpdatedByFilters = {
  OR: InputMaybe<Array<SupplyChangeReasonUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyChangeReasonUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventAmountFilters = {
  OR: InputMaybe<Array<SupplyEventAmountfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventAmountfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventCreatedAtFilters = {
  OR: InputMaybe<Array<SupplyEventCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventCreatedByFilters = {
  OR: InputMaybe<Array<SupplyEventCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventDeletedFilters = {
  OR: InputMaybe<Array<SupplyEventDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventFilters = {
  OR: InputMaybe<Array<SupplyEventFiltersOr>>;
  amount: InputMaybe<SupplyEventAmountFilters>;
  createdAt: InputMaybe<SupplyEventCreatedAtFilters>;
  createdBy: InputMaybe<SupplyEventCreatedByFilters>;
  deleted: InputMaybe<SupplyEventDeletedFilters>;
  id: InputMaybe<SupplyEventIdFilters>;
  note: InputMaybe<SupplyEventNoteFilters>;
  organizationId: InputMaybe<SupplyEventOrganizationIdFilters>;
  scannedBarcode: InputMaybe<SupplyEventScannedBarcodeFilters>;
  supplyChangeReasonId: InputMaybe<SupplyEventSupplyChangeReasonIdFilters>;
  supplyItemId: InputMaybe<SupplyEventSupplyItemIdFilters>;
  updatedAt: InputMaybe<SupplyEventUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyEventUpdatedByFilters>;
};

export type SupplyEventFiltersOr = {
  amount: InputMaybe<SupplyEventAmountFilters>;
  createdAt: InputMaybe<SupplyEventCreatedAtFilters>;
  createdBy: InputMaybe<SupplyEventCreatedByFilters>;
  deleted: InputMaybe<SupplyEventDeletedFilters>;
  id: InputMaybe<SupplyEventIdFilters>;
  note: InputMaybe<SupplyEventNoteFilters>;
  organizationId: InputMaybe<SupplyEventOrganizationIdFilters>;
  scannedBarcode: InputMaybe<SupplyEventScannedBarcodeFilters>;
  supplyChangeReasonId: InputMaybe<SupplyEventSupplyChangeReasonIdFilters>;
  supplyItemId: InputMaybe<SupplyEventSupplyItemIdFilters>;
  updatedAt: InputMaybe<SupplyEventUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyEventUpdatedByFilters>;
};

export type SupplyEventIdFilters = {
  OR: InputMaybe<Array<SupplyEventIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventNoteFilters = {
  OR: InputMaybe<Array<SupplyEventNotefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventNotefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventOrderBy = {
  amount: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  note: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  scannedBarcode: InputMaybe<InnerOrder>;
  supplyChangeReasonId: InputMaybe<InnerOrder>;
  supplyItemId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type SupplyEventOrganizationIdFilters = {
  OR: InputMaybe<Array<SupplyEventOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<SupplyEventRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<SupplyEventRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryFilters = {
  OR: InputMaybe<Array<SupplyEventRevisionHistoryFiltersOr>>;
  action: InputMaybe<SupplyEventRevisionHistoryActionFilters>;
  changedFields: InputMaybe<SupplyEventRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<SupplyEventRevisionHistoryIdFilters>;
  organizationId: InputMaybe<SupplyEventRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<SupplyEventRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<SupplyEventRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyEventRevisionHistoryUpdatedByFilters>;
};

export type SupplyEventRevisionHistoryFiltersOr = {
  action: InputMaybe<SupplyEventRevisionHistoryActionFilters>;
  changedFields: InputMaybe<SupplyEventRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<SupplyEventRevisionHistoryIdFilters>;
  organizationId: InputMaybe<SupplyEventRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<SupplyEventRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<SupplyEventRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyEventRevisionHistoryUpdatedByFilters>;
};

export type SupplyEventRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<SupplyEventRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type SupplyEventRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<SupplyEventRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<SupplyEventRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<SupplyEventRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<SupplyEventRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventScannedBarcodeFilters = {
  OR: InputMaybe<Array<SupplyEventScannedBarcodefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventScannedBarcodefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventSupplyChangeReasonIdFilters = {
  OR: InputMaybe<Array<SupplyEventSupplyChangeReasonIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventSupplyChangeReasonIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventSupplyItemIdFilters = {
  OR: InputMaybe<Array<SupplyEventSupplyItemIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventSupplyItemIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventUpdatedAtFilters = {
  OR: InputMaybe<Array<SupplyEventUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventUpdatedByFilters = {
  OR: InputMaybe<Array<SupplyEventUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyEventUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemActiveFilters = {
  OR: InputMaybe<Array<SupplyItemActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemBarcodeFilters = {
  OR: InputMaybe<Array<SupplyItemBarcodefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemBarcodefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemCreatedAtFilters = {
  OR: InputMaybe<Array<SupplyItemCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemCreatedByFilters = {
  OR: InputMaybe<Array<SupplyItemCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemCurrentStockFilters = {
  OR: InputMaybe<Array<SupplyItemCurrentStockfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemCurrentStockfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemDeletedFilters = {
  OR: InputMaybe<Array<SupplyItemDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemFilters = {
  OR: InputMaybe<Array<SupplyItemFiltersOr>>;
  active: InputMaybe<SupplyItemActiveFilters>;
  barcode: InputMaybe<SupplyItemBarcodeFilters>;
  createdAt: InputMaybe<SupplyItemCreatedAtFilters>;
  createdBy: InputMaybe<SupplyItemCreatedByFilters>;
  currentStock: InputMaybe<SupplyItemCurrentStockFilters>;
  deleted: InputMaybe<SupplyItemDeletedFilters>;
  id: InputMaybe<SupplyItemIdFilters>;
  label: InputMaybe<SupplyItemLabelFilters>;
  needsRecount: InputMaybe<SupplyItemNeedsRecountFilters>;
  organizationId: InputMaybe<SupplyItemOrganizationIdFilters>;
  updatedAt: InputMaybe<SupplyItemUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyItemUpdatedByFilters>;
};

export type SupplyItemFiltersOr = {
  active: InputMaybe<SupplyItemActiveFilters>;
  barcode: InputMaybe<SupplyItemBarcodeFilters>;
  createdAt: InputMaybe<SupplyItemCreatedAtFilters>;
  createdBy: InputMaybe<SupplyItemCreatedByFilters>;
  currentStock: InputMaybe<SupplyItemCurrentStockFilters>;
  deleted: InputMaybe<SupplyItemDeletedFilters>;
  id: InputMaybe<SupplyItemIdFilters>;
  label: InputMaybe<SupplyItemLabelFilters>;
  needsRecount: InputMaybe<SupplyItemNeedsRecountFilters>;
  organizationId: InputMaybe<SupplyItemOrganizationIdFilters>;
  updatedAt: InputMaybe<SupplyItemUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyItemUpdatedByFilters>;
};

export type SupplyItemIdFilters = {
  OR: InputMaybe<Array<SupplyItemIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemLabelFilters = {
  OR: InputMaybe<Array<SupplyItemLabelfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemLabelfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemNeedsRecountFilters = {
  OR: InputMaybe<Array<SupplyItemNeedsRecountfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemNeedsRecountfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemOrderBy = {
  active: InputMaybe<InnerOrder>;
  barcode: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  currentStock: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  label: InputMaybe<InnerOrder>;
  needsRecount: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type SupplyItemOrganizationIdFilters = {
  OR: InputMaybe<Array<SupplyItemOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<SupplyItemRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<SupplyItemRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryFilters = {
  OR: InputMaybe<Array<SupplyItemRevisionHistoryFiltersOr>>;
  action: InputMaybe<SupplyItemRevisionHistoryActionFilters>;
  changedFields: InputMaybe<SupplyItemRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<SupplyItemRevisionHistoryIdFilters>;
  organizationId: InputMaybe<SupplyItemRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<SupplyItemRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<SupplyItemRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyItemRevisionHistoryUpdatedByFilters>;
};

export type SupplyItemRevisionHistoryFiltersOr = {
  action: InputMaybe<SupplyItemRevisionHistoryActionFilters>;
  changedFields: InputMaybe<SupplyItemRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<SupplyItemRevisionHistoryIdFilters>;
  organizationId: InputMaybe<SupplyItemRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<SupplyItemRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<SupplyItemRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<SupplyItemRevisionHistoryUpdatedByFilters>;
};

export type SupplyItemRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<SupplyItemRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type SupplyItemRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<SupplyItemRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<SupplyItemRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<SupplyItemRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<SupplyItemRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemUpdatedAtFilters = {
  OR: InputMaybe<Array<SupplyItemUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemUpdatedByFilters = {
  OR: InputMaybe<Array<SupplyItemUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type SupplyItemUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskCreatedAtFilters = {
  OR: InputMaybe<Array<TaskCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskCreatedByFilters = {
  OR: InputMaybe<Array<TaskCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskDeletedFilters = {
  OR: InputMaybe<Array<TaskDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskDescriptionFilters = {
  OR: InputMaybe<Array<TaskDescriptionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskDescriptionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskDetailsFilters = {
  OR: InputMaybe<Array<TaskDetailsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskDetailsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskFilters = {
  OR: InputMaybe<Array<TaskFiltersOr>>;
  createdAt: InputMaybe<TaskCreatedAtFilters>;
  createdBy: InputMaybe<TaskCreatedByFilters>;
  deleted: InputMaybe<TaskDeletedFilters>;
  description: InputMaybe<TaskDescriptionFilters>;
  details: InputMaybe<TaskDetailsFilters>;
  id: InputMaybe<TaskIdFilters>;
  organizationId: InputMaybe<TaskOrganizationIdFilters>;
  patientId: InputMaybe<TaskPatientIdFilters>;
  status: InputMaybe<TaskStatusFilters>;
  taskType: InputMaybe<TaskTaskTypeFilters>;
  updatedAt: InputMaybe<TaskUpdatedAtFilters>;
  updatedBy: InputMaybe<TaskUpdatedByFilters>;
};

export type TaskFiltersOr = {
  createdAt: InputMaybe<TaskCreatedAtFilters>;
  createdBy: InputMaybe<TaskCreatedByFilters>;
  deleted: InputMaybe<TaskDeletedFilters>;
  description: InputMaybe<TaskDescriptionFilters>;
  details: InputMaybe<TaskDetailsFilters>;
  id: InputMaybe<TaskIdFilters>;
  organizationId: InputMaybe<TaskOrganizationIdFilters>;
  patientId: InputMaybe<TaskPatientIdFilters>;
  status: InputMaybe<TaskStatusFilters>;
  taskType: InputMaybe<TaskTaskTypeFilters>;
  updatedAt: InputMaybe<TaskUpdatedAtFilters>;
  updatedBy: InputMaybe<TaskUpdatedByFilters>;
};

export type TaskIdFilters = {
  OR: InputMaybe<Array<TaskIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  description: InputMaybe<InnerOrder>;
  details: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  patientId: InputMaybe<InnerOrder>;
  status: InputMaybe<InnerOrder>;
  taskType: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type TaskOrganizationIdFilters = {
  OR: InputMaybe<Array<TaskOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskPatientIdFilters = {
  OR: InputMaybe<Array<TaskPatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskPatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<TaskRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<TaskRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryFilters = {
  OR: InputMaybe<Array<TaskRevisionHistoryFiltersOr>>;
  action: InputMaybe<TaskRevisionHistoryActionFilters>;
  changedFields: InputMaybe<TaskRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<TaskRevisionHistoryIdFilters>;
  organizationId: InputMaybe<TaskRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<TaskRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<TaskRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<TaskRevisionHistoryUpdatedByFilters>;
};

export type TaskRevisionHistoryFiltersOr = {
  action: InputMaybe<TaskRevisionHistoryActionFilters>;
  changedFields: InputMaybe<TaskRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<TaskRevisionHistoryIdFilters>;
  organizationId: InputMaybe<TaskRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<TaskRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<TaskRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<TaskRevisionHistoryUpdatedByFilters>;
};

export type TaskRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<TaskRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type TaskRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<TaskRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<TaskRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<TaskRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<TaskRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum TaskStatusEnum {
  Canceled = 'canceled',
  Complete = 'complete',
  Pending = 'pending'
}

export type TaskStatusFilters = {
  OR: InputMaybe<Array<TaskStatusfiltersOr>>;
  eq: InputMaybe<TaskStatusEnum>;
  gt: InputMaybe<TaskStatusEnum>;
  gte: InputMaybe<TaskStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<TaskStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<TaskStatusEnum>;
  lte: InputMaybe<TaskStatusEnum>;
  ne: InputMaybe<TaskStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<TaskStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskStatusfiltersOr = {
  eq: InputMaybe<TaskStatusEnum>;
  gt: InputMaybe<TaskStatusEnum>;
  gte: InputMaybe<TaskStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<TaskStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<TaskStatusEnum>;
  lte: InputMaybe<TaskStatusEnum>;
  ne: InputMaybe<TaskStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<TaskStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum TaskTaskTypeEnum {
  Scheduling = 'scheduling',
  VisitRequest = 'visit_request'
}

export type TaskTaskTypeFilters = {
  OR: InputMaybe<Array<TaskTaskTypefiltersOr>>;
  eq: InputMaybe<TaskTaskTypeEnum>;
  gt: InputMaybe<TaskTaskTypeEnum>;
  gte: InputMaybe<TaskTaskTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<TaskTaskTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<TaskTaskTypeEnum>;
  lte: InputMaybe<TaskTaskTypeEnum>;
  ne: InputMaybe<TaskTaskTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<TaskTaskTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskTaskTypefiltersOr = {
  eq: InputMaybe<TaskTaskTypeEnum>;
  gt: InputMaybe<TaskTaskTypeEnum>;
  gte: InputMaybe<TaskTaskTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<TaskTaskTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<TaskTaskTypeEnum>;
  lte: InputMaybe<TaskTaskTypeEnum>;
  ne: InputMaybe<TaskTaskTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<TaskTaskTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskUpdatedAtFilters = {
  OR: InputMaybe<Array<TaskUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskUpdatedByFilters = {
  OR: InputMaybe<Array<TaskUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TaskUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreatedAtFilters = {
  OR: InputMaybe<Array<TeamCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreatedByFilters = {
  OR: InputMaybe<Array<TeamCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamDeletedFilters = {
  OR: InputMaybe<Array<TeamDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamFilters = {
  OR: InputMaybe<Array<TeamFiltersOr>>;
  createdAt: InputMaybe<TeamCreatedAtFilters>;
  createdBy: InputMaybe<TeamCreatedByFilters>;
  deleted: InputMaybe<TeamDeletedFilters>;
  id: InputMaybe<TeamIdFilters>;
  name: InputMaybe<TeamNameFilters>;
  organizationId: InputMaybe<TeamOrganizationIdFilters>;
  updatedAt: InputMaybe<TeamUpdatedAtFilters>;
  updatedBy: InputMaybe<TeamUpdatedByFilters>;
};

export type TeamFiltersOr = {
  createdAt: InputMaybe<TeamCreatedAtFilters>;
  createdBy: InputMaybe<TeamCreatedByFilters>;
  deleted: InputMaybe<TeamDeletedFilters>;
  id: InputMaybe<TeamIdFilters>;
  name: InputMaybe<TeamNameFilters>;
  organizationId: InputMaybe<TeamOrganizationIdFilters>;
  updatedAt: InputMaybe<TeamUpdatedAtFilters>;
  updatedBy: InputMaybe<TeamUpdatedByFilters>;
};

export type TeamIdFilters = {
  OR: InputMaybe<Array<TeamIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamNameFilters = {
  OR: InputMaybe<Array<TeamNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type TeamOrganizationIdFilters = {
  OR: InputMaybe<Array<TeamOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderCreatedAtFilters = {
  OR: InputMaybe<Array<TeamProviderCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderCreatedByFilters = {
  OR: InputMaybe<Array<TeamProviderCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderDeletedFilters = {
  OR: InputMaybe<Array<TeamProviderDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderFilters = {
  OR: InputMaybe<Array<TeamProviderFiltersOr>>;
  createdAt: InputMaybe<TeamProviderCreatedAtFilters>;
  createdBy: InputMaybe<TeamProviderCreatedByFilters>;
  deleted: InputMaybe<TeamProviderDeletedFilters>;
  id: InputMaybe<TeamProviderIdFilters>;
  organizationId: InputMaybe<TeamProviderOrganizationIdFilters>;
  providerId: InputMaybe<TeamProviderProviderIdFilters>;
  teamId: InputMaybe<TeamProviderTeamIdFilters>;
  updatedAt: InputMaybe<TeamProviderUpdatedAtFilters>;
  updatedBy: InputMaybe<TeamProviderUpdatedByFilters>;
};

export type TeamProviderFiltersOr = {
  createdAt: InputMaybe<TeamProviderCreatedAtFilters>;
  createdBy: InputMaybe<TeamProviderCreatedByFilters>;
  deleted: InputMaybe<TeamProviderDeletedFilters>;
  id: InputMaybe<TeamProviderIdFilters>;
  organizationId: InputMaybe<TeamProviderOrganizationIdFilters>;
  providerId: InputMaybe<TeamProviderProviderIdFilters>;
  teamId: InputMaybe<TeamProviderTeamIdFilters>;
  updatedAt: InputMaybe<TeamProviderUpdatedAtFilters>;
  updatedBy: InputMaybe<TeamProviderUpdatedByFilters>;
};

export type TeamProviderIdFilters = {
  OR: InputMaybe<Array<TeamProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  teamId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type TeamProviderOrganizationIdFilters = {
  OR: InputMaybe<Array<TeamProviderOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderProviderIdFilters = {
  OR: InputMaybe<Array<TeamProviderProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<TeamProviderRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<TeamProviderRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryFilters = {
  OR: InputMaybe<Array<TeamProviderRevisionHistoryFiltersOr>>;
  action: InputMaybe<TeamProviderRevisionHistoryActionFilters>;
  changedFields: InputMaybe<TeamProviderRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<TeamProviderRevisionHistoryIdFilters>;
  organizationId: InputMaybe<TeamProviderRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<TeamProviderRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<TeamProviderRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<TeamProviderRevisionHistoryUpdatedByFilters>;
};

export type TeamProviderRevisionHistoryFiltersOr = {
  action: InputMaybe<TeamProviderRevisionHistoryActionFilters>;
  changedFields: InputMaybe<TeamProviderRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<TeamProviderRevisionHistoryIdFilters>;
  organizationId: InputMaybe<TeamProviderRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<TeamProviderRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<TeamProviderRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<TeamProviderRevisionHistoryUpdatedByFilters>;
};

export type TeamProviderRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<TeamProviderRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type TeamProviderRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<TeamProviderRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<TeamProviderRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<TeamProviderRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<TeamProviderRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderTeamIdFilters = {
  OR: InputMaybe<Array<TeamProviderTeamIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderTeamIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderUpdatedAtFilters = {
  OR: InputMaybe<Array<TeamProviderUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderUpdatedByFilters = {
  OR: InputMaybe<Array<TeamProviderUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamProviderUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<TeamRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<TeamRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryFilters = {
  OR: InputMaybe<Array<TeamRevisionHistoryFiltersOr>>;
  action: InputMaybe<TeamRevisionHistoryActionFilters>;
  changedFields: InputMaybe<TeamRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<TeamRevisionHistoryIdFilters>;
  organizationId: InputMaybe<TeamRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<TeamRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<TeamRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<TeamRevisionHistoryUpdatedByFilters>;
};

export type TeamRevisionHistoryFiltersOr = {
  action: InputMaybe<TeamRevisionHistoryActionFilters>;
  changedFields: InputMaybe<TeamRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<TeamRevisionHistoryIdFilters>;
  organizationId: InputMaybe<TeamRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<TeamRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<TeamRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<TeamRevisionHistoryUpdatedByFilters>;
};

export type TeamRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<TeamRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type TeamRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<TeamRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<TeamRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<TeamRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<TeamRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamUpdatedAtFilters = {
  OR: InputMaybe<Array<TeamUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamUpdatedByFilters = {
  OR: InputMaybe<Array<TeamUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type TeamUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAnswerOption = {
  answer: Scalars['String']['input'];
  id: InputMaybe<Scalars['Int']['input']>;
};

export type UpsertUserDetails = {
  deleted: Scalars['Boolean']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationalUnits: InputMaybe<Array<Scalars['Int']['input']>>;
  provider: InputMaybe<UpsertUserDetailsProvider>;
  roles: Array<InputMaybe<Scalars['Int']['input']>>;
  serviceLines: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type UpsertUserDetailsProvider = {
  active: Scalars['Boolean']['input'];
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressPlaceId: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  external: InputMaybe<Scalars['Boolean']['input']>;
  gender: InputMaybe<Scalars['String']['input']>;
  identifier: InputMaybe<Scalars['String']['input']>;
  languages: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  licensedStates: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerTypeId: Scalars['Int']['input'];
  teams: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UserCreatedAtFilters = {
  OR: InputMaybe<Array<UserCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatedByFilters = {
  OR: InputMaybe<Array<UserCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserDeletedFilters = {
  OR: InputMaybe<Array<UserDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailFilters = {
  OR: InputMaybe<Array<UserEmailfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserEmailfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserFilters = {
  OR: InputMaybe<Array<UserFiltersOr>>;
  createdAt: InputMaybe<UserCreatedAtFilters>;
  createdBy: InputMaybe<UserCreatedByFilters>;
  deleted: InputMaybe<UserDeletedFilters>;
  email: InputMaybe<UserEmailFilters>;
  firstName: InputMaybe<UserFirstNameFilters>;
  id: InputMaybe<UserIdFilters>;
  lastName: InputMaybe<UserLastNameFilters>;
  pinHash: InputMaybe<UserPinHashFilters>;
  systemAccount: InputMaybe<UserSystemAccountFilters>;
  updatedAt: InputMaybe<UserUpdatedAtFilters>;
  updatedBy: InputMaybe<UserUpdatedByFilters>;
  username: InputMaybe<UserUsernameFilters>;
};

export type UserFiltersOr = {
  createdAt: InputMaybe<UserCreatedAtFilters>;
  createdBy: InputMaybe<UserCreatedByFilters>;
  deleted: InputMaybe<UserDeletedFilters>;
  email: InputMaybe<UserEmailFilters>;
  firstName: InputMaybe<UserFirstNameFilters>;
  id: InputMaybe<UserIdFilters>;
  lastName: InputMaybe<UserLastNameFilters>;
  pinHash: InputMaybe<UserPinHashFilters>;
  systemAccount: InputMaybe<UserSystemAccountFilters>;
  updatedAt: InputMaybe<UserUpdatedAtFilters>;
  updatedBy: InputMaybe<UserUpdatedByFilters>;
  username: InputMaybe<UserUsernameFilters>;
};

export type UserFirstNameFilters = {
  OR: InputMaybe<Array<UserFirstNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserFirstNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserIdFilters = {
  OR: InputMaybe<Array<UserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserLastNameFilters = {
  OR: InputMaybe<Array<UserLastNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserLastNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserPinHashFilters = {
  OR: InputMaybe<Array<UserPinHashfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserPinHashfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<UserRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<UserRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryFilters = {
  OR: InputMaybe<Array<UserRevisionHistoryFiltersOr>>;
  action: InputMaybe<UserRevisionHistoryActionFilters>;
  changedFields: InputMaybe<UserRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<UserRevisionHistoryIdFilters>;
  recordData: InputMaybe<UserRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<UserRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<UserRevisionHistoryUpdatedByFilters>;
};

export type UserRevisionHistoryFiltersOr = {
  action: InputMaybe<UserRevisionHistoryActionFilters>;
  changedFields: InputMaybe<UserRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<UserRevisionHistoryIdFilters>;
  recordData: InputMaybe<UserRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<UserRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<UserRevisionHistoryUpdatedByFilters>;
};

export type UserRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<UserRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type UserRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<UserRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<UserRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<UserRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleCreatedAtFilters = {
  OR: InputMaybe<Array<UserRoleCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleCreatedByFilters = {
  OR: InputMaybe<Array<UserRoleCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleDeletedFilters = {
  OR: InputMaybe<Array<UserRoleDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleFilters = {
  OR: InputMaybe<Array<UserRoleFiltersOr>>;
  createdAt: InputMaybe<UserRoleCreatedAtFilters>;
  createdBy: InputMaybe<UserRoleCreatedByFilters>;
  deleted: InputMaybe<UserRoleDeletedFilters>;
  id: InputMaybe<UserRoleIdFilters>;
  name: InputMaybe<UserRoleNameFilters>;
  organizationId: InputMaybe<UserRoleOrganizationIdFilters>;
  permissions: InputMaybe<UserRolePermissionsFilters>;
  updatedAt: InputMaybe<UserRoleUpdatedAtFilters>;
  updatedBy: InputMaybe<UserRoleUpdatedByFilters>;
};

export type UserRoleFiltersOr = {
  createdAt: InputMaybe<UserRoleCreatedAtFilters>;
  createdBy: InputMaybe<UserRoleCreatedByFilters>;
  deleted: InputMaybe<UserRoleDeletedFilters>;
  id: InputMaybe<UserRoleIdFilters>;
  name: InputMaybe<UserRoleNameFilters>;
  organizationId: InputMaybe<UserRoleOrganizationIdFilters>;
  permissions: InputMaybe<UserRolePermissionsFilters>;
  updatedAt: InputMaybe<UserRoleUpdatedAtFilters>;
  updatedBy: InputMaybe<UserRoleUpdatedByFilters>;
};

export type UserRoleIdFilters = {
  OR: InputMaybe<Array<UserRoleIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleNameFilters = {
  OR: InputMaybe<Array<UserRoleNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  permissions: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type UserRoleOrganizationIdFilters = {
  OR: InputMaybe<Array<UserRoleOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRolePermissionsFilters = {
  OR: InputMaybe<Array<UserRolePermissionsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRolePermissionsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<UserRoleRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<UserRoleRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryFilters = {
  OR: InputMaybe<Array<UserRoleRevisionHistoryFiltersOr>>;
  action: InputMaybe<UserRoleRevisionHistoryActionFilters>;
  changedFields: InputMaybe<UserRoleRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<UserRoleRevisionHistoryIdFilters>;
  organizationId: InputMaybe<UserRoleRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<UserRoleRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<UserRoleRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<UserRoleRevisionHistoryUpdatedByFilters>;
};

export type UserRoleRevisionHistoryFiltersOr = {
  action: InputMaybe<UserRoleRevisionHistoryActionFilters>;
  changedFields: InputMaybe<UserRoleRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<UserRoleRevisionHistoryIdFilters>;
  organizationId: InputMaybe<UserRoleRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<UserRoleRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<UserRoleRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<UserRoleRevisionHistoryUpdatedByFilters>;
};

export type UserRoleRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<UserRoleRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type UserRoleRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<UserRoleRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<UserRoleRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<UserRoleRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<UserRoleRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleUpdatedAtFilters = {
  OR: InputMaybe<Array<UserRoleUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleUpdatedByFilters = {
  OR: InputMaybe<Array<UserRoleUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserRoleUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserSystemAccountFilters = {
  OR: InputMaybe<Array<UserSystemAccountfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserSystemAccountfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdatedAtFilters = {
  OR: InputMaybe<Array<UserUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdatedByFilters = {
  OR: InputMaybe<Array<UserUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserUsernameFilters = {
  OR: InputMaybe<Array<UserUsernamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type UserUsernamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressCityFilters = {
  OR: InputMaybe<Array<VisitAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressCoordinatesFilters = {
  OR: InputMaybe<Array<VisitAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressLineTwoFilters = {
  OR: InputMaybe<Array<VisitAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressStateFilters = {
  OR: InputMaybe<Array<VisitAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressStreetFilters = {
  OR: InputMaybe<Array<VisitAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressTimezoneFilters = {
  OR: InputMaybe<Array<VisitAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressZipFilters = {
  OR: InputMaybe<Array<VisitAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitArrivalWindowEndTimeFilters = {
  OR: InputMaybe<Array<VisitArrivalWindowEndTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitArrivalWindowEndTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitArrivalWindowStartTimeFilters = {
  OR: InputMaybe<Array<VisitArrivalWindowStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitArrivalWindowStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonActiveFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonActivefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonActivefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonCreatedAtFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonCreatedByFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonDeletedFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonDescriptionFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonDescriptionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonDescriptionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonFiltersOr>>;
  active: InputMaybe<VisitCancellationReasonActiveFilters>;
  createdAt: InputMaybe<VisitCancellationReasonCreatedAtFilters>;
  createdBy: InputMaybe<VisitCancellationReasonCreatedByFilters>;
  deleted: InputMaybe<VisitCancellationReasonDeletedFilters>;
  description: InputMaybe<VisitCancellationReasonDescriptionFilters>;
  id: InputMaybe<VisitCancellationReasonIdFilters>;
  organizationId: InputMaybe<VisitCancellationReasonOrganizationIdFilters>;
  reasonType: InputMaybe<VisitCancellationReasonReasonTypeFilters>;
  updatedAt: InputMaybe<VisitCancellationReasonUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitCancellationReasonUpdatedByFilters>;
};

export type VisitCancellationReasonFiltersOr = {
  active: InputMaybe<VisitCancellationReasonActiveFilters>;
  createdAt: InputMaybe<VisitCancellationReasonCreatedAtFilters>;
  createdBy: InputMaybe<VisitCancellationReasonCreatedByFilters>;
  deleted: InputMaybe<VisitCancellationReasonDeletedFilters>;
  description: InputMaybe<VisitCancellationReasonDescriptionFilters>;
  id: InputMaybe<VisitCancellationReasonIdFilters>;
  organizationId: InputMaybe<VisitCancellationReasonOrganizationIdFilters>;
  reasonType: InputMaybe<VisitCancellationReasonReasonTypeFilters>;
  updatedAt: InputMaybe<VisitCancellationReasonUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitCancellationReasonUpdatedByFilters>;
};

export type VisitCancellationReasonIdFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonOrderBy = {
  active: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  description: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  reasonType: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitCancellationReasonOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum VisitCancellationReasonReasonTypeEnum {
  Cancel = 'cancel',
  Either = 'either',
  Reschedule = 'reschedule'
}

export type VisitCancellationReasonReasonTypeFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonReasonTypefiltersOr>>;
  eq: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  gt: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  gte: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitCancellationReasonReasonTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  lte: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  ne: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitCancellationReasonReasonTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonReasonTypefiltersOr = {
  eq: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  gt: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  gte: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitCancellationReasonReasonTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  lte: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  ne: InputMaybe<VisitCancellationReasonReasonTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitCancellationReasonReasonTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitCancellationReasonRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitCancellationReasonRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitCancellationReasonRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitCancellationReasonRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitCancellationReasonRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitCancellationReasonRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitCancellationReasonRevisionHistoryUpdatedByFilters>;
};

export type VisitCancellationReasonRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitCancellationReasonRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitCancellationReasonRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitCancellationReasonRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitCancellationReasonRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitCancellationReasonRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitCancellationReasonRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitCancellationReasonRevisionHistoryUpdatedByFilters>;
};

export type VisitCancellationReasonRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitCancellationReasonRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonUpdatedByFilters = {
  OR: InputMaybe<Array<VisitCancellationReasonUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCancellationReasonUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCareRequirementIdFilters = {
  OR: InputMaybe<Array<VisitCareRequirementIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCareRequirementIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCreatedAtFilters = {
  OR: InputMaybe<Array<VisitCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCreatedByFilters = {
  OR: InputMaybe<Array<VisitCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitDeletedFilters = {
  OR: InputMaybe<Array<VisitDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEndTimeFilters = {
  OR: InputMaybe<Array<VisitEndTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEndTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEpisodeIdFilters = {
  OR: InputMaybe<Array<VisitEpisodeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEpisodeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryAutoGeneratedFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryAutoGeneratedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryAutoGeneratedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryCreatedAtFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryCreatedByFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryDeletedFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryEventFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryEventfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryEventTimeFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryEventTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryEventTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryEventfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryFiltersOr>>;
  autoGenerated: InputMaybe<VisitEventLogEntryAutoGeneratedFilters>;
  createdAt: InputMaybe<VisitEventLogEntryCreatedAtFilters>;
  createdBy: InputMaybe<VisitEventLogEntryCreatedByFilters>;
  deleted: InputMaybe<VisitEventLogEntryDeletedFilters>;
  event: InputMaybe<VisitEventLogEntryEventFilters>;
  eventTime: InputMaybe<VisitEventLogEntryEventTimeFilters>;
  id: InputMaybe<VisitEventLogEntryIdFilters>;
  logEntryType: InputMaybe<VisitEventLogEntryLogEntryTypeFilters>;
  organizationId: InputMaybe<VisitEventLogEntryOrganizationIdFilters>;
  updatedAt: InputMaybe<VisitEventLogEntryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitEventLogEntryUpdatedByFilters>;
  visitId: InputMaybe<VisitEventLogEntryVisitIdFilters>;
  visitRescheduleReasonId: InputMaybe<VisitEventLogEntryVisitRescheduleReasonIdFilters>;
  visitResourceId: InputMaybe<VisitEventLogEntryVisitResourceIdFilters>;
};

export type VisitEventLogEntryFiltersOr = {
  autoGenerated: InputMaybe<VisitEventLogEntryAutoGeneratedFilters>;
  createdAt: InputMaybe<VisitEventLogEntryCreatedAtFilters>;
  createdBy: InputMaybe<VisitEventLogEntryCreatedByFilters>;
  deleted: InputMaybe<VisitEventLogEntryDeletedFilters>;
  event: InputMaybe<VisitEventLogEntryEventFilters>;
  eventTime: InputMaybe<VisitEventLogEntryEventTimeFilters>;
  id: InputMaybe<VisitEventLogEntryIdFilters>;
  logEntryType: InputMaybe<VisitEventLogEntryLogEntryTypeFilters>;
  organizationId: InputMaybe<VisitEventLogEntryOrganizationIdFilters>;
  updatedAt: InputMaybe<VisitEventLogEntryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitEventLogEntryUpdatedByFilters>;
  visitId: InputMaybe<VisitEventLogEntryVisitIdFilters>;
  visitRescheduleReasonId: InputMaybe<VisitEventLogEntryVisitRescheduleReasonIdFilters>;
  visitResourceId: InputMaybe<VisitEventLogEntryVisitResourceIdFilters>;
};

export type VisitEventLogEntryIdFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum VisitEventLogEntryLogEntryTypeEnum {
  Cancel = 'cancel',
  Reschedule = 'reschedule',
  VisitResourceStatusUpdate = 'visit_resource_status_update',
  VisitStatusUpdate = 'visit_status_update'
}

export type VisitEventLogEntryLogEntryTypeFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryLogEntryTypefiltersOr>>;
  eq: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  gt: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  gte: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitEventLogEntryLogEntryTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  lte: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  ne: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitEventLogEntryLogEntryTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryLogEntryTypefiltersOr = {
  eq: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  gt: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  gte: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitEventLogEntryLogEntryTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  lte: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  ne: InputMaybe<VisitEventLogEntryLogEntryTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitEventLogEntryLogEntryTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryOrderBy = {
  autoGenerated: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  event: InputMaybe<InnerOrder>;
  eventTime: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  logEntryType: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitId: InputMaybe<InnerOrder>;
  visitRescheduleReasonId: InputMaybe<InnerOrder>;
  visitResourceId: InputMaybe<InnerOrder>;
};

export type VisitEventLogEntryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitEventLogEntryRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitEventLogEntryRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitEventLogEntryRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitEventLogEntryRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitEventLogEntryRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitEventLogEntryRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitEventLogEntryRevisionHistoryUpdatedByFilters>;
};

export type VisitEventLogEntryRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitEventLogEntryRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitEventLogEntryRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitEventLogEntryRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitEventLogEntryRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitEventLogEntryRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitEventLogEntryRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitEventLogEntryRevisionHistoryUpdatedByFilters>;
};

export type VisitEventLogEntryRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitEventLogEntryRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryVisitIdFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryVisitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryVisitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryVisitRescheduleReasonIdFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryVisitRescheduleReasonIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryVisitRescheduleReasonIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryVisitResourceIdFilters = {
  OR: InputMaybe<Array<VisitEventLogEntryVisitResourceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventLogEntryVisitResourceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum VisitEventStatusEnum {
  Arrived = 'arrived',
  Canceled = 'canceled',
  Complete = 'complete',
  EnRoute = 'en_route',
  InProgress = 'in_progress',
  Scheduled = 'scheduled'
}

export type VisitEventStatusFilters = {
  OR: InputMaybe<Array<VisitEventStatusfiltersOr>>;
  eq: InputMaybe<VisitEventStatusEnum>;
  gt: InputMaybe<VisitEventStatusEnum>;
  gte: InputMaybe<VisitEventStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitEventStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitEventStatusEnum>;
  lte: InputMaybe<VisitEventStatusEnum>;
  ne: InputMaybe<VisitEventStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitEventStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitEventStatusfiltersOr = {
  eq: InputMaybe<VisitEventStatusEnum>;
  gt: InputMaybe<VisitEventStatusEnum>;
  gte: InputMaybe<VisitEventStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitEventStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitEventStatusEnum>;
  lte: InputMaybe<VisitEventStatusEnum>;
  ne: InputMaybe<VisitEventStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitEventStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitFilters = {
  OR: InputMaybe<Array<VisitFiltersOr>>;
  addressCity: InputMaybe<VisitAddressCityFilters>;
  addressCoordinates: InputMaybe<VisitAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<VisitAddressLineTwoFilters>;
  addressState: InputMaybe<VisitAddressStateFilters>;
  addressStreet: InputMaybe<VisitAddressStreetFilters>;
  addressTimezone: InputMaybe<VisitAddressTimezoneFilters>;
  addressZip: InputMaybe<VisitAddressZipFilters>;
  arrivalWindowEndTime: InputMaybe<VisitArrivalWindowEndTimeFilters>;
  arrivalWindowStartTime: InputMaybe<VisitArrivalWindowStartTimeFilters>;
  careRequirementId: InputMaybe<VisitCareRequirementIdFilters>;
  createdAt: InputMaybe<VisitCreatedAtFilters>;
  createdBy: InputMaybe<VisitCreatedByFilters>;
  deleted: InputMaybe<VisitDeletedFilters>;
  endTime: InputMaybe<VisitEndTimeFilters>;
  episodeId: InputMaybe<VisitEpisodeIdFilters>;
  eventStatus: InputMaybe<VisitEventStatusFilters>;
  id: InputMaybe<VisitIdFilters>;
  manualEdits: InputMaybe<VisitManualEditsFilters>;
  organizationId: InputMaybe<VisitOrganizationIdFilters>;
  patientId: InputMaybe<VisitPatientIdFilters>;
  serviceInstructions: InputMaybe<VisitServiceInstructionsFilters>;
  startTime: InputMaybe<VisitStartTimeFilters>;
  updatedAt: InputMaybe<VisitUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitUpdatedByFilters>;
  visitCancellationReasonId: InputMaybe<VisitVisitCancellationReasonIdFilters>;
  visitTypeId: InputMaybe<VisitVisitTypeIdFilters>;
  visitWarningLogId: InputMaybe<VisitVisitWarningLogIdFilters>;
};

export type VisitFiltersOr = {
  addressCity: InputMaybe<VisitAddressCityFilters>;
  addressCoordinates: InputMaybe<VisitAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<VisitAddressLineTwoFilters>;
  addressState: InputMaybe<VisitAddressStateFilters>;
  addressStreet: InputMaybe<VisitAddressStreetFilters>;
  addressTimezone: InputMaybe<VisitAddressTimezoneFilters>;
  addressZip: InputMaybe<VisitAddressZipFilters>;
  arrivalWindowEndTime: InputMaybe<VisitArrivalWindowEndTimeFilters>;
  arrivalWindowStartTime: InputMaybe<VisitArrivalWindowStartTimeFilters>;
  careRequirementId: InputMaybe<VisitCareRequirementIdFilters>;
  createdAt: InputMaybe<VisitCreatedAtFilters>;
  createdBy: InputMaybe<VisitCreatedByFilters>;
  deleted: InputMaybe<VisitDeletedFilters>;
  endTime: InputMaybe<VisitEndTimeFilters>;
  episodeId: InputMaybe<VisitEpisodeIdFilters>;
  eventStatus: InputMaybe<VisitEventStatusFilters>;
  id: InputMaybe<VisitIdFilters>;
  manualEdits: InputMaybe<VisitManualEditsFilters>;
  organizationId: InputMaybe<VisitOrganizationIdFilters>;
  patientId: InputMaybe<VisitPatientIdFilters>;
  serviceInstructions: InputMaybe<VisitServiceInstructionsFilters>;
  startTime: InputMaybe<VisitStartTimeFilters>;
  updatedAt: InputMaybe<VisitUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitUpdatedByFilters>;
  visitCancellationReasonId: InputMaybe<VisitVisitCancellationReasonIdFilters>;
  visitTypeId: InputMaybe<VisitVisitTypeIdFilters>;
  visitWarningLogId: InputMaybe<VisitVisitWarningLogIdFilters>;
};

export type VisitIdFilters = {
  OR: InputMaybe<Array<VisitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitInput = {
  addressCoordinates: Scalars['String']['input'];
  eventStatus: Scalars['String']['input'];
};

export type VisitLocationInput = {
  location: Scalars['String']['input'];
  providerIds: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type VisitManualEditsFilters = {
  OR: InputMaybe<Array<VisitManualEditsfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitManualEditsfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteBodyFilters = {
  OR: InputMaybe<Array<VisitNoteBodyfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteBodyfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteCreatedAtFilters = {
  OR: InputMaybe<Array<VisitNoteCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteCreatedByFilters = {
  OR: InputMaybe<Array<VisitNoteCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteDeletedFilters = {
  OR: InputMaybe<Array<VisitNoteDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteFilters = {
  OR: InputMaybe<Array<VisitNoteFiltersOr>>;
  body: InputMaybe<VisitNoteBodyFilters>;
  createdAt: InputMaybe<VisitNoteCreatedAtFilters>;
  createdBy: InputMaybe<VisitNoteCreatedByFilters>;
  deleted: InputMaybe<VisitNoteDeletedFilters>;
  id: InputMaybe<VisitNoteIdFilters>;
  organizationId: InputMaybe<VisitNoteOrganizationIdFilters>;
  updatedAt: InputMaybe<VisitNoteUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitNoteUpdatedByFilters>;
  userId: InputMaybe<VisitNoteUserIdFilters>;
  visitId: InputMaybe<VisitNoteVisitIdFilters>;
};

export type VisitNoteFiltersOr = {
  body: InputMaybe<VisitNoteBodyFilters>;
  createdAt: InputMaybe<VisitNoteCreatedAtFilters>;
  createdBy: InputMaybe<VisitNoteCreatedByFilters>;
  deleted: InputMaybe<VisitNoteDeletedFilters>;
  id: InputMaybe<VisitNoteIdFilters>;
  organizationId: InputMaybe<VisitNoteOrganizationIdFilters>;
  updatedAt: InputMaybe<VisitNoteUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitNoteUpdatedByFilters>;
  userId: InputMaybe<VisitNoteUserIdFilters>;
  visitId: InputMaybe<VisitNoteVisitIdFilters>;
};

export type VisitNoteIdFilters = {
  OR: InputMaybe<Array<VisitNoteIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteOrderBy = {
  body: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  userId: InputMaybe<InnerOrder>;
  visitId: InputMaybe<InnerOrder>;
};

export type VisitNoteOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitNoteOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitNoteRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitNoteRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitNoteRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitNoteRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitNoteRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitNoteRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitNoteRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitNoteRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitNoteRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitNoteRevisionHistoryUpdatedByFilters>;
};

export type VisitNoteRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitNoteRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitNoteRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitNoteRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitNoteRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitNoteRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitNoteRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitNoteRevisionHistoryUpdatedByFilters>;
};

export type VisitNoteRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitNoteRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitNoteRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitNoteRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitNoteRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitNoteRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitNoteRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitNoteUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteUpdatedByFilters = {
  OR: InputMaybe<Array<VisitNoteUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteUserIdFilters = {
  OR: InputMaybe<Array<VisitNoteUserIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteUserIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteVisitIdFilters = {
  OR: InputMaybe<Array<VisitNoteVisitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitNoteVisitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  arrivalWindowEndTime: InputMaybe<InnerOrder>;
  arrivalWindowStartTime: InputMaybe<InnerOrder>;
  careRequirementId: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  endTime: InputMaybe<InnerOrder>;
  episodeId: InputMaybe<InnerOrder>;
  eventStatus: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  manualEdits: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  patientId: InputMaybe<InnerOrder>;
  serviceInstructions: InputMaybe<InnerOrder>;
  startTime: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitCancellationReasonId: InputMaybe<InnerOrder>;
  visitTypeId: InputMaybe<InnerOrder>;
  visitWarningLogId: InputMaybe<InnerOrder>;
};

export type VisitOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitPatientIdFilters = {
  OR: InputMaybe<Array<VisitPatientIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitPatientIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressCityFilters = {
  OR: InputMaybe<Array<VisitResourceAddressCityfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressCityfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressCoordinatesFilters = {
  OR: InputMaybe<Array<VisitResourceAddressCoordinatesfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressCoordinatesfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressLineTwoFilters = {
  OR: InputMaybe<Array<VisitResourceAddressLineTwofiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressLineTwofiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressStateFilters = {
  OR: InputMaybe<Array<VisitResourceAddressStatefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressStatefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressStreetFilters = {
  OR: InputMaybe<Array<VisitResourceAddressStreetfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressStreetfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressTimezoneFilters = {
  OR: InputMaybe<Array<VisitResourceAddressTimezonefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressTimezonefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressZipFilters = {
  OR: InputMaybe<Array<VisitResourceAddressZipfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceAddressZipfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceCreatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceCreatedByFilters = {
  OR: InputMaybe<Array<VisitResourceCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceDeletedFilters = {
  OR: InputMaybe<Array<VisitResourceDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceEndOfShiftDriveTimeFilters = {
  OR: InputMaybe<Array<VisitResourceEndOfShiftDriveTimefiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceEndOfShiftDriveTimefiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceEndTimeFilters = {
  OR: InputMaybe<Array<VisitResourceEndTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceEndTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum VisitResourceErrandStatusEnum {
  Arrived = 'arrived',
  Canceled = 'canceled',
  Complete = 'complete',
  EnRoute = 'en_route',
  InProgress = 'in_progress',
  Scheduled = 'scheduled'
}

export type VisitResourceErrandStatusFilters = {
  OR: InputMaybe<Array<VisitResourceErrandStatusfiltersOr>>;
  eq: InputMaybe<VisitResourceErrandStatusEnum>;
  gt: InputMaybe<VisitResourceErrandStatusEnum>;
  gte: InputMaybe<VisitResourceErrandStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitResourceErrandStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitResourceErrandStatusEnum>;
  lte: InputMaybe<VisitResourceErrandStatusEnum>;
  ne: InputMaybe<VisitResourceErrandStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitResourceErrandStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceErrandStatusfiltersOr = {
  eq: InputMaybe<VisitResourceErrandStatusEnum>;
  gt: InputMaybe<VisitResourceErrandStatusEnum>;
  gte: InputMaybe<VisitResourceErrandStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitResourceErrandStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitResourceErrandStatusEnum>;
  lte: InputMaybe<VisitResourceErrandStatusEnum>;
  ne: InputMaybe<VisitResourceErrandStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitResourceErrandStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceFilters = {
  OR: InputMaybe<Array<VisitResourceFiltersOr>>;
  addressCity: InputMaybe<VisitResourceAddressCityFilters>;
  addressCoordinates: InputMaybe<VisitResourceAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<VisitResourceAddressLineTwoFilters>;
  addressState: InputMaybe<VisitResourceAddressStateFilters>;
  addressStreet: InputMaybe<VisitResourceAddressStreetFilters>;
  addressTimezone: InputMaybe<VisitResourceAddressTimezoneFilters>;
  addressZip: InputMaybe<VisitResourceAddressZipFilters>;
  createdAt: InputMaybe<VisitResourceCreatedAtFilters>;
  createdBy: InputMaybe<VisitResourceCreatedByFilters>;
  deleted: InputMaybe<VisitResourceDeletedFilters>;
  endOfShiftDriveTime: InputMaybe<VisitResourceEndOfShiftDriveTimeFilters>;
  endTime: InputMaybe<VisitResourceEndTimeFilters>;
  errandStatus: InputMaybe<VisitResourceErrandStatusFilters>;
  id: InputMaybe<VisitResourceIdFilters>;
  interVisitDriveTime: InputMaybe<VisitResourceInterVisitDriveTimeFilters>;
  organizationId: InputMaybe<VisitResourceOrganizationIdFilters>;
  providerId: InputMaybe<VisitResourceProviderIdFilters>;
  startOfShiftDriveTime: InputMaybe<VisitResourceStartOfShiftDriveTimeFilters>;
  startTime: InputMaybe<VisitResourceStartTimeFilters>;
  updatedAt: InputMaybe<VisitResourceUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceUpdatedByFilters>;
  virtualProviderStatus: InputMaybe<VisitResourceVirtualProviderStatusFilters>;
  visitId: InputMaybe<VisitResourceVisitIdFilters>;
  visitResourceRequirementId: InputMaybe<VisitResourceVisitResourceRequirementIdFilters>;
};

export type VisitResourceFiltersOr = {
  addressCity: InputMaybe<VisitResourceAddressCityFilters>;
  addressCoordinates: InputMaybe<VisitResourceAddressCoordinatesFilters>;
  addressLineTwo: InputMaybe<VisitResourceAddressLineTwoFilters>;
  addressState: InputMaybe<VisitResourceAddressStateFilters>;
  addressStreet: InputMaybe<VisitResourceAddressStreetFilters>;
  addressTimezone: InputMaybe<VisitResourceAddressTimezoneFilters>;
  addressZip: InputMaybe<VisitResourceAddressZipFilters>;
  createdAt: InputMaybe<VisitResourceCreatedAtFilters>;
  createdBy: InputMaybe<VisitResourceCreatedByFilters>;
  deleted: InputMaybe<VisitResourceDeletedFilters>;
  endOfShiftDriveTime: InputMaybe<VisitResourceEndOfShiftDriveTimeFilters>;
  endTime: InputMaybe<VisitResourceEndTimeFilters>;
  errandStatus: InputMaybe<VisitResourceErrandStatusFilters>;
  id: InputMaybe<VisitResourceIdFilters>;
  interVisitDriveTime: InputMaybe<VisitResourceInterVisitDriveTimeFilters>;
  organizationId: InputMaybe<VisitResourceOrganizationIdFilters>;
  providerId: InputMaybe<VisitResourceProviderIdFilters>;
  startOfShiftDriveTime: InputMaybe<VisitResourceStartOfShiftDriveTimeFilters>;
  startTime: InputMaybe<VisitResourceStartTimeFilters>;
  updatedAt: InputMaybe<VisitResourceUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceUpdatedByFilters>;
  virtualProviderStatus: InputMaybe<VisitResourceVirtualProviderStatusFilters>;
  visitId: InputMaybe<VisitResourceVisitIdFilters>;
  visitResourceRequirementId: InputMaybe<VisitResourceVisitResourceRequirementIdFilters>;
};

export type VisitResourceGenericInput = {
  addressCoordinates: InputMaybe<Scalars['String']['input']>;
  endOfShiftDriveTime: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  eventKey: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  inHome: Scalars['Boolean']['input'];
  interVisitDriveTime: Scalars['Int']['input'];
  providerId: InputMaybe<Scalars['Int']['input']>;
  startOfShiftDriveTime: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  visit: VisitInput;
};

export type VisitResourceIdFilters = {
  OR: InputMaybe<Array<VisitResourceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceInterVisitDriveTimeFilters = {
  OR: InputMaybe<Array<VisitResourceInterVisitDriveTimefiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceInterVisitDriveTimefiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceOrderBy = {
  addressCity: InputMaybe<InnerOrder>;
  addressCoordinates: InputMaybe<InnerOrder>;
  addressLineTwo: InputMaybe<InnerOrder>;
  addressState: InputMaybe<InnerOrder>;
  addressStreet: InputMaybe<InnerOrder>;
  addressTimezone: InputMaybe<InnerOrder>;
  addressZip: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  endOfShiftDriveTime: InputMaybe<InnerOrder>;
  endTime: InputMaybe<InnerOrder>;
  errandStatus: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  interVisitDriveTime: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  providerId: InputMaybe<InnerOrder>;
  startOfShiftDriveTime: InputMaybe<InnerOrder>;
  startTime: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  virtualProviderStatus: InputMaybe<InnerOrder>;
  visitId: InputMaybe<InnerOrder>;
  visitResourceRequirementId: InputMaybe<InnerOrder>;
};

export type VisitResourceOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitResourceOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceProviderIdFilters = {
  OR: InputMaybe<Array<VisitResourceProviderIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceProviderIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementCreatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementCreatedByFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementDeletedFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementDurationFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementDurationfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementDurationfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementErrandTypeIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementErrandTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementErrandTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementFiltersOr>>;
  createdAt: InputMaybe<VisitResourceRequirementCreatedAtFilters>;
  createdBy: InputMaybe<VisitResourceRequirementCreatedByFilters>;
  deleted: InputMaybe<VisitResourceRequirementDeletedFilters>;
  duration: InputMaybe<VisitResourceRequirementDurationFilters>;
  errandTypeId: InputMaybe<VisitResourceRequirementErrandTypeIdFilters>;
  id: InputMaybe<VisitResourceRequirementIdFilters>;
  inHome: InputMaybe<VisitResourceRequirementInHomeFilters>;
  invitedToVisit: InputMaybe<VisitResourceRequirementInvitedToVisitFilters>;
  offset: InputMaybe<VisitResourceRequirementOffsetFilters>;
  organizationId: InputMaybe<VisitResourceRequirementOrganizationIdFilters>;
  preserveAutoschedulerGroup: InputMaybe<VisitResourceRequirementPreserveAutoschedulerGroupFilters>;
  requiresContinuityOfCare: InputMaybe<VisitResourceRequirementRequiresContinuityOfCareFilters>;
  updatedAt: InputMaybe<VisitResourceRequirementUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRequirementUpdatedByFilters>;
  visitTypeId: InputMaybe<VisitResourceRequirementVisitTypeIdFilters>;
};

export type VisitResourceRequirementFiltersOr = {
  createdAt: InputMaybe<VisitResourceRequirementCreatedAtFilters>;
  createdBy: InputMaybe<VisitResourceRequirementCreatedByFilters>;
  deleted: InputMaybe<VisitResourceRequirementDeletedFilters>;
  duration: InputMaybe<VisitResourceRequirementDurationFilters>;
  errandTypeId: InputMaybe<VisitResourceRequirementErrandTypeIdFilters>;
  id: InputMaybe<VisitResourceRequirementIdFilters>;
  inHome: InputMaybe<VisitResourceRequirementInHomeFilters>;
  invitedToVisit: InputMaybe<VisitResourceRequirementInvitedToVisitFilters>;
  offset: InputMaybe<VisitResourceRequirementOffsetFilters>;
  organizationId: InputMaybe<VisitResourceRequirementOrganizationIdFilters>;
  preserveAutoschedulerGroup: InputMaybe<VisitResourceRequirementPreserveAutoschedulerGroupFilters>;
  requiresContinuityOfCare: InputMaybe<VisitResourceRequirementRequiresContinuityOfCareFilters>;
  updatedAt: InputMaybe<VisitResourceRequirementUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRequirementUpdatedByFilters>;
  visitTypeId: InputMaybe<VisitResourceRequirementVisitTypeIdFilters>;
};

export type VisitResourceRequirementIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementInHomeFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementInHomefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementInHomefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementInvitedToVisitFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementInvitedToVisitfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementInvitedToVisitfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementOffsetFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementOffsetfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementOffsetfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  duration: InputMaybe<InnerOrder>;
  errandTypeId: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  inHome: InputMaybe<InnerOrder>;
  invitedToVisit: InputMaybe<InnerOrder>;
  offset: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  preserveAutoschedulerGroup: InputMaybe<InnerOrder>;
  requiresContinuityOfCare: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitTypeId: InputMaybe<InnerOrder>;
};

export type VisitResourceRequirementOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtCreatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtCreatedByFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtDeletedFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtFiltersOr>>;
  createdAt: InputMaybe<VisitResourceRequirementPtCreatedAtFilters>;
  createdBy: InputMaybe<VisitResourceRequirementPtCreatedByFilters>;
  deleted: InputMaybe<VisitResourceRequirementPtDeletedFilters>;
  id: InputMaybe<VisitResourceRequirementPtIdFilters>;
  organizationId: InputMaybe<VisitResourceRequirementPtOrganizationIdFilters>;
  providerTypeId: InputMaybe<VisitResourceRequirementPtProviderTypeIdFilters>;
  updatedAt: InputMaybe<VisitResourceRequirementPtUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRequirementPtUpdatedByFilters>;
  visitResourceRequirementId: InputMaybe<VisitResourceRequirementPtVisitResourceRequirementIdFilters>;
};

export type VisitResourceRequirementPtFiltersOr = {
  createdAt: InputMaybe<VisitResourceRequirementPtCreatedAtFilters>;
  createdBy: InputMaybe<VisitResourceRequirementPtCreatedByFilters>;
  deleted: InputMaybe<VisitResourceRequirementPtDeletedFilters>;
  id: InputMaybe<VisitResourceRequirementPtIdFilters>;
  organizationId: InputMaybe<VisitResourceRequirementPtOrganizationIdFilters>;
  providerTypeId: InputMaybe<VisitResourceRequirementPtProviderTypeIdFilters>;
  updatedAt: InputMaybe<VisitResourceRequirementPtUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRequirementPtUpdatedByFilters>;
  visitResourceRequirementId: InputMaybe<VisitResourceRequirementPtVisitResourceRequirementIdFilters>;
};

export type VisitResourceRequirementPtIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  providerTypeId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitResourceRequirementId: InputMaybe<InnerOrder>;
};

export type VisitResourceRequirementPtOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtProviderTypeIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtProviderTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtProviderTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitResourceRequirementPtRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitResourceRequirementPtRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitResourceRequirementPtRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitResourceRequirementPtRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitResourceRequirementPtRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitResourceRequirementPtRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRequirementPtRevisionHistoryUpdatedByFilters>;
};

export type VisitResourceRequirementPtRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitResourceRequirementPtRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitResourceRequirementPtRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitResourceRequirementPtRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitResourceRequirementPtRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitResourceRequirementPtRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitResourceRequirementPtRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRequirementPtRevisionHistoryUpdatedByFilters>;
};

export type VisitResourceRequirementPtRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitResourceRequirementPtRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtUpdatedByFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtVisitResourceRequirementIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPtVisitResourceRequirementIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPtVisitResourceRequirementIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPreserveAutoschedulerGroupFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementPreserveAutoschedulerGroupfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementPreserveAutoschedulerGroupfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRequiresContinuityOfCareFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRequiresContinuityOfCarefiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRequiresContinuityOfCarefiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitResourceRequirementRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitResourceRequirementRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitResourceRequirementRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitResourceRequirementRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitResourceRequirementRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitResourceRequirementRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRequirementRevisionHistoryUpdatedByFilters>;
};

export type VisitResourceRequirementRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitResourceRequirementRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitResourceRequirementRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitResourceRequirementRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitResourceRequirementRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitResourceRequirementRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitResourceRequirementRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRequirementRevisionHistoryUpdatedByFilters>;
};

export type VisitResourceRequirementRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitResourceRequirementRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementUpdatedByFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementVisitTypeIdFilters = {
  OR: InputMaybe<Array<VisitResourceRequirementVisitTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRequirementVisitTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitResourceRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitResourceRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitResourceRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitResourceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitResourceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitResourceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitResourceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitResourceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitResourceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRevisionHistoryUpdatedByFilters>;
};

export type VisitResourceRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitResourceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitResourceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitResourceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitResourceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitResourceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitResourceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitResourceRevisionHistoryUpdatedByFilters>;
};

export type VisitResourceRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitResourceRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitResourceRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitResourceRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitResourceRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitResourceRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceStartOfShiftDriveTimeFilters = {
  OR: InputMaybe<Array<VisitResourceStartOfShiftDriveTimefiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceStartOfShiftDriveTimefiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceStartTimeFilters = {
  OR: InputMaybe<Array<VisitResourceStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitResourceUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceUpdatedByFilters = {
  OR: InputMaybe<Array<VisitResourceUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum VisitResourceVirtualProviderStatusEnum {
  Complete = 'complete',
  Joined = 'joined',
  Notified = 'notified'
}

export type VisitResourceVirtualProviderStatusFilters = {
  OR: InputMaybe<Array<VisitResourceVirtualProviderStatusfiltersOr>>;
  eq: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  gt: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  gte: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitResourceVirtualProviderStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  lte: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  ne: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitResourceVirtualProviderStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceVirtualProviderStatusfiltersOr = {
  eq: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  gt: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  gte: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<VisitResourceVirtualProviderStatusEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  lte: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  ne: InputMaybe<VisitResourceVirtualProviderStatusEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<VisitResourceVirtualProviderStatusEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceVisitIdFilters = {
  OR: InputMaybe<Array<VisitResourceVisitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceVisitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceVisitResourceRequirementIdFilters = {
  OR: InputMaybe<Array<VisitResourceVisitResourceRequirementIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceVisitResourceRequirementIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitResourceWithRequirement = {
  duration: Scalars['Int']['input'];
  providerId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  visitResourceRequirementId: Scalars['Int']['input'];
};

export type VisitRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitRevisionHistoryUpdatedByFilters>;
};

export type VisitRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitRevisionHistoryUpdatedByFilters>;
};

export type VisitRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceCreatedAtFilters = {
  OR: InputMaybe<Array<VisitServiceCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceCreatedByFilters = {
  OR: InputMaybe<Array<VisitServiceCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceDeletedFilters = {
  OR: InputMaybe<Array<VisitServiceDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceFilters = {
  OR: InputMaybe<Array<VisitServiceFiltersOr>>;
  createdAt: InputMaybe<VisitServiceCreatedAtFilters>;
  createdBy: InputMaybe<VisitServiceCreatedByFilters>;
  deleted: InputMaybe<VisitServiceDeletedFilters>;
  id: InputMaybe<VisitServiceIdFilters>;
  organizationId: InputMaybe<VisitServiceOrganizationIdFilters>;
  serviceId: InputMaybe<VisitServiceServiceIdFilters>;
  updatedAt: InputMaybe<VisitServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitServiceUpdatedByFilters>;
  visitId: InputMaybe<VisitServiceVisitIdFilters>;
};

export type VisitServiceFiltersOr = {
  createdAt: InputMaybe<VisitServiceCreatedAtFilters>;
  createdBy: InputMaybe<VisitServiceCreatedByFilters>;
  deleted: InputMaybe<VisitServiceDeletedFilters>;
  id: InputMaybe<VisitServiceIdFilters>;
  organizationId: InputMaybe<VisitServiceOrganizationIdFilters>;
  serviceId: InputMaybe<VisitServiceServiceIdFilters>;
  updatedAt: InputMaybe<VisitServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitServiceUpdatedByFilters>;
  visitId: InputMaybe<VisitServiceVisitIdFilters>;
};

export type VisitServiceIdFilters = {
  OR: InputMaybe<Array<VisitServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceInstructionsFilters = {
  OR: InputMaybe<Array<VisitServiceInstructionsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceInstructionsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  serviceId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitId: InputMaybe<InnerOrder>;
};

export type VisitServiceOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitServiceOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitServiceRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitServiceRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitServiceRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitServiceRevisionHistoryUpdatedByFilters>;
};

export type VisitServiceRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitServiceRevisionHistoryUpdatedByFilters>;
};

export type VisitServiceRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitServiceRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitServiceRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitServiceRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitServiceRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitServiceRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitServiceRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceServiceIdFilters = {
  OR: InputMaybe<Array<VisitServiceServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitServiceUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceUpdatedByFilters = {
  OR: InputMaybe<Array<VisitServiceUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceVisitIdFilters = {
  OR: InputMaybe<Array<VisitServiceVisitIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitServiceVisitIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitStartTimeFilters = {
  OR: InputMaybe<Array<VisitStartTimefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitStartTimefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeCreatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeCreatedByFilters = {
  OR: InputMaybe<Array<VisitTypeCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeDeletedFilters = {
  OR: InputMaybe<Array<VisitTypeDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeFilters = {
  OR: InputMaybe<Array<VisitTypeFiltersOr>>;
  createdAt: InputMaybe<VisitTypeCreatedAtFilters>;
  createdBy: InputMaybe<VisitTypeCreatedByFilters>;
  deleted: InputMaybe<VisitTypeDeletedFilters>;
  id: InputMaybe<VisitTypeIdFilters>;
  name: InputMaybe<VisitTypeNameFilters>;
  organizationId: InputMaybe<VisitTypeOrganizationIdFilters>;
  schedulingConfig: InputMaybe<VisitTypeSchedulingConfigFilters>;
  updatedAt: InputMaybe<VisitTypeUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeUpdatedByFilters>;
};

export type VisitTypeFiltersOr = {
  createdAt: InputMaybe<VisitTypeCreatedAtFilters>;
  createdBy: InputMaybe<VisitTypeCreatedByFilters>;
  deleted: InputMaybe<VisitTypeDeletedFilters>;
  id: InputMaybe<VisitTypeIdFilters>;
  name: InputMaybe<VisitTypeNameFilters>;
  organizationId: InputMaybe<VisitTypeOrganizationIdFilters>;
  schedulingConfig: InputMaybe<VisitTypeSchedulingConfigFilters>;
  updatedAt: InputMaybe<VisitTypeUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeUpdatedByFilters>;
};

export type VisitTypeIdFilters = {
  OR: InputMaybe<Array<VisitTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeNameFilters = {
  OR: InputMaybe<Array<VisitTypeNamefiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeNamefiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  name: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  schedulingConfig: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitTypeOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitTypeOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitTypeRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitTypeRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitTypeRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitTypeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitTypeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitTypeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitTypeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitTypeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitTypeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeRevisionHistoryUpdatedByFilters>;
};

export type VisitTypeRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitTypeRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitTypeRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitTypeRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitTypeRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitTypeRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitTypeRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeRevisionHistoryUpdatedByFilters>;
};

export type VisitTypeRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitTypeRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitTypeRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitTypeRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitTypeRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitTypeRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeSchedulingConfig = {
  allowOverflowShifts: InputMaybe<Scalars['Boolean']['input']>;
  arrivalWindowBlockSchedule: InputMaybe<Scalars['String']['input']>;
  arrivalWindowOffsetMinutes: InputMaybe<Scalars['Int']['input']>;
  daysBeforeLastOption: InputMaybe<Scalars['Int']['input']>;
  leadTimeDays: InputMaybe<Scalars['Int']['input']>;
  virtualArrivalWindowOffset: InputMaybe<Scalars['Int']['input']>;
};

export type VisitTypeSchedulingConfigFilters = {
  OR: InputMaybe<Array<VisitTypeSchedulingConfigfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeSchedulingConfigfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceCreatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeServiceCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceCreatedByFilters = {
  OR: InputMaybe<Array<VisitTypeServiceCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceDeletedFilters = {
  OR: InputMaybe<Array<VisitTypeServiceDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceFilters = {
  OR: InputMaybe<Array<VisitTypeServiceFiltersOr>>;
  createdAt: InputMaybe<VisitTypeServiceCreatedAtFilters>;
  createdBy: InputMaybe<VisitTypeServiceCreatedByFilters>;
  deleted: InputMaybe<VisitTypeServiceDeletedFilters>;
  id: InputMaybe<VisitTypeServiceIdFilters>;
  organizationId: InputMaybe<VisitTypeServiceOrganizationIdFilters>;
  selectedByDefault: InputMaybe<VisitTypeServiceSelectedByDefaultFilters>;
  serviceId: InputMaybe<VisitTypeServiceServiceIdFilters>;
  updatedAt: InputMaybe<VisitTypeServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeServiceUpdatedByFilters>;
  visitTypeId: InputMaybe<VisitTypeServiceVisitTypeIdFilters>;
};

export type VisitTypeServiceFiltersOr = {
  createdAt: InputMaybe<VisitTypeServiceCreatedAtFilters>;
  createdBy: InputMaybe<VisitTypeServiceCreatedByFilters>;
  deleted: InputMaybe<VisitTypeServiceDeletedFilters>;
  id: InputMaybe<VisitTypeServiceIdFilters>;
  organizationId: InputMaybe<VisitTypeServiceOrganizationIdFilters>;
  selectedByDefault: InputMaybe<VisitTypeServiceSelectedByDefaultFilters>;
  serviceId: InputMaybe<VisitTypeServiceServiceIdFilters>;
  updatedAt: InputMaybe<VisitTypeServiceUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeServiceUpdatedByFilters>;
  visitTypeId: InputMaybe<VisitTypeServiceVisitTypeIdFilters>;
};

export type VisitTypeServiceIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineCreatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineCreatedByFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineDeletedFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineFiltersOr>>;
  createdAt: InputMaybe<VisitTypeServiceLineCreatedAtFilters>;
  createdBy: InputMaybe<VisitTypeServiceLineCreatedByFilters>;
  deleted: InputMaybe<VisitTypeServiceLineDeletedFilters>;
  id: InputMaybe<VisitTypeServiceLineIdFilters>;
  organizationId: InputMaybe<VisitTypeServiceLineOrganizationIdFilters>;
  serviceLineId: InputMaybe<VisitTypeServiceLineServiceLineIdFilters>;
  updatedAt: InputMaybe<VisitTypeServiceLineUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeServiceLineUpdatedByFilters>;
  visitTypeId: InputMaybe<VisitTypeServiceLineVisitTypeIdFilters>;
};

export type VisitTypeServiceLineFiltersOr = {
  createdAt: InputMaybe<VisitTypeServiceLineCreatedAtFilters>;
  createdBy: InputMaybe<VisitTypeServiceLineCreatedByFilters>;
  deleted: InputMaybe<VisitTypeServiceLineDeletedFilters>;
  id: InputMaybe<VisitTypeServiceLineIdFilters>;
  organizationId: InputMaybe<VisitTypeServiceLineOrganizationIdFilters>;
  serviceLineId: InputMaybe<VisitTypeServiceLineServiceLineIdFilters>;
  updatedAt: InputMaybe<VisitTypeServiceLineUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeServiceLineUpdatedByFilters>;
  visitTypeId: InputMaybe<VisitTypeServiceLineVisitTypeIdFilters>;
};

export type VisitTypeServiceLineIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  serviceLineId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitTypeId: InputMaybe<InnerOrder>;
};

export type VisitTypeServiceLineOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitTypeServiceLineRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitTypeServiceLineRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitTypeServiceLineRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitTypeServiceLineRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitTypeServiceLineRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitTypeServiceLineRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeServiceLineRevisionHistoryUpdatedByFilters>;
};

export type VisitTypeServiceLineRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitTypeServiceLineRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitTypeServiceLineRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitTypeServiceLineRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitTypeServiceLineRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitTypeServiceLineRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitTypeServiceLineRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeServiceLineRevisionHistoryUpdatedByFilters>;
};

export type VisitTypeServiceLineRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitTypeServiceLineRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineServiceLineIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineServiceLineIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineServiceLineIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineUpdatedByFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineVisitTypeIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceLineVisitTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceLineVisitTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  selectedByDefault: InputMaybe<InnerOrder>;
  serviceId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitTypeId: InputMaybe<InnerOrder>;
};

export type VisitTypeServiceOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<VisitTypeServiceRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<VisitTypeServiceRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryFilters = {
  OR: InputMaybe<Array<VisitTypeServiceRevisionHistoryFiltersOr>>;
  action: InputMaybe<VisitTypeServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitTypeServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitTypeServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitTypeServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitTypeServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitTypeServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeServiceRevisionHistoryUpdatedByFilters>;
};

export type VisitTypeServiceRevisionHistoryFiltersOr = {
  action: InputMaybe<VisitTypeServiceRevisionHistoryActionFilters>;
  changedFields: InputMaybe<VisitTypeServiceRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<VisitTypeServiceRevisionHistoryIdFilters>;
  organizationId: InputMaybe<VisitTypeServiceRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<VisitTypeServiceRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<VisitTypeServiceRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitTypeServiceRevisionHistoryUpdatedByFilters>;
};

export type VisitTypeServiceRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type VisitTypeServiceRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<VisitTypeServiceRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeServiceRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<VisitTypeServiceRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceSelectedByDefaultFilters = {
  OR: InputMaybe<Array<VisitTypeServiceSelectedByDefaultfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceSelectedByDefaultfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceServiceIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceServiceIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceServiceIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeServiceUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceUpdatedByFilters = {
  OR: InputMaybe<Array<VisitTypeServiceUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceVisitTypeIdFilters = {
  OR: InputMaybe<Array<VisitTypeServiceVisitTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeServiceVisitTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitTypeUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeUpdatedByFilters = {
  OR: InputMaybe<Array<VisitTypeUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitTypeUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitUpdateInput = {
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressCoordinates: InputMaybe<Scalars['String']['input']>;
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressTimezone: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  arrivalWindowEndTime: InputMaybe<Scalars['String']['input']>;
  arrivalWindowStartTime: InputMaybe<Scalars['String']['input']>;
  careRequirementId: InputMaybe<Scalars['Int']['input']>;
  createdAt: InputMaybe<Scalars['String']['input']>;
  createdBy: InputMaybe<Scalars['Int']['input']>;
  deleted: InputMaybe<Scalars['Boolean']['input']>;
  endTime: InputMaybe<Scalars['String']['input']>;
  episodeId: InputMaybe<Scalars['Int']['input']>;
  eventStatus: InputMaybe<VisitEventStatusEnum>;
  id: InputMaybe<Scalars['Int']['input']>;
  manualEdits: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: InputMaybe<Scalars['Int']['input']>;
  patientId: InputMaybe<Scalars['Int']['input']>;
  serviceInstructions: InputMaybe<Scalars['String']['input']>;
  startTime: InputMaybe<Scalars['String']['input']>;
  updatedAt: InputMaybe<Scalars['String']['input']>;
  updatedBy: InputMaybe<Scalars['Int']['input']>;
  visitCancellationReasonId: InputMaybe<Scalars['Int']['input']>;
  visitTypeId: InputMaybe<Scalars['Int']['input']>;
  visitWarningLogId: InputMaybe<Scalars['Int']['input']>;
};

export type VisitUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitUpdatedByFilters = {
  OR: InputMaybe<Array<VisitUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitVisitCancellationReasonIdFilters = {
  OR: InputMaybe<Array<VisitVisitCancellationReasonIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitVisitCancellationReasonIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitVisitTypeIdFilters = {
  OR: InputMaybe<Array<VisitVisitTypeIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitVisitTypeIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitVisitWarningLogIdFilters = {
  OR: InputMaybe<Array<VisitVisitWarningLogIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitVisitWarningLogIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogCreatedAtFilters = {
  OR: InputMaybe<Array<VisitWarningLogCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogCreatedByFilters = {
  OR: InputMaybe<Array<VisitWarningLogCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogDeletedFilters = {
  OR: InputMaybe<Array<VisitWarningLogDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogFilters = {
  OR: InputMaybe<Array<VisitWarningLogFiltersOr>>;
  createdAt: InputMaybe<VisitWarningLogCreatedAtFilters>;
  createdBy: InputMaybe<VisitWarningLogCreatedByFilters>;
  deleted: InputMaybe<VisitWarningLogDeletedFilters>;
  id: InputMaybe<VisitWarningLogIdFilters>;
  organizationId: InputMaybe<VisitWarningLogOrganizationIdFilters>;
  updatedAt: InputMaybe<VisitWarningLogUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitWarningLogUpdatedByFilters>;
  visitResourceWarnings: InputMaybe<VisitWarningLogVisitResourceWarningsFilters>;
  visitWarnings: InputMaybe<VisitWarningLogVisitWarningsFilters>;
};

export type VisitWarningLogFiltersOr = {
  createdAt: InputMaybe<VisitWarningLogCreatedAtFilters>;
  createdBy: InputMaybe<VisitWarningLogCreatedByFilters>;
  deleted: InputMaybe<VisitWarningLogDeletedFilters>;
  id: InputMaybe<VisitWarningLogIdFilters>;
  organizationId: InputMaybe<VisitWarningLogOrganizationIdFilters>;
  updatedAt: InputMaybe<VisitWarningLogUpdatedAtFilters>;
  updatedBy: InputMaybe<VisitWarningLogUpdatedByFilters>;
  visitResourceWarnings: InputMaybe<VisitWarningLogVisitResourceWarningsFilters>;
  visitWarnings: InputMaybe<VisitWarningLogVisitWarningsFilters>;
};

export type VisitWarningLogIdFilters = {
  OR: InputMaybe<Array<VisitWarningLogIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogOrderBy = {
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  visitResourceWarnings: InputMaybe<InnerOrder>;
  visitWarnings: InputMaybe<InnerOrder>;
};

export type VisitWarningLogOrganizationIdFilters = {
  OR: InputMaybe<Array<VisitWarningLogOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogUpdatedAtFilters = {
  OR: InputMaybe<Array<VisitWarningLogUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogUpdatedByFilters = {
  OR: InputMaybe<Array<VisitWarningLogUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogVisitResourceWarningsFilters = {
  OR: InputMaybe<Array<VisitWarningLogVisitResourceWarningsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogVisitResourceWarningsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogVisitWarningsFilters = {
  OR: InputMaybe<Array<VisitWarningLogVisitWarningsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type VisitWarningLogVisitWarningsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointApiKeyIdFilters = {
  OR: InputMaybe<Array<WebhookEndpointApiKeyIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointApiKeyIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointCreatedAtFilters = {
  OR: InputMaybe<Array<WebhookEndpointCreatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointCreatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointCreatedByFilters = {
  OR: InputMaybe<Array<WebhookEndpointCreatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointCreatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointDeletedFilters = {
  OR: InputMaybe<Array<WebhookEndpointDeletedfiltersOr>>;
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointDeletedfiltersOr = {
  eq: InputMaybe<Scalars['Boolean']['input']>;
  gt: InputMaybe<Scalars['Boolean']['input']>;
  gte: InputMaybe<Scalars['Boolean']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Boolean']['input']>;
  lte: InputMaybe<Scalars['Boolean']['input']>;
  ne: InputMaybe<Scalars['Boolean']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Boolean']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export enum WebhookEndpointEventTypeEnum {
  PatientUpdate = 'PatientUpdate',
  VisitUpdate = 'VisitUpdate'
}

export type WebhookEndpointEventTypeFilters = {
  OR: InputMaybe<Array<WebhookEndpointEventTypefiltersOr>>;
  eq: InputMaybe<WebhookEndpointEventTypeEnum>;
  gt: InputMaybe<WebhookEndpointEventTypeEnum>;
  gte: InputMaybe<WebhookEndpointEventTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<WebhookEndpointEventTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<WebhookEndpointEventTypeEnum>;
  lte: InputMaybe<WebhookEndpointEventTypeEnum>;
  ne: InputMaybe<WebhookEndpointEventTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<WebhookEndpointEventTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointEventTypefiltersOr = {
  eq: InputMaybe<WebhookEndpointEventTypeEnum>;
  gt: InputMaybe<WebhookEndpointEventTypeEnum>;
  gte: InputMaybe<WebhookEndpointEventTypeEnum>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<WebhookEndpointEventTypeEnum>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<WebhookEndpointEventTypeEnum>;
  lte: InputMaybe<WebhookEndpointEventTypeEnum>;
  ne: InputMaybe<WebhookEndpointEventTypeEnum>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<WebhookEndpointEventTypeEnum>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointFilters = {
  OR: InputMaybe<Array<WebhookEndpointFiltersOr>>;
  apiKeyId: InputMaybe<WebhookEndpointApiKeyIdFilters>;
  createdAt: InputMaybe<WebhookEndpointCreatedAtFilters>;
  createdBy: InputMaybe<WebhookEndpointCreatedByFilters>;
  deleted: InputMaybe<WebhookEndpointDeletedFilters>;
  eventType: InputMaybe<WebhookEndpointEventTypeFilters>;
  id: InputMaybe<WebhookEndpointIdFilters>;
  organizationId: InputMaybe<WebhookEndpointOrganizationIdFilters>;
  updatedAt: InputMaybe<WebhookEndpointUpdatedAtFilters>;
  updatedBy: InputMaybe<WebhookEndpointUpdatedByFilters>;
  url: InputMaybe<WebhookEndpointUrlFilters>;
};

export type WebhookEndpointFiltersOr = {
  apiKeyId: InputMaybe<WebhookEndpointApiKeyIdFilters>;
  createdAt: InputMaybe<WebhookEndpointCreatedAtFilters>;
  createdBy: InputMaybe<WebhookEndpointCreatedByFilters>;
  deleted: InputMaybe<WebhookEndpointDeletedFilters>;
  eventType: InputMaybe<WebhookEndpointEventTypeFilters>;
  id: InputMaybe<WebhookEndpointIdFilters>;
  organizationId: InputMaybe<WebhookEndpointOrganizationIdFilters>;
  updatedAt: InputMaybe<WebhookEndpointUpdatedAtFilters>;
  updatedBy: InputMaybe<WebhookEndpointUpdatedByFilters>;
  url: InputMaybe<WebhookEndpointUrlFilters>;
};

export type WebhookEndpointIdFilters = {
  OR: InputMaybe<Array<WebhookEndpointIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointOrderBy = {
  apiKeyId: InputMaybe<InnerOrder>;
  createdAt: InputMaybe<InnerOrder>;
  createdBy: InputMaybe<InnerOrder>;
  deleted: InputMaybe<InnerOrder>;
  eventType: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
  url: InputMaybe<InnerOrder>;
};

export type WebhookEndpointOrganizationIdFilters = {
  OR: InputMaybe<Array<WebhookEndpointOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryActionFilters = {
  OR: InputMaybe<Array<WebhookEndpointRevisionHistoryActionfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryActionfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryChangedFieldsFilters = {
  OR: InputMaybe<Array<WebhookEndpointRevisionHistoryChangedFieldsfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryChangedFieldsfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryFilters = {
  OR: InputMaybe<Array<WebhookEndpointRevisionHistoryFiltersOr>>;
  action: InputMaybe<WebhookEndpointRevisionHistoryActionFilters>;
  changedFields: InputMaybe<WebhookEndpointRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<WebhookEndpointRevisionHistoryIdFilters>;
  organizationId: InputMaybe<WebhookEndpointRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<WebhookEndpointRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<WebhookEndpointRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<WebhookEndpointRevisionHistoryUpdatedByFilters>;
};

export type WebhookEndpointRevisionHistoryFiltersOr = {
  action: InputMaybe<WebhookEndpointRevisionHistoryActionFilters>;
  changedFields: InputMaybe<WebhookEndpointRevisionHistoryChangedFieldsFilters>;
  id: InputMaybe<WebhookEndpointRevisionHistoryIdFilters>;
  organizationId: InputMaybe<WebhookEndpointRevisionHistoryOrganizationIdFilters>;
  recordData: InputMaybe<WebhookEndpointRevisionHistoryRecordDataFilters>;
  updatedAt: InputMaybe<WebhookEndpointRevisionHistoryUpdatedAtFilters>;
  updatedBy: InputMaybe<WebhookEndpointRevisionHistoryUpdatedByFilters>;
};

export type WebhookEndpointRevisionHistoryIdFilters = {
  OR: InputMaybe<Array<WebhookEndpointRevisionHistoryIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryOrderBy = {
  action: InputMaybe<InnerOrder>;
  changedFields: InputMaybe<InnerOrder>;
  id: InputMaybe<InnerOrder>;
  organizationId: InputMaybe<InnerOrder>;
  recordData: InputMaybe<InnerOrder>;
  updatedAt: InputMaybe<InnerOrder>;
  updatedBy: InputMaybe<InnerOrder>;
};

export type WebhookEndpointRevisionHistoryOrganizationIdFilters = {
  OR: InputMaybe<Array<WebhookEndpointRevisionHistoryOrganizationIdfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryOrganizationIdfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryRecordDataFilters = {
  OR: InputMaybe<Array<WebhookEndpointRevisionHistoryRecordDatafiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryRecordDatafiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryUpdatedAtFilters = {
  OR: InputMaybe<Array<WebhookEndpointRevisionHistoryUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryUpdatedByFilters = {
  OR: InputMaybe<Array<WebhookEndpointRevisionHistoryUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointRevisionHistoryUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointUpdatedAtFilters = {
  OR: InputMaybe<Array<WebhookEndpointUpdatedAtfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointUpdatedAtfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointUpdatedByFilters = {
  OR: InputMaybe<Array<WebhookEndpointUpdatedByfiltersOr>>;
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointUpdatedByfiltersOr = {
  eq: InputMaybe<Scalars['Int']['input']>;
  gt: InputMaybe<Scalars['Int']['input']>;
  gte: InputMaybe<Scalars['Int']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['Int']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['Int']['input']>;
  lte: InputMaybe<Scalars['Int']['input']>;
  ne: InputMaybe<Scalars['Int']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['Int']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointUrlFilters = {
  OR: InputMaybe<Array<WebhookEndpointUrlfiltersOr>>;
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type WebhookEndpointUrlfiltersOr = {
  eq: InputMaybe<Scalars['String']['input']>;
  gt: InputMaybe<Scalars['String']['input']>;
  gte: InputMaybe<Scalars['String']['input']>;
  ilike: InputMaybe<Scalars['String']['input']>;
  inArray: InputMaybe<Array<Scalars['String']['input']>>;
  isNotNull: InputMaybe<Scalars['Boolean']['input']>;
  isNull: InputMaybe<Scalars['Boolean']['input']>;
  like: InputMaybe<Scalars['String']['input']>;
  lt: InputMaybe<Scalars['String']['input']>;
  lte: InputMaybe<Scalars['String']['input']>;
  ne: InputMaybe<Scalars['String']['input']>;
  notIlike: InputMaybe<Scalars['String']['input']>;
  notInArray: InputMaybe<Array<Scalars['String']['input']>>;
  notLike: InputMaybe<Scalars['String']['input']>;
};

export type CreateCalendarBlockMutationVariables = Exact<{
  providerId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  title: InputMaybe<Scalars['String']['input']>;
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  addressTimezone: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<CalendarBlockFilterInput>;
  blockType: CalendarBlockBlockTypeEnum;
  addressPlaceId: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCalendarBlockMutation = { __typename?: 'Mutation', createCalendarBlock: { __typename?: 'CalendarBlockSelectItemWithFilters', id: number } };

export type CreateShiftMutationVariables = Exact<{
  providerId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  addressCoordinates: Scalars['String']['input'];
  addressTimezone: InputMaybe<Scalars['String']['input']>;
  providerTravel: ShiftProviderTravelEnum;
  shiftCenterId: InputMaybe<Scalars['Int']['input']>;
  overflowShift: Scalars['Boolean']['input'];
  useShiftCenterDriveTimes: Scalars['Boolean']['input'];
}>;


export type CreateShiftMutation = { __typename?: 'Mutation', createShift: { __typename?: 'ShiftItem', id: number } };

export type UpdateCalendarBlockMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  providerId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  title: InputMaybe<Scalars['String']['input']>;
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  addressTimezone: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<CalendarBlockFilterInput>;
  addressPlaceId: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCalendarBlockMutation = { __typename?: 'Mutation', updateCalendarBlock: { __typename?: 'CalendarBlockSelectItemWithFilters', id: number, providerId: number, startTime: string, endTime: string, title: string | null, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressTimezone: string | null, addressCoordinates: string | null, startOfShiftDriveTime: number, interVisitDriveTime: number, endOfShiftDriveTime: number, filters: { __typename?: 'calendarBlockParsedFilters', visitTypeIds: Array<number> | null } | null } };

export type UpdateCalendarBlockStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  eventStatus: CalendarBlockEventStatusEnum;
}>;


export type UpdateCalendarBlockStatusMutation = { __typename?: 'Mutation', updateCalendarBlock: { __typename?: 'CalendarBlockSelectItemWithFilters', id: number, eventStatus: CalendarBlockEventStatusEnum } };

export type CancelVisitDialogQueryVariables = Exact<{
  visitId: Scalars['Int']['input'];
}>;


export type CancelVisitDialogQuery = { __typename?: 'Query', visitSingle: { __typename?: 'VisitSelectItem', id: number, patient: { __typename?: 'VisitPatientRelation', firstName: string, lastName: string } | null } | null, visitCancellationReason: Array<{ __typename?: 'VisitCancellationReasonSelectItem', id: number, organizationId: number | null, description: string, createdAt: string, reasonType: VisitCancellationReasonReasonTypeEnum, createdBy: number | null }> };

export type CancelVisitMutationVariables = Exact<{
  visitId: Scalars['Int']['input'];
  visitCancellationReasonId: Scalars['Int']['input'];
}>;


export type CancelVisitMutation = { __typename?: 'Mutation', cancelVisit: { __typename?: 'VisitSelectItem', id: number, eventStatus: VisitEventStatusEnum, visitCancellationReasonId: number | null } };

export type UpdateShiftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  startTime: InputMaybe<Scalars['String']['input']>;
  endTime: InputMaybe<Scalars['String']['input']>;
  originalStartTime: InputMaybe<Scalars['String']['input']>;
  originalEndTime: InputMaybe<Scalars['String']['input']>;
  providerTravel: InputMaybe<ShiftProviderTravelEnum>;
  shiftCenterId: InputMaybe<Scalars['Int']['input']>;
  overflowShift: InputMaybe<Scalars['Boolean']['input']>;
  useShiftCenterDriveTimes: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateShiftMutation = { __typename?: 'Mutation', updateShift: { __typename?: 'ShiftItem', id: number, startTime: string, endTime: string, providerTravel: ShiftProviderTravelEnum, overflowShift: boolean, shiftCenterId: number | null } };

export type UpdateShiftStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status: InputMaybe<ShiftStatusEnum>;
}>;


export type UpdateShiftStatusMutation = { __typename?: 'Mutation', updateShift: { __typename?: 'ShiftItem', id: number, status: ShiftStatusEnum } };

export type SosAlertDetailFragment = { __typename?: 'SosAlertSelectItem', id: number, status: SosAlertStatusEnum, providerStatus: SosAlertProviderStatusEnum | null, latitude: string | null, longitude: string | null, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressTimezone: string | null, createdAt: string, provider: { __typename?: 'SosAlertProviderRelation', id: number, firstName: string, lastName: string } | null, visit: { __typename?: 'SosAlertVisitRelation', addressStreet: string | null, addressCity: string | null, addressState: string | null, addressTimezone: string | null, patient: { __typename?: 'SosAlertVisitRelationPatientRelation', id: number, firstName: string, lastName: string } | null } | null, events: Array<{ __typename?: 'SosAlertEventsRelation', id: number, eventType: SosAlertEventEventTypeEnum, note: string | null, createdAt: string, createdByUser: { __typename?: 'SosAlertEventsRelationCreatedByUserRelation', firstName: string, lastName: string } | null }> };

export type RecentSosAlertsQueryVariables = Exact<{
  withinHours: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentSosAlertsQuery = { __typename?: 'Query', recentSosAlerts: Array<{ __typename?: 'SosAlertSelectItem', id: number, status: SosAlertStatusEnum, providerStatus: SosAlertProviderStatusEnum | null, latitude: string | null, longitude: string | null, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressTimezone: string | null, createdAt: string, provider: { __typename?: 'SosAlertProviderRelation', id: number, firstName: string, lastName: string } | null, visit: { __typename?: 'SosAlertVisitRelation', addressStreet: string | null, addressCity: string | null, addressState: string | null, addressTimezone: string | null, patient: { __typename?: 'SosAlertVisitRelationPatientRelation', id: number, firstName: string, lastName: string } | null } | null, events: Array<{ __typename?: 'SosAlertEventsRelation', id: number, eventType: SosAlertEventEventTypeEnum, note: string | null, createdAt: string, createdByUser: { __typename?: 'SosAlertEventsRelationCreatedByUserRelation', firstName: string, lastName: string } | null }> }> };

export type AcknowledgeSosAlertMutationVariables = Exact<{
  sosAlertId: Scalars['Int']['input'];
}>;


export type AcknowledgeSosAlertMutation = { __typename?: 'Mutation', acknowledgeSosAlert: { __typename?: 'SosAlertSelectItem', id: number, status: SosAlertStatusEnum } };

export type ResolveSosAlertMutationVariables = Exact<{
  sosAlertId: Scalars['Int']['input'];
  note: InputMaybe<Scalars['String']['input']>;
}>;


export type ResolveSosAlertMutation = { __typename?: 'Mutation', resolveSosAlert: { __typename?: 'SosAlertSelectItem', id: number, status: SosAlertStatusEnum } };

export type AssignVisitResourceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  providerId: Scalars['Int']['input'];
  startTime: InputMaybe<Scalars['String']['input']>;
  endTime: InputMaybe<Scalars['String']['input']>;
}>;


export type AssignVisitResourceMutation = { __typename?: 'Mutation', updateVisitResourceObject: { __typename?: 'VisitResourceItem', id: number, providerId: number | null, startTime: string, endTime: string } };

export type GetProviderShiftForDayQueryVariables = Exact<{
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  providerId: Scalars['Int']['input'];
}>;


export type GetProviderShiftForDayQuery = { __typename?: 'Query', shift: Array<{ __typename?: 'ShiftSelectItem', id: number, startTime: string, endTime: string, status: ShiftStatusEnum }>, visitResource: Array<{ __typename?: 'VisitResourceSelectItem', id: number, startTime: string, endTime: string, visit: { __typename?: 'VisitResourceVisitRelation', id: number, eventStatus: VisitEventStatusEnum, visitTypeId: number, patient: { __typename?: 'VisitResourceVisitRelationPatientRelation', id: number, firstName: string, lastName: string } | null } | null }> };

export type VisitErrandOptionsQueryVariables = Exact<{
  errandTypeId: Scalars['Int']['input'];
}>;


export type VisitErrandOptionsQuery = { __typename?: 'Query', organizationalUnit: Array<{ __typename?: 'OrganizationalUnitSelectItem', id: number, active: boolean }>, errandLocation: Array<{ __typename?: 'ErrandLocationSelectItem', id: number, name: string, organizationalUnitId: number | null }>, provider: Array<{ __typename?: 'ProviderSelectItem', id: number, firstName: string, lastName: string, providerTypeId: number, OrganizationUser: { __typename?: 'ProviderOrganizationUserRelation', organizationalUnitOrgUsers: Array<{ __typename?: 'ProviderOrganizationUserRelationOrganizationalUnitOrgUsersRelation', organizationalUnitId: number }> } | null, serviceLineProviders: Array<{ __typename?: 'ProviderServiceLineProvidersRelation', serviceLineId: number }> }> };

export type CreateErrandVisitResourceMutationVariables = Exact<{
  visitId: Scalars['Int']['input'];
  errandTypeId: Scalars['Int']['input'];
  errandLocationId: Scalars['Int']['input'];
  providerId: Scalars['Int']['input'];
}>;


export type CreateErrandVisitResourceMutation = { __typename?: 'Mutation', createErrandVisitResource: { __typename?: 'VisitResourceItem', id: number } };

export type DeleteErrandVisitResourceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  visitId: Scalars['Int']['input'];
}>;


export type DeleteErrandVisitResourceMutation = { __typename?: 'Mutation', deleteErrandVisitResource: { __typename?: 'VisitResourceItem', id: number, deleted: boolean } };

export type DeleteVisitEventLogEntryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteVisitEventLogEntryMutation = { __typename?: 'Mutation', deleteVisitEventLog: { __typename?: 'VisitEventLogEntrySelectItem', id: number } };

export type GetVisitDetailsQueryVariables = Exact<{
  visitId: Scalars['Int']['input'];
}>;


export type GetVisitDetailsQuery = { __typename?: 'Query', visitSingle: { __typename?: 'VisitSelectItem', id: number, careRequirementId: number | null, startTime: string, endTime: string, eventStatus: VisitEventStatusEnum, addressTimezone: string | null, serviceInstructions: string | null, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, arrivalWindowStartTime: string, arrivalWindowEndTime: string, manualEdits: boolean, visitTypeId: number, visitWarningLogId: number | null, patient: { __typename?: 'VisitPatientRelation', id: number, firstName: string, lastName: string, dateOfBirth: string | null, sex: PatientSexEnum | null, phone: string | null, patientNotes: string | null, serviceInstructions: string | null, patientIdentifiers: Array<{ __typename?: 'VisitPatientRelationPatientIdentifiersRelation', identifier: string, identifier_type: string }>, careTeamProviders: Array<{ __typename?: 'VisitPatientRelationCareTeamProvidersRelation', id: number, providerId: number }> } | null, visitResources: Array<{ __typename?: 'VisitVisitResourcesRelation', id: number, startTime: string, endTime: string, providerId: number | null, errandStatus: VisitResourceErrandStatusEnum | null, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null, addressTimezone: string | null, startOfShiftDriveTime: number, interVisitDriveTime: number, endOfShiftDriveTime: number, visitResourceRequirementId: number, virtualProviderStatus: VisitResourceVirtualProviderStatusEnum | null, provider: { __typename?: 'VisitVisitResourcesRelationProviderRelation', id: number, firstName: string, lastName: string, providerType: { __typename?: 'VisitVisitResourcesRelationProviderRelationProviderTypeRelation', id: number, name: string } | null } | null, resourceRequirement: { __typename?: 'VisitVisitResourcesRelationResourceRequirementRelation', invitedToVisit: boolean, errandType: { __typename?: 'VisitVisitResourcesRelationResourceRequirementRelationErrandTypeRelation', id: number, name: string } | null } | null }>, notes: Array<{ __typename?: 'VisitNotesRelation', id: number, body: string, createdAt: string, user: { __typename?: 'VisitNotesRelationUserRelation', id: number, email: string, firstName: string, lastName: string } | null }>, visitServices: Array<{ __typename?: 'VisitVisitServicesRelation', id: number, service: { __typename?: 'VisitVisitServicesRelationServiceRelation', id: number, name: string } | null }>, cancellationReason: { __typename?: 'VisitCancellationReasonRelation', id: number, description: string } | null, episode: { __typename?: 'VisitEpisodeRelation', id: number, serviceLineId: number, organizationalUnitId: number | null, precautions: Array<{ __typename?: 'VisitEpisodeRelationPrecautionsRelation', id: number, precautionId: number }> } | null, eventLog: Array<{ __typename?: 'VisitEventLogRelation', id: number, eventTime: string, logEntryType: VisitEventLogEntryLogEntryTypeEnum | null, event: string, autoGenerated: boolean, visitResourceId: number | null, createdByUser: { __typename?: 'VisitEventLogRelationCreatedByUserRelation', firstName: string, lastName: string } | null }> } | null };

export type SubmitVisitNoteMutationVariables = Exact<{
  visitId: Scalars['Int']['input'];
  body: Scalars['String']['input'];
}>;


export type SubmitVisitNoteMutation = { __typename?: 'Mutation', createVisitNote: { __typename?: 'VisitNoteSelectItem', id: number, body: string, createdAt: string, user: { __typename?: 'VisitNoteUserRelation', id: number, email: string } | null } };

export type SetVisitManualEditsMutationVariables = Exact<{
  visitId: Scalars['Int']['input'];
  manualEdits: Scalars['Boolean']['input'];
}>;


export type SetVisitManualEditsMutation = { __typename?: 'Mutation', updateVisit: Array<{ __typename?: 'VisitItem', id: number, manualEdits: boolean }> };

export type CancelVisitRequestTaskMutationVariables = Exact<{
  taskId: Scalars['Int']['input'];
}>;


export type CancelVisitRequestTaskMutation = { __typename?: 'Mutation', cancelVisitRequest: { __typename?: 'TaskItem', id: number } };

export type CustomUpdateVisitStatusMutationVariables = Exact<{
  visitId: Scalars['Int']['input'];
  newEventStatus: VisitEventStatusEnum;
  autoGenerated: Scalars['Boolean']['input'];
  eventTime: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomUpdateVisitStatusMutation = { __typename?: 'Mutation', updateVisit: Array<{ __typename?: 'VisitItem', id: number, eventStatus: VisitEventStatusEnum }> };

export type CustomUpdateErrandStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  visitId: Scalars['Int']['input'];
  newStatus: VisitResourceErrandStatusEnum;
  autoGenerated: Scalars['Boolean']['input'];
  eventTime: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomUpdateErrandStatusMutation = { __typename?: 'Mutation', updateErrandVisitResourceStatus: { __typename?: 'VisitResourceItem', id: number, errandStatus: VisitResourceErrandStatusEnum | null } };

export type PatientTimezoneQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
}>;


export type PatientTimezoneQuery = { __typename?: 'Query', patientSingle: { __typename?: 'PatientSelectItem', id: number, addressTimezone: string | null } | null };

export type CreatePatientDataImportMutationVariables = Exact<{
  filename: Scalars['String']['input'];
}>;


export type CreatePatientDataImportMutation = { __typename?: 'Mutation', createDataImport: { __typename?: 'DataImportResult', fileUploadUrl: string, dataImport: { __typename?: 'DataImportItem', id: number, filePathToS3: string, filename: string | null, status: DataImportStatusEnum } } };

export type CreateUserDataImportMutationVariables = Exact<{
  filename: Scalars['String']['input'];
}>;


export type CreateUserDataImportMutation = { __typename?: 'Mutation', createDataImport: { __typename?: 'DataImportResult', fileUploadUrl: string, dataImport: { __typename?: 'DataImportItem', id: number, filePathToS3: string, filename: string | null, status: DataImportStatusEnum } } };

export type GetPatientDataImportPreviewQueryVariables = Exact<{
  dataImportId: Scalars['Int']['input'];
}>;


export type GetPatientDataImportPreviewQuery = { __typename?: 'Query', dataImportPreview: { __typename?: 'ImportPreviewResolverResult', columnNames: Array<string | null> | null, csvColumnNames: Array<string | null> | null, preview: { __typename?: 'PreviewType', validRecordCount: number, totalErrorCount: number, errors: Array<{ __typename?: 'PreviewError', csvRow: Array<string | null> | null, rowIndex: number, errors: Array<{ __typename?: 'PreviewDataError', instancePath: string | null, keyword: string | null, message: string | null }> }> | null, exampleRecords: Array<{ __typename?: 'PreviewExample', record: Array<string | null>, rowIndex: number }> | null } } };

export type GetUserDataImportPreviewQueryVariables = Exact<{
  dataImportId: Scalars['Int']['input'];
}>;


export type GetUserDataImportPreviewQuery = { __typename?: 'Query', dataImportPreview: { __typename?: 'ImportPreviewResolverResult', columnNames: Array<string | null> | null, csvColumnNames: Array<string | null> | null, preview: { __typename?: 'PreviewType', validRecordCount: number, totalErrorCount: number, errors: Array<{ __typename?: 'PreviewError', csvRow: Array<string | null> | null, rowIndex: number, errors: Array<{ __typename?: 'PreviewDataError', instancePath: string | null, keyword: string | null, message: string | null }> }> | null, exampleRecords: Array<{ __typename?: 'PreviewExample', record: Array<string | null>, rowIndex: number }> | null } } };

export type ExecutePatientDataImportMutationVariables = Exact<{
  dataImportId: Scalars['Int']['input'];
}>;


export type ExecutePatientDataImportMutation = { __typename?: 'Mutation', importData: { __typename?: 'DataImportItem', id: number } };

export type ExecuteUserDataImportMutationVariables = Exact<{
  dataImportId: Scalars['Int']['input'];
}>;


export type ExecuteUserDataImportMutation = { __typename?: 'Mutation', importData: { __typename?: 'DataImportItem', id: number } };

export type DeletePatientDataImportMutationVariables = Exact<{
  dataImportId: Scalars['Int']['input'];
}>;


export type DeletePatientDataImportMutation = { __typename?: 'Mutation', deleteDataImport: { __typename?: 'DataImportItem', id: number } };

export type DeleteUserDataImportMutationVariables = Exact<{
  dataImportId: Scalars['Int']['input'];
}>;


export type DeleteUserDataImportMutation = { __typename?: 'Mutation', deleteDataImport: { __typename?: 'DataImportItem', id: number } };

export type GetPatientDataImportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientDataImportQuery = { __typename?: 'Query', dataImport: Array<{ __typename?: 'DataImportSelectItem', id: number, createdAt: string, deleted: boolean, filePathToS3: string, metadata: string | null, filename: string | null, organizationId: number | null, resourceType: string, status: DataImportStatusEnum, updatedAt: string, createdBy: { __typename?: 'DataImportCreatedByRelation', firstName: string, lastName: string } | null }> };

export type GetUserDataImportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserDataImportQuery = { __typename?: 'Query', dataImport: Array<{ __typename?: 'DataImportSelectItem', id: number, createdAt: string, deleted: boolean, filePathToS3: string, metadata: string | null, filename: string | null, organizationId: number | null, resourceType: string, status: DataImportStatusEnum, updatedAt: string, createdBy: { __typename?: 'DataImportCreatedByRelation', firstName: string, lastName: string } | null }> };

export type GetKpiProviderUtilizationQueryVariables = Exact<{
  input: KpiQueryInputArgs;
}>;


export type GetKpiProviderUtilizationQuery = { __typename?: 'Query', kpiProviderUtilization: { __typename?: 'KPIChartDoughnutDataResult', shiftTime: number | null, visitTime: number | null, interVisitDriveTime: number | null, startEndDriveTime: number | null, calendarBlockTime: number | null } };

export type GetKpiVisitTypesQueryVariables = Exact<{
  input: KpiQueryInputArgs;
}>;


export type GetKpiVisitTypesQuery = { __typename?: 'Query', kpiVisitTypes: { __typename?: 'KPIVisitTypeResult', visitTypePercentages: any | null, totalVisits: number | null, visitVolumeByDate: Array<{ __typename?: 'DateGroupValues', date: string, category: string, count: number } | null> } };

export type KpiChartCancellationRateQueryVariables = Exact<{
  input: KpiQueryInputArgs;
}>;


export type KpiChartCancellationRateQuery = { __typename?: 'Query', kpiCancellationRate: { __typename?: 'KPIChartCancellationRateResult', cancellationRates: any | null, totalCancellationRate: number | null } };

export type KpiSummaryQueryVariables = Exact<{
  input: KpiQueryInputArgs;
}>;


export type KpiSummaryQuery = { __typename?: 'Query', kpiSummary: { __typename?: 'KPISummaryResult', totalVisits: number | null, rankCategoryCounts: { __typename?: 'RankCategoryCounts', high: number | null, medium: number | null, low: number | null }, visitsByStatus: { __typename?: 'VisitsByStatus', canceled: number | null, complete: number | null, in_progress: number | null, arrived: number | null, en_route: number | null, scheduled: number | null } } };

export type GetKpiVisitPerShiftQueryVariables = Exact<{
  input: KpiQueryInputArgs;
}>;


export type GetKpiVisitPerShiftQuery = { __typename?: 'Query', kpiVisitsPerShift: { __typename?: 'KPIBarChartVisitsPerShift', visitsPerShift: Array<{ __typename?: 'DateGroupsBarChart', date: string | null, totalVisits: number | null, totalShiftHours: number | null, visitsPerShift: number | null } | null> } };

export type PersistFhirQueryMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  queryText: Scalars['String']['input'];
  sourceSystem: Scalars['String']['input'];
  responseBody: Scalars['String']['input'];
}>;


export type PersistFhirQueryMutation = { __typename?: 'Mutation', persistFhirQuery: { __typename?: 'PersistFhirQueryResult', fhirQueryId: number, success: boolean } };

export type CreatePatientCareTeamMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  providerId: Scalars['Int']['input'];
  providerTypeId: Scalars['Int']['input'];
  allowAutomaticUpdates: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePatientCareTeamMutation = { __typename?: 'Mutation', createPatientCareTeam: number | null };

export type GetProvidersByTypeQueryVariables = Exact<{
  providerTypeId: Scalars['Int']['input'];
}>;


export type GetProvidersByTypeQuery = { __typename?: 'Query', provider: Array<{ __typename?: 'ProviderSelectItem', id: number, firstName: string, lastName: string, providerTypeId: number }> };

export type CreatePatientMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: InputMaybe<Scalars['String']['input']>;
  addressStreet: Scalars['String']['input'];
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  sex: InputMaybe<PatientSexEnum>;
  dateOfBirth: InputMaybe<Scalars['String']['input']>;
  patientNotes: InputMaybe<Scalars['String']['input']>;
  serviceInstructions: InputMaybe<Scalars['String']['input']>;
  patientIdentifiers: Array<ManagePatientIdentifier> | ManagePatientIdentifier;
  addressPlaceId: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePatientMutation = { __typename?: 'Mutation', createPatient: { __typename?: 'PatientSelectItem', id: number, firstName: string, lastName: string, addressTimezone: string | null } };

export type UpdatePatientMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: InputMaybe<Scalars['String']['input']>;
  addressStreet: Scalars['String']['input'];
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: InputMaybe<Scalars['String']['input']>;
  sex: InputMaybe<PatientSexEnum>;
  patientNotes: InputMaybe<Scalars['String']['input']>;
  serviceInstructions: InputMaybe<Scalars['String']['input']>;
  patientIdentifiers: Array<ManagePatientIdentifier> | ManagePatientIdentifier;
  addressPlaceId: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient: { __typename?: 'PatientSelectItem', id: number, firstName: string, lastName: string, phone: string | null, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, dateOfBirth: string | null, sex: PatientSexEnum | null, patientNotes: string | null, serviceInstructions: string | null, updatedAt: string, patientIdentifiers: Array<{ __typename?: 'PatientPatientIdentifiersRelation', id: number, identifier: string, identifier_type: string }> } };

export type DeletePatientCareTeamMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  providerTypeId: Scalars['Int']['input'];
}>;


export type DeletePatientCareTeamMutation = { __typename?: 'Mutation', deletePatientCareTeam: boolean | null };

export type SearchPatientsQueryVariables = Exact<{
  searchTerm: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPatientsQuery = { __typename?: 'Query', searchPatient: Array<{ __typename?: 'PatientSearchResult', patient: { __typename?: 'PatientSelectItem', id: number, firstName: string, lastName: string, phone: string | null, dateOfBirth: string | null, sex: PatientSexEnum | null }, bestEpisode: { __typename?: 'EpisodeSelectItem', active: boolean, createdAt: string, updatedAt: string } | null }> };

export type GenerateVisitsWarningsMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  serviceLineId: Scalars['Int']['input'];
  visitTypeId: Scalars['Int']['input'];
  resources: Array<InputMaybe<VisitResourceWithRequirement>> | InputMaybe<VisitResourceWithRequirement>;
  reschedulingVisitId: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenerateVisitsWarningsMutation = { __typename?: 'Mutation', generateVisitWarnings: { __typename?: 'VisitWarningsLogEntry', visitWarningLogId: number, visitWarnings: { __typename?: 'VisitWarnings', visitId: number, severity: number, teamMismatch: boolean | null, resourceRequirementProviderTypes: { __typename?: 'VisitWarningsResourceRequirementProviderTypes', expectedProviderTypes: Array<Array<number>>, actualProviderIds: Array<number | null>, extraProviderIds: Array<number> } | null }, visitResourceWarnings: Array<{ __typename?: 'VisitResourceWarnings', visitId: number, providerId: number, severity: number, shiftMissing: boolean | null, previousVisitDriveTimeOverlap: number | null, nextVisitDriveTimeOverlap: number | null, startOfShiftDriveTimeOverlap: number | null, endOfShiftDriveTimeOverlap: number | null, gapCreatedBeforeVisit: number | null, gapCreatedAfterVisit: number | null, excessiveDriveTimeBeforeVisit: number | null, excessiveDriveTimeAfterVisit: number | null, duration: { __typename?: 'VisitResourceWarningDuration', expectedDurationInMinutes: number, actualDurationInMinutes: number } | null, previousBlocker: { __typename?: 'VisitResourceBlockingItem', type: string, label: string } | null, nextBlocker: { __typename?: 'VisitResourceBlockingItemNext', type: string, label: string } | null }> } | null };

export type GetPatientInstructionsQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
}>;


export type GetPatientInstructionsQuery = { __typename?: 'Query', patientSingle: { __typename?: 'PatientSelectItem', id: number, addressTimezone: string | null, addressState: string | null, serviceInstructions: string | null, episodes: Array<{ __typename?: 'PatientEpisodesRelation', id: number, active: boolean, serviceLineId: number, organizationalUnitId: number | null }>, careTeamProviders: Array<{ __typename?: 'PatientCareTeamProvidersRelation', id: number, providerId: number, providerTypeId: number, provider: { __typename?: 'PatientCareTeamProvidersRelationProviderRelation', providerTypeId: number } | null }> } | null, organizationalUnit: Array<{ __typename?: 'OrganizationalUnitSelectItem', id: number, name: string, active: boolean }> };

export type CreateVisitRequestMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  serviceLineId: Scalars['Int']['input'];
  visitTypeId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  serviceInstructions: InputMaybe<Scalars['String']['input']>;
  serviceIds: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  constraints: InputMaybe<Constraints>;
}>;


export type CreateVisitRequestMutation = { __typename?: 'Mutation', createVisitRequest: { __typename?: 'TaskItem', id: number } };

export type OverrideVisitUnitProvidersQueryVariables = Exact<{
  organizationalUnitId: Scalars['Int']['input'];
}>;


export type OverrideVisitUnitProvidersQuery = { __typename?: 'Query', organizationalUnitOrgUser: Array<{ __typename?: 'OrganizationalUnitOrgUserSelectItem', orgUser: { __typename?: 'OrganizationalUnitOrgUserOrgUserRelation', providers: Array<{ __typename?: 'OrganizationalUnitOrgUserOrgUserRelationProvidersRelation', id: number }> } | null }> };

export type EpisodeOrganizationalUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type EpisodeOrganizationalUnitsQuery = { __typename?: 'Query', organizationalUnit: Array<{ __typename?: 'OrganizationalUnitSelectItem', id: number, name: string, active: boolean }> };

export type SchedulerOptionsQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  targetTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  serviceLineId: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  visitTypeId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  serviceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  providerTraits: Array<InputMaybe<ProvideTraitQueryInput>> | InputMaybe<ProvideTraitQueryInput>;
  daysOfWeek: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  hoursOfDay: InputMaybe<HoursOfDayQueryInput>;
  reschedulingVisitId: InputMaybe<Scalars['Int']['input']>;
  selectedProviderIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  useOverflowShifts: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SchedulerOptionsQuery = { __typename?: 'Query', scheduleOption: { __typename?: 'ScheduleOptions', options: Array<{ __typename?: 'ScheduleOption', startTime: string, endTime: string, arrivalWindowEnd: string, arrivalWindowStart: string, rankCategory: string, originDrive: number, destinationDrive: number, driveForScoring: number, contiguous: boolean, runId: string, resources: Array<{ __typename?: 'ScheduleOptionResource', startTime: string, endTime: string, inHome: boolean, providerId: number, shiftId: number, raceConditionHash: string, preferred: boolean }>, scores: { __typename?: 'ScheduleOptionScore', totalScore: number, driveScore: number, proximityScore: number, utilizationScore: number } }>, providers: Array<{ __typename?: 'ProviderItem', id: number, firstName: string, lastName: string }> } };

export type SchedulerProvidersListQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  serviceLineId: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  visitTypeId: Scalars['Int']['input'];
}>;


export type SchedulerProvidersListQuery = { __typename?: 'Query', scheduleProvidersList: Array<{ __typename?: 'ScheduleProviderInfo', id: number, firstName: string, lastName: string, preferred: boolean, providerTypeId: number, hasProviderType: boolean, hasServiceLine: boolean, hasStateLicense: boolean, hasNearbyShifts: boolean, hasVirtualShifts: boolean, hasInHomeShifts: boolean, hasNonOverflowShifts: boolean }> };

export type ScheduleVisitMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  visitTypeId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  resources: Array<NewVisitResourceInput> | NewVisitResourceInput;
  serviceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  serviceInstructions: InputMaybe<Scalars['String']['input']>;
  note: InputMaybe<Scalars['String']['input']>;
  runId: Scalars['String']['input'];
  reschedulingVisitId: InputMaybe<Scalars['Int']['input']>;
  serviceLineId: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  chosenOptionIndex: InputMaybe<Scalars['Int']['input']>;
}>;


export type ScheduleVisitMutation = { __typename?: 'Mutation', scheduleVisit: { __typename?: 'VisitSelectItem', id: number, startTime: string, endTime: string, arrivalWindowStartTime: string, arrivalWindowEndTime: string, serviceInstructions: string | null, patient: { __typename?: 'VisitPatientRelation', id: number, serviceInstructions: string | null } | null } };

export type SchedulerOrganizationalUnitsQueryVariables = Exact<{
  organizationUserId: Scalars['Int']['input'];
}>;


export type SchedulerOrganizationalUnitsQuery = { __typename?: 'Query', organizationalUnit: Array<{ __typename?: 'OrganizationalUnitSelectItem', id: number, name: string, active: boolean }>, organizationalUnitOrgUser: Array<{ __typename?: 'OrganizationalUnitOrgUserSelectItem', organizationalUnit: { __typename?: 'OrganizationalUnitOrgUserOrganizationalUnitRelation', id: number, name: string, active: boolean } | null }> };

export type ScheduleOverrideVisitMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  serviceLineId: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  visitTypeId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  resources: Array<NewOverrideVisitResourceInput> | NewOverrideVisitResourceInput;
  serviceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  visitWarningLogId: Scalars['Int']['input'];
  reschedulingVisitId: InputMaybe<Scalars['Int']['input']>;
  serviceInstructions: InputMaybe<Scalars['String']['input']>;
  note: InputMaybe<Scalars['String']['input']>;
}>;


export type ScheduleOverrideVisitMutation = { __typename?: 'Mutation', scheduleOverrideVisit: { __typename?: 'VisitSelectItem', id: number } };

export type UpsertUserMutationVariables = Exact<{
  currentId: InputMaybe<Scalars['Int']['input']>;
  currentEmail: InputMaybe<Scalars['String']['input']>;
  userDetails: UpsertUserDetails;
}>;


export type UpsertUserMutation = { __typename?: 'Mutation', upsertUser: { __typename?: 'UpsertUserResult', id: number } | null };

export type ReactivateProviderMutationVariables = Exact<{
  providerId: Scalars['Int']['input'];
}>;


export type ReactivateProviderMutation = { __typename?: 'Mutation', reactivateProvider: { __typename?: 'ProviderItem', id: number } };

export type SearchUsersQueryVariables = Exact<{
  searchTerm: InputMaybe<Scalars['String']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  hideSystemAccounts: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUser: Array<{ __typename?: 'UserSearchResult', id: number, email: string, firstName: string, lastName: string, roles: Array<string>, active: boolean, providerType: string | null, providerFirstName: string | null, providerLastName: string | null } | null> };

export type HomeHealthDemoHorizonQueryVariables = Exact<{
  start: InputMaybe<Scalars['String']['input']>;
  end: InputMaybe<Scalars['String']['input']>;
}>;


export type HomeHealthDemoHorizonQuery = { __typename?: 'Query', shift: Array<{ __typename?: 'ShiftSelectItem', id: number, status: ShiftStatusEnum, startTime: string, endTime: string, providerId: number, overflowShift: boolean, shiftCenterId: number | null, useShiftCenterDriveTimes: boolean, addressZip: string | null, shiftCenter: { __typename?: 'ShiftShiftCenterRelation', id: number, name: string, addressZip: string | null } | null, provider: { __typename?: 'ShiftProviderRelation', id: number, addressZip: string | null } | null }>, calendarBlock: Array<{ __typename?: 'CalendarBlockSelectItemWithFilters', id: number, title: string | null, startTime: string, endTime: string, eventStatus: CalendarBlockEventStatusEnum, providerId: number, blockType: CalendarBlockBlockTypeEnum, filters: { __typename?: 'calendarBlockParsedFilters', visitTypeIds: Array<number> | null } | null }>, visitResource: Array<{ __typename?: 'VisitResourceSelectItem', id: number, visitId: number, providerId: number | null, startTime: string, endTime: string, startOfShiftDriveTime: number, interVisitDriveTime: number, endOfShiftDriveTime: number, visit: { __typename?: 'VisitResourceVisitRelation', id: number, startTime: string, endTime: string, eventStatus: VisitEventStatusEnum, visitTypeId: number, addressZip: string | null, arrivalWindowStartTime: string, arrivalWindowEndTime: string, visitType: { __typename?: 'VisitResourceVisitRelationVisitTypeRelation', id: number, name: string } | null, patient: { __typename?: 'VisitResourceVisitRelationPatientRelation', id: number, firstName: string, lastName: string, addressZip: string | null } | null } | null }>, patient: Array<{ __typename?: 'PatientSelectItem', id: number, firstName: string, lastName: string, addressZip: string | null, patientIdentifiers: Array<{ __typename?: 'PatientPatientIdentifiersRelation', identifier: string, identifier_type: string }> }>, episode: Array<{ __typename?: 'EpisodeSelectItem', id: number, patientId: number, active: boolean }>, visitCancellationReason: Array<{ __typename?: 'VisitCancellationReasonSelectItem', id: number, description: string }>, service: Array<{ __typename?: 'ServiceSelectItem', id: number, name: string, description: string | null }>, commandIndexProviders: { __typename?: 'ProvidersResponse', providers: Array<{ __typename?: 'ProviderSelectItem', id: number, firstName: string, lastName: string, addressZip: string | null, active: boolean, providerType: { __typename?: 'ProviderProviderTypeRelation', id: number, name: string } | null, OrganizationUser: { __typename?: 'ProviderOrganizationUserRelation', user: { __typename?: 'ProviderOrganizationUserRelationUserRelation', email: string } | null } | null }> } };

export type HomeHealthDemoLastResetQueryVariables = Exact<{
  markerId: Scalars['Int']['input'];
}>;


export type HomeHealthDemoLastResetQuery = { __typename?: 'Query', service: Array<{ __typename?: 'ServiceSelectItem', id: number, createdAt: string, createdBy: number | null }>, organizationUser: Array<{ __typename?: 'OrganizationUserSelectItem', userId: number, user: { __typename?: 'OrganizationUserUserRelation', firstName: string, lastName: string, email: string } | null }> };

export type HomeHealthDemoScheduleOverrideVisitMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  serviceLineId: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  visitTypeId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  resources: Array<NewOverrideVisitResourceInput> | NewOverrideVisitResourceInput;
  serviceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  reschedulingVisitId: InputMaybe<Scalars['Int']['input']>;
  serviceInstructions: InputMaybe<Scalars['String']['input']>;
  note: InputMaybe<Scalars['String']['input']>;
}>;


export type HomeHealthDemoScheduleOverrideVisitMutation = { __typename?: 'Mutation', scheduleOverrideVisit: { __typename?: 'VisitSelectItem', id: number, startTime: string, endTime: string } };

export type HomeHealthDemoResetMutationVariables = Exact<{
  demoDate: Scalars['String']['input'];
  asOf: Scalars['String']['input'];
  phone: Scalars['String']['input'];
}>;


export type HomeHealthDemoResetMutation = { __typename?: 'Mutation', resetHomeHealthDemo: { __typename?: 'ResetHomeHealthDemoResult', demoDate: string, files: number, statements: number } };

export type CreateAvailabilityMutationVariables = Exact<{
  providerId: Scalars['Int']['input'];
  additionalProviderIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  tzHandling: AvailTzHandling;
  type: AvailabilityTypeEnum;
  note: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  providerTravel: InputMaybe<AvailabilityProviderTravelEnum>;
  shiftCenterId: InputMaybe<Scalars['Int']['input']>;
  overflowShift: Scalars['Boolean']['input'];
  useShiftCenterDriveTimes: Scalars['Boolean']['input'];
  rruleFreq: AvailabilityRruleFreqEnum;
  rruleDtstart: Scalars['String']['input'];
  rruleInterval: InputMaybe<Scalars['Int']['input']>;
  rruleByweekday: InputMaybe<Scalars['String']['input']>;
  rruleUntil: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAvailabilityMutation = { __typename?: 'Mutation', createAvailability: { __typename?: 'AvailabilitySelectItemWithFilters', id: number } };

export type UpdateAvailabilityMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  additionalIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  providerId: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  providerTravel: InputMaybe<AvailabilityProviderTravelEnum>;
  shiftCenterId: InputMaybe<Scalars['Int']['input']>;
  tzHandling: AvailTzHandling;
  overflowShift: Scalars['Boolean']['input'];
  useShiftCenterDriveTimes: Scalars['Boolean']['input'];
  rruleFreq: AvailabilityRruleFreqEnum;
  rruleDtstart: Scalars['String']['input'];
  rruleInterval: InputMaybe<Scalars['Int']['input']>;
  rruleByweekday: InputMaybe<Scalars['String']['input']>;
  rruleUntil: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAvailabilityMutation = { __typename?: 'Mutation', updateAvailability: { __typename?: 'AvailabilitySelectItemWithFilters', id: number, type: AvailabilityTypeEnum, note: string, providerTravel: AvailabilityProviderTravelEnum, shiftCenterId: number | null, overflowShift: boolean, useShiftCenterDriveTimes: boolean, startTime: string, endTime: string, rruleFreq: AvailabilityRruleFreqEnum, rruleDtstart: string, rruleInterval: number | null, rruleByweekday: Array<string | null> | null, rruleUntil: string | null } };

export type CreateRecurringCalendarBlockMutationVariables = Exact<{
  providerId: Scalars['Int']['input'];
  additionalProviderIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  tzHandling: AvailTzHandling;
  type: AvailabilityTypeEnum;
  note: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  blockType: AvailabilityBlockTypeEnum;
  blockFilters: InputMaybe<CalendarBlockFilterInput>;
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  rruleFreq: AvailabilityRruleFreqEnum;
  rruleDtstart: Scalars['String']['input'];
  rruleInterval: InputMaybe<Scalars['Int']['input']>;
  rruleByweekday: InputMaybe<Scalars['String']['input']>;
  rruleUntil: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRecurringCalendarBlockMutation = { __typename?: 'Mutation', createAvailability: { __typename?: 'AvailabilitySelectItemWithFilters', id: number } };

export type UpdateRecurringCalendarBlockMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  additionalIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  tzHandling: AvailTzHandling;
  providerId: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  blockType: AvailabilityBlockTypeEnum;
  blockFilters: InputMaybe<CalendarBlockFilterInput>;
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  rruleFreq: AvailabilityRruleFreqEnum;
  rruleDtstart: Scalars['String']['input'];
  rruleInterval: InputMaybe<Scalars['Int']['input']>;
  rruleByweekday: InputMaybe<Scalars['String']['input']>;
  rruleUntil: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRecurringCalendarBlockMutation = { __typename?: 'Mutation', updateAvailability: { __typename?: 'AvailabilitySelectItemWithFilters', id: number, type: AvailabilityTypeEnum, note: string, startTime: string, endTime: string, blockType: AvailabilityBlockTypeEnum, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressTimezone: string | null, addressCoordinates: string | null, rruleFreq: AvailabilityRruleFreqEnum, rruleDtstart: string, rruleInterval: number | null, rruleByweekday: Array<string | null> | null, rruleUntil: string | null, blockFilters: { __typename?: 'AvailabilityParsedFilters', visitTypeIds: Array<number> | null } | null } };

export type DeleteAvailabilityMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  additionalIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  providerId: Scalars['Int']['input'];
}>;


export type DeleteAvailabilityMutation = { __typename?: 'Mutation', deleteAvailability: { __typename?: 'AvailabilitySelectItemWithFilters', id: number } };

export type ApplyAvailabilityTemplateMutationVariables = Exact<{
  availabilityIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  providerIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  todayDate: Scalars['String']['input'];
  doNotCommit: InputMaybe<Scalars['Boolean']['input']>;
  tzHandling: AvailTzHandling;
}>;


export type ApplyAvailabilityTemplateMutation = { __typename?: 'Mutation', applyAvailabilityTemplate: Array<{ __typename?: 'AvailabilitySelectItemWithFilters', id: number }> };

export type CommandIndexCombinedDataQueryVariables = Exact<{
  filterStartTime: InputMaybe<Scalars['String']['input']>;
  filterEndTime: InputMaybe<Scalars['String']['input']>;
  organizationalUnitSegmentationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CommandIndexCombinedDataQuery = { __typename?: 'Query', visitResource: Array<{ __typename?: 'VisitResourceSelectItem', id: number, providerId: number | null, startTime: string, endTime: string, startOfShiftDriveTime: number, interVisitDriveTime: number, endOfShiftDriveTime: number, visitId: number, updatedBy: number | null, virtualProviderStatus: VisitResourceVirtualProviderStatusEnum | null, errandStatus: VisitResourceErrandStatusEnum | null, visitResourceRequirementId: number, addressCoordinates: string | null, provider: { __typename?: 'VisitResourceProviderRelation', id: number, firstName: string, lastName: string, providerTypeId: number, active: boolean } | null, visit: { __typename?: 'VisitResourceVisitRelation', id: number, careRequirementId: number | null, startTime: string, endTime: string, eventStatus: VisitEventStatusEnum, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressTimezone: string | null, addressCoordinates: string, arrivalWindowStartTime: string, arrivalWindowEndTime: string, createdAt: string, visitWarningLogId: number | null, updatedBy: number | null, manualEdits: boolean, visitTypeId: number, cancellationReason: { __typename?: 'VisitResourceVisitRelationCancellationReasonRelation', id: number, description: string } | null, patient: { __typename?: 'VisitResourceVisitRelationPatientRelation', id: number, firstName: string, lastName: string, addressCoordinates: string | null, patientNotes: string | null, serviceInstructions: string | null, patientIdentifiers: Array<{ __typename?: 'VisitResourceVisitRelationPatientRelationPatientIdentifiersRelation', identifier: string, identifier_type: string }>, careTeamProviders: Array<{ __typename?: 'VisitResourceVisitRelationPatientRelationCareTeamProvidersRelation', id: number, allowAutomaticUpdates: boolean, patientId: number, providerId: number, providerTypeId: number }> } | null, episode: { __typename?: 'VisitResourceVisitRelationEpisodeRelation', id: number, serviceLineId: number, organizationalUnitId?: number | null, autoschedulerGroup: number | null, precautions: Array<{ __typename?: 'VisitResourceVisitRelationEpisodeRelationPrecautionsRelation', id: number, precautionId: number }> } | null, eventLog: Array<{ __typename?: 'VisitResourceVisitRelationEventLogRelation', id: number, event: string, eventTime: string, autoGenerated: boolean, createdByUser: { __typename?: 'VisitResourceVisitRelationEventLogRelationCreatedByUserRelation', firstName: string, lastName: string } | null }> } | null }>, shift: Array<{ __typename?: 'ShiftSelectItem', id: number, status: ShiftStatusEnum, startTime: string, endTime: string, addressTimezone: string | null, providerTravel: ShiftProviderTravelEnum, manualEdits: boolean, overflowShift: boolean, providerId: number, updatedBy: number | null, addressCoordinates: string, shiftCenterId: number | null, useShiftCenterDriveTimes: boolean, provider: { __typename?: 'ShiftProviderRelation', id: number, firstName: string, lastName: string, addressCoordinates: string | null, providerTypeId: number, external: boolean, active: boolean } | null }>, calendarBlock: Array<{ __typename?: 'CalendarBlockSelectItemWithFilters', id: number, title: string | null, startTime: string, endTime: string, eventStatus: CalendarBlockEventStatusEnum, providerId: number, startOfShiftDriveTime: number, interVisitDriveTime: number, endOfShiftDriveTime: number, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null, addressTimezone: string | null, updatedBy: number | null, blockType: CalendarBlockBlockTypeEnum, availabilityId: number | null, manualEdits: boolean, filters: { __typename?: 'calendarBlockParsedFilters', visitTypeIds: Array<number> | null } | null, provider: { __typename?: 'CalendarBlockProviderRelation', id: number, firstName: string, lastName: string } | null }>, task: Array<{ __typename?: 'TaskSelectItem', id: number, taskType: TaskTaskTypeEnum, status: TaskStatusEnum, description: string, createdAt: string, details: string | null, patient: { __typename?: 'TaskPatientRelation', id: number, firstName: string, lastName: string, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressTimezone: string | null, addressCoordinates: string | null, patientNotes: string | null, serviceInstructions: string | null, patientIdentifiers: Array<{ __typename?: 'TaskPatientRelationPatientIdentifiersRelation', identifier: string, identifier_type: string }>, careTeamProviders: Array<{ __typename?: 'TaskPatientRelationCareTeamProvidersRelation', id: number, allowAutomaticUpdates: boolean, patientId: number, providerId: number, providerTypeId: number }> } | null }> };

export type GetSimpleDriveTimeQueryVariables = Exact<{
  shift: Shift;
  providerAddress: ProviderAddress;
  visitResources: Array<VisitResourceGenericInput> | VisitResourceGenericInput;
  calendarBlocks: Array<CalendarBlockInput> | CalendarBlockInput;
}>;


export type GetSimpleDriveTimeQuery = { __typename?: 'Query', simpleDriveTime: Array<{ __typename?: 'VisitResourceUpdate', id: number | null, eventKey: string | null, providerId: number | null, startOfShiftDriveTime: string | null, interVisitDriveTime: string | null, endOfShiftDriveTime: string | null }> };

export type CommandIndexCareRequirementVisitsQueryVariables = Exact<{
  filterStartTime: InputMaybe<Scalars['String']['input']>;
  filterEndTime: InputMaybe<Scalars['String']['input']>;
}>;


export type CommandIndexCareRequirementVisitsQuery = { __typename?: 'Query', visit: Array<{ __typename?: 'VisitSelectItem', id: number, startTime: string, patientId: number, manualEdits: boolean, careRequirement: { __typename?: 'VisitCareRequirementRelation', id: number, visitTypeId: number, duration: number, earliestStartTime: string | null, latestStartTime: string | null, minTimeFromLastVisit: number | null, maxTimeFromLastVisit: number | null } | null }> };

export type UpdateVisitResourceStatusMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  visitId: Scalars['Int']['input'];
  newStatus: VisitResourceVirtualProviderStatusEnum;
}>;


export type UpdateVisitResourceStatusMutation = { __typename?: 'Mutation', updateVisitResourceStatus: { __typename?: 'VisitResourceItem', id: number, visitId: number, virtualProviderStatus: VisitResourceVirtualProviderStatusEnum | null } };

export type GetAvailableOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableOrgsQuery = { __typename?: 'Query', currentUser: { __typename?: 'currentUser', id: number, userId: number, organizations: Array<{ __typename?: 'currentUserOrganizations', id: number, name: string, organizationUserId: number, roles: Array<string>, perms: Array<PermissionEnum>, serviceLineIds: Array<number>, providerId: number | null, settings: { __typename?: 'OrganizationSettings', enableMobileNotifications: boolean, mobileNotificationsWindow: number, enableLocationBasedStatusUpdates: boolean, idleSessionTimeoutMinutes: number, mobileIdleLockTimeoutMinutes: number, mobileIdleSignOutMinutes: number, mobileUnlockMethod: MobileUnlockMethodEnum, shufflerLeadTime: number, barcodeTypes: Array<BarcodeTypeEnum> } }> } };

export type OrgConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgConfigQuery = { __typename?: 'Query', serviceLine: Array<{ __typename?: 'ServiceLineSelectItem', id: number, name: string, schedulingConfig: string | null, visitTypeServiceLines: Array<{ __typename?: 'ServiceLineVisitTypeServiceLinesRelation', id: number, visitTypeId: number }>, errandTypeServiceLines: Array<{ __typename?: 'ServiceLineErrandTypeServiceLinesRelation', id: number, errandTypeId: number }> }>, visitType: Array<{ __typename?: 'VisitTypeSelectItem', id: number, name: string, schedulingConfig: string | null, visitTypeServices: Array<{ __typename?: 'VisitTypeVisitTypeServicesRelation', id: number, selectedByDefault: boolean, service: { __typename?: 'VisitTypeVisitTypeServicesRelationServiceRelation', id: number, name: string, duration: number, active: boolean } | null }> }>, visitResourceRequirement: Array<{ __typename?: 'VisitResourceRequirementSelectItem', id: number, duration: number, inHome: boolean, invitedToVisit: boolean, offset: number, visitTypeId: number | null, errandTypeId: number | null, requiresContinuityOfCare: boolean, preserveAutoschedulerGroup: boolean, visitResourceRequirementPT: Array<{ __typename?: 'VisitResourceRequirementVisitResourceRequirementPTRelation', providerTypeId: number }> }>, errandType: Array<{ __typename?: 'ErrandTypeSelectItem', id: number, name: string, description: string, relativeToVisit: ErrandTypeRelativeToVisitEnum, active: boolean }>, program: Array<{ __typename?: 'ProgramSelectItem', id: number, name: string, serviceLineId: number }>, eligibilityQuestion: Array<{ __typename?: 'EligibilityQuestionSelectItem', id: number, question: string, answerFormatType: EligibilityQuestionAnswerFormatTypeEnum, answerModule: EligibilityQuestionAnswerModuleEnum | null, answerModulePredicate: string | null, useForPreScoreCheck: boolean, answerOptions: Array<{ __typename?: 'EligibilityQuestionAnswerOptionsRelation', id: number, answer: string }>, programEligibilityQuestions: Array<{ __typename?: 'EligibilityQuestionProgramEligibilityQuestionsRelation', programId: number, disqualifyingAnswers: Array<number> }> }>, service: Array<{ __typename?: 'ServiceSelectItem', id: number, name: string, description: string | null, duration: number, active: boolean }>, providerType: Array<{ __typename?: 'ProviderTypeSelectItem', id: number, name: string, requireStateLicense: boolean }>, shiftCenter: Array<{ __typename?: 'ShiftCenterSelectItem', id: number, name: string, organizationalUnitId: number | null, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string, addressTimezone: string | null }>, secrets: { __typename?: 'Secrets', GOOGLE_MAPS_WEB_API_KEY: string, MAPBOXGL_API_KEY: string }, teamProvider: Array<{ __typename?: 'TeamProviderSelectItem', id: number, teamId: number, providerId: number, team: { __typename?: 'TeamProviderTeamRelation', id: number, name: string } | null }>, visitCancellationReason: Array<{ __typename?: 'VisitCancellationReasonSelectItem', id: number, description: string, reasonType: VisitCancellationReasonReasonTypeEnum, active: boolean }>, supplyChangeReason: Array<{ __typename?: 'SupplyChangeReasonSelectItem', id: number, label: string, eventType: SupplyChangeReasonEventTypeEnum, active: boolean }>, precaution: Array<{ __typename?: 'PrecautionSelectItem', id: number, name: string, color: string, description: string | null, active: boolean }> };

export type GetPatientVisitsDemoQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
}>;


export type GetPatientVisitsDemoQuery = { __typename?: 'Query', patientSingle: { __typename?: 'PatientSelectItem', id: number, firstName: string, lastName: string, addressTimezone: string | null, episodes: Array<{ __typename?: 'PatientEpisodesRelation', id: number, active: boolean }>, visits: Array<{ __typename?: 'PatientVisitsRelation', id: number, startTime: string, endTime: string, eventStatus: VisitEventStatusEnum, episodeId: number, arrivalWindowStartTime: string, arrivalWindowEndTime: string, visitType: { __typename?: 'PatientVisitsRelationVisitTypeRelation', id: number, name: string } | null, visitResources: Array<{ __typename?: 'PatientVisitsRelationVisitResourcesRelation', id: number, provider: { __typename?: 'PatientVisitsRelationVisitResourcesRelationProviderRelation', id: number, firstName: string, lastName: string } | null }>, visitServices: Array<{ __typename?: 'PatientVisitsRelationVisitServicesRelation', service: { __typename?: 'PatientVisitsRelationVisitServicesRelationServiceRelation', id: number, name: string } | null }> }> } | null };

export type CancelVisitDemoMutationVariables = Exact<{
  visitId: Scalars['Int']['input'];
  visitCancellationReasonId: Scalars['Int']['input'];
}>;


export type CancelVisitDemoMutation = { __typename?: 'Mutation', cancelVisit: { __typename?: 'VisitSelectItem', id: number, eventStatus: VisitEventStatusEnum } };

export type GetDemoPatientsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDemoPatientsQuery = { __typename?: 'Query', activePatients: Array<{ __typename?: 'ActivePatient', id: number }> };

export type AssignCandidacyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  orgUserId: InputMaybe<Scalars['Int']['input']>;
}>;


export type AssignCandidacyMutation = { __typename?: 'Mutation', assignCandidacy: { __typename?: 'CandidacySelectItem', id: number, assignedToId: number | null, assignedTo: { __typename?: 'CandidacyAssignedToRelation', id: number, user: { __typename?: 'CandidacyAssignedToRelationUserRelation', id: number, firstName: string, lastName: string } | null } | null } };

export type TakeCandidacyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type TakeCandidacyMutation = { __typename?: 'Mutation', takeCandidacy: { __typename?: 'CandidacySelectItem', id: number, assignedToId: number | null, assignedTo: { __typename?: 'CandidacyAssignedToRelation', id: number, user: { __typename?: 'CandidacyAssignedToRelationUserRelation', id: number, firstName: string, lastName: string } | null } | null } };

export type BulkAssignCandidacyMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  orgUserId: InputMaybe<Scalars['Int']['input']>;
}>;


export type BulkAssignCandidacyMutation = { __typename?: 'Mutation', bulkAssignCandidacy: Array<{ __typename?: 'CandidacySelectItem', id: number, assignedToId: number | null, assignedTo: { __typename?: 'CandidacyAssignedToRelation', id: number, user: { __typename?: 'CandidacyAssignedToRelationUserRelation', id: number, firstName: string, lastName: string } | null } | null }> };

export type BulkTakeCandidacyMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type BulkTakeCandidacyMutation = { __typename?: 'Mutation', bulkTakeCandidacy: Array<{ __typename?: 'CandidacySelectItem', id: number, assignedToId: number | null, assignedTo: { __typename?: 'CandidacyAssignedToRelation', id: number, user: { __typename?: 'CandidacyAssignedToRelationUserRelation', id: number, firstName: string, lastName: string } | null } | null }> };

export type OrgTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgTeamMembersQuery = { __typename?: 'Query', organizationUser: Array<{ __typename?: 'OrganizationUserSelectItem', id: number, userId: number, user: { __typename?: 'OrganizationUserUserRelation', id: number, firstName: string, lastName: string, email: string } | null }> };

export type CandidacyAssignmentRulesQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidacyAssignmentRulesQuery = { __typename?: 'Query', candidacyAssignmentRules: Array<{ __typename?: 'CandidacyAssignmentRule', id: number, fhirLocationId: string | null, fhirOrganizationId: string | null, assignedToId: number, fhirLocation: { __typename?: 'FhirResourceSearchResult', fhirId: string, displayText: string, name: string, hierarchy: Array<string>, typeDisplay: string | null, formDisplay: string | null, managingOrganization: string | null } | null, fhirOrganization: { __typename?: 'FhirResourceSearchResult', fhirId: string, displayText: string, name: string, hierarchy: Array<string>, typeDisplay: string | null, formDisplay: string | null, managingOrganization: string | null } | null, assignedTo: { __typename?: 'CandidacyAssignmentRuleAssignee', id: number, user: { __typename?: 'CandidacyAssignmentRuleUser', id: number, firstName: string, lastName: string, email: string } | null } }> };

export type SearchFhirLocationsQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchFhirLocationsQuery = { __typename?: 'Query', searchFhirLocations: Array<{ __typename?: 'FhirResourceSearchResult', fhirId: string, displayText: string, name: string, hierarchy: Array<string>, typeDisplay: string | null, formDisplay: string | null, managingOrganization: string | null }> };

export type SearchFhirOrganizationsQueryVariables = Exact<{
  keyword: Scalars['String']['input'];
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchFhirOrganizationsQuery = { __typename?: 'Query', searchFhirOrganizations: Array<{ __typename?: 'FhirResourceSearchResult', fhirId: string, displayText: string, name: string, hierarchy: Array<string>, typeDisplay: string | null, formDisplay: string | null, managingOrganization: string | null }> };

export type CreateCandidacyAssignmentRuleMutationVariables = Exact<{
  fhirLocationId: InputMaybe<Scalars['String']['input']>;
  fhirOrganizationId: InputMaybe<Scalars['String']['input']>;
  assignedToId: Scalars['Int']['input'];
}>;


export type CreateCandidacyAssignmentRuleMutation = { __typename?: 'Mutation', createCandidacyAssignmentRule: { __typename?: 'CandidacyAssignmentRule', id: number, fhirLocationId: string | null, fhirOrganizationId: string | null, assignedToId: number } };

export type UpdateCandidacyAssignmentRuleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  fhirLocationId: InputMaybe<Scalars['String']['input']>;
  fhirOrganizationId: InputMaybe<Scalars['String']['input']>;
  assignedToId: Scalars['Int']['input'];
}>;


export type UpdateCandidacyAssignmentRuleMutation = { __typename?: 'Mutation', updateCandidacyAssignmentRule: { __typename?: 'CandidacyAssignmentRule', id: number, fhirLocationId: string | null, fhirOrganizationId: string | null, assignedToId: number } };

export type DeleteCandidacyAssignmentRuleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteCandidacyAssignmentRuleMutation = { __typename?: 'Mutation', deleteCandidacyAssignmentRule: boolean };

export type TestCandidacyAutoAssignmentQueryVariables = Exact<{
  encounterResourceJson: Scalars['String']['input'];
}>;


export type TestCandidacyAutoAssignmentQuery = { __typename?: 'Query', testCandidacyAutoAssignment: number | null };

export type PredictCandidacyListQueryVariables = Exact<{
  where: InputMaybe<CandidacyFilters>;
  orderBy: InputMaybe<PredictCandidacyOrderBy>;
  offset: InputMaybe<Scalars['Int']['input']>;
  limit: InputMaybe<Scalars['Int']['input']>;
}>;


export type PredictCandidacyListQuery = { __typename?: 'Query', predictCandidacyList: Array<{ __typename?: 'CandidacySelectItem', id: number, patientId: number, assignedToId: number | null, chosenProgramId: number | null, candidateStatus: CandidacyCandidateStatusEnum, updatedAt: string, patient: { __typename?: 'CandidacyPatientRelation', id: number, firstName: string, lastName: string, dateOfBirth: string | null, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, patientIdentifiers: Array<{ __typename?: 'CandidacyPatientRelationPatientIdentifiersRelation', id: number, identifier: string, identifier_type: string }> } | null, assignedTo: { __typename?: 'CandidacyAssignedToRelation', id: number, user: { __typename?: 'CandidacyAssignedToRelationUserRelation', id: number, firstName: string, lastName: string } | null } | null }> };

export type GetClinicalConstraintTemplatesForEpisodeQueryVariables = Exact<{
  serviceLineId: Scalars['Int']['input'];
}>;


export type GetClinicalConstraintTemplatesForEpisodeQuery = { __typename?: 'Query', clinicalConstraintTemplate: Array<{ __typename?: 'ClinicalConstraintTemplateSelectItem', id: number, serviceLineId: number, name: string, description: string | null, rruleFreq: ClinicalConstraintTemplateRruleFreqEnum, durationDays: number, firstVisitTypeId: number | null, firstVisitServiceIds: Array<number> | null, firstVisitDuration: number | null, requirements: Array<{ __typename?: 'ClinicalConstraintTemplateRequirementsRelation', id: number, templateId: number, visitTypeId: number, duration: number, rruleInterval: number | null, rruleByweekday: string | null, earliestStartTime: string | null, latestStartTime: string | null, minTimeFromLastVisit: number | null, maxTimeFromLastVisit: number | null, serviceIds: Array<number> }> }> };

export type GetClinicalConstraintTemplatesForConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClinicalConstraintTemplatesForConfigQuery = { __typename?: 'Query', clinicalConstraintTemplate: Array<{ __typename?: 'ClinicalConstraintTemplateSelectItem', id: number, serviceLineId: number, name: string, description: string | null, rruleFreq: ClinicalConstraintTemplateRruleFreqEnum, durationDays: number, updatedAt: string, firstVisitTypeId: number | null, firstVisitServiceIds: Array<number> | null, firstVisitDuration: number | null, requirements: Array<{ __typename?: 'ClinicalConstraintTemplateRequirementsRelation', id: number, templateId: number, visitTypeId: number, duration: number, rruleInterval: number | null, rruleByweekday: string | null, earliestStartTime: string | null, latestStartTime: string | null, minTimeFromLastVisit: number | null, maxTimeFromLastVisit: number | null, serviceIds: Array<number> }> }> };

export type CreateClinicalConstraintTemplateMutationVariables = Exact<{
  serviceLineId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  rruleFreq: Scalars['String']['input'];
  durationDays: Scalars['Int']['input'];
  firstVisitTypeId: InputMaybe<Scalars['Int']['input']>;
  firstVisitServiceIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  firstVisitDuration: InputMaybe<Scalars['Int']['input']>;
  requirements: Array<ClinicalConstraintTemplateRequirementInput> | ClinicalConstraintTemplateRequirementInput;
}>;


export type CreateClinicalConstraintTemplateMutation = { __typename?: 'Mutation', createClinicalConstraintTemplate: { __typename?: 'ClinicalConstraintTemplateItem', id: number, serviceLineId: number, name: string, description: string | null, rruleFreq: ClinicalConstraintTemplateRruleFreqEnum, durationDays: number, updatedAt: string } };

export type UpdateClinicalConstraintTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  rruleFreq: InputMaybe<Scalars['String']['input']>;
  durationDays: InputMaybe<Scalars['Int']['input']>;
  firstVisitTypeId: InputMaybe<Scalars['Int']['input']>;
  firstVisitServiceIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  firstVisitDuration: InputMaybe<Scalars['Int']['input']>;
  requirements: Array<ClinicalConstraintTemplateRequirementUpsertInput> | ClinicalConstraintTemplateRequirementUpsertInput;
}>;


export type UpdateClinicalConstraintTemplateMutation = { __typename?: 'Mutation', updateClinicalConstraintTemplate: { __typename?: 'ClinicalConstraintTemplateItem', id: number, updatedAt: string } };

export type DeleteClinicalConstraintTemplateMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteClinicalConstraintTemplateMutation = { __typename?: 'Mutation', deleteClinicalConstraintTemplate: { __typename?: 'ClinicalConstraintTemplateItem', id: number, deleted: boolean, updatedAt: string } };

export type CreateEpisodeMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  serviceLineId: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  autoschedulerGroup: InputMaybe<Scalars['Int']['input']>;
  careRequirements: InputMaybe<Array<CareRequirementInput> | CareRequirementInput>;
  precautionIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CreateEpisodeMutation = { __typename?: 'Mutation', createEpisode: { __typename?: 'EpisodeItem', id: number, active: boolean, serviceLineId: number, organizationalUnitId: number | null, updatedAt: string } };

export type GetEpisodeCareRequirementsQueryVariables = Exact<{
  episodeId: Scalars['Int']['input'];
}>;


export type GetEpisodeCareRequirementsQuery = { __typename?: 'Query', episodeSingle: { __typename?: 'EpisodeSelectItem', id: number, autoschedulerGroup: number | null, organizationalUnitId: number | null } | null, careRequirement: Array<{ __typename?: 'CareRequirementSelectItem', id: number, episodeId: number, visitTypeId: number, duration: number, rruleFreq: CareRequirementRruleFreqEnum, rruleDtstart: string, rruleUntil: string | null, rruleInterval: number | null, rruleByweekday: string | null, earliestStartTime: string | null, latestStartTime: string | null, minTimeFromLastVisit: number | null, maxTimeFromLastVisit: number | null, dayOfAdmission: boolean, services: Array<{ __typename?: 'CareRequirementServicesRelation', id: number, serviceId: number, deleted: boolean, service: { __typename?: 'CareRequirementServicesRelationServiceRelation', id: number, name: string } | null }> }>, visit: Array<{ __typename?: 'VisitSelectItem', id: number }> };

export type UpdateEpisodeMutationVariables = Exact<{
  episodeId: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
  autoschedulerGroup: InputMaybe<Scalars['Int']['input']>;
  careRequirements: InputMaybe<Array<CareRequirementUpsertInput> | CareRequirementUpsertInput>;
  precautionIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type UpdateEpisodeMutation = { __typename?: 'Mutation', updateEpisode: { __typename?: 'EpisodeSelectItem', id: number, active: boolean, serviceLineId: number, organizationalUnitId: number | null, updatedAt: string, precautions: Array<{ __typename?: 'EpisodePrecautionsRelation', id: number, precautionId: number }> } };

export type GetProviderSelectItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderSelectItemsQuery = { __typename?: 'Query', provider: Array<{ __typename?: 'ProviderSelectItem', id: number, firstName: string, lastName: string, providerTypeId: number }> };

export type CommandIndexProvidersQueryVariables = Exact<{
  includeShifts?: InputMaybe<Scalars['Boolean']['input']>;
  start: InputMaybe<Scalars['String']['input']>;
  end: InputMaybe<Scalars['String']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
  organizationalUnitSegmentationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CommandIndexProvidersQuery = { __typename?: 'Query', commandIndexProviders: { __typename?: 'ProvidersResponse', providers: Array<{ __typename?: 'ProviderSelectItem', id: number, firstName: string, lastName: string, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null, addressTimezone: string | null, external: boolean, providerTypeId: number, active: boolean, providerType: { __typename?: 'ProviderProviderTypeRelation', id: number, name: string, requireStateLicense: boolean } | null, traits: Array<{ __typename?: 'ProviderTraitsRelation', trait: string, value: string }>, teamProviders: Array<{ __typename?: 'ProviderTeamProvidersRelation', teamId: number }>, serviceLineProviders: Array<{ __typename?: 'ProviderServiceLineProvidersRelation', serviceLineId: number, serviceLine: { __typename?: 'ProviderServiceLineProvidersRelationServiceLineRelation', id: number, visitTypeServiceLines: Array<{ __typename?: 'ProviderServiceLineProvidersRelationServiceLineRelationVisitTypeServiceLinesRelation', visitTypeId: number }> } | null }> }>, providersByType: Array<{ __typename?: 'ProvidersByTypeGroup', typeId: string, typeName: string, providers: Array<{ __typename?: 'ProviderSelectItem', id: number, firstName: string, lastName: string, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null, addressTimezone: string | null, external: boolean, providerTypeId: number, active: boolean, providerType: { __typename?: 'ProviderProviderTypeRelation', id: number, name: string, requireStateLicense: boolean } | null, traits: Array<{ __typename?: 'ProviderTraitsRelation', trait: string, value: string }>, teamProviders: Array<{ __typename?: 'ProviderTeamProvidersRelation', teamId: number }>, serviceLineProviders: Array<{ __typename?: 'ProviderServiceLineProvidersRelation', serviceLineId: number, serviceLine: { __typename?: 'ProviderServiceLineProvidersRelationServiceLineRelation', id: number, visitTypeServiceLines: Array<{ __typename?: 'ProviderServiceLineProvidersRelationServiceLineRelationVisitTypeServiceLinesRelation', visitTypeId: number }> } | null }> }> }> }, organizationalUnitOrgUser?: Array<{ __typename?: 'OrganizationalUnitOrgUserSelectItem', organizationalUnitId: number, orgUser: { __typename?: 'OrganizationalUnitOrgUserOrgUserRelation', providers: Array<{ __typename?: 'OrganizationalUnitOrgUserOrgUserRelationProvidersRelation', id: number }> } | null }>, organizationalUnit?: Array<{ __typename?: 'OrganizationalUnitSelectItem', id: number, active: boolean }>, shift?: Array<{ __typename?: 'ShiftSelectItem', id: number, startTime: string, endTime: string, providerTravel: ShiftProviderTravelEnum, status: ShiftStatusEnum, providerId: number, addressCoordinates: string, addressTimezone: string | null, manualEdits: boolean, overflowShift: boolean, updatedBy: number | null, shiftCenterId: number | null, useShiftCenterDriveTimes: boolean }> };

export type PatientLocationQueryVariables = Exact<{
  patientId: Scalars['Int']['input'];
}>;


export type PatientLocationQuery = { __typename?: 'Query', patientSingle: { __typename?: 'PatientSelectItem', firstName: string, lastName: string, addressCoordinates: string | null } | null };

export type ProviderRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderRolesQuery = { __typename?: 'Query', provider: Array<{ __typename?: 'ProviderSelectItem', id: number, firstName: string, lastName: string, OrganizationUser: { __typename?: 'ProviderOrganizationUserRelation', id: number, roles: Array<{ __typename?: 'ProviderOrganizationUserRelationRolesRelation', globalUserRole: OrganizationUserRoleGlobalUserRoleEnum | null }>, user: { __typename?: 'ProviderOrganizationUserRelationUserRelation', firstName: string, lastName: string } | null } | null }> };

export type AddProvidersRoleMutationVariables = Exact<{
  organizationUserIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  role: OrganizationUserRoleGlobalUserRoleEnum;
}>;


export type AddProvidersRoleMutation = { __typename?: 'Mutation', addRoleToOrganizationUsers: { __typename?: 'UpdateRoleResults', count: number } };

export type RemoveProvidersRoleMutationVariables = Exact<{
  organizationUserIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  role: OrganizationUserRoleGlobalUserRoleEnum;
}>;


export type RemoveProvidersRoleMutation = { __typename?: 'Mutation', removeRoleFromOrganizationUsers: { __typename?: 'UpdateRoleResults', count: number } };

export type AvailabilityByTimespanQueryVariables = Exact<{
  start: Scalars['String']['input'];
}>;


export type AvailabilityByTimespanQuery = { __typename?: 'Query', availability: Array<{ __typename?: 'AvailabilitySelectItemWithFilters', id: number, type: AvailabilityTypeEnum, note: string, startTime: string, endTime: string, providerId: number, providerTravel: AvailabilityProviderTravelEnum, shiftCenterId: number | null, overflowShift: boolean, useShiftCenterDriveTimes: boolean, blockType: AvailabilityBlockTypeEnum, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressTimezone: string | null, addressCoordinates: string | null, rruleFreq: AvailabilityRruleFreqEnum, rruleDtstart: string, rruleUntil: string | null, rruleInterval: number | null, rruleByweekday: Array<string | null> | null, blockFilters: { __typename?: 'AvailabilityParsedFilters', visitTypeIds: Array<number> | null } | null }>, provider: Array<{ __typename?: 'ProviderSelectItem', id: number, addressTimezone: string | null, firstName: string, lastName: string, providerTypeId: number, addressStreet: string | null, addressCity: string | null, addressState: string | null, organizationUserId: number, teamProviders: Array<{ __typename?: 'ProviderTeamProvidersRelation', teamId: number }>, serviceLineProviders: Array<{ __typename?: 'ProviderServiceLineProvidersRelation', serviceLineId: number }> }>, shift: Array<{ __typename?: 'ShiftSelectItem', id: number, addressTimezone: string | null, providerId: number, startTime: string }>, calendarBlock: Array<{ __typename?: 'CalendarBlockSelectItemWithFilters', id: number, startTime: string, availabilityId: number | null }>, team: Array<{ __typename?: 'TeamSelectItem', id: number, name: string }> };

export type CensusPatientLocationQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type CensusPatientLocationQuery = { __typename?: 'Query', activePatients: Array<{ __typename?: 'ActivePatient', id: number, firstName: string, lastName: string, addressCoordinates: string | null }> };

export type UpdateVisitResourceMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  endOfShiftDriveTime: InputMaybe<Scalars['Int']['input']>;
  startOfShiftDriveTime: InputMaybe<Scalars['Int']['input']>;
  interVisitDriveTime: InputMaybe<Scalars['Int']['input']>;
  startTime: InputMaybe<Scalars['String']['input']>;
  endTime: InputMaybe<Scalars['String']['input']>;
  providerId: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateVisitResourceMutationMutation = { __typename?: 'Mutation', updateVisitResourceObject: { __typename?: 'VisitResourceItem', id: number } };

export type UpdateCalendarBlockMutationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  providerId: InputMaybe<Scalars['Int']['input']>;
  startTime: InputMaybe<Scalars['String']['input']>;
  endTime: InputMaybe<Scalars['String']['input']>;
  startOfShiftDriveTime: InputMaybe<Scalars['Int']['input']>;
  endOfShiftDriveTime: InputMaybe<Scalars['Int']['input']>;
  interVisitDriveTime: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateCalendarBlockMutationMutation = { __typename?: 'Mutation', updateCalendarBlock: { __typename?: 'CalendarBlockSelectItemWithFilters', id: number, providerId: number, startTime: string, endTime: string, startOfShiftDriveTime: number, endOfShiftDriveTime: number, interVisitDriveTime: number } };

export type CommandActivePatientsQueryVariables = Exact<{
  orderBy: ActivePatientOrderBy;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type CommandActivePatientsQuery = { __typename?: 'Query', activePatients: Array<{ __typename?: 'ActivePatient', id: number, firstName: string, lastName: string }> };

export type ScheduleVisitFromVisitRequestMutationVariables = Exact<{
  patientId: Scalars['Int']['input'];
  serviceLineId: Scalars['Int']['input'];
  visitTypeId: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
  resources: Array<NewOverrideVisitResourceInput> | NewOverrideVisitResourceInput;
  serviceIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  visitWarningLogId: InputMaybe<Scalars['Int']['input']>;
  taskId: InputMaybe<Scalars['Int']['input']>;
}>;


export type ScheduleVisitFromVisitRequestMutation = { __typename?: 'Mutation', scheduleOverrideVisit: { __typename?: 'VisitSelectItem', id: number, visitResources: Array<{ __typename?: 'VisitVisitResourcesRelation', id: number, providerId: number | null, startOfShiftDriveTime: number, interVisitDriveTime: number, endOfShiftDriveTime: number }> } };

export type DriveTimeOptimizerQueryVariables = Exact<{
  input: DriveTimeOptimizerInput;
}>;


export type DriveTimeOptimizerQuery = { __typename?: 'Query', driveTimeOptimizer: { __typename?: 'DriveTimeOptimizerOutput', optimizerLogId: number, optimizerLogData: string, success: boolean, assignments: Array<{ __typename?: 'DriveTimeOptimizerAssignment', visitResourceId: number, providerId: number, startTime: string, endTime: string }>, skipped: Array<{ __typename?: 'DriveTimeOptimizerSkip', visitResourceId: number, reasons: Array<string> }> } };

export type CreateOptimizerLogInitialStateUploadUrlMutationVariables = Exact<{
  optimizerLogId: Scalars['Int']['input'];
}>;


export type CreateOptimizerLogInitialStateUploadUrlMutation = { __typename?: 'Mutation', createOptimizerLogInitialStateUploadUrl: string };

export type SchedulerLogViewQueryVariables = Exact<{
  visitId: InputMaybe<Scalars['Int']['input']>;
}>;


export type SchedulerLogViewQuery = { __typename?: 'Query', schedulerLogSingle: { __typename?: 'SchedulerLogSelectItem', visitId: number | null, runId: string, chosenOptionIndex: number | null, logData: string, createdAt: string, createdBy: { __typename?: 'SchedulerLogCreatedByRelation', email: string } | null } | null };

export type MostRecentSchedulerLogViewQueryVariables = Exact<{ [key: string]: never; }>;


export type MostRecentSchedulerLogViewQuery = { __typename?: 'Query', schedulerLogRecent: Array<{ __typename?: 'SchedulerLogSelectItem', runId: string, chosenOptionIndex: number | null, logData: string, createdAt: string, createdBy: { __typename?: 'SchedulerLogCreatedByRelation', email: string } | null }> };

export type RecentSchedulerLogIndexViewQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  patientId: InputMaybe<Scalars['Int']['input']>;
  userId: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentSchedulerLogIndexViewQuery = { __typename?: 'Query', schedulerLogRecent: Array<{ __typename?: 'SchedulerLogSelectItem', runId: string, chosenOptionIndex: number | null, createdAt: string, logData: string, patient: { __typename?: 'SchedulerLogPatientRelation', firstName: string, lastName: string } | null, createdBy: { __typename?: 'SchedulerLogCreatedByRelation', email: string } | null }> };

export type OptimizerLogIndexViewQueryVariables = Exact<{
  limit: InputMaybe<Scalars['Int']['input']>;
  offset: InputMaybe<Scalars['Int']['input']>;
  where: InputMaybe<OptimizerLogFilters>;
}>;


export type OptimizerLogIndexViewQuery = { __typename?: 'Query', optimizerLog: Array<{ __typename?: 'OptimizerLogSelectItem', id: number, createdAt: string, logData: string, createdBy: { __typename?: 'OptimizerLogCreatedByRelation', email: string } | null }> };

export type OptimizerLogInitialStateQueryVariables = Exact<{
  optimizerLogId: Scalars['Int']['input'];
}>;


export type OptimizerLogInitialStateQuery = { __typename?: 'Query', optimizerLogInitialState: string };

export type CopyDemoDayMutationVariables = Exact<{
  copyFrom: Scalars['String']['input'];
  copyTo: Scalars['String']['input'];
  demoTime: Scalars['String']['input'];
  doNotCommit: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CopyDemoDayMutation = { __typename?: 'Mutation', copyDemoDay: { __typename?: 'CopyDemoDayResults', calendarBlocks: number, deletedCount: number, visits: number, visitEventLogEntries: number, visitNotes: number, visitResources: number, visitServices: number } };

export type WebhookPublicKeyQueryVariables = Exact<{
  apiKeyId: Scalars['Int']['input'];
}>;


export type WebhookPublicKeyQuery = { __typename?: 'Query', webhookPublicKey: { __typename?: 'WebhookPublicKey', id: number, publicPem: string } };

export type CreateApiKeyMutationVariables = Exact<{
  expiresAt: InputMaybe<Scalars['String']['input']>;
  keyPurpose: ApiKeyPurpose;
  requireFipsCompliance: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'CreateApiKeyResult', privatePem: string, privateDer: string, apiKey: { __typename?: 'ApiKey', id: number, apiKey: string, keyPurpose: ApiKeyPurpose, expiresAt: string | null, createdAt: string, updatedAt: string } } };

export type CreateWebhookApiKeyMutationVariables = Exact<{
  expiresAt: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWebhookApiKeyMutation = { __typename?: 'Mutation', createWebhookApiKey: { __typename?: 'CreateWebhookApiKeyResult', publicPem: string, apiKey: { __typename?: 'ApiKey', id: number, apiKey: string, expiresAt: string | null, createdAt: string, updatedAt: string } } };

export type CreateFhirServerMutationVariables = Exact<{
  fhirProvider: FhirServerFhirProviderEnum;
  useForLogin: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
  hl7Folder: Scalars['String']['input'];
}>;


export type CreateFhirServerMutation = { __typename?: 'Mutation', createFhirServer: { __typename?: 'FhirServerItem', id: number } };

export type DeleteApiKeyMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteApiKey: { __typename?: 'ApiKey', id: number, apiKey: string } };

export type CreateWebhookEndpointMutationVariables = Exact<{
  apiKeyId: Scalars['Int']['input'];
  eventType: WebhookEndpointEventTypeEnum;
  url: Scalars['String']['input'];
}>;


export type CreateWebhookEndpointMutation = { __typename?: 'Mutation', createWebhookEndpoint: { __typename?: 'WebhookEndpointItem', id: number, apiKeyId: number, eventType: WebhookEndpointEventTypeEnum, url: string } };

export type UpdateWebhookEndpointMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  apiKeyId: InputMaybe<Scalars['Int']['input']>;
  url: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateWebhookEndpointMutation = { __typename?: 'Mutation', updateWebhookEndpoint: { __typename?: 'WebhookEndpointSelectItem', id: number, apiKeyId: number, eventType: WebhookEndpointEventTypeEnum, url: string } };

export type UpdateFhirServerMutationVariables = Exact<{
  fhirServerId: Scalars['Int']['input'];
  fhirProvider: FhirServerFhirProviderEnum;
  useForLogin: Scalars['Boolean']['input'];
  url: Scalars['String']['input'];
  hl7Folder: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type UpdateFhirServerMutation = { __typename?: 'Mutation', updateFhirServer: { __typename?: 'FhirServerItem', id: number } };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename?: 'Query', apiKey: Array<{ __typename?: 'ApiKeySelectItem', id: number, apiKey: string, keyPurpose: ApiKeyKeyPurposeEnum, algorithm: ApiKeyAlgorithmEnum, expiresAt: string | null, createdAt: string, updatedAt: string, organizationUser: { __typename?: 'ApiKeyOrganizationUserRelation', user: { __typename?: 'ApiKeyOrganizationUserRelationUserRelation', firstName: string, lastName: string } | null } | null, createdByUser: { __typename?: 'ApiKeyCreatedByUserRelation', firstName: string, lastName: string } | null }>, webhookEndpoint: Array<{ __typename?: 'WebhookEndpointSelectItem', id: number, eventType: WebhookEndpointEventTypeEnum, url: string, apiKeyId: number }> };

export type FhirServersQueryVariables = Exact<{ [key: string]: never; }>;


export type FhirServersQuery = { __typename?: 'Query', fhirServer: Array<{ __typename?: 'FhirServerSelectItem', id: number, active: boolean, fhirProvider: FhirServerFhirProviderEnum, useForLogin: boolean, url: string, hl7Folder: string | null }> };

export type LatestProviderLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestProviderLocationsQuery = { __typename?: 'Query', latestProviderLocations: Array<{ __typename?: 'EnhancedProviderLocation', latitude: string | null, longitude: string | null, timestamp: string | null, activity: string | null, clockStatus: string | null, clockedAt: string | null, provider: { __typename?: 'ProviderInfo', firstName: string | null, lastName: string | null } | null }> };

export type CreateCancellationReasonMutationVariables = Exact<{
  description: Scalars['String']['input'];
  active: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCancellationReasonMutation = { __typename?: 'Mutation', createVisitCancellationReason: { __typename?: 'VisitCancellationReasonSelectItem', id: number } };

export type UpdateCancellationReasonMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateCancellationReasonMutation = { __typename?: 'Mutation', updateVisitCancellationReason: { __typename?: 'VisitCancellationReasonSelectItem', id: number, description: string, active: boolean } };

export type UpdateErrandTypeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  relativeToVisit: ErrandTypeRelativeToVisitEnum;
  active: Scalars['Boolean']['input'];
}>;


export type UpdateErrandTypeMutation = { __typename?: 'Mutation', updateErrandType: { __typename?: 'ErrandTypeItem', id: number } };

export type UpdateServiceLineMutationVariables = Exact<{
  serviceLineId: Scalars['Int']['input'];
  schedulingConfig: ServiceLineSchedulingConfig;
}>;


export type UpdateServiceLineMutation = { __typename?: 'Mutation', updateServiceLine: { __typename?: 'ServiceLineSelectItem', id: number, name: string, schedulingConfig: string | null } };

export type UpdateVisitTypeMutationVariables = Exact<{
  visitTypeId: Scalars['Int']['input'];
  schedulingConfig: VisitTypeSchedulingConfig;
}>;


export type UpdateVisitTypeMutation = { __typename?: 'Mutation', updateVisitType: { __typename?: 'VisitTypeItem', id: number, name: string, schedulingConfig: string | null } };

export type CreateErrandTypeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateErrandTypeMutation = { __typename?: 'Mutation', createErrandType: { __typename?: 'ErrandTypeItem', id: number, name: string } };

export type CreateServiceLineMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateServiceLineMutation = { __typename?: 'Mutation', createServiceLine: { __typename?: 'ServiceLineItem', id: number, name: string } };

export type CreateVisitTypeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateVisitTypeMutation = { __typename?: 'Mutation', createVisitType: { __typename?: 'VisitTypeItem', id: number, name: string } };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  providerIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'TeamItem', id: number, name: string } };

export type CreateTeamMutationVariables = Exact<{
  name: Scalars['String']['input'];
  providerIds: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'TeamItem', id: number, name: string } };

export type CreateErrandLocationMutationVariables = Exact<{
  errandTypeId: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  addressPlaceId: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateErrandLocationMutation = { __typename?: 'Mutation', createErrandLocation: { __typename?: 'ErrandLocationItem', id: number, organizationalUnitId: number | null, name: string, description: string, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null } };

export type UpdateErrandLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  updateFutureResources: InputMaybe<Scalars['Boolean']['input']>;
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressLineTwo: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
  addressPlaceId: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateErrandLocationMutation = { __typename?: 'Mutation', updateErrandLocation: { __typename?: 'ErrandLocationItem', id: number, organizationalUnitId: number | null, name: string, description: string, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null } };

export type CreateErrandResourceRequirementMutationVariables = Exact<{
  errandTypeId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  providerTypeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CreateErrandResourceRequirementMutation = { __typename?: 'Mutation', createVisitResourceRequirement: { __typename?: 'VisitResourceRequirementItem', id: number } };

export type UpdateErrandResourceRequirementMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  providerTypeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateErrandResourceRequirementMutation = { __typename?: 'Mutation', updateVisitResourceRequirement: { __typename?: 'VisitResourceRequirementItem', id: number } };

export type ErrandLocationsQueryVariables = Exact<{
  errandTypeId: Scalars['Int']['input'];
}>;


export type ErrandLocationsQuery = { __typename?: 'Query', organizationalUnit: Array<{ __typename?: 'OrganizationalUnitSelectItem', id: number, name: string, active: boolean }>, errandLocation: Array<{ __typename?: 'ErrandLocationSelectItem', id: number, name: string, description: string, errandTypeId: number, organizationalUnitId: number | null, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null, addressTimezone: string | null }> };

export type DeleteErrandLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteErrandLocationMutation = { __typename?: 'Mutation', deleteErrandLocation: { __typename?: 'ErrandLocationItem', id: number, deleted: boolean } };

export type CreateOrganizationalUnitMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateOrganizationalUnitMutation = { __typename?: 'Mutation', createOrganizationalUnit: { __typename?: 'OrganizationalUnitSelectItem', id: number } };

export type RenameOrganizationalUnitMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameOrganizationalUnitMutation = { __typename?: 'Mutation', updateOrganizationalUnit: { __typename?: 'OrganizationalUnitSelectItem', id: number, name: string, active: boolean } };

export type SetOrganizationalUnitActiveMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type SetOrganizationalUnitActiveMutation = { __typename?: 'Mutation', updateOrganizationalUnit: { __typename?: 'OrganizationalUnitSelectItem', id: number, name: string, active: boolean } };

export type CreatePrecautionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  color: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePrecautionMutation = { __typename?: 'Mutation', createPrecaution: { __typename?: 'PrecautionItem', id: number } };

export type UpdatePrecautionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  color: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  active: Scalars['Boolean']['input'];
}>;


export type UpdatePrecautionMutation = { __typename?: 'Mutation', updatePrecaution: { __typename?: 'PrecautionSelectItem', id: number, name: string, color: string, description: string | null, active: boolean } };

export type CreateVisitTypeServiceLineMutationVariables = Exact<{
  visitTypeId: Scalars['Int']['input'];
  serviceLineId: Scalars['Int']['input'];
}>;


export type CreateVisitTypeServiceLineMutation = { __typename?: 'Mutation', createVisitTypeServiceLine: { __typename?: 'VisitTypeServiceLineItem', id: number, visitTypeId: number, serviceLineId: number } };

export type DeleteVisitTypeServiceLineMutationVariables = Exact<{
  visitTypeServiceLineId: Scalars['Int']['input'];
}>;


export type DeleteVisitTypeServiceLineMutation = { __typename?: 'Mutation', deleteVisitTypeServiceLine: { __typename?: 'VisitTypeServiceLineItem', id: number, deleted: boolean } };

export type CreateErrandTypeServiceLineMutationVariables = Exact<{
  errandTypeId: Scalars['Int']['input'];
  serviceLineId: Scalars['Int']['input'];
}>;


export type CreateErrandTypeServiceLineMutation = { __typename?: 'Mutation', createErrandTypeServiceLine: { __typename?: 'ErrandTypeServiceLineItem', id: number, errandTypeId: number, serviceLineId: number } };

export type DeleteErrandTypeServiceLineMutationVariables = Exact<{
  errandTypeServiceLineId: Scalars['Int']['input'];
}>;


export type DeleteErrandTypeServiceLineMutation = { __typename?: 'Mutation', deleteErrandTypeServiceLine: { __typename?: 'ErrandTypeServiceLineItem', id: number, deleted: boolean } };

export type CreateServiceMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Int']['input'];
  active: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateServiceMutation = { __typename?: 'Mutation', createService: { __typename?: 'ServiceSelectItem', id: number } };

export type UpdateServiceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  duration: InputMaybe<Scalars['Int']['input']>;
  active: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'ServiceSelectItem', id: number, name: string, description: string | null, duration: number, active: boolean } };

export type CreateShiftCenterMutationVariables = Exact<{
  name: Scalars['String']['input'];
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  addressStreet: Scalars['String']['input'];
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateShiftCenterMutation = { __typename?: 'Mutation', createShiftCenter: { __typename?: 'ShiftCenterItem', id: number, name: string, organizationalUnitId: number | null, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string } };

export type UpdateShiftCenterMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  organizationalUnitId: InputMaybe<Scalars['Int']['input']>;
  addressStreet: InputMaybe<Scalars['String']['input']>;
  addressCity: InputMaybe<Scalars['String']['input']>;
  addressState: InputMaybe<Scalars['String']['input']>;
  addressZip: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateShiftCenterMutation = { __typename?: 'Mutation', updateShiftCenter: { __typename?: 'ShiftCenterItem', id: number, name: string, organizationalUnitId: number | null, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string } };

export type CreateSupplyChangeReasonMutationVariables = Exact<{
  label: Scalars['String']['input'];
  eventType: SupplyChangeReasonEventTypeEnum;
}>;


export type CreateSupplyChangeReasonMutation = { __typename?: 'Mutation', createSupplyChangeReason: { __typename?: 'SupplyChangeReasonItem', id: number } };

export type UpdateSupplyChangeReasonMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type UpdateSupplyChangeReasonMutation = { __typename?: 'Mutation', updateSupplyChangeReason: { __typename?: 'SupplyChangeReasonSelectItem', id: number, label: string, active: boolean } };

export type OrganizationalUnitsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationalUnitsQuery = { __typename?: 'Query', organizationalUnit: Array<{ __typename?: 'OrganizationalUnitSelectItem', id: number, name: string, active: boolean }> };

export type TeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamsQuery = { __typename?: 'Query', team: Array<{ __typename?: 'TeamSelectItem', id: number, name: string, teamProviders: Array<{ __typename?: 'TeamTeamProvidersRelation', provider: { __typename?: 'TeamTeamProvidersRelationProviderRelation', id: number, firstName: string, lastName: string } | null }> }> };

export type CreateProviderTypeMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateProviderTypeMutation = { __typename?: 'Mutation', createProviderType: { __typename?: 'ProviderTypeSelectItem', id: number, name: string, requireStateLicense: boolean } };

export type UpdateProviderTypeMutationVariables = Exact<{
  providerTypeId: Scalars['Int']['input'];
  name: InputMaybe<Scalars['String']['input']>;
  requireStateLicense: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProviderTypeMutation = { __typename?: 'Mutation', updateProviderType: { __typename?: 'ProviderTypeSelectItem', id: number, name: string, requireStateLicense: boolean } };

export type UpdateOrganizationSettingsMutationVariables = Exact<{
  enableMobileNotifications: Scalars['Boolean']['input'];
  mobileNotificationsWindow: Scalars['Int']['input'];
  enableLocationBasedStatusUpdates: Scalars['Boolean']['input'];
  shufflerLeadTime: Scalars['Int']['input'];
}>;


export type UpdateOrganizationSettingsMutation = { __typename?: 'Mutation', updateOrganizationSettings: { __typename?: 'Organization', id: number } };

export type UpdateVisitResourceRequirementMutationVariables = Exact<{
  visitResourceRequirement: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  inHome: Scalars['Boolean']['input'];
  invitedToVisit: Scalars['Boolean']['input'];
  offset: Scalars['Int']['input'];
  requiresContinuityOfCare: Scalars['Boolean']['input'];
  preserveAutoschedulerGroup: Scalars['Boolean']['input'];
  providerTypeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type UpdateVisitResourceRequirementMutation = { __typename?: 'Mutation', updateVisitResourceRequirement: { __typename?: 'VisitResourceRequirementItem', id: number } };

export type CreateVisitResourceRequirementMutationVariables = Exact<{
  visitTypeId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  providerTypeIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CreateVisitResourceRequirementMutation = { __typename?: 'Mutation', createVisitResourceRequirement: { __typename?: 'VisitResourceRequirementItem', id: number } };

export type DeleteVisitResourceRequirementMutationVariables = Exact<{
  visitResourceRequirementId: Scalars['Int']['input'];
}>;


export type DeleteVisitResourceRequirementMutation = { __typename?: 'Mutation', deleteVisitResourceRequirement: { __typename?: 'VisitResourceRequirementItem', id: number, deleted: boolean } };

export type CreateVisitTypeServiceMutationVariables = Exact<{
  visitTypeId: Scalars['Int']['input'];
  serviceId: Scalars['Int']['input'];
  selectedByDefault: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateVisitTypeServiceMutation = { __typename?: 'Mutation', createVisitTypeService: { __typename?: 'VisitTypeServiceSelectItem', id: number } };

export type UpdateVisitTypeServiceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  selectedByDefault: Scalars['Boolean']['input'];
}>;


export type UpdateVisitTypeServiceMutation = { __typename?: 'Mutation', updateVisitTypeService: { __typename?: 'VisitTypeServiceSelectItem', id: number, selectedByDefault: boolean } };

export type DeleteVisitTypeServiceMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteVisitTypeServiceMutation = { __typename?: 'Mutation', deleteVisitTypeService: { __typename?: 'VisitTypeServiceSelectItem', id: number, deleted: boolean } };

export type ListActiveHospitalAtHomeEpisodesQueryVariables = Exact<{
  serviceLineIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type ListActiveHospitalAtHomeEpisodesQuery = { __typename?: 'Query', episode: Array<{ __typename?: 'EpisodeSelectItem', id: number, patientId: number }> };

export type ListActivePatientsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  orderBy: ActivePatientOrderBy;
}>;


export type ListActivePatientsQuery = { __typename?: 'Query', activePatients: Array<{ __typename?: 'ActivePatient', id: number, firstName: string, lastName: string, addressCity: string | null, addressState: string | null, addressZip: string | null, addressTimezone: string | null, dateOfBirth: string | null, phone: string | null, nextVisit: { __typename?: 'ActivePatientNextVisit', startTime: string, providers: Array<{ __typename?: 'ActivePatientNextVisitProvider', firstName: string, lastName: string } | null> } | null }> };

export type WorlistPatientsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  orderBy: ActivePatientOrderBy;
  providerId: Scalars['Int']['input'];
}>;


export type WorlistPatientsQuery = { __typename?: 'Query', activePatients: Array<{ __typename?: 'ActivePatient', id: number, firstName: string, lastName: string, addressCity: string | null, addressState: string | null, addressZip: string | null, addressTimezone: string | null, dateOfBirth: string | null, phone: string | null, nextVisit: { __typename?: 'ActivePatientNextVisit', startTime: string, providers: Array<{ __typename?: 'ActivePatientNextVisitProvider', firstName: string, lastName: string } | null> } | null }> };

export type PatientDetailScreenQueryVariables = Exact<{
  patientId: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatientDetailScreenQuery = { __typename?: 'Query', patientSingle: { __typename?: 'PatientSelectItem', id: number, firstName: string, lastName: string, phone: string | null, preferredLanguage: string | null, sex: PatientSexEnum | null, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null, addressTimezone: string | null, dateOfBirth: string | null, patientNotes: string | null, serviceInstructions: string | null, patientIdentifiers: Array<{ __typename?: 'PatientPatientIdentifiersRelation', identifier: string, identifier_type: string }>, episodes: Array<{ __typename?: 'PatientEpisodesRelation', id: number, active: boolean, serviceLineId: number, organizationalUnitId: number | null, updatedAt: string, precautions: Array<{ __typename?: 'PatientEpisodesRelationPrecautionsRelation', id: number, precautionId: number }> }>, careTeamProviders: Array<{ __typename?: 'PatientCareTeamProvidersRelation', id: number, allowAutomaticUpdates: boolean, providerId: number, providerTypeId: number, provider: { __typename?: 'PatientCareTeamProvidersRelationProviderRelation', id: number, firstName: string, lastName: string, providerTypeId: number } | null }> } | null, visit: Array<{ __typename?: 'VisitSelectItem', id: number, startTime: string, endTime: string, eventStatus: VisitEventStatusEnum, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string, addressTimezone: string | null, serviceInstructions: string | null, arrivalWindowStartTime: string, arrivalWindowEndTime: string, episode: { __typename?: 'VisitEpisodeRelation', serviceLineId: number } | null, visitResources: Array<{ __typename?: 'VisitVisitResourcesRelation', providerId: number | null, provider: { __typename?: 'VisitVisitResourcesRelationProviderRelation', id: number, firstName: string, lastName: string } | null }>, visitType: { __typename?: 'VisitVisitTypeRelation', id: number, name: string } | null, visitServices: Array<{ __typename?: 'VisitVisitServicesRelation', id: number, serviceId: number, service: { __typename?: 'VisitVisitServicesRelationServiceRelation', id: number, name: string } | null }>, cancellationReason: { __typename?: 'VisitCancellationReasonRelation', id: number, description: string } | null }> };

export type UpdateProgramMutationVariables = Exact<{
  programId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  serviceLineId: Scalars['Int']['input'];
}>;


export type UpdateProgramMutation = { __typename?: 'Mutation', updateProgram: { __typename?: 'ProgramSelectItem', id: number, name: string } };

export type CreateProgramMutationVariables = Exact<{
  name: Scalars['String']['input'];
  serviceLineId: Scalars['Int']['input'];
}>;


export type CreateProgramMutation = { __typename?: 'Mutation', createProgram: { __typename?: 'ProgramItem', id: number, name: string, serviceLineId: number } };

export type CreateProgramEligibilityQuestionMutationVariables = Exact<{
  programEligibilityQuestions: Array<ProgramEligibilityQuestionProgramInput> | ProgramEligibilityQuestionProgramInput;
  question: Scalars['String']['input'];
  answerFormatType: EligibilityQuestionAnswerFormatTypeEnum;
  answerModule: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  answerModulePredicate: InputMaybe<Scalars['String']['input']>;
  answerOptions: InputMaybe<Array<CreateAnswerOption> | CreateAnswerOption>;
  useForPreScoreCheck: Scalars['Boolean']['input'];
}>;


export type CreateProgramEligibilityQuestionMutation = { __typename?: 'Mutation', createProgramEligibilityQuestion: { __typename?: 'EligibilityQuestionItem', id: number } };

export type UpdateProgramEligibilityQuestionMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  programEligibilityQuestions: Array<ProgramEligibilityQuestionProgramInput> | ProgramEligibilityQuestionProgramInput;
  question: Scalars['String']['input'];
  answerModule: InputMaybe<EligibilityQuestionAnswerModuleEnum>;
  answerModulePredicate: InputMaybe<Scalars['String']['input']>;
  answerOptions: InputMaybe<Array<UpdateAnswerOption> | UpdateAnswerOption>;
  useForPreScoreCheck: Scalars['Boolean']['input'];
}>;


export type UpdateProgramEligibilityQuestionMutation = { __typename?: 'Mutation', updateProgramEligibilityQuestion: { __typename?: 'EligibilityQuestionItem', id: number } };

export type DeleteProgramEligibilityQuestionMutationVariables = Exact<{
  eligibilityQuestionId: Scalars['Int']['input'];
}>;


export type DeleteProgramEligibilityQuestionMutation = { __typename?: 'Mutation', deleteProgramEligibilityQuestion: { __typename?: 'EligibilityQuestionItem', id: number, deleted: boolean } };

export type ProviderLocationQueryVariables = Exact<{
  providerId: Scalars['Int']['input'];
  start: Scalars['String']['input'];
  end: Scalars['String']['input'];
}>;


export type ProviderLocationQuery = { __typename?: 'Query', location: Array<{ __typename?: 'LocationSelectItem', latitude: string, longitude: string, timestamp: string }>, latestProviderLocations: Array<{ __typename?: 'EnhancedProviderLocation', clockStatus: string | null, timestamp: string | null }> };

export type PatientDetailQueryVariables = Exact<{
  patientId: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatientDetailQuery = { __typename?: 'Query', patientSingle: { __typename?: 'PatientSelectItem', id: number, firstName: string, lastName: string, phone: string | null, preferredLanguage: string | null, sex: PatientSexEnum | null, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string | null, addressTimezone: string | null, dateOfBirth: string | null, patientNotes: string | null, serviceInstructions: string | null, organizationId: number | null, updatedAt: string, episodes: Array<{ __typename?: 'PatientEpisodesRelation', id: number, active: boolean, serviceLineId: number, organizationalUnitId: number | null, updatedAt: string, precautions: Array<{ __typename?: 'PatientEpisodesRelationPrecautionsRelation', id: number, precautionId: number }> }>, patientIdentifiers: Array<{ __typename?: 'PatientPatientIdentifiersRelation', identifier: string, identifier_type: string }>, visits: Array<{ __typename?: 'PatientVisitsRelation', id: number, startTime: string, endTime: string, eventStatus: VisitEventStatusEnum, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressCoordinates: string, addressTimezone: string | null, serviceInstructions: string | null, episode: { __typename?: 'PatientVisitsRelationEpisodeRelation', serviceLineId: number } | null, visitResources: Array<{ __typename?: 'PatientVisitsRelationVisitResourcesRelation', providerId: number | null, provider: { __typename?: 'PatientVisitsRelationVisitResourcesRelationProviderRelation', id: number, firstName: string, lastName: string } | null }>, visitType: { __typename?: 'PatientVisitsRelationVisitTypeRelation', id: number, name: string } | null, visitServices: Array<{ __typename?: 'PatientVisitsRelationVisitServicesRelation', id: number, serviceId: number, service: { __typename?: 'PatientVisitsRelationVisitServicesRelationServiceRelation', id: number, name: string } | null }> }> } | null };

export type SchedulerScreenVisitQueryVariables = Exact<{
  visitId: InputMaybe<Scalars['Int']['input']>;
}>;


export type SchedulerScreenVisitQuery = { __typename?: 'Query', visitSingle: { __typename?: 'VisitSelectItem', id: number, startTime: string, endTime: string, arrivalWindowStartTime: string, arrivalWindowEndTime: string, serviceInstructions: string | null, visitTypeId: number, createdAt: string, patient: { __typename?: 'VisitPatientRelation', id: number, firstName: string, lastName: string, dateOfBirth: string | null, sex: PatientSexEnum | null, patientNotes: string | null, serviceInstructions: string | null, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, addressTimezone: string | null, phone: string | null, updatedAt: string, episodes: Array<{ __typename?: 'VisitPatientRelationEpisodesRelation', id: number, active: boolean, serviceLineId: number, organizationalUnitId: number | null, updatedAt: string, precautions: Array<{ __typename?: 'VisitPatientRelationEpisodesRelationPrecautionsRelation', id: number, precautionId: number }> }>, patientIdentifiers: Array<{ __typename?: 'VisitPatientRelationPatientIdentifiersRelation', identifier: string, identifier_type: string }> } | null, visitResources: Array<{ __typename?: 'VisitVisitResourcesRelation', id: number, provider: { __typename?: 'VisitVisitResourcesRelationProviderRelation', id: number, firstName: string, lastName: string } | null }>, visitServices: Array<{ __typename?: 'VisitVisitServicesRelation', id: number, service: { __typename?: 'VisitVisitServicesRelationServiceRelation', id: number, name: string } | null }>, episode: { __typename?: 'VisitEpisodeRelation', id: number, serviceLineId: number, organizationalUnitId: number | null } | null } | null };

export type CreateUserRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  permissions: Array<PermissionEnum> | PermissionEnum;
}>;


export type CreateUserRoleMutation = { __typename?: 'Mutation', createUserRole: { __typename?: 'UserRoleSelectItem', id: number, name: string, permissions: Array<PermissionEnum> } };

export type UpdateUserRoleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  permissions: Array<PermissionEnum> | PermissionEnum;
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole: { __typename?: 'UserRoleSelectItem', id: number, name: string, permissions: Array<PermissionEnum> } };

export type UserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserRolesQuery = { __typename?: 'Query', userRole: Array<{ __typename?: 'UserRoleSelectItem', id: number, name: string, permissions: Array<PermissionEnum> }> };

export type UpdateOrganizationTimeoutsMutationVariables = Exact<{
  idleSessionTimeoutMinutes: Scalars['Int']['input'];
  mobileIdleLockTimeoutMinutes: Scalars['Int']['input'];
  mobileIdleSignOutMinutes: Scalars['Int']['input'];
  mobileUnlockMethod: MobileUnlockMethodEnum;
}>;


export type UpdateOrganizationTimeoutsMutation = { __typename?: 'Mutation', updateOrganizationSettings: { __typename?: 'Organization', id: number } };

export type HistoricalSosAlertsQueryVariables = Exact<{
  since: Scalars['String']['input'];
}>;


export type HistoricalSosAlertsQuery = { __typename?: 'Query', sosAlert: Array<{ __typename?: 'SosAlertSelectItem', id: number, status: SosAlertStatusEnum, providerStatus: SosAlertProviderStatusEnum | null, latitude: string | null, longitude: string | null, addressStreet: string | null, addressCity: string | null, addressState: string | null, addressTimezone: string | null, createdAt: string, provider: { __typename?: 'SosAlertProviderRelation', id: number, firstName: string, lastName: string } | null, visit: { __typename?: 'SosAlertVisitRelation', addressStreet: string | null, addressCity: string | null, addressState: string | null, addressTimezone: string | null, patient: { __typename?: 'SosAlertVisitRelationPatientRelation', id: number, firstName: string, lastName: string } | null } | null, events: Array<{ __typename?: 'SosAlertEventsRelation', id: number, eventType: SosAlertEventEventTypeEnum, note: string | null, createdAt: string, createdByUser: { __typename?: 'SosAlertEventsRelationCreatedByUserRelation', firstName: string, lastName: string } | null }> }> };

export type CreateSupplyItemMutationVariables = Exact<{
  label: Scalars['String']['input'];
  barcode: Scalars['String']['input'];
  currentStock: Scalars['Int']['input'];
}>;


export type CreateSupplyItemMutation = { __typename?: 'Mutation', createSupplyItem: { __typename?: 'SupplyItemItem', id: number } };

export type UpdateSupplyItemMutationVariables = Exact<{
  supplyItemId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  barcode: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type UpdateSupplyItemMutation = { __typename?: 'Mutation', updateSupplyItem: { __typename?: 'SupplyItemSelectItem', id: number, label: string, barcode: string, currentStock: number, active: boolean } };

export type SupplyItemDetailsQueryVariables = Exact<{
  supplyItemId: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy: SupplyEventOrderBy;
}>;


export type SupplyItemDetailsQuery = { __typename?: 'Query', supplyItemSingle: { __typename?: 'SupplyItemSelectItem', id: number, label: string, barcode: string, currentStock: number, needsRecount: boolean, active: boolean, supplyEvents: Array<{ __typename?: 'SupplyItemSupplyEventsRelation', id: number, supplyChangeReasonId: number, note: string, amount: number, scannedBarcode: boolean, createdAt: string, createdByUser: { __typename?: 'SupplyItemSupplyEventsRelationCreatedByUserRelation', firstName: string, lastName: string } | null }> } | null };

export type SupplyEventMutationVariables = Exact<{
  supplyItemId: Scalars['Int']['input'];
  supplyChangeReasonId: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
}>;


export type SupplyEventMutation = { __typename?: 'Mutation', supplyEvent: { __typename?: 'SupplyItemSelectItem', id: number } };

export type SupplyItemsPageQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  orderBy: SupplyItemOrderBy;
  hideInactive: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SupplyItemsPageQuery = { __typename?: 'Query', supplyItem: Array<{ __typename?: 'SupplyItemSelectItem', id: number, label: string, barcode: string, currentStock: number, needsRecount: boolean, active: boolean, updatedAt: string, supplyEvents: Array<{ __typename?: 'SupplyItemSupplyEventsRelation', id: number, supplyChangeReasonId: number, amount: number, createdAt: string, createdByUser: { __typename?: 'SupplyItemSupplyEventsRelationCreatedByUserRelation', firstName: string, lastName: string } | null }> }> };

export type UserDetailQueryVariables = Exact<{
  userId: InputMaybe<Scalars['Int']['input']>;
}>;


export type UserDetailQuery = { __typename?: 'Query', userDetails: { __typename?: 'OrganizationUserSelectItem', id: number, deleted: boolean, user: { __typename?: 'OrganizationUserUserRelation', id: number, email: string, firstName: string, lastName: string } | null, roles: Array<{ __typename?: 'OrganizationUserRolesRelation', userRoleId: number | null }>, serviceLineOrgUsers: Array<{ __typename?: 'OrganizationUserServiceLineOrgUsersRelation', serviceLineId: number }>, organizationalUnitOrgUsers: Array<{ __typename?: 'OrganizationUserOrganizationalUnitOrgUsersRelation', organizationalUnitId: number }>, providers: Array<{ __typename?: 'OrganizationUserProvidersRelation', id: number, active: boolean, providerTypeId: number, addressStreet: string | null, addressLineTwo: string | null, addressCity: string | null, addressState: string | null, addressZip: string | null, external: boolean, identifier: string | null, teamProviders: Array<{ __typename?: 'OrganizationUserProvidersRelationTeamProvidersRelation', teamId: number }>, traits: Array<{ __typename?: 'OrganizationUserProvidersRelationTraitsRelation', trait: string, value: string }> }> } | null };

export type OrganizationProviderConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationProviderConfigQuery = { __typename?: 'Query', organizationSingle: { __typename?: 'OrganizationSelectItem', teams: Array<{ __typename?: 'OrganizationTeamsRelation', id: number, name: string }>, serviceLines: Array<{ __typename?: 'OrganizationServiceLinesRelation', id: number, name: string }>, organizationalUnits: Array<{ __typename?: 'OrganizationOrganizationalUnitsRelation', id: number, name: string, active: boolean }>, providerTypes: Array<{ __typename?: 'OrganizationProviderTypesRelation', id: number, name: string, requireStateLicense: boolean }>, roles: Array<{ __typename?: 'OrganizationRolesRelation', id: number, name: string }> } | null };

export type VisitWorklistWarningsQueryVariables = Exact<{
  start: Scalars['String']['input'];
  end: Scalars['String']['input'];
}>;


export type VisitWorklistWarningsQuery = { __typename?: 'Query', visitWorklistWarnings: Array<{ __typename?: 'VisitWorklistVisitRow', visit: { __typename?: 'VisitSelectMini', id: number, startTime: string, endTime: string, addressTimezone: string | null, visitType: { __typename?: 'VisitTypeMini', id: number, name: string }, patient: { __typename?: 'PatientMini', id: number, firstName: string, lastName: string }, episode: { __typename?: 'EpisodeSelectMini', id: number, serviceLineId: number } }, visitWarnings: Array<{ __typename?: 'VisitOrResourceWarningLabel', severity: number, category: string, warning: string }>, visitResources: Array<{ __typename?: 'VisitResourceWithWarnings', visitResource: { __typename?: 'VisitResourceSelectMini', id: number, provider: { __typename?: 'ProviderMini', id: number, firstName: string, lastName: string } | null }, warnings: Array<{ __typename?: 'VisitOrResourceWarningLabel', severity: number, category: string, warning: string }> }> }> };

export type VisitLocationsQueryVariables = Exact<{
  start: Scalars['String']['input'];
  end: Scalars['String']['input'];
}>;


export type VisitLocationsQuery = { __typename?: 'Query', visitResource: Array<{ __typename?: 'VisitResourceSelectItem', startTime: string, endTime: string, visitId: number, addressCoordinates: string | null, resourceRequirement: { __typename?: 'VisitResourceResourceRequirementRelation', inHome: boolean } | null, provider: { __typename?: 'VisitResourceProviderRelation', id: number, firstName: string, lastName: string, addressCoordinates: string | null } | null, visit: { __typename?: 'VisitResourceVisitRelation', addressCoordinates: string, eventStatus: VisitEventStatusEnum, patient: { __typename?: 'VisitResourceVisitRelationPatientRelation', id: number, firstName: string, lastName: string } | null } | null }>, shift: Array<{ __typename?: 'ShiftSelectItem', startTime: string, endTime: string, providerId: number, addressCoordinates: string, useShiftCenterDriveTimes: boolean, shiftCenter: { __typename?: 'ShiftShiftCenterRelation', addressCoordinates: string } | null }> };

export const SosAlertDetailFragmentDoc = gql`
    fragment SosAlertDetail on SosAlertSelectItem {
  id
  status
  providerStatus
  latitude
  longitude
  addressStreet
  addressCity
  addressState
  addressTimezone
  createdAt
  provider {
    id
    firstName
    lastName
  }
  visit {
    addressStreet
    addressCity
    addressState
    addressTimezone
    patient {
      id
      firstName
      lastName
    }
  }
  events {
    id
    eventType
    note
    createdAt
    createdByUser {
      firstName
      lastName
    }
  }
}
    `;
export const CreateCalendarBlockDocument = gql`
    mutation CreateCalendarBlock($providerId: Int!, $startTime: String!, $endTime: String!, $title: String, $addressStreet: String, $addressLineTwo: String, $addressCity: String, $addressState: String, $addressZip: String, $addressTimezone: String, $filters: CalendarBlockFilterInput, $blockType: CalendarBlockBlockTypeEnum!, $addressPlaceId: String) @permission(requires: manageCalendarBlocks) {
  createCalendarBlock(
    providerId: $providerId
    startTime: $startTime
    endTime: $endTime
    title: $title
    addressStreet: $addressStreet
    addressLineTwo: $addressLineTwo
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    addressTimezone: $addressTimezone
    filters: $filters
    blockType: $blockType
    addressPlaceId: $addressPlaceId
  ) {
    id
  }
}
    `;
export type CreateCalendarBlockMutationFn = Apollo.MutationFunction<CreateCalendarBlockMutation, CreateCalendarBlockMutationVariables>;

/**
 * __useCreateCalendarBlockMutation__
 *
 * To run a mutation, you first call `useCreateCalendarBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarBlockMutation, { data, loading, error }] = useCreateCalendarBlockMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      title: // value for 'title'
 *      addressStreet: // value for 'addressStreet'
 *      addressLineTwo: // value for 'addressLineTwo'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      addressTimezone: // value for 'addressTimezone'
 *      filters: // value for 'filters'
 *      blockType: // value for 'blockType'
 *      addressPlaceId: // value for 'addressPlaceId'
 *   },
 * });
 */
export function useCreateCalendarBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalendarBlockMutation, CreateCalendarBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalendarBlockMutation, CreateCalendarBlockMutationVariables>(CreateCalendarBlockDocument, options);
      }
export type CreateCalendarBlockMutationHookResult = ReturnType<typeof useCreateCalendarBlockMutation>;
export type CreateCalendarBlockMutationOptions = Apollo.BaseMutationOptions<CreateCalendarBlockMutation, CreateCalendarBlockMutationVariables>;
export const CreateShiftDocument = gql`
    mutation CreateShift($providerId: Int!, $startTime: String!, $endTime: String!, $addressStreet: String, $addressLineTwo: String, $addressCity: String, $addressState: String, $addressZip: String, $addressCoordinates: String!, $addressTimezone: String, $providerTravel: ShiftProviderTravelEnum!, $shiftCenterId: Int, $overflowShift: Boolean!, $useShiftCenterDriveTimes: Boolean!) @permission(requires: manageProviderShifts) {
  createShift(
    status: confirmed
    providerId: $providerId
    startTime: $startTime
    endTime: $endTime
    addressStreet: $addressStreet
    addressLineTwo: $addressLineTwo
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    addressCoordinates: $addressCoordinates
    addressTimezone: $addressTimezone
    providerTravel: $providerTravel
    shiftCenterId: $shiftCenterId
    overflowShift: $overflowShift
    useShiftCenterDriveTimes: $useShiftCenterDriveTimes
  ) {
    id
  }
}
    `;
export type CreateShiftMutationFn = Apollo.MutationFunction<CreateShiftMutation, CreateShiftMutationVariables>;

/**
 * __useCreateShiftMutation__
 *
 * To run a mutation, you first call `useCreateShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShiftMutation, { data, loading, error }] = useCreateShiftMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      addressStreet: // value for 'addressStreet'
 *      addressLineTwo: // value for 'addressLineTwo'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      addressCoordinates: // value for 'addressCoordinates'
 *      addressTimezone: // value for 'addressTimezone'
 *      providerTravel: // value for 'providerTravel'
 *      shiftCenterId: // value for 'shiftCenterId'
 *      overflowShift: // value for 'overflowShift'
 *      useShiftCenterDriveTimes: // value for 'useShiftCenterDriveTimes'
 *   },
 * });
 */
export function useCreateShiftMutation(baseOptions?: Apollo.MutationHookOptions<CreateShiftMutation, CreateShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShiftMutation, CreateShiftMutationVariables>(CreateShiftDocument, options);
      }
export type CreateShiftMutationHookResult = ReturnType<typeof useCreateShiftMutation>;
export type CreateShiftMutationOptions = Apollo.BaseMutationOptions<CreateShiftMutation, CreateShiftMutationVariables>;
export const UpdateCalendarBlockDocument = gql`
    mutation UpdateCalendarBlock($id: Int!, $providerId: Int!, $startTime: String!, $endTime: String!, $title: String, $addressStreet: String, $addressLineTwo: String, $addressCity: String, $addressState: String, $addressZip: String, $addressTimezone: String, $filters: CalendarBlockFilterInput, $addressPlaceId: String) @permission(requires: manageCalendarBlocks) {
  updateCalendarBlock(
    id: $id
    providerId: $providerId
    startTime: $startTime
    endTime: $endTime
    title: $title
    addressStreet: $addressStreet
    addressLineTwo: $addressLineTwo
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    addressTimezone: $addressTimezone
    filters: $filters
    addressPlaceId: $addressPlaceId
  ) {
    id
    providerId
    startTime
    endTime
    title
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressTimezone
    addressCoordinates
    addressTimezone
    startOfShiftDriveTime
    interVisitDriveTime
    endOfShiftDriveTime
    filters {
      visitTypeIds
    }
  }
}
    `;
export type UpdateCalendarBlockMutationFn = Apollo.MutationFunction<UpdateCalendarBlockMutation, UpdateCalendarBlockMutationVariables>;

/**
 * __useUpdateCalendarBlockMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarBlockMutation, { data, loading, error }] = useUpdateCalendarBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      providerId: // value for 'providerId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      title: // value for 'title'
 *      addressStreet: // value for 'addressStreet'
 *      addressLineTwo: // value for 'addressLineTwo'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      addressTimezone: // value for 'addressTimezone'
 *      filters: // value for 'filters'
 *      addressPlaceId: // value for 'addressPlaceId'
 *   },
 * });
 */
export function useUpdateCalendarBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarBlockMutation, UpdateCalendarBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarBlockMutation, UpdateCalendarBlockMutationVariables>(UpdateCalendarBlockDocument, options);
      }
export type UpdateCalendarBlockMutationHookResult = ReturnType<typeof useUpdateCalendarBlockMutation>;
export type UpdateCalendarBlockMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarBlockMutation, UpdateCalendarBlockMutationVariables>;
export const UpdateCalendarBlockStatusDocument = gql`
    mutation UpdateCalendarBlockStatus($id: Int!, $eventStatus: CalendarBlockEventStatusEnum!) @permission(requires: manageCalendarBlocks) {
  updateCalendarBlock(id: $id, eventStatus: $eventStatus) {
    id
    eventStatus
  }
}
    `;
export type UpdateCalendarBlockStatusMutationFn = Apollo.MutationFunction<UpdateCalendarBlockStatusMutation, UpdateCalendarBlockStatusMutationVariables>;

/**
 * __useUpdateCalendarBlockStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarBlockStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarBlockStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarBlockStatusMutation, { data, loading, error }] = useUpdateCalendarBlockStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventStatus: // value for 'eventStatus'
 *   },
 * });
 */
export function useUpdateCalendarBlockStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarBlockStatusMutation, UpdateCalendarBlockStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarBlockStatusMutation, UpdateCalendarBlockStatusMutationVariables>(UpdateCalendarBlockStatusDocument, options);
      }
export type UpdateCalendarBlockStatusMutationHookResult = ReturnType<typeof useUpdateCalendarBlockStatusMutation>;
export type UpdateCalendarBlockStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarBlockStatusMutation, UpdateCalendarBlockStatusMutationVariables>;
export const CancelVisitDialogDocument = gql`
    query CancelVisitDialog($visitId: Int!) @permission(requires: manageAnyVisit, check: [userInVisitServiceLine]) {
  visitSingle(where: {id: {eq: $visitId}}) {
    id
    patient {
      firstName
      lastName
    }
  }
  visitCancellationReason(where: {reasonType: {eq: cancel}, active: {eq: true}}) {
    id
    organizationId
    description
    createdAt
    reasonType
    createdBy
  }
}
    `;

/**
 * __useCancelVisitDialogQuery__
 *
 * To run a query within a React component, call `useCancelVisitDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelVisitDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelVisitDialogQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useCancelVisitDialogQuery(baseOptions: Apollo.QueryHookOptions<CancelVisitDialogQuery, CancelVisitDialogQueryVariables> & ({ variables: CancelVisitDialogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancelVisitDialogQuery, CancelVisitDialogQueryVariables>(CancelVisitDialogDocument, options);
      }
export function useCancelVisitDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancelVisitDialogQuery, CancelVisitDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancelVisitDialogQuery, CancelVisitDialogQueryVariables>(CancelVisitDialogDocument, options);
        }
// @ts-ignore
export function useCancelVisitDialogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CancelVisitDialogQuery, CancelVisitDialogQueryVariables>): Apollo.UseSuspenseQueryResult<CancelVisitDialogQuery, CancelVisitDialogQueryVariables>;
export function useCancelVisitDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CancelVisitDialogQuery, CancelVisitDialogQueryVariables>): Apollo.UseSuspenseQueryResult<CancelVisitDialogQuery | undefined, CancelVisitDialogQueryVariables>;
export function useCancelVisitDialogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CancelVisitDialogQuery, CancelVisitDialogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CancelVisitDialogQuery, CancelVisitDialogQueryVariables>(CancelVisitDialogDocument, options);
        }
export type CancelVisitDialogQueryHookResult = ReturnType<typeof useCancelVisitDialogQuery>;
export type CancelVisitDialogLazyQueryHookResult = ReturnType<typeof useCancelVisitDialogLazyQuery>;
export type CancelVisitDialogSuspenseQueryHookResult = ReturnType<typeof useCancelVisitDialogSuspenseQuery>;
export const CancelVisitDocument = gql`
    mutation CancelVisit($visitId: Int!, $visitCancellationReasonId: Int!) @permission(requires: manageAnyVisit, check: [userInVisitServiceLine]) {
  cancelVisit(
    visitId: $visitId
    visitCancellationReasonId: $visitCancellationReasonId
  ) {
    id
    eventStatus
    visitCancellationReasonId
  }
}
    `;
export type CancelVisitMutationFn = Apollo.MutationFunction<CancelVisitMutation, CancelVisitMutationVariables>;

/**
 * __useCancelVisitMutation__
 *
 * To run a mutation, you first call `useCancelVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelVisitMutation, { data, loading, error }] = useCancelVisitMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      visitCancellationReasonId: // value for 'visitCancellationReasonId'
 *   },
 * });
 */
export function useCancelVisitMutation(baseOptions?: Apollo.MutationHookOptions<CancelVisitMutation, CancelVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelVisitMutation, CancelVisitMutationVariables>(CancelVisitDocument, options);
      }
export type CancelVisitMutationHookResult = ReturnType<typeof useCancelVisitMutation>;
export type CancelVisitMutationOptions = Apollo.BaseMutationOptions<CancelVisitMutation, CancelVisitMutationVariables>;
export const UpdateShiftDocument = gql`
    mutation UpdateShift($id: Int!, $startTime: String, $endTime: String, $originalStartTime: String, $originalEndTime: String, $providerTravel: ShiftProviderTravelEnum, $shiftCenterId: Int, $overflowShift: Boolean, $useShiftCenterDriveTimes: Boolean) @permission(requires: manageProviderShifts) {
  updateShift(
    id: $id
    startTime: $startTime
    endTime: $endTime
    originalStartTime: $originalStartTime
    originalEndTime: $originalEndTime
    providerTravel: $providerTravel
    shiftCenterId: $shiftCenterId
    overflowShift: $overflowShift
    useShiftCenterDriveTimes: $useShiftCenterDriveTimes
  ) {
    id
    startTime
    endTime
    providerTravel
    overflowShift
    shiftCenterId
  }
}
    `;
export type UpdateShiftMutationFn = Apollo.MutationFunction<UpdateShiftMutation, UpdateShiftMutationVariables>;

/**
 * __useUpdateShiftMutation__
 *
 * To run a mutation, you first call `useUpdateShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShiftMutation, { data, loading, error }] = useUpdateShiftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      originalStartTime: // value for 'originalStartTime'
 *      originalEndTime: // value for 'originalEndTime'
 *      providerTravel: // value for 'providerTravel'
 *      shiftCenterId: // value for 'shiftCenterId'
 *      overflowShift: // value for 'overflowShift'
 *      useShiftCenterDriveTimes: // value for 'useShiftCenterDriveTimes'
 *   },
 * });
 */
export function useUpdateShiftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShiftMutation, UpdateShiftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShiftMutation, UpdateShiftMutationVariables>(UpdateShiftDocument, options);
      }
export type UpdateShiftMutationHookResult = ReturnType<typeof useUpdateShiftMutation>;
export type UpdateShiftMutationOptions = Apollo.BaseMutationOptions<UpdateShiftMutation, UpdateShiftMutationVariables>;
export const UpdateShiftStatusDocument = gql`
    mutation UpdateShiftStatus($id: Int!, $status: ShiftStatusEnum) @permission(requires: manageProviderShifts) {
  updateShift(id: $id, status: $status) {
    id
    status
  }
}
    `;
export type UpdateShiftStatusMutationFn = Apollo.MutationFunction<UpdateShiftStatusMutation, UpdateShiftStatusMutationVariables>;

/**
 * __useUpdateShiftStatusMutation__
 *
 * To run a mutation, you first call `useUpdateShiftStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShiftStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShiftStatusMutation, { data, loading, error }] = useUpdateShiftStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateShiftStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShiftStatusMutation, UpdateShiftStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShiftStatusMutation, UpdateShiftStatusMutationVariables>(UpdateShiftStatusDocument, options);
      }
export type UpdateShiftStatusMutationHookResult = ReturnType<typeof useUpdateShiftStatusMutation>;
export type UpdateShiftStatusMutationOptions = Apollo.BaseMutationOptions<UpdateShiftStatusMutation, UpdateShiftStatusMutationVariables>;
export const RecentSosAlertsDocument = gql`
    query RecentSosAlerts($withinHours: Int) @permission(requires: manageSosAlerts) {
  recentSosAlerts(withinHours: $withinHours) {
    ...SosAlertDetail
  }
}
    ${SosAlertDetailFragmentDoc}`;

/**
 * __useRecentSosAlertsQuery__
 *
 * To run a query within a React component, call `useRecentSosAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentSosAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentSosAlertsQuery({
 *   variables: {
 *      withinHours: // value for 'withinHours'
 *   },
 * });
 */
export function useRecentSosAlertsQuery(baseOptions?: Apollo.QueryHookOptions<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>(RecentSosAlertsDocument, options);
      }
export function useRecentSosAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>(RecentSosAlertsDocument, options);
        }
// @ts-ignore
export function useRecentSosAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>;
export function useRecentSosAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<RecentSosAlertsQuery | undefined, RecentSosAlertsQueryVariables>;
export function useRecentSosAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentSosAlertsQuery, RecentSosAlertsQueryVariables>(RecentSosAlertsDocument, options);
        }
export type RecentSosAlertsQueryHookResult = ReturnType<typeof useRecentSosAlertsQuery>;
export type RecentSosAlertsLazyQueryHookResult = ReturnType<typeof useRecentSosAlertsLazyQuery>;
export type RecentSosAlertsSuspenseQueryHookResult = ReturnType<typeof useRecentSosAlertsSuspenseQuery>;
export const AcknowledgeSosAlertDocument = gql`
    mutation AcknowledgeSosAlert($sosAlertId: Int!) @permission(requires: manageSosAlerts) {
  acknowledgeSosAlert(sosAlertId: $sosAlertId) {
    id
    status
  }
}
    `;
export type AcknowledgeSosAlertMutationFn = Apollo.MutationFunction<AcknowledgeSosAlertMutation, AcknowledgeSosAlertMutationVariables>;

/**
 * __useAcknowledgeSosAlertMutation__
 *
 * To run a mutation, you first call `useAcknowledgeSosAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeSosAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeSosAlertMutation, { data, loading, error }] = useAcknowledgeSosAlertMutation({
 *   variables: {
 *      sosAlertId: // value for 'sosAlertId'
 *   },
 * });
 */
export function useAcknowledgeSosAlertMutation(baseOptions?: Apollo.MutationHookOptions<AcknowledgeSosAlertMutation, AcknowledgeSosAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcknowledgeSosAlertMutation, AcknowledgeSosAlertMutationVariables>(AcknowledgeSosAlertDocument, options);
      }
export type AcknowledgeSosAlertMutationHookResult = ReturnType<typeof useAcknowledgeSosAlertMutation>;
export type AcknowledgeSosAlertMutationOptions = Apollo.BaseMutationOptions<AcknowledgeSosAlertMutation, AcknowledgeSosAlertMutationVariables>;
export const ResolveSosAlertDocument = gql`
    mutation ResolveSosAlert($sosAlertId: Int!, $note: String) @permission(requires: manageSosAlerts) {
  resolveSosAlert(sosAlertId: $sosAlertId, note: $note) {
    id
    status
  }
}
    `;
export type ResolveSosAlertMutationFn = Apollo.MutationFunction<ResolveSosAlertMutation, ResolveSosAlertMutationVariables>;

/**
 * __useResolveSosAlertMutation__
 *
 * To run a mutation, you first call `useResolveSosAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveSosAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveSosAlertMutation, { data, loading, error }] = useResolveSosAlertMutation({
 *   variables: {
 *      sosAlertId: // value for 'sosAlertId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useResolveSosAlertMutation(baseOptions?: Apollo.MutationHookOptions<ResolveSosAlertMutation, ResolveSosAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveSosAlertMutation, ResolveSosAlertMutationVariables>(ResolveSosAlertDocument, options);
      }
export type ResolveSosAlertMutationHookResult = ReturnType<typeof useResolveSosAlertMutation>;
export type ResolveSosAlertMutationOptions = Apollo.BaseMutationOptions<ResolveSosAlertMutation, ResolveSosAlertMutationVariables>;
export const AssignVisitResourceDocument = gql`
    mutation AssignVisitResource($id: Int!, $providerId: Int!, $startTime: String, $endTime: String) @permission(requires: createDragEvents) {
  updateVisitResourceObject(
    id: $id
    providerId: $providerId
    startTime: $startTime
    endTime: $endTime
  ) {
    id
    providerId
    startTime
    endTime
  }
}
    `;
export type AssignVisitResourceMutationFn = Apollo.MutationFunction<AssignVisitResourceMutation, AssignVisitResourceMutationVariables>;

/**
 * __useAssignVisitResourceMutation__
 *
 * To run a mutation, you first call `useAssignVisitResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignVisitResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignVisitResourceMutation, { data, loading, error }] = useAssignVisitResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      providerId: // value for 'providerId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useAssignVisitResourceMutation(baseOptions?: Apollo.MutationHookOptions<AssignVisitResourceMutation, AssignVisitResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignVisitResourceMutation, AssignVisitResourceMutationVariables>(AssignVisitResourceDocument, options);
      }
export type AssignVisitResourceMutationHookResult = ReturnType<typeof useAssignVisitResourceMutation>;
export type AssignVisitResourceMutationOptions = Apollo.BaseMutationOptions<AssignVisitResourceMutation, AssignVisitResourceMutationVariables>;
export const GetProviderShiftForDayDocument = gql`
    query GetProviderShiftForDay($startTime: String!, $endTime: String!, $providerId: Int!) @permission(requires: useWebApp) {
  shift(
    where: {providerId: {eq: $providerId}, OR: [{startTime: {gte: $startTime, lt: $endTime}}, {endTime: {gte: $startTime, lt: $endTime}}]}
  ) {
    id
    startTime
    endTime
    status
  }
  visitResource(
    where: {providerId: {eq: $providerId}, startTime: {gte: $startTime, lt: $endTime}}
  ) {
    id
    startTime
    endTime
    visit {
      id
      eventStatus
      visitTypeId
      patient {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetProviderShiftForDayQuery__
 *
 * To run a query within a React component, call `useGetProviderShiftForDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderShiftForDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderShiftForDayQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useGetProviderShiftForDayQuery(baseOptions: Apollo.QueryHookOptions<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables> & ({ variables: GetProviderShiftForDayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables>(GetProviderShiftForDayDocument, options);
      }
export function useGetProviderShiftForDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables>(GetProviderShiftForDayDocument, options);
        }
// @ts-ignore
export function useGetProviderShiftForDaySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables>;
export function useGetProviderShiftForDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderShiftForDayQuery | undefined, GetProviderShiftForDayQueryVariables>;
export function useGetProviderShiftForDaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderShiftForDayQuery, GetProviderShiftForDayQueryVariables>(GetProviderShiftForDayDocument, options);
        }
export type GetProviderShiftForDayQueryHookResult = ReturnType<typeof useGetProviderShiftForDayQuery>;
export type GetProviderShiftForDayLazyQueryHookResult = ReturnType<typeof useGetProviderShiftForDayLazyQuery>;
export type GetProviderShiftForDaySuspenseQueryHookResult = ReturnType<typeof useGetProviderShiftForDaySuspenseQuery>;
export const VisitErrandOptionsDocument = gql`
    query VisitErrandOptions($errandTypeId: Int!) @permission(requires: useWebApp) {
  organizationalUnit {
    id
    active
  }
  errandLocation(
    orderBy: {name: {direction: asc, priority: 1}}
    where: {errandTypeId: {eq: $errandTypeId}}
  ) {
    id
    name
    organizationalUnitId
  }
  provider(
    orderBy: {firstName: {direction: asc, priority: 1}, lastName: {direction: asc, priority: 2}}
    where: {active: {eq: true}}
  ) {
    id
    firstName
    lastName
    providerTypeId
    OrganizationUser {
      organizationalUnitOrgUsers {
        organizationalUnitId
      }
    }
    serviceLineProviders {
      serviceLineId
    }
  }
}
    `;

/**
 * __useVisitErrandOptionsQuery__
 *
 * To run a query within a React component, call `useVisitErrandOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitErrandOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitErrandOptionsQuery({
 *   variables: {
 *      errandTypeId: // value for 'errandTypeId'
 *   },
 * });
 */
export function useVisitErrandOptionsQuery(baseOptions: Apollo.QueryHookOptions<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables> & ({ variables: VisitErrandOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables>(VisitErrandOptionsDocument, options);
      }
export function useVisitErrandOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables>(VisitErrandOptionsDocument, options);
        }
// @ts-ignore
export function useVisitErrandOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables>;
export function useVisitErrandOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<VisitErrandOptionsQuery | undefined, VisitErrandOptionsQueryVariables>;
export function useVisitErrandOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisitErrandOptionsQuery, VisitErrandOptionsQueryVariables>(VisitErrandOptionsDocument, options);
        }
export type VisitErrandOptionsQueryHookResult = ReturnType<typeof useVisitErrandOptionsQuery>;
export type VisitErrandOptionsLazyQueryHookResult = ReturnType<typeof useVisitErrandOptionsLazyQuery>;
export type VisitErrandOptionsSuspenseQueryHookResult = ReturnType<typeof useVisitErrandOptionsSuspenseQuery>;
export const CreateErrandVisitResourceDocument = gql`
    mutation CreateErrandVisitResource($visitId: Int!, $errandTypeId: Int!, $errandLocationId: Int!, $providerId: Int!) @permission(requires: manageAnyVisit, check: [userInVisitServiceLine]) {
  createErrandVisitResource(
    visitId: $visitId
    errandTypeId: $errandTypeId
    errandLocationId: $errandLocationId
    providerId: $providerId
  ) {
    id
  }
}
    `;
export type CreateErrandVisitResourceMutationFn = Apollo.MutationFunction<CreateErrandVisitResourceMutation, CreateErrandVisitResourceMutationVariables>;

/**
 * __useCreateErrandVisitResourceMutation__
 *
 * To run a mutation, you first call `useCreateErrandVisitResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrandVisitResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrandVisitResourceMutation, { data, loading, error }] = useCreateErrandVisitResourceMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      errandTypeId: // value for 'errandTypeId'
 *      errandLocationId: // value for 'errandLocationId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useCreateErrandVisitResourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrandVisitResourceMutation, CreateErrandVisitResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrandVisitResourceMutation, CreateErrandVisitResourceMutationVariables>(CreateErrandVisitResourceDocument, options);
      }
export type CreateErrandVisitResourceMutationHookResult = ReturnType<typeof useCreateErrandVisitResourceMutation>;
export type CreateErrandVisitResourceMutationOptions = Apollo.BaseMutationOptions<CreateErrandVisitResourceMutation, CreateErrandVisitResourceMutationVariables>;
export const DeleteErrandVisitResourceDocument = gql`
    mutation DeleteErrandVisitResource($id: Int!, $visitId: Int!) @permission(requires: manageAnyVisit, check: [userInVisitServiceLine]) {
  deleteErrandVisitResource(id: $id, visitId: $visitId) {
    id
    deleted
  }
}
    `;
export type DeleteErrandVisitResourceMutationFn = Apollo.MutationFunction<DeleteErrandVisitResourceMutation, DeleteErrandVisitResourceMutationVariables>;

/**
 * __useDeleteErrandVisitResourceMutation__
 *
 * To run a mutation, you first call `useDeleteErrandVisitResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErrandVisitResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErrandVisitResourceMutation, { data, loading, error }] = useDeleteErrandVisitResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useDeleteErrandVisitResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErrandVisitResourceMutation, DeleteErrandVisitResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErrandVisitResourceMutation, DeleteErrandVisitResourceMutationVariables>(DeleteErrandVisitResourceDocument, options);
      }
export type DeleteErrandVisitResourceMutationHookResult = ReturnType<typeof useDeleteErrandVisitResourceMutation>;
export type DeleteErrandVisitResourceMutationOptions = Apollo.BaseMutationOptions<DeleteErrandVisitResourceMutation, DeleteErrandVisitResourceMutationVariables>;
export const DeleteVisitEventLogEntryDocument = gql`
    mutation DeleteVisitEventLogEntry($id: Int!) @permission(requires: manageVisitStatus) {
  deleteVisitEventLog(id: $id) {
    id
  }
}
    `;
export type DeleteVisitEventLogEntryMutationFn = Apollo.MutationFunction<DeleteVisitEventLogEntryMutation, DeleteVisitEventLogEntryMutationVariables>;

/**
 * __useDeleteVisitEventLogEntryMutation__
 *
 * To run a mutation, you first call `useDeleteVisitEventLogEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisitEventLogEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVisitEventLogEntryMutation, { data, loading, error }] = useDeleteVisitEventLogEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVisitEventLogEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVisitEventLogEntryMutation, DeleteVisitEventLogEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVisitEventLogEntryMutation, DeleteVisitEventLogEntryMutationVariables>(DeleteVisitEventLogEntryDocument, options);
      }
export type DeleteVisitEventLogEntryMutationHookResult = ReturnType<typeof useDeleteVisitEventLogEntryMutation>;
export type DeleteVisitEventLogEntryMutationOptions = Apollo.BaseMutationOptions<DeleteVisitEventLogEntryMutation, DeleteVisitEventLogEntryMutationVariables>;
export const GetVisitDetailsDocument = gql`
    query GetVisitDetails($visitId: Int!) @permission(requires: useWebApp) {
  visitSingle(where: {id: {eq: $visitId}}) {
    id
    careRequirementId
    startTime
    endTime
    eventStatus
    addressTimezone
    serviceInstructions
    addressStreet
    addressCity
    addressState
    addressZip
    arrivalWindowStartTime
    arrivalWindowEndTime
    manualEdits
    patient {
      id
      firstName
      lastName
      dateOfBirth
      sex
      phone
      patientNotes
      serviceInstructions
      patientIdentifiers {
        identifier
        identifier_type
      }
      careTeamProviders {
        id
        providerId
      }
    }
    visitTypeId
    visitResources {
      id
      startTime
      endTime
      providerId
      errandStatus
      addressStreet
      addressLineTwo
      addressCity
      addressState
      addressZip
      addressCoordinates
      addressTimezone
      startOfShiftDriveTime
      interVisitDriveTime
      endOfShiftDriveTime
      visitResourceRequirementId
      virtualProviderStatus
      provider {
        id
        firstName
        lastName
        providerType {
          id
          name
        }
      }
      resourceRequirement {
        invitedToVisit
        errandType {
          id
          name
        }
      }
    }
    notes {
      id
      body
      createdAt
      user {
        id
        email
        firstName
        lastName
      }
    }
    visitServices {
      id
      service {
        id
        name
      }
    }
    manualEdits
    visitWarningLogId
    cancellationReason {
      id
      description
    }
    episode {
      id
      serviceLineId
      organizationalUnitId
      precautions {
        id
        precautionId
      }
    }
    eventLog {
      id
      eventTime
      logEntryType
      event
      autoGenerated
      visitResourceId
      createdByUser {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetVisitDetailsQuery__
 *
 * To run a query within a React component, call `useGetVisitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVisitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVisitDetailsQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useGetVisitDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetVisitDetailsQuery, GetVisitDetailsQueryVariables> & ({ variables: GetVisitDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVisitDetailsQuery, GetVisitDetailsQueryVariables>(GetVisitDetailsDocument, options);
      }
export function useGetVisitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVisitDetailsQuery, GetVisitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVisitDetailsQuery, GetVisitDetailsQueryVariables>(GetVisitDetailsDocument, options);
        }
// @ts-ignore
export function useGetVisitDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVisitDetailsQuery, GetVisitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVisitDetailsQuery, GetVisitDetailsQueryVariables>;
export function useGetVisitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisitDetailsQuery, GetVisitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVisitDetailsQuery | undefined, GetVisitDetailsQueryVariables>;
export function useGetVisitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVisitDetailsQuery, GetVisitDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVisitDetailsQuery, GetVisitDetailsQueryVariables>(GetVisitDetailsDocument, options);
        }
export type GetVisitDetailsQueryHookResult = ReturnType<typeof useGetVisitDetailsQuery>;
export type GetVisitDetailsLazyQueryHookResult = ReturnType<typeof useGetVisitDetailsLazyQuery>;
export type GetVisitDetailsSuspenseQueryHookResult = ReturnType<typeof useGetVisitDetailsSuspenseQuery>;
export const SubmitVisitNoteDocument = gql`
    mutation SubmitVisitNote($visitId: Int!, $body: String!) @permission(requires: manageAnyVisit) {
  createVisitNote(visitId: $visitId, body: $body) {
    id
    body
    createdAt
    user {
      id
      email
    }
  }
}
    `;
export type SubmitVisitNoteMutationFn = Apollo.MutationFunction<SubmitVisitNoteMutation, SubmitVisitNoteMutationVariables>;

/**
 * __useSubmitVisitNoteMutation__
 *
 * To run a mutation, you first call `useSubmitVisitNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVisitNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVisitNoteMutation, { data, loading, error }] = useSubmitVisitNoteMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSubmitVisitNoteMutation(baseOptions?: Apollo.MutationHookOptions<SubmitVisitNoteMutation, SubmitVisitNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitVisitNoteMutation, SubmitVisitNoteMutationVariables>(SubmitVisitNoteDocument, options);
      }
export type SubmitVisitNoteMutationHookResult = ReturnType<typeof useSubmitVisitNoteMutation>;
export type SubmitVisitNoteMutationOptions = Apollo.BaseMutationOptions<SubmitVisitNoteMutation, SubmitVisitNoteMutationVariables>;
export const SetVisitManualEditsDocument = gql`
    mutation SetVisitManualEdits($visitId: Int!, $manualEdits: Boolean!) @permission(requires: manageAnyVisit, check: [userInVisitServiceLine]) {
  updateVisit(where: {id: {eq: $visitId}}, set: {manualEdits: $manualEdits}) {
    id
    manualEdits
  }
}
    `;
export type SetVisitManualEditsMutationFn = Apollo.MutationFunction<SetVisitManualEditsMutation, SetVisitManualEditsMutationVariables>;

/**
 * __useSetVisitManualEditsMutation__
 *
 * To run a mutation, you first call `useSetVisitManualEditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVisitManualEditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVisitManualEditsMutation, { data, loading, error }] = useSetVisitManualEditsMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      manualEdits: // value for 'manualEdits'
 *   },
 * });
 */
export function useSetVisitManualEditsMutation(baseOptions?: Apollo.MutationHookOptions<SetVisitManualEditsMutation, SetVisitManualEditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetVisitManualEditsMutation, SetVisitManualEditsMutationVariables>(SetVisitManualEditsDocument, options);
      }
export type SetVisitManualEditsMutationHookResult = ReturnType<typeof useSetVisitManualEditsMutation>;
export type SetVisitManualEditsMutationOptions = Apollo.BaseMutationOptions<SetVisitManualEditsMutation, SetVisitManualEditsMutationVariables>;
export const CancelVisitRequestTaskDocument = gql`
    mutation CancelVisitRequestTask($taskId: Int!) @permission(requires: createDragEvents) {
  cancelVisitRequest(taskId: $taskId) {
    id
  }
}
    `;
export type CancelVisitRequestTaskMutationFn = Apollo.MutationFunction<CancelVisitRequestTaskMutation, CancelVisitRequestTaskMutationVariables>;

/**
 * __useCancelVisitRequestTaskMutation__
 *
 * To run a mutation, you first call `useCancelVisitRequestTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelVisitRequestTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelVisitRequestTaskMutation, { data, loading, error }] = useCancelVisitRequestTaskMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useCancelVisitRequestTaskMutation(baseOptions?: Apollo.MutationHookOptions<CancelVisitRequestTaskMutation, CancelVisitRequestTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelVisitRequestTaskMutation, CancelVisitRequestTaskMutationVariables>(CancelVisitRequestTaskDocument, options);
      }
export type CancelVisitRequestTaskMutationHookResult = ReturnType<typeof useCancelVisitRequestTaskMutation>;
export type CancelVisitRequestTaskMutationOptions = Apollo.BaseMutationOptions<CancelVisitRequestTaskMutation, CancelVisitRequestTaskMutationVariables>;
export const CustomUpdateVisitStatusDocument = gql`
    mutation CustomUpdateVisitStatus($visitId: Int!, $newEventStatus: VisitEventStatusEnum!, $autoGenerated: Boolean!, $eventTime: String) @permission(requires: manageVisitStatus) {
  updateVisit(
    where: {id: {eq: $visitId}}
    set: {eventStatus: $newEventStatus}
    autoGenerated: $autoGenerated
    eventTime: $eventTime
  ) {
    id
    eventStatus
  }
}
    `;
export type CustomUpdateVisitStatusMutationFn = Apollo.MutationFunction<CustomUpdateVisitStatusMutation, CustomUpdateVisitStatusMutationVariables>;

/**
 * __useCustomUpdateVisitStatusMutation__
 *
 * To run a mutation, you first call `useCustomUpdateVisitStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateVisitStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateVisitStatusMutation, { data, loading, error }] = useCustomUpdateVisitStatusMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      newEventStatus: // value for 'newEventStatus'
 *      autoGenerated: // value for 'autoGenerated'
 *      eventTime: // value for 'eventTime'
 *   },
 * });
 */
export function useCustomUpdateVisitStatusMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateVisitStatusMutation, CustomUpdateVisitStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateVisitStatusMutation, CustomUpdateVisitStatusMutationVariables>(CustomUpdateVisitStatusDocument, options);
      }
export type CustomUpdateVisitStatusMutationHookResult = ReturnType<typeof useCustomUpdateVisitStatusMutation>;
export type CustomUpdateVisitStatusMutationOptions = Apollo.BaseMutationOptions<CustomUpdateVisitStatusMutation, CustomUpdateVisitStatusMutationVariables>;
export const CustomUpdateErrandStatusDocument = gql`
    mutation CustomUpdateErrandStatus($id: Int!, $visitId: Int!, $newStatus: VisitResourceErrandStatusEnum!, $autoGenerated: Boolean!, $eventTime: String) @permission(requires: manageVisitStatus, check: [userInVisitServiceLine]) {
  updateErrandVisitResourceStatus(
    id: $id
    visitId: $visitId
    newStatus: $newStatus
    autoGenerated: $autoGenerated
    eventTime: $eventTime
  ) {
    id
    errandStatus
  }
}
    `;
export type CustomUpdateErrandStatusMutationFn = Apollo.MutationFunction<CustomUpdateErrandStatusMutation, CustomUpdateErrandStatusMutationVariables>;

/**
 * __useCustomUpdateErrandStatusMutation__
 *
 * To run a mutation, you first call `useCustomUpdateErrandStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateErrandStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateErrandStatusMutation, { data, loading, error }] = useCustomUpdateErrandStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visitId: // value for 'visitId'
 *      newStatus: // value for 'newStatus'
 *      autoGenerated: // value for 'autoGenerated'
 *      eventTime: // value for 'eventTime'
 *   },
 * });
 */
export function useCustomUpdateErrandStatusMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateErrandStatusMutation, CustomUpdateErrandStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateErrandStatusMutation, CustomUpdateErrandStatusMutationVariables>(CustomUpdateErrandStatusDocument, options);
      }
export type CustomUpdateErrandStatusMutationHookResult = ReturnType<typeof useCustomUpdateErrandStatusMutation>;
export type CustomUpdateErrandStatusMutationOptions = Apollo.BaseMutationOptions<CustomUpdateErrandStatusMutation, CustomUpdateErrandStatusMutationVariables>;
export const PatientTimezoneDocument = gql`
    query PatientTimezone($patientId: Int!) @permission(requires: useWebApp) {
  patientSingle(where: {id: {eq: $patientId}}) {
    id
    addressTimezone
  }
}
    `;

/**
 * __usePatientTimezoneQuery__
 *
 * To run a query within a React component, call `usePatientTimezoneQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientTimezoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientTimezoneQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientTimezoneQuery(baseOptions: Apollo.QueryHookOptions<PatientTimezoneQuery, PatientTimezoneQueryVariables> & ({ variables: PatientTimezoneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientTimezoneQuery, PatientTimezoneQueryVariables>(PatientTimezoneDocument, options);
      }
export function usePatientTimezoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientTimezoneQuery, PatientTimezoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientTimezoneQuery, PatientTimezoneQueryVariables>(PatientTimezoneDocument, options);
        }
// @ts-ignore
export function usePatientTimezoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PatientTimezoneQuery, PatientTimezoneQueryVariables>): Apollo.UseSuspenseQueryResult<PatientTimezoneQuery, PatientTimezoneQueryVariables>;
export function usePatientTimezoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatientTimezoneQuery, PatientTimezoneQueryVariables>): Apollo.UseSuspenseQueryResult<PatientTimezoneQuery | undefined, PatientTimezoneQueryVariables>;
export function usePatientTimezoneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatientTimezoneQuery, PatientTimezoneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PatientTimezoneQuery, PatientTimezoneQueryVariables>(PatientTimezoneDocument, options);
        }
export type PatientTimezoneQueryHookResult = ReturnType<typeof usePatientTimezoneQuery>;
export type PatientTimezoneLazyQueryHookResult = ReturnType<typeof usePatientTimezoneLazyQuery>;
export type PatientTimezoneSuspenseQueryHookResult = ReturnType<typeof usePatientTimezoneSuspenseQuery>;
export const CreatePatientDataImportDocument = gql`
    mutation CreatePatientDataImport($filename: String!) @permission(requires: importPatients) {
  createDataImport(resourceType: patient, filename: $filename) {
    dataImport {
      id
      filePathToS3
      filename
      status
    }
    fileUploadUrl
  }
}
    `;
export type CreatePatientDataImportMutationFn = Apollo.MutationFunction<CreatePatientDataImportMutation, CreatePatientDataImportMutationVariables>;

/**
 * __useCreatePatientDataImportMutation__
 *
 * To run a mutation, you first call `useCreatePatientDataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientDataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientDataImportMutation, { data, loading, error }] = useCreatePatientDataImportMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useCreatePatientDataImportMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientDataImportMutation, CreatePatientDataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientDataImportMutation, CreatePatientDataImportMutationVariables>(CreatePatientDataImportDocument, options);
      }
export type CreatePatientDataImportMutationHookResult = ReturnType<typeof useCreatePatientDataImportMutation>;
export type CreatePatientDataImportMutationOptions = Apollo.BaseMutationOptions<CreatePatientDataImportMutation, CreatePatientDataImportMutationVariables>;
export const CreateUserDataImportDocument = gql`
    mutation CreateUserDataImport($filename: String!) @permission(requires: importUsers) {
  createDataImport(resourceType: user, filename: $filename) {
    dataImport {
      id
      filePathToS3
      filename
      status
    }
    fileUploadUrl
  }
}
    `;
export type CreateUserDataImportMutationFn = Apollo.MutationFunction<CreateUserDataImportMutation, CreateUserDataImportMutationVariables>;

/**
 * __useCreateUserDataImportMutation__
 *
 * To run a mutation, you first call `useCreateUserDataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDataImportMutation, { data, loading, error }] = useCreateUserDataImportMutation({
 *   variables: {
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useCreateUserDataImportMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDataImportMutation, CreateUserDataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDataImportMutation, CreateUserDataImportMutationVariables>(CreateUserDataImportDocument, options);
      }
export type CreateUserDataImportMutationHookResult = ReturnType<typeof useCreateUserDataImportMutation>;
export type CreateUserDataImportMutationOptions = Apollo.BaseMutationOptions<CreateUserDataImportMutation, CreateUserDataImportMutationVariables>;
export const GetPatientDataImportPreviewDocument = gql`
    query GetPatientDataImportPreview($dataImportId: Int!) @permission(requires: importPatients) {
  dataImportPreview(dataImportId: $dataImportId, resourceType: patient) {
    columnNames
    csvColumnNames
    preview {
      validRecordCount
      totalErrorCount
      errors {
        csvRow
        rowIndex
        errors {
          instancePath
          keyword
          message
        }
      }
      exampleRecords {
        record
        rowIndex
      }
    }
  }
}
    `;

/**
 * __useGetPatientDataImportPreviewQuery__
 *
 * To run a query within a React component, call `useGetPatientDataImportPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientDataImportPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientDataImportPreviewQuery({
 *   variables: {
 *      dataImportId: // value for 'dataImportId'
 *   },
 * });
 */
export function useGetPatientDataImportPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables> & ({ variables: GetPatientDataImportPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables>(GetPatientDataImportPreviewDocument, options);
      }
export function useGetPatientDataImportPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables>(GetPatientDataImportPreviewDocument, options);
        }
// @ts-ignore
export function useGetPatientDataImportPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables>;
export function useGetPatientDataImportPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientDataImportPreviewQuery | undefined, GetPatientDataImportPreviewQueryVariables>;
export function useGetPatientDataImportPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientDataImportPreviewQuery, GetPatientDataImportPreviewQueryVariables>(GetPatientDataImportPreviewDocument, options);
        }
export type GetPatientDataImportPreviewQueryHookResult = ReturnType<typeof useGetPatientDataImportPreviewQuery>;
export type GetPatientDataImportPreviewLazyQueryHookResult = ReturnType<typeof useGetPatientDataImportPreviewLazyQuery>;
export type GetPatientDataImportPreviewSuspenseQueryHookResult = ReturnType<typeof useGetPatientDataImportPreviewSuspenseQuery>;
export const GetUserDataImportPreviewDocument = gql`
    query GetUserDataImportPreview($dataImportId: Int!) @permission(requires: importUsers) {
  dataImportPreview(dataImportId: $dataImportId, resourceType: user) {
    columnNames
    csvColumnNames
    preview {
      validRecordCount
      totalErrorCount
      errors {
        csvRow
        rowIndex
        errors {
          instancePath
          keyword
          message
        }
      }
      exampleRecords {
        record
        rowIndex
      }
    }
  }
}
    `;

/**
 * __useGetUserDataImportPreviewQuery__
 *
 * To run a query within a React component, call `useGetUserDataImportPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataImportPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataImportPreviewQuery({
 *   variables: {
 *      dataImportId: // value for 'dataImportId'
 *   },
 * });
 */
export function useGetUserDataImportPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables> & ({ variables: GetUserDataImportPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables>(GetUserDataImportPreviewDocument, options);
      }
export function useGetUserDataImportPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables>(GetUserDataImportPreviewDocument, options);
        }
// @ts-ignore
export function useGetUserDataImportPreviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables>;
export function useGetUserDataImportPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDataImportPreviewQuery | undefined, GetUserDataImportPreviewQueryVariables>;
export function useGetUserDataImportPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDataImportPreviewQuery, GetUserDataImportPreviewQueryVariables>(GetUserDataImportPreviewDocument, options);
        }
export type GetUserDataImportPreviewQueryHookResult = ReturnType<typeof useGetUserDataImportPreviewQuery>;
export type GetUserDataImportPreviewLazyQueryHookResult = ReturnType<typeof useGetUserDataImportPreviewLazyQuery>;
export type GetUserDataImportPreviewSuspenseQueryHookResult = ReturnType<typeof useGetUserDataImportPreviewSuspenseQuery>;
export const ExecutePatientDataImportDocument = gql`
    mutation ExecutePatientDataImport($dataImportId: Int!) @permission(requires: importPatients) {
  importData(resourceType: patient, dataImportId: $dataImportId) {
    id
  }
}
    `;
export type ExecutePatientDataImportMutationFn = Apollo.MutationFunction<ExecutePatientDataImportMutation, ExecutePatientDataImportMutationVariables>;

/**
 * __useExecutePatientDataImportMutation__
 *
 * To run a mutation, you first call `useExecutePatientDataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecutePatientDataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executePatientDataImportMutation, { data, loading, error }] = useExecutePatientDataImportMutation({
 *   variables: {
 *      dataImportId: // value for 'dataImportId'
 *   },
 * });
 */
export function useExecutePatientDataImportMutation(baseOptions?: Apollo.MutationHookOptions<ExecutePatientDataImportMutation, ExecutePatientDataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecutePatientDataImportMutation, ExecutePatientDataImportMutationVariables>(ExecutePatientDataImportDocument, options);
      }
export type ExecutePatientDataImportMutationHookResult = ReturnType<typeof useExecutePatientDataImportMutation>;
export type ExecutePatientDataImportMutationOptions = Apollo.BaseMutationOptions<ExecutePatientDataImportMutation, ExecutePatientDataImportMutationVariables>;
export const ExecuteUserDataImportDocument = gql`
    mutation ExecuteUserDataImport($dataImportId: Int!) @permission(requires: importUsers) {
  importData(resourceType: user, dataImportId: $dataImportId) {
    id
  }
}
    `;
export type ExecuteUserDataImportMutationFn = Apollo.MutationFunction<ExecuteUserDataImportMutation, ExecuteUserDataImportMutationVariables>;

/**
 * __useExecuteUserDataImportMutation__
 *
 * To run a mutation, you first call `useExecuteUserDataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteUserDataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeUserDataImportMutation, { data, loading, error }] = useExecuteUserDataImportMutation({
 *   variables: {
 *      dataImportId: // value for 'dataImportId'
 *   },
 * });
 */
export function useExecuteUserDataImportMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteUserDataImportMutation, ExecuteUserDataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteUserDataImportMutation, ExecuteUserDataImportMutationVariables>(ExecuteUserDataImportDocument, options);
      }
export type ExecuteUserDataImportMutationHookResult = ReturnType<typeof useExecuteUserDataImportMutation>;
export type ExecuteUserDataImportMutationOptions = Apollo.BaseMutationOptions<ExecuteUserDataImportMutation, ExecuteUserDataImportMutationVariables>;
export const DeletePatientDataImportDocument = gql`
    mutation DeletePatientDataImport($dataImportId: Int!) @permission(requires: importPatients) {
  deleteDataImport(resourceType: patient, dataImportId: $dataImportId) {
    id
  }
}
    `;
export type DeletePatientDataImportMutationFn = Apollo.MutationFunction<DeletePatientDataImportMutation, DeletePatientDataImportMutationVariables>;

/**
 * __useDeletePatientDataImportMutation__
 *
 * To run a mutation, you first call `useDeletePatientDataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientDataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientDataImportMutation, { data, loading, error }] = useDeletePatientDataImportMutation({
 *   variables: {
 *      dataImportId: // value for 'dataImportId'
 *   },
 * });
 */
export function useDeletePatientDataImportMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientDataImportMutation, DeletePatientDataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientDataImportMutation, DeletePatientDataImportMutationVariables>(DeletePatientDataImportDocument, options);
      }
export type DeletePatientDataImportMutationHookResult = ReturnType<typeof useDeletePatientDataImportMutation>;
export type DeletePatientDataImportMutationOptions = Apollo.BaseMutationOptions<DeletePatientDataImportMutation, DeletePatientDataImportMutationVariables>;
export const DeleteUserDataImportDocument = gql`
    mutation DeleteUserDataImport($dataImportId: Int!) @permission(requires: importUsers) {
  deleteDataImport(resourceType: user, dataImportId: $dataImportId) {
    id
  }
}
    `;
export type DeleteUserDataImportMutationFn = Apollo.MutationFunction<DeleteUserDataImportMutation, DeleteUserDataImportMutationVariables>;

/**
 * __useDeleteUserDataImportMutation__
 *
 * To run a mutation, you first call `useDeleteUserDataImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserDataImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserDataImportMutation, { data, loading, error }] = useDeleteUserDataImportMutation({
 *   variables: {
 *      dataImportId: // value for 'dataImportId'
 *   },
 * });
 */
export function useDeleteUserDataImportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserDataImportMutation, DeleteUserDataImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserDataImportMutation, DeleteUserDataImportMutationVariables>(DeleteUserDataImportDocument, options);
      }
export type DeleteUserDataImportMutationHookResult = ReturnType<typeof useDeleteUserDataImportMutation>;
export type DeleteUserDataImportMutationOptions = Apollo.BaseMutationOptions<DeleteUserDataImportMutation, DeleteUserDataImportMutationVariables>;
export const GetPatientDataImportDocument = gql`
    query GetPatientDataImport @permission(requires: importPatients) {
  dataImport(
    where: {resourceType: {eq: "patient"}}
    orderBy: {createdAt: {direction: desc, priority: 1}}
  ) {
    id
    createdAt
    createdBy {
      firstName
      lastName
    }
    deleted
    filePathToS3
    metadata
    filename
    organizationId
    resourceType
    status
    updatedAt
  }
}
    `;

/**
 * __useGetPatientDataImportQuery__
 *
 * To run a query within a React component, call `useGetPatientDataImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientDataImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientDataImportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPatientDataImportQuery(baseOptions?: Apollo.QueryHookOptions<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>(GetPatientDataImportDocument, options);
      }
export function useGetPatientDataImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>(GetPatientDataImportDocument, options);
        }
// @ts-ignore
export function useGetPatientDataImportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>;
export function useGetPatientDataImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientDataImportQuery | undefined, GetPatientDataImportQueryVariables>;
export function useGetPatientDataImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientDataImportQuery, GetPatientDataImportQueryVariables>(GetPatientDataImportDocument, options);
        }
export type GetPatientDataImportQueryHookResult = ReturnType<typeof useGetPatientDataImportQuery>;
export type GetPatientDataImportLazyQueryHookResult = ReturnType<typeof useGetPatientDataImportLazyQuery>;
export type GetPatientDataImportSuspenseQueryHookResult = ReturnType<typeof useGetPatientDataImportSuspenseQuery>;
export const GetUserDataImportDocument = gql`
    query GetUserDataImport @permission(requires: importUsers) {
  dataImport(
    where: {resourceType: {eq: "user"}}
    orderBy: {createdAt: {direction: desc, priority: 1}}
  ) {
    id
    createdAt
    createdBy {
      firstName
      lastName
    }
    deleted
    filePathToS3
    metadata
    filename
    organizationId
    resourceType
    status
    updatedAt
  }
}
    `;

/**
 * __useGetUserDataImportQuery__
 *
 * To run a query within a React component, call `useGetUserDataImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDataImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDataImportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserDataImportQuery(baseOptions?: Apollo.QueryHookOptions<GetUserDataImportQuery, GetUserDataImportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserDataImportQuery, GetUserDataImportQueryVariables>(GetUserDataImportDocument, options);
      }
export function useGetUserDataImportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserDataImportQuery, GetUserDataImportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserDataImportQuery, GetUserDataImportQueryVariables>(GetUserDataImportDocument, options);
        }
// @ts-ignore
export function useGetUserDataImportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserDataImportQuery, GetUserDataImportQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDataImportQuery, GetUserDataImportQueryVariables>;
export function useGetUserDataImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDataImportQuery, GetUserDataImportQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserDataImportQuery | undefined, GetUserDataImportQueryVariables>;
export function useGetUserDataImportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserDataImportQuery, GetUserDataImportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserDataImportQuery, GetUserDataImportQueryVariables>(GetUserDataImportDocument, options);
        }
export type GetUserDataImportQueryHookResult = ReturnType<typeof useGetUserDataImportQuery>;
export type GetUserDataImportLazyQueryHookResult = ReturnType<typeof useGetUserDataImportLazyQuery>;
export type GetUserDataImportSuspenseQueryHookResult = ReturnType<typeof useGetUserDataImportSuspenseQuery>;
export const GetKpiProviderUtilizationDocument = gql`
    query GetKPIProviderUtilization($input: KPIQueryInputArgs!) @permission(requires: viewKPIs) {
  kpiProviderUtilization(input: $input) {
    shiftTime
    visitTime
    interVisitDriveTime
    startEndDriveTime
    calendarBlockTime
  }
}
    `;

/**
 * __useGetKpiProviderUtilizationQuery__
 *
 * To run a query within a React component, call `useGetKpiProviderUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiProviderUtilizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiProviderUtilizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetKpiProviderUtilizationQuery(baseOptions: Apollo.QueryHookOptions<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables> & ({ variables: GetKpiProviderUtilizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables>(GetKpiProviderUtilizationDocument, options);
      }
export function useGetKpiProviderUtilizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables>(GetKpiProviderUtilizationDocument, options);
        }
// @ts-ignore
export function useGetKpiProviderUtilizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables>;
export function useGetKpiProviderUtilizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetKpiProviderUtilizationQuery | undefined, GetKpiProviderUtilizationQueryVariables>;
export function useGetKpiProviderUtilizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKpiProviderUtilizationQuery, GetKpiProviderUtilizationQueryVariables>(GetKpiProviderUtilizationDocument, options);
        }
export type GetKpiProviderUtilizationQueryHookResult = ReturnType<typeof useGetKpiProviderUtilizationQuery>;
export type GetKpiProviderUtilizationLazyQueryHookResult = ReturnType<typeof useGetKpiProviderUtilizationLazyQuery>;
export type GetKpiProviderUtilizationSuspenseQueryHookResult = ReturnType<typeof useGetKpiProviderUtilizationSuspenseQuery>;
export const GetKpiVisitTypesDocument = gql`
    query GetKPIVisitTypes($input: KPIQueryInputArgs!) @permission(requires: viewKPIs) {
  kpiVisitTypes(input: $input) {
    visitTypePercentages
    totalVisits
    visitVolumeByDate {
      date
      category
      count
    }
  }
}
    `;

/**
 * __useGetKpiVisitTypesQuery__
 *
 * To run a query within a React component, call `useGetKpiVisitTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiVisitTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiVisitTypesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetKpiVisitTypesQuery(baseOptions: Apollo.QueryHookOptions<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables> & ({ variables: GetKpiVisitTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables>(GetKpiVisitTypesDocument, options);
      }
export function useGetKpiVisitTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables>(GetKpiVisitTypesDocument, options);
        }
// @ts-ignore
export function useGetKpiVisitTypesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables>;
export function useGetKpiVisitTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables>): Apollo.UseSuspenseQueryResult<GetKpiVisitTypesQuery | undefined, GetKpiVisitTypesQueryVariables>;
export function useGetKpiVisitTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKpiVisitTypesQuery, GetKpiVisitTypesQueryVariables>(GetKpiVisitTypesDocument, options);
        }
export type GetKpiVisitTypesQueryHookResult = ReturnType<typeof useGetKpiVisitTypesQuery>;
export type GetKpiVisitTypesLazyQueryHookResult = ReturnType<typeof useGetKpiVisitTypesLazyQuery>;
export type GetKpiVisitTypesSuspenseQueryHookResult = ReturnType<typeof useGetKpiVisitTypesSuspenseQuery>;
export const KpiChartCancellationRateDocument = gql`
    query KPIChartCancellationRate($input: KPIQueryInputArgs!) @permission(requires: viewKPIs) {
  kpiCancellationRate(input: $input) {
    cancellationRates
    totalCancellationRate
  }
}
    `;

/**
 * __useKpiChartCancellationRateQuery__
 *
 * To run a query within a React component, call `useKpiChartCancellationRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiChartCancellationRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiChartCancellationRateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKpiChartCancellationRateQuery(baseOptions: Apollo.QueryHookOptions<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables> & ({ variables: KpiChartCancellationRateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables>(KpiChartCancellationRateDocument, options);
      }
export function useKpiChartCancellationRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables>(KpiChartCancellationRateDocument, options);
        }
// @ts-ignore
export function useKpiChartCancellationRateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables>): Apollo.UseSuspenseQueryResult<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables>;
export function useKpiChartCancellationRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables>): Apollo.UseSuspenseQueryResult<KpiChartCancellationRateQuery | undefined, KpiChartCancellationRateQueryVariables>;
export function useKpiChartCancellationRateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KpiChartCancellationRateQuery, KpiChartCancellationRateQueryVariables>(KpiChartCancellationRateDocument, options);
        }
export type KpiChartCancellationRateQueryHookResult = ReturnType<typeof useKpiChartCancellationRateQuery>;
export type KpiChartCancellationRateLazyQueryHookResult = ReturnType<typeof useKpiChartCancellationRateLazyQuery>;
export type KpiChartCancellationRateSuspenseQueryHookResult = ReturnType<typeof useKpiChartCancellationRateSuspenseQuery>;
export const KpiSummaryDocument = gql`
    query KPISummary($input: KPIQueryInputArgs!) @permission(requires: viewKPIs) {
  kpiSummary(input: $input) {
    totalVisits
    rankCategoryCounts {
      high
      medium
      low
    }
    visitsByStatus {
      canceled
      complete
      in_progress
      arrived
      en_route
      scheduled
    }
  }
}
    `;

/**
 * __useKpiSummaryQuery__
 *
 * To run a query within a React component, call `useKpiSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useKpiSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKpiSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useKpiSummaryQuery(baseOptions: Apollo.QueryHookOptions<KpiSummaryQuery, KpiSummaryQueryVariables> & ({ variables: KpiSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KpiSummaryQuery, KpiSummaryQueryVariables>(KpiSummaryDocument, options);
      }
export function useKpiSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KpiSummaryQuery, KpiSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KpiSummaryQuery, KpiSummaryQueryVariables>(KpiSummaryDocument, options);
        }
// @ts-ignore
export function useKpiSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<KpiSummaryQuery, KpiSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<KpiSummaryQuery, KpiSummaryQueryVariables>;
export function useKpiSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KpiSummaryQuery, KpiSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<KpiSummaryQuery | undefined, KpiSummaryQueryVariables>;
export function useKpiSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KpiSummaryQuery, KpiSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KpiSummaryQuery, KpiSummaryQueryVariables>(KpiSummaryDocument, options);
        }
export type KpiSummaryQueryHookResult = ReturnType<typeof useKpiSummaryQuery>;
export type KpiSummaryLazyQueryHookResult = ReturnType<typeof useKpiSummaryLazyQuery>;
export type KpiSummarySuspenseQueryHookResult = ReturnType<typeof useKpiSummarySuspenseQuery>;
export const GetKpiVisitPerShiftDocument = gql`
    query GetKPIVisitPerShift($input: KPIQueryInputArgs!) @permission(requires: viewKPIs) {
  kpiVisitsPerShift(input: $input) {
    visitsPerShift {
      date
      totalVisits
      totalShiftHours
      visitsPerShift
    }
  }
}
    `;

/**
 * __useGetKpiVisitPerShiftQuery__
 *
 * To run a query within a React component, call `useGetKpiVisitPerShiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKpiVisitPerShiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKpiVisitPerShiftQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetKpiVisitPerShiftQuery(baseOptions: Apollo.QueryHookOptions<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables> & ({ variables: GetKpiVisitPerShiftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables>(GetKpiVisitPerShiftDocument, options);
      }
export function useGetKpiVisitPerShiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables>(GetKpiVisitPerShiftDocument, options);
        }
// @ts-ignore
export function useGetKpiVisitPerShiftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables>): Apollo.UseSuspenseQueryResult<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables>;
export function useGetKpiVisitPerShiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables>): Apollo.UseSuspenseQueryResult<GetKpiVisitPerShiftQuery | undefined, GetKpiVisitPerShiftQueryVariables>;
export function useGetKpiVisitPerShiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKpiVisitPerShiftQuery, GetKpiVisitPerShiftQueryVariables>(GetKpiVisitPerShiftDocument, options);
        }
export type GetKpiVisitPerShiftQueryHookResult = ReturnType<typeof useGetKpiVisitPerShiftQuery>;
export type GetKpiVisitPerShiftLazyQueryHookResult = ReturnType<typeof useGetKpiVisitPerShiftLazyQuery>;
export type GetKpiVisitPerShiftSuspenseQueryHookResult = ReturnType<typeof useGetKpiVisitPerShiftSuspenseQuery>;
export const PersistFhirQueryDocument = gql`
    mutation PersistFhirQuery($patientId: Int!, $queryText: String!, $sourceSystem: String!, $responseBody: String!) @permission(requires: debugApps) {
  persistFhirQuery(
    patientId: $patientId
    queryText: $queryText
    sourceSystem: $sourceSystem
    responseBody: $responseBody
  ) {
    fhirQueryId
    success
  }
}
    `;
export type PersistFhirQueryMutationFn = Apollo.MutationFunction<PersistFhirQueryMutation, PersistFhirQueryMutationVariables>;

/**
 * __usePersistFhirQueryMutation__
 *
 * To run a mutation, you first call `usePersistFhirQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePersistFhirQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [persistFhirQueryMutation, { data, loading, error }] = usePersistFhirQueryMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      queryText: // value for 'queryText'
 *      sourceSystem: // value for 'sourceSystem'
 *      responseBody: // value for 'responseBody'
 *   },
 * });
 */
export function usePersistFhirQueryMutation(baseOptions?: Apollo.MutationHookOptions<PersistFhirQueryMutation, PersistFhirQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PersistFhirQueryMutation, PersistFhirQueryMutationVariables>(PersistFhirQueryDocument, options);
      }
export type PersistFhirQueryMutationHookResult = ReturnType<typeof usePersistFhirQueryMutation>;
export type PersistFhirQueryMutationOptions = Apollo.BaseMutationOptions<PersistFhirQueryMutation, PersistFhirQueryMutationVariables>;
export const CreatePatientCareTeamDocument = gql`
    mutation CreatePatientCareTeam($patientId: Int!, $providerId: Int!, $providerTypeId: Int!, $allowAutomaticUpdates: Boolean) @permission(requires: useWebApp) {
  createPatientCareTeam(
    patientId: $patientId
    providerId: $providerId
    providerTypeId: $providerTypeId
    allowAutomaticUpdates: $allowAutomaticUpdates
  )
}
    `;
export type CreatePatientCareTeamMutationFn = Apollo.MutationFunction<CreatePatientCareTeamMutation, CreatePatientCareTeamMutationVariables>;

/**
 * __useCreatePatientCareTeamMutation__
 *
 * To run a mutation, you first call `useCreatePatientCareTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientCareTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientCareTeamMutation, { data, loading, error }] = useCreatePatientCareTeamMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      providerId: // value for 'providerId'
 *      providerTypeId: // value for 'providerTypeId'
 *      allowAutomaticUpdates: // value for 'allowAutomaticUpdates'
 *   },
 * });
 */
export function useCreatePatientCareTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientCareTeamMutation, CreatePatientCareTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientCareTeamMutation, CreatePatientCareTeamMutationVariables>(CreatePatientCareTeamDocument, options);
      }
export type CreatePatientCareTeamMutationHookResult = ReturnType<typeof useCreatePatientCareTeamMutation>;
export type CreatePatientCareTeamMutationOptions = Apollo.BaseMutationOptions<CreatePatientCareTeamMutation, CreatePatientCareTeamMutationVariables>;
export const GetProvidersByTypeDocument = gql`
    query GetProvidersByType($providerTypeId: Int!) @permission(requires: useWebApp) {
  provider(
    where: {providerTypeId: {eq: $providerTypeId}, active: {eq: true}}
    orderBy: {firstName: {direction: asc, priority: 1}}
  ) {
    id
    firstName
    lastName
    providerTypeId
  }
}
    `;

/**
 * __useGetProvidersByTypeQuery__
 *
 * To run a query within a React component, call `useGetProvidersByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvidersByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvidersByTypeQuery({
 *   variables: {
 *      providerTypeId: // value for 'providerTypeId'
 *   },
 * });
 */
export function useGetProvidersByTypeQuery(baseOptions: Apollo.QueryHookOptions<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables> & ({ variables: GetProvidersByTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables>(GetProvidersByTypeDocument, options);
      }
export function useGetProvidersByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables>(GetProvidersByTypeDocument, options);
        }
// @ts-ignore
export function useGetProvidersByTypeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables>;
export function useGetProvidersByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables>): Apollo.UseSuspenseQueryResult<GetProvidersByTypeQuery | undefined, GetProvidersByTypeQueryVariables>;
export function useGetProvidersByTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProvidersByTypeQuery, GetProvidersByTypeQueryVariables>(GetProvidersByTypeDocument, options);
        }
export type GetProvidersByTypeQueryHookResult = ReturnType<typeof useGetProvidersByTypeQuery>;
export type GetProvidersByTypeLazyQueryHookResult = ReturnType<typeof useGetProvidersByTypeLazyQuery>;
export type GetProvidersByTypeSuspenseQueryHookResult = ReturnType<typeof useGetProvidersByTypeSuspenseQuery>;
export const CreatePatientDocument = gql`
    mutation CreatePatient($firstName: String!, $lastName: String!, $phone: String, $addressStreet: String!, $addressLineTwo: String, $addressCity: String, $addressState: String, $addressZip: String, $sex: PatientSexEnum, $dateOfBirth: String, $patientNotes: String, $serviceInstructions: String, $patientIdentifiers: [ManagePatientIdentifier!]!, $addressPlaceId: String) @permission(requires: managePatients) {
  createPatient(
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    addressStreet: $addressStreet
    addressLineTwo: $addressLineTwo
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    dateOfBirth: $dateOfBirth
    sex: $sex
    patientNotes: $patientNotes
    serviceInstructions: $serviceInstructions
    patientIdentifiers: $patientIdentifiers
    addressPlaceId: $addressPlaceId
  ) {
    id
    firstName
    lastName
    addressTimezone
  }
}
    `;
export type CreatePatientMutationFn = Apollo.MutationFunction<CreatePatientMutation, CreatePatientMutationVariables>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      addressStreet: // value for 'addressStreet'
 *      addressLineTwo: // value for 'addressLineTwo'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      sex: // value for 'sex'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      patientNotes: // value for 'patientNotes'
 *      serviceInstructions: // value for 'serviceInstructions'
 *      patientIdentifiers: // value for 'patientIdentifiers'
 *      addressPlaceId: // value for 'addressPlaceId'
 *   },
 * });
 */
export function useCreatePatientMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientMutation, CreatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(CreatePatientDocument, options);
      }
export type CreatePatientMutationHookResult = ReturnType<typeof useCreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation UpdatePatient($patientId: Int!, $firstName: String!, $lastName: String!, $phone: String, $addressStreet: String!, $addressLineTwo: String, $addressCity: String, $addressState: String, $addressZip: String, $dateOfBirth: String, $sex: PatientSexEnum, $patientNotes: String, $serviceInstructions: String, $patientIdentifiers: [ManagePatientIdentifier!]!, $addressPlaceId: String) @permission(requires: managePatients) {
  updatePatient(
    id: $patientId
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    addressStreet: $addressStreet
    addressLineTwo: $addressLineTwo
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    dateOfBirth: $dateOfBirth
    sex: $sex
    patientNotes: $patientNotes
    serviceInstructions: $serviceInstructions
    patientIdentifiers: $patientIdentifiers
    addressPlaceId: $addressPlaceId
  ) {
    id
    firstName
    lastName
    phone
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    dateOfBirth
    sex
    patientNotes
    serviceInstructions
    patientIdentifiers {
      id
      identifier
      identifier_type
    }
    updatedAt
  }
}
    `;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      addressStreet: // value for 'addressStreet'
 *      addressLineTwo: // value for 'addressLineTwo'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      sex: // value for 'sex'
 *      patientNotes: // value for 'patientNotes'
 *      serviceInstructions: // value for 'serviceInstructions'
 *      patientIdentifiers: // value for 'patientIdentifiers'
 *      addressPlaceId: // value for 'addressPlaceId'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const DeletePatientCareTeamDocument = gql`
    mutation DeletePatientCareTeam($patientId: Int!, $providerTypeId: Int!) @permission(requires: useWebApp) {
  deletePatientCareTeam(patientId: $patientId, providerTypeId: $providerTypeId)
}
    `;
export type DeletePatientCareTeamMutationFn = Apollo.MutationFunction<DeletePatientCareTeamMutation, DeletePatientCareTeamMutationVariables>;

/**
 * __useDeletePatientCareTeamMutation__
 *
 * To run a mutation, you first call `useDeletePatientCareTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePatientCareTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePatientCareTeamMutation, { data, loading, error }] = useDeletePatientCareTeamMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      providerTypeId: // value for 'providerTypeId'
 *   },
 * });
 */
export function useDeletePatientCareTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeletePatientCareTeamMutation, DeletePatientCareTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePatientCareTeamMutation, DeletePatientCareTeamMutationVariables>(DeletePatientCareTeamDocument, options);
      }
export type DeletePatientCareTeamMutationHookResult = ReturnType<typeof useDeletePatientCareTeamMutation>;
export type DeletePatientCareTeamMutationOptions = Apollo.BaseMutationOptions<DeletePatientCareTeamMutation, DeletePatientCareTeamMutationVariables>;
export const SearchPatientsDocument = gql`
    query SearchPatients($searchTerm: String, $limit: Int, $offset: Int) @permission(requires: useWebApp) {
  searchPatient(searchTerm: $searchTerm, limit: $limit, offset: $offset) {
    patient {
      id
      firstName
      lastName
      phone
      dateOfBirth
      sex
    }
    bestEpisode {
      active
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useSearchPatientsQuery__
 *
 * To run a query within a React component, call `useSearchPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPatientsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchPatientsQuery(baseOptions?: Apollo.QueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPatientsQuery, SearchPatientsQueryVariables>(SearchPatientsDocument, options);
      }
export function useSearchPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPatientsQuery, SearchPatientsQueryVariables>(SearchPatientsDocument, options);
        }
// @ts-ignore
export function useSearchPatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchPatientsQuery, SearchPatientsQueryVariables>;
export function useSearchPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchPatientsQuery | undefined, SearchPatientsQueryVariables>;
export function useSearchPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPatientsQuery, SearchPatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPatientsQuery, SearchPatientsQueryVariables>(SearchPatientsDocument, options);
        }
export type SearchPatientsQueryHookResult = ReturnType<typeof useSearchPatientsQuery>;
export type SearchPatientsLazyQueryHookResult = ReturnType<typeof useSearchPatientsLazyQuery>;
export type SearchPatientsSuspenseQueryHookResult = ReturnType<typeof useSearchPatientsSuspenseQuery>;
export const GenerateVisitsWarningsDocument = gql`
    mutation GenerateVisitsWarnings($patientId: Int!, $serviceLineId: Int!, $visitTypeId: Int!, $resources: [VisitResourceWithRequirement]!, $reschedulingVisitId: Int) @permission(requires: createOverrideVisits, check: [userInServiceLine]) {
  generateVisitWarnings(
    patientId: $patientId
    serviceLineId: $serviceLineId
    visitTypeId: $visitTypeId
    resources: $resources
    reschedulingVisitId: $reschedulingVisitId
  ) {
    visitWarningLogId
    visitWarnings {
      visitId
      severity
      resourceRequirementProviderTypes {
        expectedProviderTypes
        actualProviderIds
        extraProviderIds
      }
      teamMismatch
    }
    visitResourceWarnings {
      visitId
      providerId
      severity
      shiftMissing
      duration {
        expectedDurationInMinutes
        actualDurationInMinutes
      }
      previousVisitDriveTimeOverlap
      nextVisitDriveTimeOverlap
      startOfShiftDriveTimeOverlap
      endOfShiftDriveTimeOverlap
      gapCreatedBeforeVisit
      gapCreatedAfterVisit
      excessiveDriveTimeBeforeVisit
      excessiveDriveTimeAfterVisit
      previousBlocker {
        type
        label
      }
      nextBlocker {
        type
        label
      }
    }
  }
}
    `;
export type GenerateVisitsWarningsMutationFn = Apollo.MutationFunction<GenerateVisitsWarningsMutation, GenerateVisitsWarningsMutationVariables>;

/**
 * __useGenerateVisitsWarningsMutation__
 *
 * To run a mutation, you first call `useGenerateVisitsWarningsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateVisitsWarningsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateVisitsWarningsMutation, { data, loading, error }] = useGenerateVisitsWarningsMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      serviceLineId: // value for 'serviceLineId'
 *      visitTypeId: // value for 'visitTypeId'
 *      resources: // value for 'resources'
 *      reschedulingVisitId: // value for 'reschedulingVisitId'
 *   },
 * });
 */
export function useGenerateVisitsWarningsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateVisitsWarningsMutation, GenerateVisitsWarningsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateVisitsWarningsMutation, GenerateVisitsWarningsMutationVariables>(GenerateVisitsWarningsDocument, options);
      }
export type GenerateVisitsWarningsMutationHookResult = ReturnType<typeof useGenerateVisitsWarningsMutation>;
export type GenerateVisitsWarningsMutationOptions = Apollo.BaseMutationOptions<GenerateVisitsWarningsMutation, GenerateVisitsWarningsMutationVariables>;
export const GetPatientInstructionsDocument = gql`
    query GetPatientInstructions($patientId: Int!) @permission(requires: scheduleVisits) {
  patientSingle(where: {id: {eq: $patientId}}) {
    id
    addressTimezone
    addressState
    serviceInstructions
    episodes {
      id
      active
      serviceLineId
      organizationalUnitId
    }
    careTeamProviders {
      id
      providerId
      providerTypeId
      provider {
        providerTypeId
      }
    }
  }
  organizationalUnit(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    active
  }
}
    `;

/**
 * __useGetPatientInstructionsQuery__
 *
 * To run a query within a React component, call `useGetPatientInstructionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientInstructionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientInstructionsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetPatientInstructionsQuery(baseOptions: Apollo.QueryHookOptions<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables> & ({ variables: GetPatientInstructionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables>(GetPatientInstructionsDocument, options);
      }
export function useGetPatientInstructionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables>(GetPatientInstructionsDocument, options);
        }
// @ts-ignore
export function useGetPatientInstructionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables>;
export function useGetPatientInstructionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientInstructionsQuery | undefined, GetPatientInstructionsQueryVariables>;
export function useGetPatientInstructionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientInstructionsQuery, GetPatientInstructionsQueryVariables>(GetPatientInstructionsDocument, options);
        }
export type GetPatientInstructionsQueryHookResult = ReturnType<typeof useGetPatientInstructionsQuery>;
export type GetPatientInstructionsLazyQueryHookResult = ReturnType<typeof useGetPatientInstructionsLazyQuery>;
export type GetPatientInstructionsSuspenseQueryHookResult = ReturnType<typeof useGetPatientInstructionsSuspenseQuery>;
export const CreateVisitRequestDocument = gql`
    mutation CreateVisitRequest($patientId: Int!, $serviceLineId: Int!, $visitTypeId: Int!, $duration: Int!, $serviceInstructions: String, $serviceIds: [Int], $constraints: Constraints) @permission(requires: createDragEvents, check: [userInServiceLine]) {
  createVisitRequest(
    patientId: $patientId
    serviceLineId: $serviceLineId
    visitTypeId: $visitTypeId
    duration: $duration
    serviceInstructions: $serviceInstructions
    serviceIds: $serviceIds
    constraints: $constraints
  ) {
    id
  }
}
    `;
export type CreateVisitRequestMutationFn = Apollo.MutationFunction<CreateVisitRequestMutation, CreateVisitRequestMutationVariables>;

/**
 * __useCreateVisitRequestMutation__
 *
 * To run a mutation, you first call `useCreateVisitRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitRequestMutation, { data, loading, error }] = useCreateVisitRequestMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      serviceLineId: // value for 'serviceLineId'
 *      visitTypeId: // value for 'visitTypeId'
 *      duration: // value for 'duration'
 *      serviceInstructions: // value for 'serviceInstructions'
 *      serviceIds: // value for 'serviceIds'
 *      constraints: // value for 'constraints'
 *   },
 * });
 */
export function useCreateVisitRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitRequestMutation, CreateVisitRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitRequestMutation, CreateVisitRequestMutationVariables>(CreateVisitRequestDocument, options);
      }
export type CreateVisitRequestMutationHookResult = ReturnType<typeof useCreateVisitRequestMutation>;
export type CreateVisitRequestMutationOptions = Apollo.BaseMutationOptions<CreateVisitRequestMutation, CreateVisitRequestMutationVariables>;
export const OverrideVisitUnitProvidersDocument = gql`
    query OverrideVisitUnitProviders($organizationalUnitId: Int!) @permission(requires: createOverrideVisits) {
  organizationalUnitOrgUser(
    where: {organizationalUnitId: {eq: $organizationalUnitId}}
  ) {
    orgUser {
      providers {
        id
      }
    }
  }
}
    `;

/**
 * __useOverrideVisitUnitProvidersQuery__
 *
 * To run a query within a React component, call `useOverrideVisitUnitProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverrideVisitUnitProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverrideVisitUnitProvidersQuery({
 *   variables: {
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *   },
 * });
 */
export function useOverrideVisitUnitProvidersQuery(baseOptions: Apollo.QueryHookOptions<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables> & ({ variables: OverrideVisitUnitProvidersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables>(OverrideVisitUnitProvidersDocument, options);
      }
export function useOverrideVisitUnitProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables>(OverrideVisitUnitProvidersDocument, options);
        }
// @ts-ignore
export function useOverrideVisitUnitProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables>;
export function useOverrideVisitUnitProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<OverrideVisitUnitProvidersQuery | undefined, OverrideVisitUnitProvidersQueryVariables>;
export function useOverrideVisitUnitProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OverrideVisitUnitProvidersQuery, OverrideVisitUnitProvidersQueryVariables>(OverrideVisitUnitProvidersDocument, options);
        }
export type OverrideVisitUnitProvidersQueryHookResult = ReturnType<typeof useOverrideVisitUnitProvidersQuery>;
export type OverrideVisitUnitProvidersLazyQueryHookResult = ReturnType<typeof useOverrideVisitUnitProvidersLazyQuery>;
export type OverrideVisitUnitProvidersSuspenseQueryHookResult = ReturnType<typeof useOverrideVisitUnitProvidersSuspenseQuery>;
export const EpisodeOrganizationalUnitsDocument = gql`
    query EpisodeOrganizationalUnits @permission(requires: managePatients) {
  organizationalUnit(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    active
  }
}
    `;

/**
 * __useEpisodeOrganizationalUnitsQuery__
 *
 * To run a query within a React component, call `useEpisodeOrganizationalUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodeOrganizationalUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodeOrganizationalUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEpisodeOrganizationalUnitsQuery(baseOptions?: Apollo.QueryHookOptions<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>(EpisodeOrganizationalUnitsDocument, options);
      }
export function useEpisodeOrganizationalUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>(EpisodeOrganizationalUnitsDocument, options);
        }
// @ts-ignore
export function useEpisodeOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>;
export function useEpisodeOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<EpisodeOrganizationalUnitsQuery | undefined, EpisodeOrganizationalUnitsQueryVariables>;
export function useEpisodeOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EpisodeOrganizationalUnitsQuery, EpisodeOrganizationalUnitsQueryVariables>(EpisodeOrganizationalUnitsDocument, options);
        }
export type EpisodeOrganizationalUnitsQueryHookResult = ReturnType<typeof useEpisodeOrganizationalUnitsQuery>;
export type EpisodeOrganizationalUnitsLazyQueryHookResult = ReturnType<typeof useEpisodeOrganizationalUnitsLazyQuery>;
export type EpisodeOrganizationalUnitsSuspenseQueryHookResult = ReturnType<typeof useEpisodeOrganizationalUnitsSuspenseQuery>;
export const SchedulerOptionsDocument = gql`
    query SchedulerOptions($patientId: Int!, $startTime: String!, $targetTime: String!, $endTime: String!, $serviceLineId: Int!, $organizationalUnitId: Int, $visitTypeId: Int!, $duration: Int!, $serviceIds: [Int!]!, $providerTraits: [ProvideTraitQueryInput]!, $daysOfWeek: [Int], $hoursOfDay: HoursOfDayQueryInput, $reschedulingVisitId: Int, $selectedProviderIds: [Int!], $useOverflowShifts: Boolean) @permission(requires: scheduleVisits, check: [userInServiceLine]) {
  scheduleOption(
    patientId: $patientId
    startTime: $startTime
    targetTime: $targetTime
    endTime: $endTime
    serviceLineId: $serviceLineId
    organizationalUnitId: $organizationalUnitId
    visitTypeId: $visitTypeId
    duration: $duration
    serviceIds: $serviceIds
    providerTraits: $providerTraits
    daysOfWeek: $daysOfWeek
    hoursOfDay: $hoursOfDay
    reschedulingVisitId: $reschedulingVisitId
    selectedProviderIds: $selectedProviderIds
    useOverflowShifts: $useOverflowShifts
  ) {
    options {
      startTime
      endTime
      arrivalWindowEnd
      arrivalWindowStart
      rankCategory
      originDrive
      destinationDrive
      driveForScoring
      contiguous
      resources {
        startTime
        endTime
        inHome
        providerId
        shiftId
        raceConditionHash
        preferred
      }
      scores {
        totalScore
        driveScore
        proximityScore
        utilizationScore
      }
      runId
    }
    providers {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useSchedulerOptionsQuery__
 *
 * To run a query within a React component, call `useSchedulerOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerOptionsQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      startTime: // value for 'startTime'
 *      targetTime: // value for 'targetTime'
 *      endTime: // value for 'endTime'
 *      serviceLineId: // value for 'serviceLineId'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      visitTypeId: // value for 'visitTypeId'
 *      duration: // value for 'duration'
 *      serviceIds: // value for 'serviceIds'
 *      providerTraits: // value for 'providerTraits'
 *      daysOfWeek: // value for 'daysOfWeek'
 *      hoursOfDay: // value for 'hoursOfDay'
 *      reschedulingVisitId: // value for 'reschedulingVisitId'
 *      selectedProviderIds: // value for 'selectedProviderIds'
 *      useOverflowShifts: // value for 'useOverflowShifts'
 *   },
 * });
 */
export function useSchedulerOptionsQuery(baseOptions: Apollo.QueryHookOptions<SchedulerOptionsQuery, SchedulerOptionsQueryVariables> & ({ variables: SchedulerOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulerOptionsQuery, SchedulerOptionsQueryVariables>(SchedulerOptionsDocument, options);
      }
export function useSchedulerOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulerOptionsQuery, SchedulerOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulerOptionsQuery, SchedulerOptionsQueryVariables>(SchedulerOptionsDocument, options);
        }
// @ts-ignore
export function useSchedulerOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulerOptionsQuery, SchedulerOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerOptionsQuery, SchedulerOptionsQueryVariables>;
export function useSchedulerOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerOptionsQuery, SchedulerOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerOptionsQuery | undefined, SchedulerOptionsQueryVariables>;
export function useSchedulerOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerOptionsQuery, SchedulerOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulerOptionsQuery, SchedulerOptionsQueryVariables>(SchedulerOptionsDocument, options);
        }
export type SchedulerOptionsQueryHookResult = ReturnType<typeof useSchedulerOptionsQuery>;
export type SchedulerOptionsLazyQueryHookResult = ReturnType<typeof useSchedulerOptionsLazyQuery>;
export type SchedulerOptionsSuspenseQueryHookResult = ReturnType<typeof useSchedulerOptionsSuspenseQuery>;
export const SchedulerProvidersListDocument = gql`
    query SchedulerProvidersList($patientId: Int!, $startTime: String!, $endTime: String!, $serviceLineId: Int!, $organizationalUnitId: Int, $visitTypeId: Int!) @permission(requires: scheduleVisits, check: [userInServiceLine]) {
  scheduleProvidersList(
    patientId: $patientId
    startTime: $startTime
    endTime: $endTime
    serviceLineId: $serviceLineId
    organizationalUnitId: $organizationalUnitId
    visitTypeId: $visitTypeId
  ) {
    id
    firstName
    lastName
    preferred
    providerTypeId
    hasProviderType
    hasServiceLine
    hasStateLicense
    hasNearbyShifts
    hasVirtualShifts
    hasInHomeShifts
    hasNonOverflowShifts
  }
}
    `;

/**
 * __useSchedulerProvidersListQuery__
 *
 * To run a query within a React component, call `useSchedulerProvidersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerProvidersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerProvidersListQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      serviceLineId: // value for 'serviceLineId'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      visitTypeId: // value for 'visitTypeId'
 *   },
 * });
 */
export function useSchedulerProvidersListQuery(baseOptions: Apollo.QueryHookOptions<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables> & ({ variables: SchedulerProvidersListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables>(SchedulerProvidersListDocument, options);
      }
export function useSchedulerProvidersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables>(SchedulerProvidersListDocument, options);
        }
// @ts-ignore
export function useSchedulerProvidersListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables>;
export function useSchedulerProvidersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerProvidersListQuery | undefined, SchedulerProvidersListQueryVariables>;
export function useSchedulerProvidersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulerProvidersListQuery, SchedulerProvidersListQueryVariables>(SchedulerProvidersListDocument, options);
        }
export type SchedulerProvidersListQueryHookResult = ReturnType<typeof useSchedulerProvidersListQuery>;
export type SchedulerProvidersListLazyQueryHookResult = ReturnType<typeof useSchedulerProvidersListLazyQuery>;
export type SchedulerProvidersListSuspenseQueryHookResult = ReturnType<typeof useSchedulerProvidersListSuspenseQuery>;
export const ScheduleVisitDocument = gql`
    mutation ScheduleVisit($patientId: Int!, $startTime: String!, $visitTypeId: Int!, $duration: Int!, $resources: [NewVisitResourceInput!]!, $serviceIds: [Int!]!, $serviceInstructions: String, $note: String, $runId: String!, $reschedulingVisitId: Int, $serviceLineId: Int!, $organizationalUnitId: Int, $chosenOptionIndex: Int) @permission(requires: scheduleVisits, check: [userInServiceLine]) {
  scheduleVisit(
    patientId: $patientId
    startTime: $startTime
    visitTypeId: $visitTypeId
    duration: $duration
    resources: $resources
    serviceIds: $serviceIds
    serviceInstructions: $serviceInstructions
    note: $note
    runId: $runId
    reschedulingVisitId: $reschedulingVisitId
    serviceLineId: $serviceLineId
    organizationalUnitId: $organizationalUnitId
    chosenOptionIndex: $chosenOptionIndex
  ) {
    id
    startTime
    endTime
    arrivalWindowStartTime
    arrivalWindowEndTime
    serviceInstructions
    patient {
      id
      serviceInstructions
    }
  }
}
    `;
export type ScheduleVisitMutationFn = Apollo.MutationFunction<ScheduleVisitMutation, ScheduleVisitMutationVariables>;

/**
 * __useScheduleVisitMutation__
 *
 * To run a mutation, you first call `useScheduleVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleVisitMutation, { data, loading, error }] = useScheduleVisitMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      startTime: // value for 'startTime'
 *      visitTypeId: // value for 'visitTypeId'
 *      duration: // value for 'duration'
 *      resources: // value for 'resources'
 *      serviceIds: // value for 'serviceIds'
 *      serviceInstructions: // value for 'serviceInstructions'
 *      note: // value for 'note'
 *      runId: // value for 'runId'
 *      reschedulingVisitId: // value for 'reschedulingVisitId'
 *      serviceLineId: // value for 'serviceLineId'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      chosenOptionIndex: // value for 'chosenOptionIndex'
 *   },
 * });
 */
export function useScheduleVisitMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleVisitMutation, ScheduleVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleVisitMutation, ScheduleVisitMutationVariables>(ScheduleVisitDocument, options);
      }
export type ScheduleVisitMutationHookResult = ReturnType<typeof useScheduleVisitMutation>;
export type ScheduleVisitMutationOptions = Apollo.BaseMutationOptions<ScheduleVisitMutation, ScheduleVisitMutationVariables>;
export const SchedulerOrganizationalUnitsDocument = gql`
    query SchedulerOrganizationalUnits($organizationUserId: Int!) @permission(requires: scheduleVisits) {
  organizationalUnit(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    active
  }
  organizationalUnitOrgUser(
    where: {organizationUserId: {eq: $organizationUserId}}
  ) {
    organizationalUnit {
      id
      name
      active
    }
  }
}
    `;

/**
 * __useSchedulerOrganizationalUnitsQuery__
 *
 * To run a query within a React component, call `useSchedulerOrganizationalUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerOrganizationalUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerOrganizationalUnitsQuery({
 *   variables: {
 *      organizationUserId: // value for 'organizationUserId'
 *   },
 * });
 */
export function useSchedulerOrganizationalUnitsQuery(baseOptions: Apollo.QueryHookOptions<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables> & ({ variables: SchedulerOrganizationalUnitsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables>(SchedulerOrganizationalUnitsDocument, options);
      }
export function useSchedulerOrganizationalUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables>(SchedulerOrganizationalUnitsDocument, options);
        }
// @ts-ignore
export function useSchedulerOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables>;
export function useSchedulerOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerOrganizationalUnitsQuery | undefined, SchedulerOrganizationalUnitsQueryVariables>;
export function useSchedulerOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulerOrganizationalUnitsQuery, SchedulerOrganizationalUnitsQueryVariables>(SchedulerOrganizationalUnitsDocument, options);
        }
export type SchedulerOrganizationalUnitsQueryHookResult = ReturnType<typeof useSchedulerOrganizationalUnitsQuery>;
export type SchedulerOrganizationalUnitsLazyQueryHookResult = ReturnType<typeof useSchedulerOrganizationalUnitsLazyQuery>;
export type SchedulerOrganizationalUnitsSuspenseQueryHookResult = ReturnType<typeof useSchedulerOrganizationalUnitsSuspenseQuery>;
export const ScheduleOverrideVisitDocument = gql`
    mutation ScheduleOverrideVisit($patientId: Int!, $serviceLineId: Int!, $organizationalUnitId: Int, $visitTypeId: Int!, $startTime: String!, $resources: [NewOverrideVisitResourceInput!]!, $serviceIds: [Int!]!, $duration: Int!, $visitWarningLogId: Int!, $reschedulingVisitId: Int, $serviceInstructions: String, $note: String) @permission(requires: createOverrideVisits, check: [userInServiceLine]) {
  scheduleOverrideVisit(
    patientId: $patientId
    serviceLineId: $serviceLineId
    organizationalUnitId: $organizationalUnitId
    visitTypeId: $visitTypeId
    startTime: $startTime
    resources: $resources
    serviceIds: $serviceIds
    duration: $duration
    visitWarningLogId: $visitWarningLogId
    reschedulingVisitId: $reschedulingVisitId
    serviceInstructions: $serviceInstructions
    note: $note
  ) {
    id
  }
}
    `;
export type ScheduleOverrideVisitMutationFn = Apollo.MutationFunction<ScheduleOverrideVisitMutation, ScheduleOverrideVisitMutationVariables>;

/**
 * __useScheduleOverrideVisitMutation__
 *
 * To run a mutation, you first call `useScheduleOverrideVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleOverrideVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleOverrideVisitMutation, { data, loading, error }] = useScheduleOverrideVisitMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      serviceLineId: // value for 'serviceLineId'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      visitTypeId: // value for 'visitTypeId'
 *      startTime: // value for 'startTime'
 *      resources: // value for 'resources'
 *      serviceIds: // value for 'serviceIds'
 *      duration: // value for 'duration'
 *      visitWarningLogId: // value for 'visitWarningLogId'
 *      reschedulingVisitId: // value for 'reschedulingVisitId'
 *      serviceInstructions: // value for 'serviceInstructions'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useScheduleOverrideVisitMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleOverrideVisitMutation, ScheduleOverrideVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleOverrideVisitMutation, ScheduleOverrideVisitMutationVariables>(ScheduleOverrideVisitDocument, options);
      }
export type ScheduleOverrideVisitMutationHookResult = ReturnType<typeof useScheduleOverrideVisitMutation>;
export type ScheduleOverrideVisitMutationOptions = Apollo.BaseMutationOptions<ScheduleOverrideVisitMutation, ScheduleOverrideVisitMutationVariables>;
export const UpsertUserDocument = gql`
    mutation upsertUser($currentId: Int, $currentEmail: String, $userDetails: UpsertUserDetails!) @permission(requires: manageUsers) {
  upsertUser(
    currentId: $currentId
    currentEmail: $currentEmail
    userDetails: $userDetails
  ) {
    id
  }
}
    `;
export type UpsertUserMutationFn = Apollo.MutationFunction<UpsertUserMutation, UpsertUserMutationVariables>;

/**
 * __useUpsertUserMutation__
 *
 * To run a mutation, you first call `useUpsertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserMutation, { data, loading, error }] = useUpsertUserMutation({
 *   variables: {
 *      currentId: // value for 'currentId'
 *      currentEmail: // value for 'currentEmail'
 *      userDetails: // value for 'userDetails'
 *   },
 * });
 */
export function useUpsertUserMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserMutation, UpsertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserMutation, UpsertUserMutationVariables>(UpsertUserDocument, options);
      }
export type UpsertUserMutationHookResult = ReturnType<typeof useUpsertUserMutation>;
export type UpsertUserMutationOptions = Apollo.BaseMutationOptions<UpsertUserMutation, UpsertUserMutationVariables>;
export const ReactivateProviderDocument = gql`
    mutation ReactivateProvider($providerId: Int!) @permission(requires: manageUsers) {
  reactivateProvider(providerId: $providerId) {
    id
  }
}
    `;
export type ReactivateProviderMutationFn = Apollo.MutationFunction<ReactivateProviderMutation, ReactivateProviderMutationVariables>;

/**
 * __useReactivateProviderMutation__
 *
 * To run a mutation, you first call `useReactivateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateProviderMutation, { data, loading, error }] = useReactivateProviderMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useReactivateProviderMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateProviderMutation, ReactivateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateProviderMutation, ReactivateProviderMutationVariables>(ReactivateProviderDocument, options);
      }
export type ReactivateProviderMutationHookResult = ReturnType<typeof useReactivateProviderMutation>;
export type ReactivateProviderMutationOptions = Apollo.BaseMutationOptions<ReactivateProviderMutation, ReactivateProviderMutationVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($searchTerm: String, $limit: Int, $offset: Int, $hideSystemAccounts: Boolean) @permission(requires: manageUsers) {
  searchUser(
    searchTerm: $searchTerm
    limit: $limit
    offset: $offset
    hideSystemAccounts: $hideSystemAccounts
  ) {
    id
    email
    firstName
    lastName
    roles
    active
    providerType
    providerFirstName
    providerLastName
  }
}
    `;

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      hideSystemAccounts: // value for 'hideSystemAccounts'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
// @ts-ignore
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUsersQuery | undefined, SearchUsersQueryVariables>;
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export const HomeHealthDemoHorizonDocument = gql`
    query HomeHealthDemoHorizon($start: String, $end: String) @permission(requires: useWebApp) {
  shift(
    where: {OR: [{startTime: {gte: $start, lt: $end}}, {endTime: {gte: $start, lt: $end}}]}
  ) {
    id
    status
    startTime
    endTime
    providerId
    overflowShift
    shiftCenterId
    useShiftCenterDriveTimes
    addressZip
    shiftCenter {
      id
      name
      addressZip
    }
    provider {
      id
      addressZip
    }
  }
  calendarBlock(where: {startTime: {gte: $start, lt: $end}}) {
    id
    title
    startTime
    endTime
    eventStatus
    providerId
    blockType
    filters {
      visitTypeIds
    }
  }
  visitResource(where: {startTime: {gte: $start, lt: $end}}) {
    id
    visitId
    providerId
    startTime
    endTime
    startOfShiftDriveTime
    interVisitDriveTime
    endOfShiftDriveTime
    visit {
      id
      startTime
      endTime
      eventStatus
      visitTypeId
      addressZip
      arrivalWindowStartTime
      arrivalWindowEndTime
      visitType {
        id
        name
      }
      patient {
        id
        firstName
        lastName
        addressZip
      }
    }
  }
  patient {
    id
    firstName
    lastName
    addressZip
    patientIdentifiers {
      identifier
      identifier_type
    }
  }
  episode(where: {active: {eq: true}}) {
    id
    patientId
    active
  }
  visitCancellationReason(where: {active: {eq: true}}) {
    id
    description
  }
  service(where: {name: {eq: "Demo day"}}) {
    id
    name
    description
  }
  commandIndexProviders(where: {active: {eq: true}}) {
    providers {
      id
      firstName
      lastName
      addressZip
      active
      providerType {
        id
        name
      }
      OrganizationUser {
        user {
          email
        }
      }
    }
  }
}
    `;

/**
 * __useHomeHealthDemoHorizonQuery__
 *
 * To run a query within a React component, call `useHomeHealthDemoHorizonQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeHealthDemoHorizonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeHealthDemoHorizonQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useHomeHealthDemoHorizonQuery(baseOptions?: Apollo.QueryHookOptions<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>(HomeHealthDemoHorizonDocument, options);
      }
export function useHomeHealthDemoHorizonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>(HomeHealthDemoHorizonDocument, options);
        }
// @ts-ignore
export function useHomeHealthDemoHorizonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>): Apollo.UseSuspenseQueryResult<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>;
export function useHomeHealthDemoHorizonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>): Apollo.UseSuspenseQueryResult<HomeHealthDemoHorizonQuery | undefined, HomeHealthDemoHorizonQueryVariables>;
export function useHomeHealthDemoHorizonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeHealthDemoHorizonQuery, HomeHealthDemoHorizonQueryVariables>(HomeHealthDemoHorizonDocument, options);
        }
export type HomeHealthDemoHorizonQueryHookResult = ReturnType<typeof useHomeHealthDemoHorizonQuery>;
export type HomeHealthDemoHorizonLazyQueryHookResult = ReturnType<typeof useHomeHealthDemoHorizonLazyQuery>;
export type HomeHealthDemoHorizonSuspenseQueryHookResult = ReturnType<typeof useHomeHealthDemoHorizonSuspenseQuery>;
export const HomeHealthDemoLastResetDocument = gql`
    query HomeHealthDemoLastReset($markerId: Int!) @permission(requires: copyDemoData) {
  service(where: {id: {eq: $markerId}}) {
    id
    createdAt
    createdBy
  }
  organizationUser {
    userId
    user {
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useHomeHealthDemoLastResetQuery__
 *
 * To run a query within a React component, call `useHomeHealthDemoLastResetQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeHealthDemoLastResetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeHealthDemoLastResetQuery({
 *   variables: {
 *      markerId: // value for 'markerId'
 *   },
 * });
 */
export function useHomeHealthDemoLastResetQuery(baseOptions: Apollo.QueryHookOptions<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables> & ({ variables: HomeHealthDemoLastResetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables>(HomeHealthDemoLastResetDocument, options);
      }
export function useHomeHealthDemoLastResetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables>(HomeHealthDemoLastResetDocument, options);
        }
// @ts-ignore
export function useHomeHealthDemoLastResetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables>): Apollo.UseSuspenseQueryResult<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables>;
export function useHomeHealthDemoLastResetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables>): Apollo.UseSuspenseQueryResult<HomeHealthDemoLastResetQuery | undefined, HomeHealthDemoLastResetQueryVariables>;
export function useHomeHealthDemoLastResetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomeHealthDemoLastResetQuery, HomeHealthDemoLastResetQueryVariables>(HomeHealthDemoLastResetDocument, options);
        }
export type HomeHealthDemoLastResetQueryHookResult = ReturnType<typeof useHomeHealthDemoLastResetQuery>;
export type HomeHealthDemoLastResetLazyQueryHookResult = ReturnType<typeof useHomeHealthDemoLastResetLazyQuery>;
export type HomeHealthDemoLastResetSuspenseQueryHookResult = ReturnType<typeof useHomeHealthDemoLastResetSuspenseQuery>;
export const HomeHealthDemoScheduleOverrideVisitDocument = gql`
    mutation HomeHealthDemoScheduleOverrideVisit($patientId: Int!, $serviceLineId: Int!, $organizationalUnitId: Int, $visitTypeId: Int!, $startTime: String!, $resources: [NewOverrideVisitResourceInput!]!, $serviceIds: [Int!]!, $duration: Int!, $reschedulingVisitId: Int, $serviceInstructions: String, $note: String) @permission(requires: createOverrideVisits, check: [userInServiceLine]) {
  scheduleOverrideVisit(
    patientId: $patientId
    serviceLineId: $serviceLineId
    organizationalUnitId: $organizationalUnitId
    visitTypeId: $visitTypeId
    startTime: $startTime
    resources: $resources
    serviceIds: $serviceIds
    duration: $duration
    reschedulingVisitId: $reschedulingVisitId
    serviceInstructions: $serviceInstructions
    note: $note
  ) {
    id
    startTime
    endTime
  }
}
    `;
export type HomeHealthDemoScheduleOverrideVisitMutationFn = Apollo.MutationFunction<HomeHealthDemoScheduleOverrideVisitMutation, HomeHealthDemoScheduleOverrideVisitMutationVariables>;

/**
 * __useHomeHealthDemoScheduleOverrideVisitMutation__
 *
 * To run a mutation, you first call `useHomeHealthDemoScheduleOverrideVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeHealthDemoScheduleOverrideVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeHealthDemoScheduleOverrideVisitMutation, { data, loading, error }] = useHomeHealthDemoScheduleOverrideVisitMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      serviceLineId: // value for 'serviceLineId'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      visitTypeId: // value for 'visitTypeId'
 *      startTime: // value for 'startTime'
 *      resources: // value for 'resources'
 *      serviceIds: // value for 'serviceIds'
 *      duration: // value for 'duration'
 *      reschedulingVisitId: // value for 'reschedulingVisitId'
 *      serviceInstructions: // value for 'serviceInstructions'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useHomeHealthDemoScheduleOverrideVisitMutation(baseOptions?: Apollo.MutationHookOptions<HomeHealthDemoScheduleOverrideVisitMutation, HomeHealthDemoScheduleOverrideVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HomeHealthDemoScheduleOverrideVisitMutation, HomeHealthDemoScheduleOverrideVisitMutationVariables>(HomeHealthDemoScheduleOverrideVisitDocument, options);
      }
export type HomeHealthDemoScheduleOverrideVisitMutationHookResult = ReturnType<typeof useHomeHealthDemoScheduleOverrideVisitMutation>;
export type HomeHealthDemoScheduleOverrideVisitMutationOptions = Apollo.BaseMutationOptions<HomeHealthDemoScheduleOverrideVisitMutation, HomeHealthDemoScheduleOverrideVisitMutationVariables>;
export const HomeHealthDemoResetDocument = gql`
    mutation HomeHealthDemoReset($demoDate: String!, $asOf: String!, $phone: String!) @permission(requires: copyDemoData) {
  resetHomeHealthDemo(demoDate: $demoDate, asOf: $asOf, phone: $phone) {
    demoDate
    files
    statements
  }
}
    `;
export type HomeHealthDemoResetMutationFn = Apollo.MutationFunction<HomeHealthDemoResetMutation, HomeHealthDemoResetMutationVariables>;

/**
 * __useHomeHealthDemoResetMutation__
 *
 * To run a mutation, you first call `useHomeHealthDemoResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHomeHealthDemoResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [homeHealthDemoResetMutation, { data, loading, error }] = useHomeHealthDemoResetMutation({
 *   variables: {
 *      demoDate: // value for 'demoDate'
 *      asOf: // value for 'asOf'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useHomeHealthDemoResetMutation(baseOptions?: Apollo.MutationHookOptions<HomeHealthDemoResetMutation, HomeHealthDemoResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HomeHealthDemoResetMutation, HomeHealthDemoResetMutationVariables>(HomeHealthDemoResetDocument, options);
      }
export type HomeHealthDemoResetMutationHookResult = ReturnType<typeof useHomeHealthDemoResetMutation>;
export type HomeHealthDemoResetMutationOptions = Apollo.BaseMutationOptions<HomeHealthDemoResetMutation, HomeHealthDemoResetMutationVariables>;
export const CreateAvailabilityDocument = gql`
    mutation CreateAvailability($providerId: Int!, $additionalProviderIds: [Int!], $tzHandling: AvailTZHandling!, $type: AvailabilityTypeEnum!, $note: String!, $startTime: String!, $endTime: String!, $providerTravel: AvailabilityProviderTravelEnum, $shiftCenterId: Int, $overflowShift: Boolean!, $useShiftCenterDriveTimes: Boolean!, $rruleFreq: AvailabilityRruleFreqEnum!, $rruleDtstart: String!, $rruleInterval: Int, $rruleByweekday: String, $rruleUntil: String) @permission(requires: manageProviderShifts) {
  createAvailability(
    providerId: $providerId
    additionalProviderIds: $additionalProviderIds
    tzHandling: $tzHandling
    type: $type
    note: $note
    startTime: $startTime
    endTime: $endTime
    providerTravel: $providerTravel
    shiftCenterId: $shiftCenterId
    overflowShift: $overflowShift
    useShiftCenterDriveTimes: $useShiftCenterDriveTimes
    rruleFreq: $rruleFreq
    rruleDtstart: $rruleDtstart
    rruleInterval: $rruleInterval
    rruleByweekday: $rruleByweekday
    rruleUntil: $rruleUntil
  ) {
    id
  }
}
    `;
export type CreateAvailabilityMutationFn = Apollo.MutationFunction<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>;

/**
 * __useCreateAvailabilityMutation__
 *
 * To run a mutation, you first call `useCreateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAvailabilityMutation, { data, loading, error }] = useCreateAvailabilityMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      additionalProviderIds: // value for 'additionalProviderIds'
 *      tzHandling: // value for 'tzHandling'
 *      type: // value for 'type'
 *      note: // value for 'note'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      providerTravel: // value for 'providerTravel'
 *      shiftCenterId: // value for 'shiftCenterId'
 *      overflowShift: // value for 'overflowShift'
 *      useShiftCenterDriveTimes: // value for 'useShiftCenterDriveTimes'
 *      rruleFreq: // value for 'rruleFreq'
 *      rruleDtstart: // value for 'rruleDtstart'
 *      rruleInterval: // value for 'rruleInterval'
 *      rruleByweekday: // value for 'rruleByweekday'
 *      rruleUntil: // value for 'rruleUntil'
 *   },
 * });
 */
export function useCreateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>(CreateAvailabilityDocument, options);
      }
export type CreateAvailabilityMutationHookResult = ReturnType<typeof useCreateAvailabilityMutation>;
export type CreateAvailabilityMutationOptions = Apollo.BaseMutationOptions<CreateAvailabilityMutation, CreateAvailabilityMutationVariables>;
export const UpdateAvailabilityDocument = gql`
    mutation UpdateAvailability($id: Int!, $additionalIds: [Int!], $providerId: Int!, $note: String!, $startTime: String!, $endTime: String!, $providerTravel: AvailabilityProviderTravelEnum, $shiftCenterId: Int, $tzHandling: AvailTZHandling!, $overflowShift: Boolean!, $useShiftCenterDriveTimes: Boolean!, $rruleFreq: AvailabilityRruleFreqEnum!, $rruleDtstart: String!, $rruleInterval: Int, $rruleByweekday: String, $rruleUntil: String) @permission(requires: manageProviderShifts) {
  updateAvailability(
    id: $id
    additionalIds: $additionalIds
    tzHandling: $tzHandling
    providerId: $providerId
    note: $note
    providerTravel: $providerTravel
    shiftCenterId: $shiftCenterId
    overflowShift: $overflowShift
    useShiftCenterDriveTimes: $useShiftCenterDriveTimes
    startTime: $startTime
    endTime: $endTime
    rruleFreq: $rruleFreq
    rruleDtstart: $rruleDtstart
    rruleInterval: $rruleInterval
    rruleByweekday: $rruleByweekday
    rruleUntil: $rruleUntil
  ) {
    id
    type
    note
    providerTravel
    shiftCenterId
    overflowShift
    useShiftCenterDriveTimes
    startTime
    endTime
    rruleFreq
    rruleDtstart
    rruleInterval
    rruleByweekday
    rruleUntil
  }
}
    `;
export type UpdateAvailabilityMutationFn = Apollo.MutationFunction<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;

/**
 * __useUpdateAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvailabilityMutation, { data, loading, error }] = useUpdateAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      additionalIds: // value for 'additionalIds'
 *      providerId: // value for 'providerId'
 *      note: // value for 'note'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      providerTravel: // value for 'providerTravel'
 *      shiftCenterId: // value for 'shiftCenterId'
 *      tzHandling: // value for 'tzHandling'
 *      overflowShift: // value for 'overflowShift'
 *      useShiftCenterDriveTimes: // value for 'useShiftCenterDriveTimes'
 *      rruleFreq: // value for 'rruleFreq'
 *      rruleDtstart: // value for 'rruleDtstart'
 *      rruleInterval: // value for 'rruleInterval'
 *      rruleByweekday: // value for 'rruleByweekday'
 *      rruleUntil: // value for 'rruleUntil'
 *   },
 * });
 */
export function useUpdateAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>(UpdateAvailabilityDocument, options);
      }
export type UpdateAvailabilityMutationHookResult = ReturnType<typeof useUpdateAvailabilityMutation>;
export type UpdateAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateAvailabilityMutation, UpdateAvailabilityMutationVariables>;
export const CreateRecurringCalendarBlockDocument = gql`
    mutation CreateRecurringCalendarBlock($providerId: Int!, $additionalProviderIds: [Int!], $tzHandling: AvailTZHandling!, $type: AvailabilityTypeEnum!, $note: String!, $startTime: String!, $endTime: String!, $blockType: AvailabilityBlockTypeEnum!, $blockFilters: CalendarBlockFilterInput, $addressStreet: String, $addressCity: String, $addressState: String, $addressZip: String, $rruleFreq: AvailabilityRruleFreqEnum!, $rruleDtstart: String!, $rruleInterval: Int, $rruleByweekday: String, $rruleUntil: String) @permission(requires: manageProviderShifts) {
  createAvailability(
    providerId: $providerId
    additionalProviderIds: $additionalProviderIds
    tzHandling: $tzHandling
    type: $type
    note: $note
    startTime: $startTime
    endTime: $endTime
    blockType: $blockType
    blockFilters: $blockFilters
    addressStreet: $addressStreet
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    rruleFreq: $rruleFreq
    rruleDtstart: $rruleDtstart
    rruleInterval: $rruleInterval
    rruleByweekday: $rruleByweekday
    rruleUntil: $rruleUntil
  ) {
    id
  }
}
    `;
export type CreateRecurringCalendarBlockMutationFn = Apollo.MutationFunction<CreateRecurringCalendarBlockMutation, CreateRecurringCalendarBlockMutationVariables>;

/**
 * __useCreateRecurringCalendarBlockMutation__
 *
 * To run a mutation, you first call `useCreateRecurringCalendarBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringCalendarBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringCalendarBlockMutation, { data, loading, error }] = useCreateRecurringCalendarBlockMutation({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      additionalProviderIds: // value for 'additionalProviderIds'
 *      tzHandling: // value for 'tzHandling'
 *      type: // value for 'type'
 *      note: // value for 'note'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      blockType: // value for 'blockType'
 *      blockFilters: // value for 'blockFilters'
 *      addressStreet: // value for 'addressStreet'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      rruleFreq: // value for 'rruleFreq'
 *      rruleDtstart: // value for 'rruleDtstart'
 *      rruleInterval: // value for 'rruleInterval'
 *      rruleByweekday: // value for 'rruleByweekday'
 *      rruleUntil: // value for 'rruleUntil'
 *   },
 * });
 */
export function useCreateRecurringCalendarBlockMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringCalendarBlockMutation, CreateRecurringCalendarBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringCalendarBlockMutation, CreateRecurringCalendarBlockMutationVariables>(CreateRecurringCalendarBlockDocument, options);
      }
export type CreateRecurringCalendarBlockMutationHookResult = ReturnType<typeof useCreateRecurringCalendarBlockMutation>;
export type CreateRecurringCalendarBlockMutationOptions = Apollo.BaseMutationOptions<CreateRecurringCalendarBlockMutation, CreateRecurringCalendarBlockMutationVariables>;
export const UpdateRecurringCalendarBlockDocument = gql`
    mutation UpdateRecurringCalendarBlock($id: Int!, $additionalIds: [Int!], $tzHandling: AvailTZHandling!, $providerId: Int!, $note: String!, $startTime: String!, $endTime: String!, $blockType: AvailabilityBlockTypeEnum!, $blockFilters: CalendarBlockFilterInput, $addressStreet: String, $addressCity: String, $addressState: String, $addressZip: String, $rruleFreq: AvailabilityRruleFreqEnum!, $rruleDtstart: String!, $rruleInterval: Int, $rruleByweekday: String, $rruleUntil: String) @permission(requires: manageProviderShifts) {
  updateAvailability(
    id: $id
    additionalIds: $additionalIds
    tzHandling: $tzHandling
    providerId: $providerId
    note: $note
    startTime: $startTime
    endTime: $endTime
    blockType: $blockType
    blockFilters: $blockFilters
    addressStreet: $addressStreet
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    rruleFreq: $rruleFreq
    rruleDtstart: $rruleDtstart
    rruleInterval: $rruleInterval
    rruleByweekday: $rruleByweekday
    rruleUntil: $rruleUntil
  ) {
    id
    type
    note
    startTime
    endTime
    blockType
    blockFilters {
      visitTypeIds
    }
    addressStreet
    addressCity
    addressState
    addressZip
    addressTimezone
    addressCoordinates
    rruleFreq
    rruleDtstart
    rruleInterval
    rruleByweekday
    rruleUntil
  }
}
    `;
export type UpdateRecurringCalendarBlockMutationFn = Apollo.MutationFunction<UpdateRecurringCalendarBlockMutation, UpdateRecurringCalendarBlockMutationVariables>;

/**
 * __useUpdateRecurringCalendarBlockMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringCalendarBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringCalendarBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringCalendarBlockMutation, { data, loading, error }] = useUpdateRecurringCalendarBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      additionalIds: // value for 'additionalIds'
 *      tzHandling: // value for 'tzHandling'
 *      providerId: // value for 'providerId'
 *      note: // value for 'note'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      blockType: // value for 'blockType'
 *      blockFilters: // value for 'blockFilters'
 *      addressStreet: // value for 'addressStreet'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      rruleFreq: // value for 'rruleFreq'
 *      rruleDtstart: // value for 'rruleDtstart'
 *      rruleInterval: // value for 'rruleInterval'
 *      rruleByweekday: // value for 'rruleByweekday'
 *      rruleUntil: // value for 'rruleUntil'
 *   },
 * });
 */
export function useUpdateRecurringCalendarBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecurringCalendarBlockMutation, UpdateRecurringCalendarBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecurringCalendarBlockMutation, UpdateRecurringCalendarBlockMutationVariables>(UpdateRecurringCalendarBlockDocument, options);
      }
export type UpdateRecurringCalendarBlockMutationHookResult = ReturnType<typeof useUpdateRecurringCalendarBlockMutation>;
export type UpdateRecurringCalendarBlockMutationOptions = Apollo.BaseMutationOptions<UpdateRecurringCalendarBlockMutation, UpdateRecurringCalendarBlockMutationVariables>;
export const DeleteAvailabilityDocument = gql`
    mutation DeleteAvailability($id: Int!, $additionalIds: [Int!], $providerId: Int!) @permission(requires: manageProviderShifts) {
  deleteAvailability(
    id: $id
    additionalIds: $additionalIds
    providerId: $providerId
  ) {
    id
  }
}
    `;
export type DeleteAvailabilityMutationFn = Apollo.MutationFunction<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>;

/**
 * __useDeleteAvailabilityMutation__
 *
 * To run a mutation, you first call `useDeleteAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAvailabilityMutation, { data, loading, error }] = useDeleteAvailabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      additionalIds: // value for 'additionalIds'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useDeleteAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>(DeleteAvailabilityDocument, options);
      }
export type DeleteAvailabilityMutationHookResult = ReturnType<typeof useDeleteAvailabilityMutation>;
export type DeleteAvailabilityMutationOptions = Apollo.BaseMutationOptions<DeleteAvailabilityMutation, DeleteAvailabilityMutationVariables>;
export const ApplyAvailabilityTemplateDocument = gql`
    mutation ApplyAvailabilityTemplate($availabilityIds: [Int!]!, $providerIds: [Int!]!, $todayDate: String!, $doNotCommit: Boolean, $tzHandling: AvailTZHandling!) @permission(requires: manageProviderShifts) {
  applyAvailabilityTemplate(
    availabilityIds: $availabilityIds
    providerIds: $providerIds
    todayDate: $todayDate
    doNotCommit: $doNotCommit
    tzHandling: $tzHandling
  ) {
    id
  }
}
    `;
export type ApplyAvailabilityTemplateMutationFn = Apollo.MutationFunction<ApplyAvailabilityTemplateMutation, ApplyAvailabilityTemplateMutationVariables>;

/**
 * __useApplyAvailabilityTemplateMutation__
 *
 * To run a mutation, you first call `useApplyAvailabilityTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyAvailabilityTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyAvailabilityTemplateMutation, { data, loading, error }] = useApplyAvailabilityTemplateMutation({
 *   variables: {
 *      availabilityIds: // value for 'availabilityIds'
 *      providerIds: // value for 'providerIds'
 *      todayDate: // value for 'todayDate'
 *      doNotCommit: // value for 'doNotCommit'
 *      tzHandling: // value for 'tzHandling'
 *   },
 * });
 */
export function useApplyAvailabilityTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ApplyAvailabilityTemplateMutation, ApplyAvailabilityTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyAvailabilityTemplateMutation, ApplyAvailabilityTemplateMutationVariables>(ApplyAvailabilityTemplateDocument, options);
      }
export type ApplyAvailabilityTemplateMutationHookResult = ReturnType<typeof useApplyAvailabilityTemplateMutation>;
export type ApplyAvailabilityTemplateMutationOptions = Apollo.BaseMutationOptions<ApplyAvailabilityTemplateMutation, ApplyAvailabilityTemplateMutationVariables>;
export const CommandIndexCombinedDataDocument = gql`
    query CommandIndexCombinedData($filterStartTime: String, $filterEndTime: String, $organizationalUnitSegmentationEnabled: Boolean = false) @permission(requires: useWebApp) {
  visitResource(where: {startTime: {gte: $filterStartTime, lt: $filterEndTime}}) {
    id
    providerId
    startTime
    endTime
    startOfShiftDriveTime
    interVisitDriveTime
    endOfShiftDriveTime
    visitId
    updatedBy
    provider {
      id
      firstName
      lastName
      providerTypeId
      active
    }
    virtualProviderStatus
    errandStatus
    visitResourceRequirementId
    addressCoordinates
    visit {
      id
      careRequirementId
      startTime
      endTime
      eventStatus
      addressStreet
      addressLineTwo
      addressCity
      addressState
      addressZip
      addressTimezone
      addressCoordinates
      arrivalWindowStartTime
      arrivalWindowEndTime
      createdAt
      visitWarningLogId
      updatedBy
      manualEdits
      cancellationReason {
        id
        description
      }
      patient {
        id
        firstName
        lastName
        addressCoordinates
        patientNotes
        serviceInstructions
        patientIdentifiers {
          identifier
          identifier_type
        }
        careTeamProviders {
          id
          allowAutomaticUpdates
          patientId
          providerId
          providerTypeId
        }
      }
      episode {
        id
        serviceLineId
        organizationalUnitId @include(if: $organizationalUnitSegmentationEnabled)
        autoschedulerGroup
        precautions {
          id
          precautionId
        }
      }
      visitTypeId
      eventLog(
        where: {visitResourceId: {isNull: true}}
        orderBy: {eventTime: {direction: desc, priority: 1}}
        limit: 1
      ) {
        id
        event
        eventTime
        autoGenerated
        createdByUser {
          firstName
          lastName
        }
      }
    }
  }
  shift(
    where: {OR: [{startTime: {gte: $filterStartTime, lt: $filterEndTime}}, {endTime: {gte: $filterStartTime, lt: $filterEndTime}}]}
  ) {
    id
    status
    startTime
    endTime
    addressTimezone
    providerTravel
    manualEdits
    overflowShift
    providerId
    updatedBy
    provider {
      id
      firstName
      lastName
      addressCoordinates
      providerTypeId
      external
      active
    }
    addressCoordinates
    shiftCenterId
    useShiftCenterDriveTimes
  }
  calendarBlock(where: {startTime: {gte: $filterStartTime, lt: $filterEndTime}}) {
    id
    title
    startTime
    endTime
    eventStatus
    providerId
    startOfShiftDriveTime
    interVisitDriveTime
    endOfShiftDriveTime
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressCoordinates
    addressTimezone
    updatedBy
    blockType
    availabilityId
    manualEdits
    filters {
      visitTypeIds
    }
    provider {
      id
      firstName
      lastName
    }
  }
  task(where: {taskType: {eq: visit_request}, status: {eq: pending}}) {
    id
    taskType
    status
    description
    createdAt
    details
    patient {
      id
      firstName
      lastName
      addressStreet
      addressLineTwo
      addressCity
      addressState
      addressZip
      addressTimezone
      addressCoordinates
      patientNotes
      serviceInstructions
      patientIdentifiers {
        identifier
        identifier_type
      }
      careTeamProviders {
        id
        allowAutomaticUpdates
        patientId
        providerId
        providerTypeId
      }
    }
  }
}
    `;

/**
 * __useCommandIndexCombinedDataQuery__
 *
 * To run a query within a React component, call `useCommandIndexCombinedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommandIndexCombinedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommandIndexCombinedDataQuery({
 *   variables: {
 *      filterStartTime: // value for 'filterStartTime'
 *      filterEndTime: // value for 'filterEndTime'
 *      organizationalUnitSegmentationEnabled: // value for 'organizationalUnitSegmentationEnabled'
 *   },
 * });
 */
export function useCommandIndexCombinedDataQuery(baseOptions?: Apollo.QueryHookOptions<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>(CommandIndexCombinedDataDocument, options);
      }
export function useCommandIndexCombinedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>(CommandIndexCombinedDataDocument, options);
        }
// @ts-ignore
export function useCommandIndexCombinedDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>): Apollo.UseSuspenseQueryResult<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>;
export function useCommandIndexCombinedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>): Apollo.UseSuspenseQueryResult<CommandIndexCombinedDataQuery | undefined, CommandIndexCombinedDataQueryVariables>;
export function useCommandIndexCombinedDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommandIndexCombinedDataQuery, CommandIndexCombinedDataQueryVariables>(CommandIndexCombinedDataDocument, options);
        }
export type CommandIndexCombinedDataQueryHookResult = ReturnType<typeof useCommandIndexCombinedDataQuery>;
export type CommandIndexCombinedDataLazyQueryHookResult = ReturnType<typeof useCommandIndexCombinedDataLazyQuery>;
export type CommandIndexCombinedDataSuspenseQueryHookResult = ReturnType<typeof useCommandIndexCombinedDataSuspenseQuery>;
export const GetSimpleDriveTimeDocument = gql`
    query GetSimpleDriveTime($shift: Shift!, $providerAddress: ProviderAddress!, $visitResources: [VisitResourceGenericInput!]!, $calendarBlocks: [CalendarBlockInput!]!) @permission(requires: createDragEvents) {
  simpleDriveTime(
    shift: $shift
    providerAddress: $providerAddress
    visitResources: $visitResources
    calendarBlocks: $calendarBlocks
  ) {
    id
    eventKey
    providerId
    startOfShiftDriveTime
    interVisitDriveTime
    endOfShiftDriveTime
  }
}
    `;

/**
 * __useGetSimpleDriveTimeQuery__
 *
 * To run a query within a React component, call `useGetSimpleDriveTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleDriveTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleDriveTimeQuery({
 *   variables: {
 *      shift: // value for 'shift'
 *      providerAddress: // value for 'providerAddress'
 *      visitResources: // value for 'visitResources'
 *      calendarBlocks: // value for 'calendarBlocks'
 *   },
 * });
 */
export function useGetSimpleDriveTimeQuery(baseOptions: Apollo.QueryHookOptions<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables> & ({ variables: GetSimpleDriveTimeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables>(GetSimpleDriveTimeDocument, options);
      }
export function useGetSimpleDriveTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables>(GetSimpleDriveTimeDocument, options);
        }
// @ts-ignore
export function useGetSimpleDriveTimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables>;
export function useGetSimpleDriveTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables>): Apollo.UseSuspenseQueryResult<GetSimpleDriveTimeQuery | undefined, GetSimpleDriveTimeQueryVariables>;
export function useGetSimpleDriveTimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSimpleDriveTimeQuery, GetSimpleDriveTimeQueryVariables>(GetSimpleDriveTimeDocument, options);
        }
export type GetSimpleDriveTimeQueryHookResult = ReturnType<typeof useGetSimpleDriveTimeQuery>;
export type GetSimpleDriveTimeLazyQueryHookResult = ReturnType<typeof useGetSimpleDriveTimeLazyQuery>;
export type GetSimpleDriveTimeSuspenseQueryHookResult = ReturnType<typeof useGetSimpleDriveTimeSuspenseQuery>;
export const CommandIndexCareRequirementVisitsDocument = gql`
    query CommandIndexCareRequirementVisits($filterStartTime: String, $filterEndTime: String) @permission(requires: useWebApp) {
  visit(
    where: {startTime: {gte: $filterStartTime, lt: $filterEndTime}, eventStatus: {ne: canceled}, careRequirementId: {ne: null}}
  ) {
    id
    startTime
    patientId
    manualEdits
    careRequirement {
      id
      visitTypeId
      duration
      earliestStartTime
      latestStartTime
      minTimeFromLastVisit
      maxTimeFromLastVisit
    }
  }
}
    `;

/**
 * __useCommandIndexCareRequirementVisitsQuery__
 *
 * To run a query within a React component, call `useCommandIndexCareRequirementVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommandIndexCareRequirementVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommandIndexCareRequirementVisitsQuery({
 *   variables: {
 *      filterStartTime: // value for 'filterStartTime'
 *      filterEndTime: // value for 'filterEndTime'
 *   },
 * });
 */
export function useCommandIndexCareRequirementVisitsQuery(baseOptions?: Apollo.QueryHookOptions<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>(CommandIndexCareRequirementVisitsDocument, options);
      }
export function useCommandIndexCareRequirementVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>(CommandIndexCareRequirementVisitsDocument, options);
        }
// @ts-ignore
export function useCommandIndexCareRequirementVisitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>): Apollo.UseSuspenseQueryResult<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>;
export function useCommandIndexCareRequirementVisitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>): Apollo.UseSuspenseQueryResult<CommandIndexCareRequirementVisitsQuery | undefined, CommandIndexCareRequirementVisitsQueryVariables>;
export function useCommandIndexCareRequirementVisitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommandIndexCareRequirementVisitsQuery, CommandIndexCareRequirementVisitsQueryVariables>(CommandIndexCareRequirementVisitsDocument, options);
        }
export type CommandIndexCareRequirementVisitsQueryHookResult = ReturnType<typeof useCommandIndexCareRequirementVisitsQuery>;
export type CommandIndexCareRequirementVisitsLazyQueryHookResult = ReturnType<typeof useCommandIndexCareRequirementVisitsLazyQuery>;
export type CommandIndexCareRequirementVisitsSuspenseQueryHookResult = ReturnType<typeof useCommandIndexCareRequirementVisitsSuspenseQuery>;
export const UpdateVisitResourceStatusDocument = gql`
    mutation UpdateVisitResourceStatus($id: Int!, $visitId: Int!, $newStatus: VisitResourceVirtualProviderStatusEnum!) @permission(requires: useWebApp, check: [userIsProviderOnVisit]) {
  updateVisitResourceStatus(
    id: $id
    visitId: $visitId
    virtualProviderStatus: $newStatus
  ) {
    id
    visitId
    virtualProviderStatus
  }
}
    `;
export type UpdateVisitResourceStatusMutationFn = Apollo.MutationFunction<UpdateVisitResourceStatusMutation, UpdateVisitResourceStatusMutationVariables>;

/**
 * __useUpdateVisitResourceStatusMutation__
 *
 * To run a mutation, you first call `useUpdateVisitResourceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitResourceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitResourceStatusMutation, { data, loading, error }] = useUpdateVisitResourceStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visitId: // value for 'visitId'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useUpdateVisitResourceStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitResourceStatusMutation, UpdateVisitResourceStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitResourceStatusMutation, UpdateVisitResourceStatusMutationVariables>(UpdateVisitResourceStatusDocument, options);
      }
export type UpdateVisitResourceStatusMutationHookResult = ReturnType<typeof useUpdateVisitResourceStatusMutation>;
export type UpdateVisitResourceStatusMutationOptions = Apollo.BaseMutationOptions<UpdateVisitResourceStatusMutation, UpdateVisitResourceStatusMutationVariables>;
export const GetAvailableOrgsDocument = gql`
    query GetAvailableOrgs @permission(requires: isAuthenticated) {
  currentUser {
    id
    userId
    organizations {
      id
      name
      organizationUserId
      roles
      perms
      serviceLineIds
      providerId
      settings {
        enableMobileNotifications
        mobileNotificationsWindow
        enableLocationBasedStatusUpdates
        idleSessionTimeoutMinutes
        mobileIdleLockTimeoutMinutes
        mobileIdleSignOutMinutes
        mobileUnlockMethod
        shufflerLeadTime
        barcodeTypes
      }
    }
  }
}
    `;

/**
 * __useGetAvailableOrgsQuery__
 *
 * To run a query within a React component, call `useGetAvailableOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableOrgsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>(GetAvailableOrgsDocument, options);
      }
export function useGetAvailableOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>(GetAvailableOrgsDocument, options);
        }
// @ts-ignore
export function useGetAvailableOrgsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>;
export function useGetAvailableOrgsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableOrgsQuery | undefined, GetAvailableOrgsQueryVariables>;
export function useGetAvailableOrgsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableOrgsQuery, GetAvailableOrgsQueryVariables>(GetAvailableOrgsDocument, options);
        }
export type GetAvailableOrgsQueryHookResult = ReturnType<typeof useGetAvailableOrgsQuery>;
export type GetAvailableOrgsLazyQueryHookResult = ReturnType<typeof useGetAvailableOrgsLazyQuery>;
export type GetAvailableOrgsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableOrgsSuspenseQuery>;
export const OrgConfigDocument = gql`
    query OrgConfig @permission(requires: useWebApp) {
  serviceLine(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    schedulingConfig
    visitTypeServiceLines {
      id
      visitTypeId
    }
    errandTypeServiceLines {
      id
      errandTypeId
    }
  }
  visitType(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    schedulingConfig
    visitTypeServices {
      id
      selectedByDefault
      service {
        id
        name
        duration
        active
      }
    }
  }
  visitResourceRequirement(orderBy: {id: {direction: asc, priority: 1}}) {
    id
    duration
    inHome
    invitedToVisit
    offset
    visitTypeId
    errandTypeId
    requiresContinuityOfCare
    preserveAutoschedulerGroup
    visitResourceRequirementPT {
      providerTypeId
    }
  }
  errandType(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    description
    relativeToVisit
    active
  }
  program(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    serviceLineId
  }
  eligibilityQuestion(orderBy: {id: {direction: asc, priority: 1}}) {
    id
    question
    answerFormatType
    answerModule
    answerModulePredicate
    useForPreScoreCheck
    answerOptions {
      id
      answer
    }
    programEligibilityQuestions(orderBy: {programId: {direction: asc, priority: 1}}) {
      programId
      disqualifyingAnswers
    }
  }
  service(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    description
    duration
    active
  }
  providerType(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    requireStateLicense
  }
  shiftCenter(orderBy: {id: {direction: asc, priority: 1}}) {
    id
    name
    organizationalUnitId
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressCoordinates
    addressTimezone
  }
  secrets {
    GOOGLE_MAPS_WEB_API_KEY
    MAPBOXGL_API_KEY
  }
  teamProvider {
    id
    teamId
    providerId
    team {
      id
      name
    }
  }
  visitCancellationReason {
    id
    description
    reasonType
    active
  }
  supplyChangeReason {
    id
    label
    eventType
    active
  }
  precaution(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    color
    description
    active
  }
}
    `;

/**
 * __useOrgConfigQuery__
 *
 * To run a query within a React component, call `useOrgConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgConfigQuery(baseOptions?: Apollo.QueryHookOptions<OrgConfigQuery, OrgConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgConfigQuery, OrgConfigQueryVariables>(OrgConfigDocument, options);
      }
export function useOrgConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgConfigQuery, OrgConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgConfigQuery, OrgConfigQueryVariables>(OrgConfigDocument, options);
        }
// @ts-ignore
export function useOrgConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgConfigQuery, OrgConfigQueryVariables>): Apollo.UseSuspenseQueryResult<OrgConfigQuery, OrgConfigQueryVariables>;
export function useOrgConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgConfigQuery, OrgConfigQueryVariables>): Apollo.UseSuspenseQueryResult<OrgConfigQuery | undefined, OrgConfigQueryVariables>;
export function useOrgConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgConfigQuery, OrgConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgConfigQuery, OrgConfigQueryVariables>(OrgConfigDocument, options);
        }
export type OrgConfigQueryHookResult = ReturnType<typeof useOrgConfigQuery>;
export type OrgConfigLazyQueryHookResult = ReturnType<typeof useOrgConfigLazyQuery>;
export type OrgConfigSuspenseQueryHookResult = ReturnType<typeof useOrgConfigSuspenseQuery>;
export const GetPatientVisitsDemoDocument = gql`
    query GetPatientVisitsDemo($patientId: Int!) @permission(requires: useWebApp) {
  patientSingle(where: {id: {eq: $patientId}}) {
    id
    firstName
    lastName
    addressTimezone
    episodes(where: {active: {eq: true}}) {
      id
      active
    }
    visits {
      id
      startTime
      endTime
      eventStatus
      episodeId
      arrivalWindowStartTime
      arrivalWindowEndTime
      visitType {
        id
        name
      }
      visitResources {
        id
        provider {
          id
          firstName
          lastName
        }
      }
      visitServices {
        service {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetPatientVisitsDemoQuery__
 *
 * To run a query within a React component, call `useGetPatientVisitsDemoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientVisitsDemoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientVisitsDemoQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function useGetPatientVisitsDemoQuery(baseOptions: Apollo.QueryHookOptions<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables> & ({ variables: GetPatientVisitsDemoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables>(GetPatientVisitsDemoDocument, options);
      }
export function useGetPatientVisitsDemoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables>(GetPatientVisitsDemoDocument, options);
        }
// @ts-ignore
export function useGetPatientVisitsDemoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables>;
export function useGetPatientVisitsDemoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientVisitsDemoQuery | undefined, GetPatientVisitsDemoQueryVariables>;
export function useGetPatientVisitsDemoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientVisitsDemoQuery, GetPatientVisitsDemoQueryVariables>(GetPatientVisitsDemoDocument, options);
        }
export type GetPatientVisitsDemoQueryHookResult = ReturnType<typeof useGetPatientVisitsDemoQuery>;
export type GetPatientVisitsDemoLazyQueryHookResult = ReturnType<typeof useGetPatientVisitsDemoLazyQuery>;
export type GetPatientVisitsDemoSuspenseQueryHookResult = ReturnType<typeof useGetPatientVisitsDemoSuspenseQuery>;
export const CancelVisitDemoDocument = gql`
    mutation CancelVisitDemo($visitId: Int!, $visitCancellationReasonId: Int!) @permission(requires: manageAnyVisit, check: [userInVisitServiceLine]) {
  cancelVisit(
    visitId: $visitId
    visitCancellationReasonId: $visitCancellationReasonId
  ) {
    id
    eventStatus
  }
}
    `;
export type CancelVisitDemoMutationFn = Apollo.MutationFunction<CancelVisitDemoMutation, CancelVisitDemoMutationVariables>;

/**
 * __useCancelVisitDemoMutation__
 *
 * To run a mutation, you first call `useCancelVisitDemoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelVisitDemoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelVisitDemoMutation, { data, loading, error }] = useCancelVisitDemoMutation({
 *   variables: {
 *      visitId: // value for 'visitId'
 *      visitCancellationReasonId: // value for 'visitCancellationReasonId'
 *   },
 * });
 */
export function useCancelVisitDemoMutation(baseOptions?: Apollo.MutationHookOptions<CancelVisitDemoMutation, CancelVisitDemoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelVisitDemoMutation, CancelVisitDemoMutationVariables>(CancelVisitDemoDocument, options);
      }
export type CancelVisitDemoMutationHookResult = ReturnType<typeof useCancelVisitDemoMutation>;
export type CancelVisitDemoMutationOptions = Apollo.BaseMutationOptions<CancelVisitDemoMutation, CancelVisitDemoMutationVariables>;
export const GetDemoPatientsDocument = gql`
    query GetDemoPatients @permission(requires: useWebApp) {
  activePatients(
    offset: 0
    limit: 1
    orderBy: {id: {direction: asc, priority: 1}}
  ) {
    id
  }
}
    `;

/**
 * __useGetDemoPatientsQuery__
 *
 * To run a query within a React component, call `useGetDemoPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDemoPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDemoPatientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDemoPatientsQuery(baseOptions?: Apollo.QueryHookOptions<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>(GetDemoPatientsDocument, options);
      }
export function useGetDemoPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>(GetDemoPatientsDocument, options);
        }
// @ts-ignore
export function useGetDemoPatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>;
export function useGetDemoPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDemoPatientsQuery | undefined, GetDemoPatientsQueryVariables>;
export function useGetDemoPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDemoPatientsQuery, GetDemoPatientsQueryVariables>(GetDemoPatientsDocument, options);
        }
export type GetDemoPatientsQueryHookResult = ReturnType<typeof useGetDemoPatientsQuery>;
export type GetDemoPatientsLazyQueryHookResult = ReturnType<typeof useGetDemoPatientsLazyQuery>;
export type GetDemoPatientsSuspenseQueryHookResult = ReturnType<typeof useGetDemoPatientsSuspenseQuery>;
export const AssignCandidacyDocument = gql`
    mutation AssignCandidacy($id: Int!, $orgUserId: Int) @permission(requires: assignCandidacy) {
  assignCandidacy(id: $id, orgUserId: $orgUserId) {
    id
    assignedToId
    assignedTo {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type AssignCandidacyMutationFn = Apollo.MutationFunction<AssignCandidacyMutation, AssignCandidacyMutationVariables>;

/**
 * __useAssignCandidacyMutation__
 *
 * To run a mutation, you first call `useAssignCandidacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCandidacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCandidacyMutation, { data, loading, error }] = useAssignCandidacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      orgUserId: // value for 'orgUserId'
 *   },
 * });
 */
export function useAssignCandidacyMutation(baseOptions?: Apollo.MutationHookOptions<AssignCandidacyMutation, AssignCandidacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCandidacyMutation, AssignCandidacyMutationVariables>(AssignCandidacyDocument, options);
      }
export type AssignCandidacyMutationHookResult = ReturnType<typeof useAssignCandidacyMutation>;
export type AssignCandidacyMutationOptions = Apollo.BaseMutationOptions<AssignCandidacyMutation, AssignCandidacyMutationVariables>;
export const TakeCandidacyDocument = gql`
    mutation TakeCandidacy($id: Int!) @permission(requires: takeCandidacy) {
  takeCandidacy(id: $id) {
    id
    assignedToId
    assignedTo {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type TakeCandidacyMutationFn = Apollo.MutationFunction<TakeCandidacyMutation, TakeCandidacyMutationVariables>;

/**
 * __useTakeCandidacyMutation__
 *
 * To run a mutation, you first call `useTakeCandidacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakeCandidacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takeCandidacyMutation, { data, loading, error }] = useTakeCandidacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTakeCandidacyMutation(baseOptions?: Apollo.MutationHookOptions<TakeCandidacyMutation, TakeCandidacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TakeCandidacyMutation, TakeCandidacyMutationVariables>(TakeCandidacyDocument, options);
      }
export type TakeCandidacyMutationHookResult = ReturnType<typeof useTakeCandidacyMutation>;
export type TakeCandidacyMutationOptions = Apollo.BaseMutationOptions<TakeCandidacyMutation, TakeCandidacyMutationVariables>;
export const BulkAssignCandidacyDocument = gql`
    mutation BulkAssignCandidacy($ids: [Int!]!, $orgUserId: Int) @permission(requires: assignCandidacy) {
  bulkAssignCandidacy(ids: $ids, orgUserId: $orgUserId) {
    id
    assignedToId
    assignedTo {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type BulkAssignCandidacyMutationFn = Apollo.MutationFunction<BulkAssignCandidacyMutation, BulkAssignCandidacyMutationVariables>;

/**
 * __useBulkAssignCandidacyMutation__
 *
 * To run a mutation, you first call `useBulkAssignCandidacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAssignCandidacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAssignCandidacyMutation, { data, loading, error }] = useBulkAssignCandidacyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      orgUserId: // value for 'orgUserId'
 *   },
 * });
 */
export function useBulkAssignCandidacyMutation(baseOptions?: Apollo.MutationHookOptions<BulkAssignCandidacyMutation, BulkAssignCandidacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAssignCandidacyMutation, BulkAssignCandidacyMutationVariables>(BulkAssignCandidacyDocument, options);
      }
export type BulkAssignCandidacyMutationHookResult = ReturnType<typeof useBulkAssignCandidacyMutation>;
export type BulkAssignCandidacyMutationOptions = Apollo.BaseMutationOptions<BulkAssignCandidacyMutation, BulkAssignCandidacyMutationVariables>;
export const BulkTakeCandidacyDocument = gql`
    mutation BulkTakeCandidacy($ids: [Int!]!) @permission(requires: takeCandidacy) {
  bulkTakeCandidacy(ids: $ids) {
    id
    assignedToId
    assignedTo {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;
export type BulkTakeCandidacyMutationFn = Apollo.MutationFunction<BulkTakeCandidacyMutation, BulkTakeCandidacyMutationVariables>;

/**
 * __useBulkTakeCandidacyMutation__
 *
 * To run a mutation, you first call `useBulkTakeCandidacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkTakeCandidacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkTakeCandidacyMutation, { data, loading, error }] = useBulkTakeCandidacyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkTakeCandidacyMutation(baseOptions?: Apollo.MutationHookOptions<BulkTakeCandidacyMutation, BulkTakeCandidacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkTakeCandidacyMutation, BulkTakeCandidacyMutationVariables>(BulkTakeCandidacyDocument, options);
      }
export type BulkTakeCandidacyMutationHookResult = ReturnType<typeof useBulkTakeCandidacyMutation>;
export type BulkTakeCandidacyMutationOptions = Apollo.BaseMutationOptions<BulkTakeCandidacyMutation, BulkTakeCandidacyMutationVariables>;
export const OrgTeamMembersDocument = gql`
    query OrgTeamMembers @permission(requires: useWebApp) {
  organizationUser {
    id
    userId
    user {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useOrgTeamMembersQuery__
 *
 * To run a query within a React component, call `useOrgTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>(OrgTeamMembersDocument, options);
      }
export function useOrgTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>(OrgTeamMembersDocument, options);
        }
// @ts-ignore
export function useOrgTeamMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>): Apollo.UseSuspenseQueryResult<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>;
export function useOrgTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>): Apollo.UseSuspenseQueryResult<OrgTeamMembersQuery | undefined, OrgTeamMembersQueryVariables>;
export function useOrgTeamMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgTeamMembersQuery, OrgTeamMembersQueryVariables>(OrgTeamMembersDocument, options);
        }
export type OrgTeamMembersQueryHookResult = ReturnType<typeof useOrgTeamMembersQuery>;
export type OrgTeamMembersLazyQueryHookResult = ReturnType<typeof useOrgTeamMembersLazyQuery>;
export type OrgTeamMembersSuspenseQueryHookResult = ReturnType<typeof useOrgTeamMembersSuspenseQuery>;
export const CandidacyAssignmentRulesDocument = gql`
    query CandidacyAssignmentRules @permission(requires: manageOrgConfig) {
  candidacyAssignmentRules {
    id
    fhirLocationId
    fhirOrganizationId
    assignedToId
    fhirLocation {
      fhirId
      displayText
      name
      hierarchy
      typeDisplay
      formDisplay
      managingOrganization
    }
    fhirOrganization {
      fhirId
      displayText
      name
      hierarchy
      typeDisplay
      formDisplay
      managingOrganization
    }
    assignedTo {
      id
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;

/**
 * __useCandidacyAssignmentRulesQuery__
 *
 * To run a query within a React component, call `useCandidacyAssignmentRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidacyAssignmentRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidacyAssignmentRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCandidacyAssignmentRulesQuery(baseOptions?: Apollo.QueryHookOptions<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>(CandidacyAssignmentRulesDocument, options);
      }
export function useCandidacyAssignmentRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>(CandidacyAssignmentRulesDocument, options);
        }
// @ts-ignore
export function useCandidacyAssignmentRulesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>): Apollo.UseSuspenseQueryResult<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>;
export function useCandidacyAssignmentRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>): Apollo.UseSuspenseQueryResult<CandidacyAssignmentRulesQuery | undefined, CandidacyAssignmentRulesQueryVariables>;
export function useCandidacyAssignmentRulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CandidacyAssignmentRulesQuery, CandidacyAssignmentRulesQueryVariables>(CandidacyAssignmentRulesDocument, options);
        }
export type CandidacyAssignmentRulesQueryHookResult = ReturnType<typeof useCandidacyAssignmentRulesQuery>;
export type CandidacyAssignmentRulesLazyQueryHookResult = ReturnType<typeof useCandidacyAssignmentRulesLazyQuery>;
export type CandidacyAssignmentRulesSuspenseQueryHookResult = ReturnType<typeof useCandidacyAssignmentRulesSuspenseQuery>;
export const SearchFhirLocationsDocument = gql`
    query SearchFhirLocations($keyword: String!, $limit: Int) @permission(requires: manageOrgConfig) {
  searchFhirLocations(keyword: $keyword, limit: $limit) {
    fhirId
    displayText
    name
    hierarchy
    typeDisplay
    formDisplay
    managingOrganization
  }
}
    `;

/**
 * __useSearchFhirLocationsQuery__
 *
 * To run a query within a React component, call `useSearchFhirLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFhirLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFhirLocationsQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchFhirLocationsQuery(baseOptions: Apollo.QueryHookOptions<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables> & ({ variables: SearchFhirLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables>(SearchFhirLocationsDocument, options);
      }
export function useSearchFhirLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables>(SearchFhirLocationsDocument, options);
        }
// @ts-ignore
export function useSearchFhirLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables>;
export function useSearchFhirLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchFhirLocationsQuery | undefined, SearchFhirLocationsQueryVariables>;
export function useSearchFhirLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchFhirLocationsQuery, SearchFhirLocationsQueryVariables>(SearchFhirLocationsDocument, options);
        }
export type SearchFhirLocationsQueryHookResult = ReturnType<typeof useSearchFhirLocationsQuery>;
export type SearchFhirLocationsLazyQueryHookResult = ReturnType<typeof useSearchFhirLocationsLazyQuery>;
export type SearchFhirLocationsSuspenseQueryHookResult = ReturnType<typeof useSearchFhirLocationsSuspenseQuery>;
export const SearchFhirOrganizationsDocument = gql`
    query SearchFhirOrganizations($keyword: String!, $limit: Int) @permission(requires: manageOrgConfig) {
  searchFhirOrganizations(keyword: $keyword, limit: $limit) {
    fhirId
    displayText
    name
    hierarchy
    typeDisplay
    formDisplay
    managingOrganization
  }
}
    `;

/**
 * __useSearchFhirOrganizationsQuery__
 *
 * To run a query within a React component, call `useSearchFhirOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFhirOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFhirOrganizationsQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchFhirOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables> & ({ variables: SearchFhirOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables>(SearchFhirOrganizationsDocument, options);
      }
export function useSearchFhirOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables>(SearchFhirOrganizationsDocument, options);
        }
// @ts-ignore
export function useSearchFhirOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables>;
export function useSearchFhirOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchFhirOrganizationsQuery | undefined, SearchFhirOrganizationsQueryVariables>;
export function useSearchFhirOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchFhirOrganizationsQuery, SearchFhirOrganizationsQueryVariables>(SearchFhirOrganizationsDocument, options);
        }
export type SearchFhirOrganizationsQueryHookResult = ReturnType<typeof useSearchFhirOrganizationsQuery>;
export type SearchFhirOrganizationsLazyQueryHookResult = ReturnType<typeof useSearchFhirOrganizationsLazyQuery>;
export type SearchFhirOrganizationsSuspenseQueryHookResult = ReturnType<typeof useSearchFhirOrganizationsSuspenseQuery>;
export const CreateCandidacyAssignmentRuleDocument = gql`
    mutation CreateCandidacyAssignmentRule($fhirLocationId: String, $fhirOrganizationId: String, $assignedToId: Int!) @permission(requires: manageOrgConfig) {
  createCandidacyAssignmentRule(
    fhirLocationId: $fhirLocationId
    fhirOrganizationId: $fhirOrganizationId
    assignedToId: $assignedToId
  ) {
    id
    fhirLocationId
    fhirOrganizationId
    assignedToId
  }
}
    `;
export type CreateCandidacyAssignmentRuleMutationFn = Apollo.MutationFunction<CreateCandidacyAssignmentRuleMutation, CreateCandidacyAssignmentRuleMutationVariables>;

/**
 * __useCreateCandidacyAssignmentRuleMutation__
 *
 * To run a mutation, you first call `useCreateCandidacyAssignmentRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidacyAssignmentRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidacyAssignmentRuleMutation, { data, loading, error }] = useCreateCandidacyAssignmentRuleMutation({
 *   variables: {
 *      fhirLocationId: // value for 'fhirLocationId'
 *      fhirOrganizationId: // value for 'fhirOrganizationId'
 *      assignedToId: // value for 'assignedToId'
 *   },
 * });
 */
export function useCreateCandidacyAssignmentRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidacyAssignmentRuleMutation, CreateCandidacyAssignmentRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidacyAssignmentRuleMutation, CreateCandidacyAssignmentRuleMutationVariables>(CreateCandidacyAssignmentRuleDocument, options);
      }
export type CreateCandidacyAssignmentRuleMutationHookResult = ReturnType<typeof useCreateCandidacyAssignmentRuleMutation>;
export type CreateCandidacyAssignmentRuleMutationOptions = Apollo.BaseMutationOptions<CreateCandidacyAssignmentRuleMutation, CreateCandidacyAssignmentRuleMutationVariables>;
export const UpdateCandidacyAssignmentRuleDocument = gql`
    mutation UpdateCandidacyAssignmentRule($id: Int!, $fhirLocationId: String, $fhirOrganizationId: String, $assignedToId: Int!) @permission(requires: manageOrgConfig) {
  updateCandidacyAssignmentRule(
    id: $id
    fhirLocationId: $fhirLocationId
    fhirOrganizationId: $fhirOrganizationId
    assignedToId: $assignedToId
  ) {
    id
    fhirLocationId
    fhirOrganizationId
    assignedToId
  }
}
    `;
export type UpdateCandidacyAssignmentRuleMutationFn = Apollo.MutationFunction<UpdateCandidacyAssignmentRuleMutation, UpdateCandidacyAssignmentRuleMutationVariables>;

/**
 * __useUpdateCandidacyAssignmentRuleMutation__
 *
 * To run a mutation, you first call `useUpdateCandidacyAssignmentRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidacyAssignmentRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidacyAssignmentRuleMutation, { data, loading, error }] = useUpdateCandidacyAssignmentRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fhirLocationId: // value for 'fhirLocationId'
 *      fhirOrganizationId: // value for 'fhirOrganizationId'
 *      assignedToId: // value for 'assignedToId'
 *   },
 * });
 */
export function useUpdateCandidacyAssignmentRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidacyAssignmentRuleMutation, UpdateCandidacyAssignmentRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidacyAssignmentRuleMutation, UpdateCandidacyAssignmentRuleMutationVariables>(UpdateCandidacyAssignmentRuleDocument, options);
      }
export type UpdateCandidacyAssignmentRuleMutationHookResult = ReturnType<typeof useUpdateCandidacyAssignmentRuleMutation>;
export type UpdateCandidacyAssignmentRuleMutationOptions = Apollo.BaseMutationOptions<UpdateCandidacyAssignmentRuleMutation, UpdateCandidacyAssignmentRuleMutationVariables>;
export const DeleteCandidacyAssignmentRuleDocument = gql`
    mutation DeleteCandidacyAssignmentRule($id: Int!) @permission(requires: manageOrgConfig) {
  deleteCandidacyAssignmentRule(id: $id)
}
    `;
export type DeleteCandidacyAssignmentRuleMutationFn = Apollo.MutationFunction<DeleteCandidacyAssignmentRuleMutation, DeleteCandidacyAssignmentRuleMutationVariables>;

/**
 * __useDeleteCandidacyAssignmentRuleMutation__
 *
 * To run a mutation, you first call `useDeleteCandidacyAssignmentRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidacyAssignmentRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidacyAssignmentRuleMutation, { data, loading, error }] = useDeleteCandidacyAssignmentRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCandidacyAssignmentRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidacyAssignmentRuleMutation, DeleteCandidacyAssignmentRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidacyAssignmentRuleMutation, DeleteCandidacyAssignmentRuleMutationVariables>(DeleteCandidacyAssignmentRuleDocument, options);
      }
export type DeleteCandidacyAssignmentRuleMutationHookResult = ReturnType<typeof useDeleteCandidacyAssignmentRuleMutation>;
export type DeleteCandidacyAssignmentRuleMutationOptions = Apollo.BaseMutationOptions<DeleteCandidacyAssignmentRuleMutation, DeleteCandidacyAssignmentRuleMutationVariables>;
export const TestCandidacyAutoAssignmentDocument = gql`
    query TestCandidacyAutoAssignment($encounterResourceJson: String!) @permission(requires: debugApps) {
  testCandidacyAutoAssignment(encounterResourceJson: $encounterResourceJson)
}
    `;

/**
 * __useTestCandidacyAutoAssignmentQuery__
 *
 * To run a query within a React component, call `useTestCandidacyAutoAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestCandidacyAutoAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestCandidacyAutoAssignmentQuery({
 *   variables: {
 *      encounterResourceJson: // value for 'encounterResourceJson'
 *   },
 * });
 */
export function useTestCandidacyAutoAssignmentQuery(baseOptions: Apollo.QueryHookOptions<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables> & ({ variables: TestCandidacyAutoAssignmentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables>(TestCandidacyAutoAssignmentDocument, options);
      }
export function useTestCandidacyAutoAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables>(TestCandidacyAutoAssignmentDocument, options);
        }
// @ts-ignore
export function useTestCandidacyAutoAssignmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables>;
export function useTestCandidacyAutoAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables>): Apollo.UseSuspenseQueryResult<TestCandidacyAutoAssignmentQuery | undefined, TestCandidacyAutoAssignmentQueryVariables>;
export function useTestCandidacyAutoAssignmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestCandidacyAutoAssignmentQuery, TestCandidacyAutoAssignmentQueryVariables>(TestCandidacyAutoAssignmentDocument, options);
        }
export type TestCandidacyAutoAssignmentQueryHookResult = ReturnType<typeof useTestCandidacyAutoAssignmentQuery>;
export type TestCandidacyAutoAssignmentLazyQueryHookResult = ReturnType<typeof useTestCandidacyAutoAssignmentLazyQuery>;
export type TestCandidacyAutoAssignmentSuspenseQueryHookResult = ReturnType<typeof useTestCandidacyAutoAssignmentSuspenseQuery>;
export const PredictCandidacyListDocument = gql`
    query PredictCandidacyList($where: CandidacyFilters, $orderBy: PredictCandidacyOrderBy, $offset: Int, $limit: Int) @permission(requires: useWebApp) {
  predictCandidacyList(
    where: $where
    orderBy: $orderBy
    offset: $offset
    limit: $limit
  ) {
    id
    patientId
    assignedToId
    chosenProgramId
    candidateStatus
    updatedAt
    patient {
      id
      firstName
      lastName
      dateOfBirth
      addressStreet
      addressCity
      addressState
      addressZip
      patientIdentifiers {
        id
        identifier
        identifier_type
      }
    }
    assignedTo {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __usePredictCandidacyListQuery__
 *
 * To run a query within a React component, call `usePredictCandidacyListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictCandidacyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictCandidacyListQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePredictCandidacyListQuery(baseOptions?: Apollo.QueryHookOptions<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>(PredictCandidacyListDocument, options);
      }
export function usePredictCandidacyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>(PredictCandidacyListDocument, options);
        }
// @ts-ignore
export function usePredictCandidacyListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>): Apollo.UseSuspenseQueryResult<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>;
export function usePredictCandidacyListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>): Apollo.UseSuspenseQueryResult<PredictCandidacyListQuery | undefined, PredictCandidacyListQueryVariables>;
export function usePredictCandidacyListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PredictCandidacyListQuery, PredictCandidacyListQueryVariables>(PredictCandidacyListDocument, options);
        }
export type PredictCandidacyListQueryHookResult = ReturnType<typeof usePredictCandidacyListQuery>;
export type PredictCandidacyListLazyQueryHookResult = ReturnType<typeof usePredictCandidacyListLazyQuery>;
export type PredictCandidacyListSuspenseQueryHookResult = ReturnType<typeof usePredictCandidacyListSuspenseQuery>;
export const GetClinicalConstraintTemplatesForEpisodeDocument = gql`
    query GetClinicalConstraintTemplatesForEpisode($serviceLineId: Int!) @permission(requires: managePatients) {
  clinicalConstraintTemplate(
    where: {serviceLineId: {eq: $serviceLineId}, deleted: {eq: false}}
    orderBy: {name: {direction: asc, priority: 1}}
  ) {
    id
    serviceLineId
    name
    description
    rruleFreq
    durationDays
    firstVisitTypeId
    firstVisitServiceIds
    firstVisitDuration
    requirements(
      where: {deleted: {eq: false}}
      orderBy: {id: {direction: asc, priority: 1}}
    ) {
      id
      templateId
      visitTypeId
      duration
      rruleInterval
      rruleByweekday
      earliestStartTime
      latestStartTime
      minTimeFromLastVisit
      maxTimeFromLastVisit
      serviceIds
    }
  }
}
    `;

/**
 * __useGetClinicalConstraintTemplatesForEpisodeQuery__
 *
 * To run a query within a React component, call `useGetClinicalConstraintTemplatesForEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicalConstraintTemplatesForEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicalConstraintTemplatesForEpisodeQuery({
 *   variables: {
 *      serviceLineId: // value for 'serviceLineId'
 *   },
 * });
 */
export function useGetClinicalConstraintTemplatesForEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables> & ({ variables: GetClinicalConstraintTemplatesForEpisodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables>(GetClinicalConstraintTemplatesForEpisodeDocument, options);
      }
export function useGetClinicalConstraintTemplatesForEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables>(GetClinicalConstraintTemplatesForEpisodeDocument, options);
        }
// @ts-ignore
export function useGetClinicalConstraintTemplatesForEpisodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables>;
export function useGetClinicalConstraintTemplatesForEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetClinicalConstraintTemplatesForEpisodeQuery | undefined, GetClinicalConstraintTemplatesForEpisodeQueryVariables>;
export function useGetClinicalConstraintTemplatesForEpisodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicalConstraintTemplatesForEpisodeQuery, GetClinicalConstraintTemplatesForEpisodeQueryVariables>(GetClinicalConstraintTemplatesForEpisodeDocument, options);
        }
export type GetClinicalConstraintTemplatesForEpisodeQueryHookResult = ReturnType<typeof useGetClinicalConstraintTemplatesForEpisodeQuery>;
export type GetClinicalConstraintTemplatesForEpisodeLazyQueryHookResult = ReturnType<typeof useGetClinicalConstraintTemplatesForEpisodeLazyQuery>;
export type GetClinicalConstraintTemplatesForEpisodeSuspenseQueryHookResult = ReturnType<typeof useGetClinicalConstraintTemplatesForEpisodeSuspenseQuery>;
export const GetClinicalConstraintTemplatesForConfigDocument = gql`
    query GetClinicalConstraintTemplatesForConfig @permission(requires: manageOrgConfig) {
  clinicalConstraintTemplate(
    where: {deleted: {eq: false}}
    orderBy: {name: {direction: asc, priority: 1}}
  ) {
    id
    serviceLineId
    name
    description
    rruleFreq
    durationDays
    updatedAt
    firstVisitTypeId
    firstVisitServiceIds
    firstVisitDuration
    requirements(
      where: {deleted: {eq: false}}
      orderBy: {id: {direction: asc, priority: 1}}
    ) {
      id
      templateId
      visitTypeId
      duration
      rruleInterval
      rruleByweekday
      earliestStartTime
      latestStartTime
      minTimeFromLastVisit
      maxTimeFromLastVisit
      serviceIds
    }
  }
}
    `;

/**
 * __useGetClinicalConstraintTemplatesForConfigQuery__
 *
 * To run a query within a React component, call `useGetClinicalConstraintTemplatesForConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicalConstraintTemplatesForConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicalConstraintTemplatesForConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClinicalConstraintTemplatesForConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>(GetClinicalConstraintTemplatesForConfigDocument, options);
      }
export function useGetClinicalConstraintTemplatesForConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>(GetClinicalConstraintTemplatesForConfigDocument, options);
        }
// @ts-ignore
export function useGetClinicalConstraintTemplatesForConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>;
export function useGetClinicalConstraintTemplatesForConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetClinicalConstraintTemplatesForConfigQuery | undefined, GetClinicalConstraintTemplatesForConfigQueryVariables>;
export function useGetClinicalConstraintTemplatesForConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClinicalConstraintTemplatesForConfigQuery, GetClinicalConstraintTemplatesForConfigQueryVariables>(GetClinicalConstraintTemplatesForConfigDocument, options);
        }
export type GetClinicalConstraintTemplatesForConfigQueryHookResult = ReturnType<typeof useGetClinicalConstraintTemplatesForConfigQuery>;
export type GetClinicalConstraintTemplatesForConfigLazyQueryHookResult = ReturnType<typeof useGetClinicalConstraintTemplatesForConfigLazyQuery>;
export type GetClinicalConstraintTemplatesForConfigSuspenseQueryHookResult = ReturnType<typeof useGetClinicalConstraintTemplatesForConfigSuspenseQuery>;
export const CreateClinicalConstraintTemplateDocument = gql`
    mutation CreateClinicalConstraintTemplate($serviceLineId: Int!, $name: String!, $description: String, $rruleFreq: String!, $durationDays: Int!, $firstVisitTypeId: Int, $firstVisitServiceIds: [Int!], $firstVisitDuration: Int, $requirements: [ClinicalConstraintTemplateRequirementInput!]!) @permission(requires: manageOrgConfig) {
  createClinicalConstraintTemplate(
    serviceLineId: $serviceLineId
    name: $name
    description: $description
    rruleFreq: $rruleFreq
    durationDays: $durationDays
    firstVisitTypeId: $firstVisitTypeId
    firstVisitServiceIds: $firstVisitServiceIds
    firstVisitDuration: $firstVisitDuration
    requirements: $requirements
  ) {
    id
    serviceLineId
    name
    description
    rruleFreq
    durationDays
    updatedAt
  }
}
    `;
export type CreateClinicalConstraintTemplateMutationFn = Apollo.MutationFunction<CreateClinicalConstraintTemplateMutation, CreateClinicalConstraintTemplateMutationVariables>;

/**
 * __useCreateClinicalConstraintTemplateMutation__
 *
 * To run a mutation, you first call `useCreateClinicalConstraintTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClinicalConstraintTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClinicalConstraintTemplateMutation, { data, loading, error }] = useCreateClinicalConstraintTemplateMutation({
 *   variables: {
 *      serviceLineId: // value for 'serviceLineId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      rruleFreq: // value for 'rruleFreq'
 *      durationDays: // value for 'durationDays'
 *      firstVisitTypeId: // value for 'firstVisitTypeId'
 *      firstVisitServiceIds: // value for 'firstVisitServiceIds'
 *      firstVisitDuration: // value for 'firstVisitDuration'
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useCreateClinicalConstraintTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateClinicalConstraintTemplateMutation, CreateClinicalConstraintTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClinicalConstraintTemplateMutation, CreateClinicalConstraintTemplateMutationVariables>(CreateClinicalConstraintTemplateDocument, options);
      }
export type CreateClinicalConstraintTemplateMutationHookResult = ReturnType<typeof useCreateClinicalConstraintTemplateMutation>;
export type CreateClinicalConstraintTemplateMutationOptions = Apollo.BaseMutationOptions<CreateClinicalConstraintTemplateMutation, CreateClinicalConstraintTemplateMutationVariables>;
export const UpdateClinicalConstraintTemplateDocument = gql`
    mutation UpdateClinicalConstraintTemplate($id: Int!, $name: String, $description: String, $rruleFreq: String, $durationDays: Int, $firstVisitTypeId: Int, $firstVisitServiceIds: [Int!], $firstVisitDuration: Int, $requirements: [ClinicalConstraintTemplateRequirementUpsertInput!]!) @permission(requires: manageOrgConfig) {
  updateClinicalConstraintTemplate(
    id: $id
    name: $name
    description: $description
    rruleFreq: $rruleFreq
    durationDays: $durationDays
    firstVisitTypeId: $firstVisitTypeId
    firstVisitServiceIds: $firstVisitServiceIds
    firstVisitDuration: $firstVisitDuration
    requirements: $requirements
  ) {
    id
    updatedAt
  }
}
    `;
export type UpdateClinicalConstraintTemplateMutationFn = Apollo.MutationFunction<UpdateClinicalConstraintTemplateMutation, UpdateClinicalConstraintTemplateMutationVariables>;

/**
 * __useUpdateClinicalConstraintTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateClinicalConstraintTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClinicalConstraintTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClinicalConstraintTemplateMutation, { data, loading, error }] = useUpdateClinicalConstraintTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      rruleFreq: // value for 'rruleFreq'
 *      durationDays: // value for 'durationDays'
 *      firstVisitTypeId: // value for 'firstVisitTypeId'
 *      firstVisitServiceIds: // value for 'firstVisitServiceIds'
 *      firstVisitDuration: // value for 'firstVisitDuration'
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useUpdateClinicalConstraintTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClinicalConstraintTemplateMutation, UpdateClinicalConstraintTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClinicalConstraintTemplateMutation, UpdateClinicalConstraintTemplateMutationVariables>(UpdateClinicalConstraintTemplateDocument, options);
      }
export type UpdateClinicalConstraintTemplateMutationHookResult = ReturnType<typeof useUpdateClinicalConstraintTemplateMutation>;
export type UpdateClinicalConstraintTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateClinicalConstraintTemplateMutation, UpdateClinicalConstraintTemplateMutationVariables>;
export const DeleteClinicalConstraintTemplateDocument = gql`
    mutation DeleteClinicalConstraintTemplate($id: Int!) @permission(requires: manageOrgConfig) {
  deleteClinicalConstraintTemplate(id: $id) {
    id
    deleted
    updatedAt
  }
}
    `;
export type DeleteClinicalConstraintTemplateMutationFn = Apollo.MutationFunction<DeleteClinicalConstraintTemplateMutation, DeleteClinicalConstraintTemplateMutationVariables>;

/**
 * __useDeleteClinicalConstraintTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteClinicalConstraintTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClinicalConstraintTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClinicalConstraintTemplateMutation, { data, loading, error }] = useDeleteClinicalConstraintTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClinicalConstraintTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClinicalConstraintTemplateMutation, DeleteClinicalConstraintTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClinicalConstraintTemplateMutation, DeleteClinicalConstraintTemplateMutationVariables>(DeleteClinicalConstraintTemplateDocument, options);
      }
export type DeleteClinicalConstraintTemplateMutationHookResult = ReturnType<typeof useDeleteClinicalConstraintTemplateMutation>;
export type DeleteClinicalConstraintTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteClinicalConstraintTemplateMutation, DeleteClinicalConstraintTemplateMutationVariables>;
export const CreateEpisodeDocument = gql`
    mutation CreateEpisode($patientId: Int!, $serviceLineId: Int!, $organizationalUnitId: Int, $autoschedulerGroup: Int, $careRequirements: [CareRequirementInput!], $precautionIds: [Int!]) @permission(requires: managePatients, check: [userInServiceLine]) {
  createEpisode(
    patientId: $patientId
    serviceLineId: $serviceLineId
    organizationalUnitId: $organizationalUnitId
    autoschedulerGroup: $autoschedulerGroup
    careRequirements: $careRequirements
    precautionIds: $precautionIds
  ) {
    id
    active
    serviceLineId
    organizationalUnitId
    updatedAt
  }
}
    `;
export type CreateEpisodeMutationFn = Apollo.MutationFunction<CreateEpisodeMutation, CreateEpisodeMutationVariables>;

/**
 * __useCreateEpisodeMutation__
 *
 * To run a mutation, you first call `useCreateEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpisodeMutation, { data, loading, error }] = useCreateEpisodeMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      serviceLineId: // value for 'serviceLineId'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      autoschedulerGroup: // value for 'autoschedulerGroup'
 *      careRequirements: // value for 'careRequirements'
 *      precautionIds: // value for 'precautionIds'
 *   },
 * });
 */
export function useCreateEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEpisodeMutation, CreateEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEpisodeMutation, CreateEpisodeMutationVariables>(CreateEpisodeDocument, options);
      }
export type CreateEpisodeMutationHookResult = ReturnType<typeof useCreateEpisodeMutation>;
export type CreateEpisodeMutationOptions = Apollo.BaseMutationOptions<CreateEpisodeMutation, CreateEpisodeMutationVariables>;
export const GetEpisodeCareRequirementsDocument = gql`
    query GetEpisodeCareRequirements($episodeId: Int!) @permission(requires: managePatients) {
  episodeSingle(where: {id: {eq: $episodeId}}) {
    id
    autoschedulerGroup
    organizationalUnitId
  }
  careRequirement(
    where: {episodeId: {eq: $episodeId}}
    orderBy: {id: {direction: asc, priority: 1}}
  ) {
    id
    episodeId
    visitTypeId
    duration
    rruleFreq
    rruleDtstart
    rruleUntil
    rruleInterval
    rruleByweekday
    earliestStartTime
    latestStartTime
    minTimeFromLastVisit
    maxTimeFromLastVisit
    dayOfAdmission
    services {
      id
      serviceId
      deleted
      service {
        id
        name
      }
    }
  }
  visit(
    where: {episodeId: {eq: $episodeId}, eventStatus: {notInArray: [scheduled, canceled]}}
    limit: 1
  ) {
    id
  }
}
    `;

/**
 * __useGetEpisodeCareRequirementsQuery__
 *
 * To run a query within a React component, call `useGetEpisodeCareRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeCareRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeCareRequirementsQuery({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *   },
 * });
 */
export function useGetEpisodeCareRequirementsQuery(baseOptions: Apollo.QueryHookOptions<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables> & ({ variables: GetEpisodeCareRequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables>(GetEpisodeCareRequirementsDocument, options);
      }
export function useGetEpisodeCareRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables>(GetEpisodeCareRequirementsDocument, options);
        }
// @ts-ignore
export function useGetEpisodeCareRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables>;
export function useGetEpisodeCareRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEpisodeCareRequirementsQuery | undefined, GetEpisodeCareRequirementsQueryVariables>;
export function useGetEpisodeCareRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEpisodeCareRequirementsQuery, GetEpisodeCareRequirementsQueryVariables>(GetEpisodeCareRequirementsDocument, options);
        }
export type GetEpisodeCareRequirementsQueryHookResult = ReturnType<typeof useGetEpisodeCareRequirementsQuery>;
export type GetEpisodeCareRequirementsLazyQueryHookResult = ReturnType<typeof useGetEpisodeCareRequirementsLazyQuery>;
export type GetEpisodeCareRequirementsSuspenseQueryHookResult = ReturnType<typeof useGetEpisodeCareRequirementsSuspenseQuery>;
export const UpdateEpisodeDocument = gql`
    mutation UpdateEpisode($episodeId: Int!, $organizationalUnitId: Int, $active: Boolean, $autoschedulerGroup: Int, $careRequirements: [CareRequirementUpsertInput!], $precautionIds: [Int!]) @permission(requires: managePatients, check: [userInEpisodeServiceLine]) {
  updateEpisode(
    id: $episodeId
    organizationalUnitId: $organizationalUnitId
    active: $active
    autoschedulerGroup: $autoschedulerGroup
    careRequirements: $careRequirements
    precautionIds: $precautionIds
  ) {
    id
    active
    serviceLineId
    organizationalUnitId
    updatedAt
    precautions {
      id
      precautionId
    }
  }
}
    `;
export type UpdateEpisodeMutationFn = Apollo.MutationFunction<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>;

/**
 * __useUpdateEpisodeMutation__
 *
 * To run a mutation, you first call `useUpdateEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEpisodeMutation, { data, loading, error }] = useUpdateEpisodeMutation({
 *   variables: {
 *      episodeId: // value for 'episodeId'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      active: // value for 'active'
 *      autoschedulerGroup: // value for 'autoschedulerGroup'
 *      careRequirements: // value for 'careRequirements'
 *      precautionIds: // value for 'precautionIds'
 *   },
 * });
 */
export function useUpdateEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>(UpdateEpisodeDocument, options);
      }
export type UpdateEpisodeMutationHookResult = ReturnType<typeof useUpdateEpisodeMutation>;
export type UpdateEpisodeMutationOptions = Apollo.BaseMutationOptions<UpdateEpisodeMutation, UpdateEpisodeMutationVariables>;
export const GetProviderSelectItemsDocument = gql`
    query GetProviderSelectItems @permission(requires: useWebApp) {
  provider {
    id
    firstName
    lastName
    providerTypeId
  }
}
    `;

/**
 * __useGetProviderSelectItemsQuery__
 *
 * To run a query within a React component, call `useGetProviderSelectItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderSelectItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderSelectItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProviderSelectItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>(GetProviderSelectItemsDocument, options);
      }
export function useGetProviderSelectItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>(GetProviderSelectItemsDocument, options);
        }
// @ts-ignore
export function useGetProviderSelectItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>;
export function useGetProviderSelectItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderSelectItemsQuery | undefined, GetProviderSelectItemsQueryVariables>;
export function useGetProviderSelectItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderSelectItemsQuery, GetProviderSelectItemsQueryVariables>(GetProviderSelectItemsDocument, options);
        }
export type GetProviderSelectItemsQueryHookResult = ReturnType<typeof useGetProviderSelectItemsQuery>;
export type GetProviderSelectItemsLazyQueryHookResult = ReturnType<typeof useGetProviderSelectItemsLazyQuery>;
export type GetProviderSelectItemsSuspenseQueryHookResult = ReturnType<typeof useGetProviderSelectItemsSuspenseQuery>;
export const CommandIndexProvidersDocument = gql`
    query CommandIndexProviders($includeShifts: Boolean = false, $start: String, $end: String, $active: Boolean, $organizationalUnitSegmentationEnabled: Boolean = false) @permission(requires: useWebApp) {
  commandIndexProviders(where: {active: {eq: $active}}) {
    providers {
      id
      firstName
      lastName
      addressStreet
      addressLineTwo
      addressCity
      addressState
      addressZip
      addressCoordinates
      addressTimezone
      external
      providerTypeId
      providerType {
        id
        name
        requireStateLicense
      }
      traits {
        trait
        value
      }
      teamProviders {
        teamId
      }
      active
      serviceLineProviders {
        serviceLineId
        serviceLine {
          id
          visitTypeServiceLines {
            visitTypeId
          }
        }
      }
    }
    providersByType {
      typeId
      typeName
      providers {
        id
        firstName
        lastName
        addressStreet
        addressLineTwo
        addressCity
        addressState
        addressZip
        addressCoordinates
        addressTimezone
        external
        providerTypeId
        providerType {
          id
          name
          requireStateLicense
        }
        traits {
          trait
          value
        }
        teamProviders {
          teamId
        }
        active
        serviceLineProviders {
          serviceLineId
          serviceLine {
            id
            visitTypeServiceLines {
              visitTypeId
            }
          }
        }
      }
    }
  }
  organizationalUnitOrgUser @include(if: $organizationalUnitSegmentationEnabled) {
    organizationalUnitId
    orgUser {
      providers {
        id
      }
    }
  }
  organizationalUnit @include(if: $organizationalUnitSegmentationEnabled) {
    id
    active
  }
  shift(where: {startTime: {gte: $start, lt: $end}}) @include(if: $includeShifts) {
    id
    startTime
    endTime
    providerTravel
    status
    providerId
    addressCoordinates
    addressTimezone
    manualEdits
    overflowShift
    updatedBy
    shiftCenterId
    useShiftCenterDriveTimes
  }
}
    `;

/**
 * __useCommandIndexProvidersQuery__
 *
 * To run a query within a React component, call `useCommandIndexProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommandIndexProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommandIndexProvidersQuery({
 *   variables: {
 *      includeShifts: // value for 'includeShifts'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      active: // value for 'active'
 *      organizationalUnitSegmentationEnabled: // value for 'organizationalUnitSegmentationEnabled'
 *   },
 * });
 */
export function useCommandIndexProvidersQuery(baseOptions?: Apollo.QueryHookOptions<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>(CommandIndexProvidersDocument, options);
      }
export function useCommandIndexProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>(CommandIndexProvidersDocument, options);
        }
// @ts-ignore
export function useCommandIndexProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>;
export function useCommandIndexProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<CommandIndexProvidersQuery | undefined, CommandIndexProvidersQueryVariables>;
export function useCommandIndexProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommandIndexProvidersQuery, CommandIndexProvidersQueryVariables>(CommandIndexProvidersDocument, options);
        }
export type CommandIndexProvidersQueryHookResult = ReturnType<typeof useCommandIndexProvidersQuery>;
export type CommandIndexProvidersLazyQueryHookResult = ReturnType<typeof useCommandIndexProvidersLazyQuery>;
export type CommandIndexProvidersSuspenseQueryHookResult = ReturnType<typeof useCommandIndexProvidersSuspenseQuery>;
export const PatientLocationDocument = gql`
    query PatientLocation($patientId: Int!) @permission(requires: useWebApp) {
  patientSingle(where: {id: {eq: $patientId}}) {
    firstName
    lastName
    addressCoordinates
  }
}
    `;

/**
 * __usePatientLocationQuery__
 *
 * To run a query within a React component, call `usePatientLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientLocationQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientLocationQuery(baseOptions: Apollo.QueryHookOptions<PatientLocationQuery, PatientLocationQueryVariables> & ({ variables: PatientLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientLocationQuery, PatientLocationQueryVariables>(PatientLocationDocument, options);
      }
export function usePatientLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientLocationQuery, PatientLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientLocationQuery, PatientLocationQueryVariables>(PatientLocationDocument, options);
        }
// @ts-ignore
export function usePatientLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PatientLocationQuery, PatientLocationQueryVariables>): Apollo.UseSuspenseQueryResult<PatientLocationQuery, PatientLocationQueryVariables>;
export function usePatientLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatientLocationQuery, PatientLocationQueryVariables>): Apollo.UseSuspenseQueryResult<PatientLocationQuery | undefined, PatientLocationQueryVariables>;
export function usePatientLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatientLocationQuery, PatientLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PatientLocationQuery, PatientLocationQueryVariables>(PatientLocationDocument, options);
        }
export type PatientLocationQueryHookResult = ReturnType<typeof usePatientLocationQuery>;
export type PatientLocationLazyQueryHookResult = ReturnType<typeof usePatientLocationLazyQuery>;
export type PatientLocationSuspenseQueryHookResult = ReturnType<typeof usePatientLocationSuspenseQuery>;
export const ProviderRolesDocument = gql`
    query ProviderRoles @permission(requires: manageProviderShifts) {
  provider(where: {active: {eq: true}}) {
    id
    firstName
    lastName
    OrganizationUser {
      id
      roles {
        globalUserRole
      }
      user {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useProviderRolesQuery__
 *
 * To run a query within a React component, call `useProviderRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderRolesQuery(baseOptions?: Apollo.QueryHookOptions<ProviderRolesQuery, ProviderRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderRolesQuery, ProviderRolesQueryVariables>(ProviderRolesDocument, options);
      }
export function useProviderRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderRolesQuery, ProviderRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderRolesQuery, ProviderRolesQueryVariables>(ProviderRolesDocument, options);
        }
// @ts-ignore
export function useProviderRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderRolesQuery, ProviderRolesQueryVariables>): Apollo.UseSuspenseQueryResult<ProviderRolesQuery, ProviderRolesQueryVariables>;
export function useProviderRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderRolesQuery, ProviderRolesQueryVariables>): Apollo.UseSuspenseQueryResult<ProviderRolesQuery | undefined, ProviderRolesQueryVariables>;
export function useProviderRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderRolesQuery, ProviderRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderRolesQuery, ProviderRolesQueryVariables>(ProviderRolesDocument, options);
        }
export type ProviderRolesQueryHookResult = ReturnType<typeof useProviderRolesQuery>;
export type ProviderRolesLazyQueryHookResult = ReturnType<typeof useProviderRolesLazyQuery>;
export type ProviderRolesSuspenseQueryHookResult = ReturnType<typeof useProviderRolesSuspenseQuery>;
export const AddProvidersRoleDocument = gql`
    mutation AddProvidersRole($organizationUserIds: [Int!]!, $role: OrganizationUserRoleGlobalUserRoleEnum!) @permission(requires: manageProviderShifts) {
  addRoleToOrganizationUsers(ids: $organizationUserIds, role: $role) {
    count
  }
}
    `;
export type AddProvidersRoleMutationFn = Apollo.MutationFunction<AddProvidersRoleMutation, AddProvidersRoleMutationVariables>;

/**
 * __useAddProvidersRoleMutation__
 *
 * To run a mutation, you first call `useAddProvidersRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProvidersRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProvidersRoleMutation, { data, loading, error }] = useAddProvidersRoleMutation({
 *   variables: {
 *      organizationUserIds: // value for 'organizationUserIds'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddProvidersRoleMutation(baseOptions?: Apollo.MutationHookOptions<AddProvidersRoleMutation, AddProvidersRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProvidersRoleMutation, AddProvidersRoleMutationVariables>(AddProvidersRoleDocument, options);
      }
export type AddProvidersRoleMutationHookResult = ReturnType<typeof useAddProvidersRoleMutation>;
export type AddProvidersRoleMutationOptions = Apollo.BaseMutationOptions<AddProvidersRoleMutation, AddProvidersRoleMutationVariables>;
export const RemoveProvidersRoleDocument = gql`
    mutation RemoveProvidersRole($organizationUserIds: [Int!]!, $role: OrganizationUserRoleGlobalUserRoleEnum!) @permission(requires: manageProviderShifts) {
  removeRoleFromOrganizationUsers(ids: $organizationUserIds, role: $role) {
    count
  }
}
    `;
export type RemoveProvidersRoleMutationFn = Apollo.MutationFunction<RemoveProvidersRoleMutation, RemoveProvidersRoleMutationVariables>;

/**
 * __useRemoveProvidersRoleMutation__
 *
 * To run a mutation, you first call `useRemoveProvidersRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProvidersRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProvidersRoleMutation, { data, loading, error }] = useRemoveProvidersRoleMutation({
 *   variables: {
 *      organizationUserIds: // value for 'organizationUserIds'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useRemoveProvidersRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProvidersRoleMutation, RemoveProvidersRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProvidersRoleMutation, RemoveProvidersRoleMutationVariables>(RemoveProvidersRoleDocument, options);
      }
export type RemoveProvidersRoleMutationHookResult = ReturnType<typeof useRemoveProvidersRoleMutation>;
export type RemoveProvidersRoleMutationOptions = Apollo.BaseMutationOptions<RemoveProvidersRoleMutation, RemoveProvidersRoleMutationVariables>;
export const AvailabilityByTimespanDocument = gql`
    query AvailabilityByTimespan($start: String!) @permission(requires: manageProviderShifts) {
  availability(where: {rruleUntil: {OR: [{isNull: true}, {gte: $start}]}}) {
    id
    type
    note
    startTime
    endTime
    providerId
    providerTravel
    shiftCenterId
    overflowShift
    useShiftCenterDriveTimes
    blockType
    blockFilters {
      visitTypeIds
    }
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressTimezone
    addressCoordinates
    rruleFreq
    rruleDtstart
    rruleUntil
    rruleInterval
    rruleByweekday
  }
  provider(where: {active: {eq: true}}) {
    id
    addressTimezone
    firstName
    lastName
    providerTypeId
    addressStreet
    addressCity
    addressState
    teamProviders {
      teamId
    }
    serviceLineProviders {
      serviceLineId
    }
    organizationUserId
  }
  shift(where: {startTime: {gte: $start}, manualEdits: {eq: true}}) {
    id
    addressTimezone
    providerId
    startTime
  }
  calendarBlock(
    where: {OR: [{startTime: {gte: $start}, availabilityId: {isNull: false}, manualEdits: {eq: true}}, {startTime: {gte: $start}, availabilityId: {isNull: false}, eventStatus: {eq: canceled}}]}
  ) {
    id
    startTime
    availabilityId
  }
  team {
    id
    name
  }
}
    `;

/**
 * __useAvailabilityByTimespanQuery__
 *
 * To run a query within a React component, call `useAvailabilityByTimespanQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityByTimespanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityByTimespanQuery({
 *   variables: {
 *      start: // value for 'start'
 *   },
 * });
 */
export function useAvailabilityByTimespanQuery(baseOptions: Apollo.QueryHookOptions<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables> & ({ variables: AvailabilityByTimespanQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables>(AvailabilityByTimespanDocument, options);
      }
export function useAvailabilityByTimespanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables>(AvailabilityByTimespanDocument, options);
        }
// @ts-ignore
export function useAvailabilityByTimespanSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables>;
export function useAvailabilityByTimespanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables>): Apollo.UseSuspenseQueryResult<AvailabilityByTimespanQuery | undefined, AvailabilityByTimespanQueryVariables>;
export function useAvailabilityByTimespanSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailabilityByTimespanQuery, AvailabilityByTimespanQueryVariables>(AvailabilityByTimespanDocument, options);
        }
export type AvailabilityByTimespanQueryHookResult = ReturnType<typeof useAvailabilityByTimespanQuery>;
export type AvailabilityByTimespanLazyQueryHookResult = ReturnType<typeof useAvailabilityByTimespanLazyQuery>;
export type AvailabilityByTimespanSuspenseQueryHookResult = ReturnType<typeof useAvailabilityByTimespanSuspenseQuery>;
export const CensusPatientLocationDocument = gql`
    query CensusPatientLocation($limit: Int!) @permission(requires: useWebApp) {
  activePatients(
    offset: 0
    orderBy: {id: {direction: asc, priority: 1}}
    limit: $limit
  ) {
    id
    firstName
    lastName
    addressCoordinates
  }
}
    `;

/**
 * __useCensusPatientLocationQuery__
 *
 * To run a query within a React component, call `useCensusPatientLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCensusPatientLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCensusPatientLocationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCensusPatientLocationQuery(baseOptions: Apollo.QueryHookOptions<CensusPatientLocationQuery, CensusPatientLocationQueryVariables> & ({ variables: CensusPatientLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CensusPatientLocationQuery, CensusPatientLocationQueryVariables>(CensusPatientLocationDocument, options);
      }
export function useCensusPatientLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CensusPatientLocationQuery, CensusPatientLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CensusPatientLocationQuery, CensusPatientLocationQueryVariables>(CensusPatientLocationDocument, options);
        }
// @ts-ignore
export function useCensusPatientLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CensusPatientLocationQuery, CensusPatientLocationQueryVariables>): Apollo.UseSuspenseQueryResult<CensusPatientLocationQuery, CensusPatientLocationQueryVariables>;
export function useCensusPatientLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CensusPatientLocationQuery, CensusPatientLocationQueryVariables>): Apollo.UseSuspenseQueryResult<CensusPatientLocationQuery | undefined, CensusPatientLocationQueryVariables>;
export function useCensusPatientLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CensusPatientLocationQuery, CensusPatientLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CensusPatientLocationQuery, CensusPatientLocationQueryVariables>(CensusPatientLocationDocument, options);
        }
export type CensusPatientLocationQueryHookResult = ReturnType<typeof useCensusPatientLocationQuery>;
export type CensusPatientLocationLazyQueryHookResult = ReturnType<typeof useCensusPatientLocationLazyQuery>;
export type CensusPatientLocationSuspenseQueryHookResult = ReturnType<typeof useCensusPatientLocationSuspenseQuery>;
export const UpdateVisitResourceMutationDocument = gql`
    mutation UpdateVisitResourceMutation($id: Int!, $endOfShiftDriveTime: Int, $startOfShiftDriveTime: Int, $interVisitDriveTime: Int, $startTime: String, $endTime: String, $providerId: Int) @permission(requires: createDragEvents) {
  updateVisitResourceObject(
    id: $id
    endOfShiftDriveTime: $endOfShiftDriveTime
    startOfShiftDriveTime: $startOfShiftDriveTime
    interVisitDriveTime: $interVisitDriveTime
    startTime: $startTime
    endTime: $endTime
    providerId: $providerId
  ) {
    id
  }
}
    `;
export type UpdateVisitResourceMutationMutationFn = Apollo.MutationFunction<UpdateVisitResourceMutationMutation, UpdateVisitResourceMutationMutationVariables>;

/**
 * __useUpdateVisitResourceMutationMutation__
 *
 * To run a mutation, you first call `useUpdateVisitResourceMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitResourceMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitResourceMutationMutation, { data, loading, error }] = useUpdateVisitResourceMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      endOfShiftDriveTime: // value for 'endOfShiftDriveTime'
 *      startOfShiftDriveTime: // value for 'startOfShiftDriveTime'
 *      interVisitDriveTime: // value for 'interVisitDriveTime'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useUpdateVisitResourceMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitResourceMutationMutation, UpdateVisitResourceMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitResourceMutationMutation, UpdateVisitResourceMutationMutationVariables>(UpdateVisitResourceMutationDocument, options);
      }
export type UpdateVisitResourceMutationMutationHookResult = ReturnType<typeof useUpdateVisitResourceMutationMutation>;
export type UpdateVisitResourceMutationMutationOptions = Apollo.BaseMutationOptions<UpdateVisitResourceMutationMutation, UpdateVisitResourceMutationMutationVariables>;
export const UpdateCalendarBlockMutationDocument = gql`
    mutation UpdateCalendarBlockMutation($id: Int!, $providerId: Int, $startTime: String, $endTime: String, $startOfShiftDriveTime: Int, $endOfShiftDriveTime: Int, $interVisitDriveTime: Int) @permission(requires: createDragEvents) {
  updateCalendarBlock(
    id: $id
    providerId: $providerId
    startTime: $startTime
    endTime: $endTime
    startOfShiftDriveTime: $startOfShiftDriveTime
    endOfShiftDriveTime: $endOfShiftDriveTime
    interVisitDriveTime: $interVisitDriveTime
  ) {
    id
    providerId
    startTime
    endTime
    startOfShiftDriveTime
    endOfShiftDriveTime
    interVisitDriveTime
  }
}
    `;
export type UpdateCalendarBlockMutationMutationFn = Apollo.MutationFunction<UpdateCalendarBlockMutationMutation, UpdateCalendarBlockMutationMutationVariables>;

/**
 * __useUpdateCalendarBlockMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCalendarBlockMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCalendarBlockMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCalendarBlockMutationMutation, { data, loading, error }] = useUpdateCalendarBlockMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      providerId: // value for 'providerId'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      startOfShiftDriveTime: // value for 'startOfShiftDriveTime'
 *      endOfShiftDriveTime: // value for 'endOfShiftDriveTime'
 *      interVisitDriveTime: // value for 'interVisitDriveTime'
 *   },
 * });
 */
export function useUpdateCalendarBlockMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCalendarBlockMutationMutation, UpdateCalendarBlockMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCalendarBlockMutationMutation, UpdateCalendarBlockMutationMutationVariables>(UpdateCalendarBlockMutationDocument, options);
      }
export type UpdateCalendarBlockMutationMutationHookResult = ReturnType<typeof useUpdateCalendarBlockMutationMutation>;
export type UpdateCalendarBlockMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCalendarBlockMutationMutation, UpdateCalendarBlockMutationMutationVariables>;
export const CommandActivePatientsDocument = gql`
    query CommandActivePatients($orderBy: ActivePatientOrderBy!, $offset: Int!, $limit: Int!) @permission(requires: useWebApp) {
  activePatients(offset: $offset, limit: $limit, orderBy: $orderBy) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useCommandActivePatientsQuery__
 *
 * To run a query within a React component, call `useCommandActivePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommandActivePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommandActivePatientsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCommandActivePatientsQuery(baseOptions: Apollo.QueryHookOptions<CommandActivePatientsQuery, CommandActivePatientsQueryVariables> & ({ variables: CommandActivePatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommandActivePatientsQuery, CommandActivePatientsQueryVariables>(CommandActivePatientsDocument, options);
      }
export function useCommandActivePatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommandActivePatientsQuery, CommandActivePatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommandActivePatientsQuery, CommandActivePatientsQueryVariables>(CommandActivePatientsDocument, options);
        }
// @ts-ignore
export function useCommandActivePatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommandActivePatientsQuery, CommandActivePatientsQueryVariables>): Apollo.UseSuspenseQueryResult<CommandActivePatientsQuery, CommandActivePatientsQueryVariables>;
export function useCommandActivePatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommandActivePatientsQuery, CommandActivePatientsQueryVariables>): Apollo.UseSuspenseQueryResult<CommandActivePatientsQuery | undefined, CommandActivePatientsQueryVariables>;
export function useCommandActivePatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommandActivePatientsQuery, CommandActivePatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommandActivePatientsQuery, CommandActivePatientsQueryVariables>(CommandActivePatientsDocument, options);
        }
export type CommandActivePatientsQueryHookResult = ReturnType<typeof useCommandActivePatientsQuery>;
export type CommandActivePatientsLazyQueryHookResult = ReturnType<typeof useCommandActivePatientsLazyQuery>;
export type CommandActivePatientsSuspenseQueryHookResult = ReturnType<typeof useCommandActivePatientsSuspenseQuery>;
export const ScheduleVisitFromVisitRequestDocument = gql`
    mutation ScheduleVisitFromVisitRequest($patientId: Int!, $serviceLineId: Int!, $visitTypeId: Int!, $startTime: String!, $resources: [NewOverrideVisitResourceInput!]!, $serviceIds: [Int!]!, $duration: Int!, $visitWarningLogId: Int, $taskId: Int) @permission(requires: createDragEvents, check: [userInServiceLine]) {
  scheduleOverrideVisit(
    patientId: $patientId
    serviceLineId: $serviceLineId
    visitTypeId: $visitTypeId
    startTime: $startTime
    resources: $resources
    serviceIds: $serviceIds
    duration: $duration
    visitWarningLogId: $visitWarningLogId
    taskId: $taskId
  ) {
    id
    visitResources {
      id
      providerId
      startOfShiftDriveTime
      interVisitDriveTime
      endOfShiftDriveTime
    }
  }
}
    `;
export type ScheduleVisitFromVisitRequestMutationFn = Apollo.MutationFunction<ScheduleVisitFromVisitRequestMutation, ScheduleVisitFromVisitRequestMutationVariables>;

/**
 * __useScheduleVisitFromVisitRequestMutation__
 *
 * To run a mutation, you first call `useScheduleVisitFromVisitRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleVisitFromVisitRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleVisitFromVisitRequestMutation, { data, loading, error }] = useScheduleVisitFromVisitRequestMutation({
 *   variables: {
 *      patientId: // value for 'patientId'
 *      serviceLineId: // value for 'serviceLineId'
 *      visitTypeId: // value for 'visitTypeId'
 *      startTime: // value for 'startTime'
 *      resources: // value for 'resources'
 *      serviceIds: // value for 'serviceIds'
 *      duration: // value for 'duration'
 *      visitWarningLogId: // value for 'visitWarningLogId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useScheduleVisitFromVisitRequestMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleVisitFromVisitRequestMutation, ScheduleVisitFromVisitRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleVisitFromVisitRequestMutation, ScheduleVisitFromVisitRequestMutationVariables>(ScheduleVisitFromVisitRequestDocument, options);
      }
export type ScheduleVisitFromVisitRequestMutationHookResult = ReturnType<typeof useScheduleVisitFromVisitRequestMutation>;
export type ScheduleVisitFromVisitRequestMutationOptions = Apollo.BaseMutationOptions<ScheduleVisitFromVisitRequestMutation, ScheduleVisitFromVisitRequestMutationVariables>;
export const DriveTimeOptimizerDocument = gql`
    query driveTimeOptimizer($input: DriveTimeOptimizerInput!) @permission(requires: optimizeSchedule) {
  driveTimeOptimizer(input: $input) {
    optimizerLogId
    assignments {
      visitResourceId
      providerId
      startTime
      endTime
    }
    skipped {
      visitResourceId
      reasons
    }
    optimizerLogData
    success
  }
}
    `;

/**
 * __useDriveTimeOptimizerQuery__
 *
 * To run a query within a React component, call `useDriveTimeOptimizerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriveTimeOptimizerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriveTimeOptimizerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDriveTimeOptimizerQuery(baseOptions: Apollo.QueryHookOptions<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables> & ({ variables: DriveTimeOptimizerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables>(DriveTimeOptimizerDocument, options);
      }
export function useDriveTimeOptimizerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables>(DriveTimeOptimizerDocument, options);
        }
// @ts-ignore
export function useDriveTimeOptimizerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables>): Apollo.UseSuspenseQueryResult<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables>;
export function useDriveTimeOptimizerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables>): Apollo.UseSuspenseQueryResult<DriveTimeOptimizerQuery | undefined, DriveTimeOptimizerQueryVariables>;
export function useDriveTimeOptimizerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DriveTimeOptimizerQuery, DriveTimeOptimizerQueryVariables>(DriveTimeOptimizerDocument, options);
        }
export type DriveTimeOptimizerQueryHookResult = ReturnType<typeof useDriveTimeOptimizerQuery>;
export type DriveTimeOptimizerLazyQueryHookResult = ReturnType<typeof useDriveTimeOptimizerLazyQuery>;
export type DriveTimeOptimizerSuspenseQueryHookResult = ReturnType<typeof useDriveTimeOptimizerSuspenseQuery>;
export const CreateOptimizerLogInitialStateUploadUrlDocument = gql`
    mutation CreateOptimizerLogInitialStateUploadUrl($optimizerLogId: Int!) @permission(requires: optimizeSchedule) {
  createOptimizerLogInitialStateUploadUrl(optimizerLogId: $optimizerLogId)
}
    `;
export type CreateOptimizerLogInitialStateUploadUrlMutationFn = Apollo.MutationFunction<CreateOptimizerLogInitialStateUploadUrlMutation, CreateOptimizerLogInitialStateUploadUrlMutationVariables>;

/**
 * __useCreateOptimizerLogInitialStateUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateOptimizerLogInitialStateUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOptimizerLogInitialStateUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOptimizerLogInitialStateUploadUrlMutation, { data, loading, error }] = useCreateOptimizerLogInitialStateUploadUrlMutation({
 *   variables: {
 *      optimizerLogId: // value for 'optimizerLogId'
 *   },
 * });
 */
export function useCreateOptimizerLogInitialStateUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateOptimizerLogInitialStateUploadUrlMutation, CreateOptimizerLogInitialStateUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOptimizerLogInitialStateUploadUrlMutation, CreateOptimizerLogInitialStateUploadUrlMutationVariables>(CreateOptimizerLogInitialStateUploadUrlDocument, options);
      }
export type CreateOptimizerLogInitialStateUploadUrlMutationHookResult = ReturnType<typeof useCreateOptimizerLogInitialStateUploadUrlMutation>;
export type CreateOptimizerLogInitialStateUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateOptimizerLogInitialStateUploadUrlMutation, CreateOptimizerLogInitialStateUploadUrlMutationVariables>;
export const SchedulerLogViewDocument = gql`
    query SchedulerLogView($visitId: Int) @permission(requires: debugApps) {
  schedulerLogSingle(where: {visitId: {eq: $visitId}}) {
    visitId
    runId
    chosenOptionIndex
    logData
    createdAt
    createdBy {
      email
    }
  }
}
    `;

/**
 * __useSchedulerLogViewQuery__
 *
 * To run a query within a React component, call `useSchedulerLogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerLogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerLogViewQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useSchedulerLogViewQuery(baseOptions?: Apollo.QueryHookOptions<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>(SchedulerLogViewDocument, options);
      }
export function useSchedulerLogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>(SchedulerLogViewDocument, options);
        }
// @ts-ignore
export function useSchedulerLogViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>;
export function useSchedulerLogViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerLogViewQuery | undefined, SchedulerLogViewQueryVariables>;
export function useSchedulerLogViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulerLogViewQuery, SchedulerLogViewQueryVariables>(SchedulerLogViewDocument, options);
        }
export type SchedulerLogViewQueryHookResult = ReturnType<typeof useSchedulerLogViewQuery>;
export type SchedulerLogViewLazyQueryHookResult = ReturnType<typeof useSchedulerLogViewLazyQuery>;
export type SchedulerLogViewSuspenseQueryHookResult = ReturnType<typeof useSchedulerLogViewSuspenseQuery>;
export const MostRecentSchedulerLogViewDocument = gql`
    query MostRecentSchedulerLogView @permission(requires: debugApps) {
  schedulerLogRecent(limit: 1) {
    runId
    chosenOptionIndex
    logData
    createdAt
    createdBy {
      email
    }
  }
}
    `;

/**
 * __useMostRecentSchedulerLogViewQuery__
 *
 * To run a query within a React component, call `useMostRecentSchedulerLogViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostRecentSchedulerLogViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostRecentSchedulerLogViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useMostRecentSchedulerLogViewQuery(baseOptions?: Apollo.QueryHookOptions<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>(MostRecentSchedulerLogViewDocument, options);
      }
export function useMostRecentSchedulerLogViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>(MostRecentSchedulerLogViewDocument, options);
        }
// @ts-ignore
export function useMostRecentSchedulerLogViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>): Apollo.UseSuspenseQueryResult<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>;
export function useMostRecentSchedulerLogViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>): Apollo.UseSuspenseQueryResult<MostRecentSchedulerLogViewQuery | undefined, MostRecentSchedulerLogViewQueryVariables>;
export function useMostRecentSchedulerLogViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MostRecentSchedulerLogViewQuery, MostRecentSchedulerLogViewQueryVariables>(MostRecentSchedulerLogViewDocument, options);
        }
export type MostRecentSchedulerLogViewQueryHookResult = ReturnType<typeof useMostRecentSchedulerLogViewQuery>;
export type MostRecentSchedulerLogViewLazyQueryHookResult = ReturnType<typeof useMostRecentSchedulerLogViewLazyQuery>;
export type MostRecentSchedulerLogViewSuspenseQueryHookResult = ReturnType<typeof useMostRecentSchedulerLogViewSuspenseQuery>;
export const RecentSchedulerLogIndexViewDocument = gql`
    query recentSchedulerLogIndexView($limit: Int, $offset: Int, $patientId: Int, $userId: Int) @permission(requires: debugApps) {
  schedulerLogRecent(
    limit: $limit
    offset: $offset
    patientId: $patientId
    userId: $userId
  ) {
    runId
    chosenOptionIndex
    createdAt
    logData
    patient {
      firstName
      lastName
    }
    createdBy {
      email
    }
  }
}
    `;

/**
 * __useRecentSchedulerLogIndexViewQuery__
 *
 * To run a query within a React component, call `useRecentSchedulerLogIndexViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentSchedulerLogIndexViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentSchedulerLogIndexViewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      patientId: // value for 'patientId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRecentSchedulerLogIndexViewQuery(baseOptions?: Apollo.QueryHookOptions<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>(RecentSchedulerLogIndexViewDocument, options);
      }
export function useRecentSchedulerLogIndexViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>(RecentSchedulerLogIndexViewDocument, options);
        }
// @ts-ignore
export function useRecentSchedulerLogIndexViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>): Apollo.UseSuspenseQueryResult<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>;
export function useRecentSchedulerLogIndexViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>): Apollo.UseSuspenseQueryResult<RecentSchedulerLogIndexViewQuery | undefined, RecentSchedulerLogIndexViewQueryVariables>;
export function useRecentSchedulerLogIndexViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentSchedulerLogIndexViewQuery, RecentSchedulerLogIndexViewQueryVariables>(RecentSchedulerLogIndexViewDocument, options);
        }
export type RecentSchedulerLogIndexViewQueryHookResult = ReturnType<typeof useRecentSchedulerLogIndexViewQuery>;
export type RecentSchedulerLogIndexViewLazyQueryHookResult = ReturnType<typeof useRecentSchedulerLogIndexViewLazyQuery>;
export type RecentSchedulerLogIndexViewSuspenseQueryHookResult = ReturnType<typeof useRecentSchedulerLogIndexViewSuspenseQuery>;
export const OptimizerLogIndexViewDocument = gql`
    query OptimizerLogIndexView($limit: Int, $offset: Int, $where: OptimizerLogFilters) @permission(requires: debugApps) {
  optimizerLog(
    limit: $limit
    offset: $offset
    orderBy: {id: {direction: desc, priority: 1}}
    where: $where
  ) {
    id
    createdAt
    logData
    createdBy {
      email
    }
  }
}
    `;

/**
 * __useOptimizerLogIndexViewQuery__
 *
 * To run a query within a React component, call `useOptimizerLogIndexViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimizerLogIndexViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimizerLogIndexViewQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOptimizerLogIndexViewQuery(baseOptions?: Apollo.QueryHookOptions<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>(OptimizerLogIndexViewDocument, options);
      }
export function useOptimizerLogIndexViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>(OptimizerLogIndexViewDocument, options);
        }
// @ts-ignore
export function useOptimizerLogIndexViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>): Apollo.UseSuspenseQueryResult<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>;
export function useOptimizerLogIndexViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>): Apollo.UseSuspenseQueryResult<OptimizerLogIndexViewQuery | undefined, OptimizerLogIndexViewQueryVariables>;
export function useOptimizerLogIndexViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OptimizerLogIndexViewQuery, OptimizerLogIndexViewQueryVariables>(OptimizerLogIndexViewDocument, options);
        }
export type OptimizerLogIndexViewQueryHookResult = ReturnType<typeof useOptimizerLogIndexViewQuery>;
export type OptimizerLogIndexViewLazyQueryHookResult = ReturnType<typeof useOptimizerLogIndexViewLazyQuery>;
export type OptimizerLogIndexViewSuspenseQueryHookResult = ReturnType<typeof useOptimizerLogIndexViewSuspenseQuery>;
export const OptimizerLogInitialStateDocument = gql`
    query OptimizerLogInitialState($optimizerLogId: Int!) @permission(requires: debugApps) {
  optimizerLogInitialState(optimizerLogId: $optimizerLogId)
}
    `;

/**
 * __useOptimizerLogInitialStateQuery__
 *
 * To run a query within a React component, call `useOptimizerLogInitialStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptimizerLogInitialStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptimizerLogInitialStateQuery({
 *   variables: {
 *      optimizerLogId: // value for 'optimizerLogId'
 *   },
 * });
 */
export function useOptimizerLogInitialStateQuery(baseOptions: Apollo.QueryHookOptions<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables> & ({ variables: OptimizerLogInitialStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables>(OptimizerLogInitialStateDocument, options);
      }
export function useOptimizerLogInitialStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables>(OptimizerLogInitialStateDocument, options);
        }
// @ts-ignore
export function useOptimizerLogInitialStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables>): Apollo.UseSuspenseQueryResult<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables>;
export function useOptimizerLogInitialStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables>): Apollo.UseSuspenseQueryResult<OptimizerLogInitialStateQuery | undefined, OptimizerLogInitialStateQueryVariables>;
export function useOptimizerLogInitialStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OptimizerLogInitialStateQuery, OptimizerLogInitialStateQueryVariables>(OptimizerLogInitialStateDocument, options);
        }
export type OptimizerLogInitialStateQueryHookResult = ReturnType<typeof useOptimizerLogInitialStateQuery>;
export type OptimizerLogInitialStateLazyQueryHookResult = ReturnType<typeof useOptimizerLogInitialStateLazyQuery>;
export type OptimizerLogInitialStateSuspenseQueryHookResult = ReturnType<typeof useOptimizerLogInitialStateSuspenseQuery>;
export const CopyDemoDayDocument = gql`
    mutation CopyDemoDay($copyFrom: String!, $copyTo: String!, $demoTime: String!, $doNotCommit: Boolean) @permission(requires: copyDemoData) {
  copyDemoDay(
    copyFrom: $copyFrom
    copyTo: $copyTo
    demoTime: $demoTime
    doNotCommit: $doNotCommit
  ) {
    calendarBlocks
    deletedCount
    visits
    visitEventLogEntries
    visitNotes
    visitResources
    visitServices
  }
}
    `;
export type CopyDemoDayMutationFn = Apollo.MutationFunction<CopyDemoDayMutation, CopyDemoDayMutationVariables>;

/**
 * __useCopyDemoDayMutation__
 *
 * To run a mutation, you first call `useCopyDemoDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyDemoDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyDemoDayMutation, { data, loading, error }] = useCopyDemoDayMutation({
 *   variables: {
 *      copyFrom: // value for 'copyFrom'
 *      copyTo: // value for 'copyTo'
 *      demoTime: // value for 'demoTime'
 *      doNotCommit: // value for 'doNotCommit'
 *   },
 * });
 */
export function useCopyDemoDayMutation(baseOptions?: Apollo.MutationHookOptions<CopyDemoDayMutation, CopyDemoDayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyDemoDayMutation, CopyDemoDayMutationVariables>(CopyDemoDayDocument, options);
      }
export type CopyDemoDayMutationHookResult = ReturnType<typeof useCopyDemoDayMutation>;
export type CopyDemoDayMutationOptions = Apollo.BaseMutationOptions<CopyDemoDayMutation, CopyDemoDayMutationVariables>;
export const WebhookPublicKeyDocument = gql`
    query WebhookPublicKey($apiKeyId: Int!) @permission(requires: manageApiKeys) {
  webhookPublicKey(apiKeyId: $apiKeyId) {
    id
    publicPem
  }
}
    `;

/**
 * __useWebhookPublicKeyQuery__
 *
 * To run a query within a React component, call `useWebhookPublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhookPublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookPublicKeyQuery({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *   },
 * });
 */
export function useWebhookPublicKeyQuery(baseOptions: Apollo.QueryHookOptions<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables> & ({ variables: WebhookPublicKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables>(WebhookPublicKeyDocument, options);
      }
export function useWebhookPublicKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables>(WebhookPublicKeyDocument, options);
        }
// @ts-ignore
export function useWebhookPublicKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables>): Apollo.UseSuspenseQueryResult<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables>;
export function useWebhookPublicKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables>): Apollo.UseSuspenseQueryResult<WebhookPublicKeyQuery | undefined, WebhookPublicKeyQueryVariables>;
export function useWebhookPublicKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebhookPublicKeyQuery, WebhookPublicKeyQueryVariables>(WebhookPublicKeyDocument, options);
        }
export type WebhookPublicKeyQueryHookResult = ReturnType<typeof useWebhookPublicKeyQuery>;
export type WebhookPublicKeyLazyQueryHookResult = ReturnType<typeof useWebhookPublicKeyLazyQuery>;
export type WebhookPublicKeySuspenseQueryHookResult = ReturnType<typeof useWebhookPublicKeySuspenseQuery>;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($expiresAt: String, $keyPurpose: ApiKeyPurpose!, $requireFipsCompliance: Boolean) @permission(requires: manageApiKeys) {
  createApiKey(
    expiresAt: $expiresAt
    keyPurpose: $keyPurpose
    requireFipsCompliance: $requireFipsCompliance
  ) {
    apiKey {
      id
      apiKey
      keyPurpose
      expiresAt
      createdAt
      updatedAt
    }
    privatePem
    privateDer
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      expiresAt: // value for 'expiresAt'
 *      keyPurpose: // value for 'keyPurpose'
 *      requireFipsCompliance: // value for 'requireFipsCompliance'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const CreateWebhookApiKeyDocument = gql`
    mutation CreateWebhookApiKey($expiresAt: String) @permission(requires: manageApiKeys) {
  createWebhookApiKey(expiresAt: $expiresAt) {
    apiKey {
      id
      apiKey
      expiresAt
      createdAt
      updatedAt
    }
    publicPem
  }
}
    `;
export type CreateWebhookApiKeyMutationFn = Apollo.MutationFunction<CreateWebhookApiKeyMutation, CreateWebhookApiKeyMutationVariables>;

/**
 * __useCreateWebhookApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateWebhookApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookApiKeyMutation, { data, loading, error }] = useCreateWebhookApiKeyMutation({
 *   variables: {
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useCreateWebhookApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookApiKeyMutation, CreateWebhookApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookApiKeyMutation, CreateWebhookApiKeyMutationVariables>(CreateWebhookApiKeyDocument, options);
      }
export type CreateWebhookApiKeyMutationHookResult = ReturnType<typeof useCreateWebhookApiKeyMutation>;
export type CreateWebhookApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateWebhookApiKeyMutation, CreateWebhookApiKeyMutationVariables>;
export const CreateFhirServerDocument = gql`
    mutation CreateFhirServer($fhirProvider: FhirServerFhirProviderEnum!, $useForLogin: Boolean!, $url: String!, $hl7Folder: String!) @permission(requires: manageOrgConfig) {
  createFhirServer(
    fhirProvider: $fhirProvider
    useForLogin: $useForLogin
    url: $url
    hl7Folder: $hl7Folder
  ) {
    id
  }
}
    `;
export type CreateFhirServerMutationFn = Apollo.MutationFunction<CreateFhirServerMutation, CreateFhirServerMutationVariables>;

/**
 * __useCreateFhirServerMutation__
 *
 * To run a mutation, you first call `useCreateFhirServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFhirServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFhirServerMutation, { data, loading, error }] = useCreateFhirServerMutation({
 *   variables: {
 *      fhirProvider: // value for 'fhirProvider'
 *      useForLogin: // value for 'useForLogin'
 *      url: // value for 'url'
 *      hl7Folder: // value for 'hl7Folder'
 *   },
 * });
 */
export function useCreateFhirServerMutation(baseOptions?: Apollo.MutationHookOptions<CreateFhirServerMutation, CreateFhirServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFhirServerMutation, CreateFhirServerMutationVariables>(CreateFhirServerDocument, options);
      }
export type CreateFhirServerMutationHookResult = ReturnType<typeof useCreateFhirServerMutation>;
export type CreateFhirServerMutationOptions = Apollo.BaseMutationOptions<CreateFhirServerMutation, CreateFhirServerMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation DeleteApiKey($id: Int!) @permission(requires: manageApiKeys) {
  deleteApiKey(id: $id) {
    id
    apiKey
  }
}
    `;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const CreateWebhookEndpointDocument = gql`
    mutation CreateWebhookEndpoint($apiKeyId: Int!, $eventType: WebhookEndpointEventTypeEnum!, $url: String!) @permission(requires: manageApiKeys) {
  createWebhookEndpoint(apiKeyId: $apiKeyId, eventType: $eventType, url: $url) {
    id
    apiKeyId
    eventType
    url
  }
}
    `;
export type CreateWebhookEndpointMutationFn = Apollo.MutationFunction<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>;

/**
 * __useCreateWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useCreateWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookEndpointMutation, { data, loading, error }] = useCreateWebhookEndpointMutation({
 *   variables: {
 *      apiKeyId: // value for 'apiKeyId'
 *      eventType: // value for 'eventType'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>(CreateWebhookEndpointDocument, options);
      }
export type CreateWebhookEndpointMutationHookResult = ReturnType<typeof useCreateWebhookEndpointMutation>;
export type CreateWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<CreateWebhookEndpointMutation, CreateWebhookEndpointMutationVariables>;
export const UpdateWebhookEndpointDocument = gql`
    mutation UpdateWebhookEndpoint($id: Int!, $apiKeyId: Int, $url: String) @permission(requires: manageApiKeys) {
  updateWebhookEndpoint(id: $id, apiKeyId: $apiKeyId, url: $url) {
    id
    apiKeyId
    eventType
    url
  }
}
    `;
export type UpdateWebhookEndpointMutationFn = Apollo.MutationFunction<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>;

/**
 * __useUpdateWebhookEndpointMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookEndpointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookEndpointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookEndpointMutation, { data, loading, error }] = useUpdateWebhookEndpointMutation({
 *   variables: {
 *      id: // value for 'id'
 *      apiKeyId: // value for 'apiKeyId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUpdateWebhookEndpointMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>(UpdateWebhookEndpointDocument, options);
      }
export type UpdateWebhookEndpointMutationHookResult = ReturnType<typeof useUpdateWebhookEndpointMutation>;
export type UpdateWebhookEndpointMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookEndpointMutation, UpdateWebhookEndpointMutationVariables>;
export const UpdateFhirServerDocument = gql`
    mutation UpdateFhirServer($fhirServerId: Int!, $fhirProvider: FhirServerFhirProviderEnum!, $useForLogin: Boolean!, $url: String!, $hl7Folder: String!, $active: Boolean!) @permission(requires: manageOrgConfig) {
  updateFhirServer(
    id: $fhirServerId
    fhirProvider: $fhirProvider
    useForLogin: $useForLogin
    url: $url
    hl7Folder: $hl7Folder
    active: $active
  ) {
    id
  }
}
    `;
export type UpdateFhirServerMutationFn = Apollo.MutationFunction<UpdateFhirServerMutation, UpdateFhirServerMutationVariables>;

/**
 * __useUpdateFhirServerMutation__
 *
 * To run a mutation, you first call `useUpdateFhirServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFhirServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFhirServerMutation, { data, loading, error }] = useUpdateFhirServerMutation({
 *   variables: {
 *      fhirServerId: // value for 'fhirServerId'
 *      fhirProvider: // value for 'fhirProvider'
 *      useForLogin: // value for 'useForLogin'
 *      url: // value for 'url'
 *      hl7Folder: // value for 'hl7Folder'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateFhirServerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFhirServerMutation, UpdateFhirServerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFhirServerMutation, UpdateFhirServerMutationVariables>(UpdateFhirServerDocument, options);
      }
export type UpdateFhirServerMutationHookResult = ReturnType<typeof useUpdateFhirServerMutation>;
export type UpdateFhirServerMutationOptions = Apollo.BaseMutationOptions<UpdateFhirServerMutation, UpdateFhirServerMutationVariables>;
export const ApiKeysDocument = gql`
    query ApiKeys @permission(requires: manageApiKeys) {
  apiKey {
    id
    apiKey
    keyPurpose
    algorithm
    organizationUser {
      user {
        firstName
        lastName
      }
    }
    expiresAt
    createdAt
    createdByUser {
      firstName
      lastName
    }
    updatedAt
  }
  webhookEndpoint {
    id
    eventType
    url
    apiKeyId
  }
}
    `;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
// @ts-ignore
export function useApiKeysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export function useApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<ApiKeysQuery | undefined, ApiKeysQueryVariables>;
export function useApiKeysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysSuspenseQueryHookResult = ReturnType<typeof useApiKeysSuspenseQuery>;
export const FhirServersDocument = gql`
    query FhirServers @permission(requires: manageOrgConfig) {
  fhirServer(orderBy: {active: {direction: desc, priority: 1}}) {
    id
    active
    fhirProvider
    useForLogin
    url
    hl7Folder
  }
}
    `;

/**
 * __useFhirServersQuery__
 *
 * To run a query within a React component, call `useFhirServersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFhirServersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFhirServersQuery({
 *   variables: {
 *   },
 * });
 */
export function useFhirServersQuery(baseOptions?: Apollo.QueryHookOptions<FhirServersQuery, FhirServersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FhirServersQuery, FhirServersQueryVariables>(FhirServersDocument, options);
      }
export function useFhirServersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FhirServersQuery, FhirServersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FhirServersQuery, FhirServersQueryVariables>(FhirServersDocument, options);
        }
// @ts-ignore
export function useFhirServersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FhirServersQuery, FhirServersQueryVariables>): Apollo.UseSuspenseQueryResult<FhirServersQuery, FhirServersQueryVariables>;
export function useFhirServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FhirServersQuery, FhirServersQueryVariables>): Apollo.UseSuspenseQueryResult<FhirServersQuery | undefined, FhirServersQueryVariables>;
export function useFhirServersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FhirServersQuery, FhirServersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FhirServersQuery, FhirServersQueryVariables>(FhirServersDocument, options);
        }
export type FhirServersQueryHookResult = ReturnType<typeof useFhirServersQuery>;
export type FhirServersLazyQueryHookResult = ReturnType<typeof useFhirServersLazyQuery>;
export type FhirServersSuspenseQueryHookResult = ReturnType<typeof useFhirServersSuspenseQuery>;
export const LatestProviderLocationsDocument = gql`
    query LatestProviderLocations @permission(requires: viewProviderLocations) {
  latestProviderLocations {
    latitude
    longitude
    timestamp
    activity
    clockStatus
    clockedAt
    provider {
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useLatestProviderLocationsQuery__
 *
 * To run a query within a React component, call `useLatestProviderLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestProviderLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestProviderLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLatestProviderLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>(LatestProviderLocationsDocument, options);
      }
export function useLatestProviderLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>(LatestProviderLocationsDocument, options);
        }
// @ts-ignore
export function useLatestProviderLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>;
export function useLatestProviderLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<LatestProviderLocationsQuery | undefined, LatestProviderLocationsQueryVariables>;
export function useLatestProviderLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LatestProviderLocationsQuery, LatestProviderLocationsQueryVariables>(LatestProviderLocationsDocument, options);
        }
export type LatestProviderLocationsQueryHookResult = ReturnType<typeof useLatestProviderLocationsQuery>;
export type LatestProviderLocationsLazyQueryHookResult = ReturnType<typeof useLatestProviderLocationsLazyQuery>;
export type LatestProviderLocationsSuspenseQueryHookResult = ReturnType<typeof useLatestProviderLocationsSuspenseQuery>;
export const CreateCancellationReasonDocument = gql`
    mutation CreateCancellationReason($description: String!, $active: Boolean) @permission(requires: manageOrgConfig) {
  createVisitCancellationReason(description: $description, active: $active) {
    id
  }
}
    `;
export type CreateCancellationReasonMutationFn = Apollo.MutationFunction<CreateCancellationReasonMutation, CreateCancellationReasonMutationVariables>;

/**
 * __useCreateCancellationReasonMutation__
 *
 * To run a mutation, you first call `useCreateCancellationReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCancellationReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCancellationReasonMutation, { data, loading, error }] = useCreateCancellationReasonMutation({
 *   variables: {
 *      description: // value for 'description'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useCreateCancellationReasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateCancellationReasonMutation, CreateCancellationReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCancellationReasonMutation, CreateCancellationReasonMutationVariables>(CreateCancellationReasonDocument, options);
      }
export type CreateCancellationReasonMutationHookResult = ReturnType<typeof useCreateCancellationReasonMutation>;
export type CreateCancellationReasonMutationOptions = Apollo.BaseMutationOptions<CreateCancellationReasonMutation, CreateCancellationReasonMutationVariables>;
export const UpdateCancellationReasonDocument = gql`
    mutation UpdateCancellationReason($id: Int!, $description: String, $active: Boolean) @permission(requires: manageOrgConfig) {
  updateVisitCancellationReason(
    id: $id
    description: $description
    active: $active
  ) {
    id
    description
    active
  }
}
    `;
export type UpdateCancellationReasonMutationFn = Apollo.MutationFunction<UpdateCancellationReasonMutation, UpdateCancellationReasonMutationVariables>;

/**
 * __useUpdateCancellationReasonMutation__
 *
 * To run a mutation, you first call `useUpdateCancellationReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCancellationReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCancellationReasonMutation, { data, loading, error }] = useUpdateCancellationReasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      description: // value for 'description'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateCancellationReasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCancellationReasonMutation, UpdateCancellationReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCancellationReasonMutation, UpdateCancellationReasonMutationVariables>(UpdateCancellationReasonDocument, options);
      }
export type UpdateCancellationReasonMutationHookResult = ReturnType<typeof useUpdateCancellationReasonMutation>;
export type UpdateCancellationReasonMutationOptions = Apollo.BaseMutationOptions<UpdateCancellationReasonMutation, UpdateCancellationReasonMutationVariables>;
export const UpdateErrandTypeDocument = gql`
    mutation UpdateErrandType($id: Int!, $name: String!, $description: String!, $relativeToVisit: ErrandTypeRelativeToVisitEnum!, $active: Boolean!) @permission(requires: manageOrgConfig) {
  updateErrandType(
    id: $id
    name: $name
    description: $description
    relativeToVisit: $relativeToVisit
    active: $active
  ) {
    id
  }
}
    `;
export type UpdateErrandTypeMutationFn = Apollo.MutationFunction<UpdateErrandTypeMutation, UpdateErrandTypeMutationVariables>;

/**
 * __useUpdateErrandTypeMutation__
 *
 * To run a mutation, you first call `useUpdateErrandTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrandTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrandTypeMutation, { data, loading, error }] = useUpdateErrandTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      relativeToVisit: // value for 'relativeToVisit'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateErrandTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrandTypeMutation, UpdateErrandTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrandTypeMutation, UpdateErrandTypeMutationVariables>(UpdateErrandTypeDocument, options);
      }
export type UpdateErrandTypeMutationHookResult = ReturnType<typeof useUpdateErrandTypeMutation>;
export type UpdateErrandTypeMutationOptions = Apollo.BaseMutationOptions<UpdateErrandTypeMutation, UpdateErrandTypeMutationVariables>;
export const UpdateServiceLineDocument = gql`
    mutation UpdateServiceLine($serviceLineId: Int!, $schedulingConfig: ServiceLineSchedulingConfig!) @permission(requires: manageOrgConfig) {
  updateServiceLine(id: $serviceLineId, schedulingConfig: $schedulingConfig) {
    id
    name
    schedulingConfig
  }
}
    `;
export type UpdateServiceLineMutationFn = Apollo.MutationFunction<UpdateServiceLineMutation, UpdateServiceLineMutationVariables>;

/**
 * __useUpdateServiceLineMutation__
 *
 * To run a mutation, you first call `useUpdateServiceLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceLineMutation, { data, loading, error }] = useUpdateServiceLineMutation({
 *   variables: {
 *      serviceLineId: // value for 'serviceLineId'
 *      schedulingConfig: // value for 'schedulingConfig'
 *   },
 * });
 */
export function useUpdateServiceLineMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceLineMutation, UpdateServiceLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceLineMutation, UpdateServiceLineMutationVariables>(UpdateServiceLineDocument, options);
      }
export type UpdateServiceLineMutationHookResult = ReturnType<typeof useUpdateServiceLineMutation>;
export type UpdateServiceLineMutationOptions = Apollo.BaseMutationOptions<UpdateServiceLineMutation, UpdateServiceLineMutationVariables>;
export const UpdateVisitTypeDocument = gql`
    mutation UpdateVisitType($visitTypeId: Int!, $schedulingConfig: VisitTypeSchedulingConfig!) @permission(requires: manageOrgConfig) {
  updateVisitType(id: $visitTypeId, schedulingConfig: $schedulingConfig) {
    id
    name
    schedulingConfig
  }
}
    `;
export type UpdateVisitTypeMutationFn = Apollo.MutationFunction<UpdateVisitTypeMutation, UpdateVisitTypeMutationVariables>;

/**
 * __useUpdateVisitTypeMutation__
 *
 * To run a mutation, you first call `useUpdateVisitTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitTypeMutation, { data, loading, error }] = useUpdateVisitTypeMutation({
 *   variables: {
 *      visitTypeId: // value for 'visitTypeId'
 *      schedulingConfig: // value for 'schedulingConfig'
 *   },
 * });
 */
export function useUpdateVisitTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitTypeMutation, UpdateVisitTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitTypeMutation, UpdateVisitTypeMutationVariables>(UpdateVisitTypeDocument, options);
      }
export type UpdateVisitTypeMutationHookResult = ReturnType<typeof useUpdateVisitTypeMutation>;
export type UpdateVisitTypeMutationOptions = Apollo.BaseMutationOptions<UpdateVisitTypeMutation, UpdateVisitTypeMutationVariables>;
export const CreateErrandTypeDocument = gql`
    mutation CreateErrandType($name: String!) @permission(requires: manageOrgConfig) {
  createErrandType(name: $name) {
    id
    name
  }
}
    `;
export type CreateErrandTypeMutationFn = Apollo.MutationFunction<CreateErrandTypeMutation, CreateErrandTypeMutationVariables>;

/**
 * __useCreateErrandTypeMutation__
 *
 * To run a mutation, you first call `useCreateErrandTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrandTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrandTypeMutation, { data, loading, error }] = useCreateErrandTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateErrandTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrandTypeMutation, CreateErrandTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrandTypeMutation, CreateErrandTypeMutationVariables>(CreateErrandTypeDocument, options);
      }
export type CreateErrandTypeMutationHookResult = ReturnType<typeof useCreateErrandTypeMutation>;
export type CreateErrandTypeMutationOptions = Apollo.BaseMutationOptions<CreateErrandTypeMutation, CreateErrandTypeMutationVariables>;
export const CreateServiceLineDocument = gql`
    mutation CreateServiceLine($name: String!) @permission(requires: manageOrgConfig) {
  createServiceLine(name: $name) {
    id
    name
  }
}
    `;
export type CreateServiceLineMutationFn = Apollo.MutationFunction<CreateServiceLineMutation, CreateServiceLineMutationVariables>;

/**
 * __useCreateServiceLineMutation__
 *
 * To run a mutation, you first call `useCreateServiceLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceLineMutation, { data, loading, error }] = useCreateServiceLineMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateServiceLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceLineMutation, CreateServiceLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceLineMutation, CreateServiceLineMutationVariables>(CreateServiceLineDocument, options);
      }
export type CreateServiceLineMutationHookResult = ReturnType<typeof useCreateServiceLineMutation>;
export type CreateServiceLineMutationOptions = Apollo.BaseMutationOptions<CreateServiceLineMutation, CreateServiceLineMutationVariables>;
export const CreateVisitTypeDocument = gql`
    mutation CreateVisitType($name: String!) @permission(requires: manageOrgConfig) {
  createVisitType(name: $name) {
    id
    name
  }
}
    `;
export type CreateVisitTypeMutationFn = Apollo.MutationFunction<CreateVisitTypeMutation, CreateVisitTypeMutationVariables>;

/**
 * __useCreateVisitTypeMutation__
 *
 * To run a mutation, you first call `useCreateVisitTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitTypeMutation, { data, loading, error }] = useCreateVisitTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateVisitTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitTypeMutation, CreateVisitTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitTypeMutation, CreateVisitTypeMutationVariables>(CreateVisitTypeDocument, options);
      }
export type CreateVisitTypeMutationHookResult = ReturnType<typeof useCreateVisitTypeMutation>;
export type CreateVisitTypeMutationOptions = Apollo.BaseMutationOptions<CreateVisitTypeMutation, CreateVisitTypeMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($id: Int!, $name: String!, $providerIds: [Int!]) @permission(requires: manageTeams) {
  updateTeam(id: $id, name: $name, providerIds: $providerIds) {
    id
    name
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      providerIds: // value for 'providerIds'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($name: String!, $providerIds: [Int!]) @permission(requires: manageTeams) {
  createTeam(name: $name, providerIds: $providerIds) {
    id
    name
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      name: // value for 'name'
 *      providerIds: // value for 'providerIds'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const CreateErrandLocationDocument = gql`
    mutation CreateErrandLocation($errandTypeId: Int!, $organizationalUnitId: Int, $name: String!, $description: String!, $addressStreet: String, $addressLineTwo: String, $addressCity: String, $addressState: String, $addressZip: String, $addressPlaceId: String) @permission(requires: manageOrgConfig) {
  createErrandLocation(
    errandTypeId: $errandTypeId
    organizationalUnitId: $organizationalUnitId
    name: $name
    description: $description
    addressStreet: $addressStreet
    addressLineTwo: $addressLineTwo
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    addressPlaceId: $addressPlaceId
  ) {
    id
    organizationalUnitId
    name
    description
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressCoordinates
  }
}
    `;
export type CreateErrandLocationMutationFn = Apollo.MutationFunction<CreateErrandLocationMutation, CreateErrandLocationMutationVariables>;

/**
 * __useCreateErrandLocationMutation__
 *
 * To run a mutation, you first call `useCreateErrandLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrandLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrandLocationMutation, { data, loading, error }] = useCreateErrandLocationMutation({
 *   variables: {
 *      errandTypeId: // value for 'errandTypeId'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      addressStreet: // value for 'addressStreet'
 *      addressLineTwo: // value for 'addressLineTwo'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      addressPlaceId: // value for 'addressPlaceId'
 *   },
 * });
 */
export function useCreateErrandLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrandLocationMutation, CreateErrandLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrandLocationMutation, CreateErrandLocationMutationVariables>(CreateErrandLocationDocument, options);
      }
export type CreateErrandLocationMutationHookResult = ReturnType<typeof useCreateErrandLocationMutation>;
export type CreateErrandLocationMutationOptions = Apollo.BaseMutationOptions<CreateErrandLocationMutation, CreateErrandLocationMutationVariables>;
export const UpdateErrandLocationDocument = gql`
    mutation UpdateErrandLocation($id: Int!, $organizationalUnitId: Int, $name: String!, $description: String!, $updateFutureResources: Boolean, $addressStreet: String, $addressLineTwo: String, $addressCity: String, $addressState: String, $addressZip: String, $addressPlaceId: String) @permission(requires: manageOrgConfig) {
  updateErrandLocation(
    id: $id
    organizationalUnitId: $organizationalUnitId
    name: $name
    description: $description
    updateFutureResources: $updateFutureResources
    addressStreet: $addressStreet
    addressLineTwo: $addressLineTwo
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
    addressPlaceId: $addressPlaceId
  ) {
    id
    organizationalUnitId
    name
    description
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressCoordinates
  }
}
    `;
export type UpdateErrandLocationMutationFn = Apollo.MutationFunction<UpdateErrandLocationMutation, UpdateErrandLocationMutationVariables>;

/**
 * __useUpdateErrandLocationMutation__
 *
 * To run a mutation, you first call `useUpdateErrandLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrandLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrandLocationMutation, { data, loading, error }] = useUpdateErrandLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      updateFutureResources: // value for 'updateFutureResources'
 *      addressStreet: // value for 'addressStreet'
 *      addressLineTwo: // value for 'addressLineTwo'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *      addressPlaceId: // value for 'addressPlaceId'
 *   },
 * });
 */
export function useUpdateErrandLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrandLocationMutation, UpdateErrandLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrandLocationMutation, UpdateErrandLocationMutationVariables>(UpdateErrandLocationDocument, options);
      }
export type UpdateErrandLocationMutationHookResult = ReturnType<typeof useUpdateErrandLocationMutation>;
export type UpdateErrandLocationMutationOptions = Apollo.BaseMutationOptions<UpdateErrandLocationMutation, UpdateErrandLocationMutationVariables>;
export const CreateErrandResourceRequirementDocument = gql`
    mutation CreateErrandResourceRequirement($errandTypeId: Int!, $duration: Int!, $providerTypeIds: [Int!]!) @permission(requires: manageOrgConfig) {
  createVisitResourceRequirement(
    errandTypeId: $errandTypeId
    duration: $duration
    providerTypeIds: $providerTypeIds
  ) {
    id
  }
}
    `;
export type CreateErrandResourceRequirementMutationFn = Apollo.MutationFunction<CreateErrandResourceRequirementMutation, CreateErrandResourceRequirementMutationVariables>;

/**
 * __useCreateErrandResourceRequirementMutation__
 *
 * To run a mutation, you first call `useCreateErrandResourceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrandResourceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrandResourceRequirementMutation, { data, loading, error }] = useCreateErrandResourceRequirementMutation({
 *   variables: {
 *      errandTypeId: // value for 'errandTypeId'
 *      duration: // value for 'duration'
 *      providerTypeIds: // value for 'providerTypeIds'
 *   },
 * });
 */
export function useCreateErrandResourceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrandResourceRequirementMutation, CreateErrandResourceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrandResourceRequirementMutation, CreateErrandResourceRequirementMutationVariables>(CreateErrandResourceRequirementDocument, options);
      }
export type CreateErrandResourceRequirementMutationHookResult = ReturnType<typeof useCreateErrandResourceRequirementMutation>;
export type CreateErrandResourceRequirementMutationOptions = Apollo.BaseMutationOptions<CreateErrandResourceRequirementMutation, CreateErrandResourceRequirementMutationVariables>;
export const UpdateErrandResourceRequirementDocument = gql`
    mutation UpdateErrandResourceRequirement($id: Int!, $duration: Int!, $providerTypeIds: [Int!]!) @permission(requires: manageOrgConfig) {
  updateVisitResourceRequirement(
    id: $id
    duration: $duration
    providerTypeIds: $providerTypeIds
  ) {
    id
  }
}
    `;
export type UpdateErrandResourceRequirementMutationFn = Apollo.MutationFunction<UpdateErrandResourceRequirementMutation, UpdateErrandResourceRequirementMutationVariables>;

/**
 * __useUpdateErrandResourceRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateErrandResourceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrandResourceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrandResourceRequirementMutation, { data, loading, error }] = useUpdateErrandResourceRequirementMutation({
 *   variables: {
 *      id: // value for 'id'
 *      duration: // value for 'duration'
 *      providerTypeIds: // value for 'providerTypeIds'
 *   },
 * });
 */
export function useUpdateErrandResourceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrandResourceRequirementMutation, UpdateErrandResourceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrandResourceRequirementMutation, UpdateErrandResourceRequirementMutationVariables>(UpdateErrandResourceRequirementDocument, options);
      }
export type UpdateErrandResourceRequirementMutationHookResult = ReturnType<typeof useUpdateErrandResourceRequirementMutation>;
export type UpdateErrandResourceRequirementMutationOptions = Apollo.BaseMutationOptions<UpdateErrandResourceRequirementMutation, UpdateErrandResourceRequirementMutationVariables>;
export const ErrandLocationsDocument = gql`
    query ErrandLocations($errandTypeId: Int!) @permission(requires: manageOrgConfig) {
  organizationalUnit(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    active
  }
  errandLocation(
    orderBy: {name: {direction: asc, priority: 1}}
    where: {errandTypeId: {eq: $errandTypeId}}
  ) {
    id
    name
    description
    errandTypeId
    organizationalUnitId
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressCoordinates
    addressTimezone
  }
}
    `;

/**
 * __useErrandLocationsQuery__
 *
 * To run a query within a React component, call `useErrandLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useErrandLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useErrandLocationsQuery({
 *   variables: {
 *      errandTypeId: // value for 'errandTypeId'
 *   },
 * });
 */
export function useErrandLocationsQuery(baseOptions: Apollo.QueryHookOptions<ErrandLocationsQuery, ErrandLocationsQueryVariables> & ({ variables: ErrandLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ErrandLocationsQuery, ErrandLocationsQueryVariables>(ErrandLocationsDocument, options);
      }
export function useErrandLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ErrandLocationsQuery, ErrandLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ErrandLocationsQuery, ErrandLocationsQueryVariables>(ErrandLocationsDocument, options);
        }
// @ts-ignore
export function useErrandLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ErrandLocationsQuery, ErrandLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<ErrandLocationsQuery, ErrandLocationsQueryVariables>;
export function useErrandLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErrandLocationsQuery, ErrandLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<ErrandLocationsQuery | undefined, ErrandLocationsQueryVariables>;
export function useErrandLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ErrandLocationsQuery, ErrandLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ErrandLocationsQuery, ErrandLocationsQueryVariables>(ErrandLocationsDocument, options);
        }
export type ErrandLocationsQueryHookResult = ReturnType<typeof useErrandLocationsQuery>;
export type ErrandLocationsLazyQueryHookResult = ReturnType<typeof useErrandLocationsLazyQuery>;
export type ErrandLocationsSuspenseQueryHookResult = ReturnType<typeof useErrandLocationsSuspenseQuery>;
export const DeleteErrandLocationDocument = gql`
    mutation DeleteErrandLocation($id: Int!) @permission(requires: manageOrgConfig) {
  deleteErrandLocation(id: $id) {
    id
    deleted
  }
}
    `;
export type DeleteErrandLocationMutationFn = Apollo.MutationFunction<DeleteErrandLocationMutation, DeleteErrandLocationMutationVariables>;

/**
 * __useDeleteErrandLocationMutation__
 *
 * To run a mutation, you first call `useDeleteErrandLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErrandLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErrandLocationMutation, { data, loading, error }] = useDeleteErrandLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteErrandLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErrandLocationMutation, DeleteErrandLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErrandLocationMutation, DeleteErrandLocationMutationVariables>(DeleteErrandLocationDocument, options);
      }
export type DeleteErrandLocationMutationHookResult = ReturnType<typeof useDeleteErrandLocationMutation>;
export type DeleteErrandLocationMutationOptions = Apollo.BaseMutationOptions<DeleteErrandLocationMutation, DeleteErrandLocationMutationVariables>;
export const CreateOrganizationalUnitDocument = gql`
    mutation CreateOrganizationalUnit($name: String!) @permission(requires: manageOrgConfig) {
  createOrganizationalUnit(name: $name) {
    id
  }
}
    `;
export type CreateOrganizationalUnitMutationFn = Apollo.MutationFunction<CreateOrganizationalUnitMutation, CreateOrganizationalUnitMutationVariables>;

/**
 * __useCreateOrganizationalUnitMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationalUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationalUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationalUnitMutation, { data, loading, error }] = useCreateOrganizationalUnitMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOrganizationalUnitMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationalUnitMutation, CreateOrganizationalUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationalUnitMutation, CreateOrganizationalUnitMutationVariables>(CreateOrganizationalUnitDocument, options);
      }
export type CreateOrganizationalUnitMutationHookResult = ReturnType<typeof useCreateOrganizationalUnitMutation>;
export type CreateOrganizationalUnitMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationalUnitMutation, CreateOrganizationalUnitMutationVariables>;
export const RenameOrganizationalUnitDocument = gql`
    mutation RenameOrganizationalUnit($id: Int!, $name: String!) @permission(requires: manageOrgConfig) {
  updateOrganizationalUnit(id: $id, name: $name) {
    id
    name
    active
  }
}
    `;
export type RenameOrganizationalUnitMutationFn = Apollo.MutationFunction<RenameOrganizationalUnitMutation, RenameOrganizationalUnitMutationVariables>;

/**
 * __useRenameOrganizationalUnitMutation__
 *
 * To run a mutation, you first call `useRenameOrganizationalUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameOrganizationalUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameOrganizationalUnitMutation, { data, loading, error }] = useRenameOrganizationalUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameOrganizationalUnitMutation(baseOptions?: Apollo.MutationHookOptions<RenameOrganizationalUnitMutation, RenameOrganizationalUnitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameOrganizationalUnitMutation, RenameOrganizationalUnitMutationVariables>(RenameOrganizationalUnitDocument, options);
      }
export type RenameOrganizationalUnitMutationHookResult = ReturnType<typeof useRenameOrganizationalUnitMutation>;
export type RenameOrganizationalUnitMutationOptions = Apollo.BaseMutationOptions<RenameOrganizationalUnitMutation, RenameOrganizationalUnitMutationVariables>;
export const SetOrganizationalUnitActiveDocument = gql`
    mutation SetOrganizationalUnitActive($id: Int!, $active: Boolean!) @permission(requires: manageOrgConfig) {
  updateOrganizationalUnit(id: $id, active: $active) {
    id
    name
    active
  }
}
    `;
export type SetOrganizationalUnitActiveMutationFn = Apollo.MutationFunction<SetOrganizationalUnitActiveMutation, SetOrganizationalUnitActiveMutationVariables>;

/**
 * __useSetOrganizationalUnitActiveMutation__
 *
 * To run a mutation, you first call `useSetOrganizationalUnitActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrganizationalUnitActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrganizationalUnitActiveMutation, { data, loading, error }] = useSetOrganizationalUnitActiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetOrganizationalUnitActiveMutation(baseOptions?: Apollo.MutationHookOptions<SetOrganizationalUnitActiveMutation, SetOrganizationalUnitActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrganizationalUnitActiveMutation, SetOrganizationalUnitActiveMutationVariables>(SetOrganizationalUnitActiveDocument, options);
      }
export type SetOrganizationalUnitActiveMutationHookResult = ReturnType<typeof useSetOrganizationalUnitActiveMutation>;
export type SetOrganizationalUnitActiveMutationOptions = Apollo.BaseMutationOptions<SetOrganizationalUnitActiveMutation, SetOrganizationalUnitActiveMutationVariables>;
export const CreatePrecautionDocument = gql`
    mutation CreatePrecaution($name: String!, $color: String!, $description: String) @permission(requires: manageOrgConfig) {
  createPrecaution(name: $name, color: $color, description: $description) {
    id
  }
}
    `;
export type CreatePrecautionMutationFn = Apollo.MutationFunction<CreatePrecautionMutation, CreatePrecautionMutationVariables>;

/**
 * __useCreatePrecautionMutation__
 *
 * To run a mutation, you first call `useCreatePrecautionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePrecautionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPrecautionMutation, { data, loading, error }] = useCreatePrecautionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      color: // value for 'color'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreatePrecautionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePrecautionMutation, CreatePrecautionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePrecautionMutation, CreatePrecautionMutationVariables>(CreatePrecautionDocument, options);
      }
export type CreatePrecautionMutationHookResult = ReturnType<typeof useCreatePrecautionMutation>;
export type CreatePrecautionMutationOptions = Apollo.BaseMutationOptions<CreatePrecautionMutation, CreatePrecautionMutationVariables>;
export const UpdatePrecautionDocument = gql`
    mutation UpdatePrecaution($id: Int!, $name: String!, $color: String!, $description: String, $active: Boolean!) @permission(requires: manageOrgConfig) {
  updatePrecaution(
    id: $id
    name: $name
    color: $color
    description: $description
    active: $active
  ) {
    id
    name
    color
    description
    active
  }
}
    `;
export type UpdatePrecautionMutationFn = Apollo.MutationFunction<UpdatePrecautionMutation, UpdatePrecautionMutationVariables>;

/**
 * __useUpdatePrecautionMutation__
 *
 * To run a mutation, you first call `useUpdatePrecautionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrecautionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrecautionMutation, { data, loading, error }] = useUpdatePrecautionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      color: // value for 'color'
 *      description: // value for 'description'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdatePrecautionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrecautionMutation, UpdatePrecautionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrecautionMutation, UpdatePrecautionMutationVariables>(UpdatePrecautionDocument, options);
      }
export type UpdatePrecautionMutationHookResult = ReturnType<typeof useUpdatePrecautionMutation>;
export type UpdatePrecautionMutationOptions = Apollo.BaseMutationOptions<UpdatePrecautionMutation, UpdatePrecautionMutationVariables>;
export const CreateVisitTypeServiceLineDocument = gql`
    mutation CreateVisitTypeServiceLine($visitTypeId: Int!, $serviceLineId: Int!) @permission(requires: manageOrgConfig) {
  createVisitTypeServiceLine(
    visitTypeId: $visitTypeId
    serviceLineId: $serviceLineId
  ) {
    id
    visitTypeId
    serviceLineId
  }
}
    `;
export type CreateVisitTypeServiceLineMutationFn = Apollo.MutationFunction<CreateVisitTypeServiceLineMutation, CreateVisitTypeServiceLineMutationVariables>;

/**
 * __useCreateVisitTypeServiceLineMutation__
 *
 * To run a mutation, you first call `useCreateVisitTypeServiceLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitTypeServiceLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitTypeServiceLineMutation, { data, loading, error }] = useCreateVisitTypeServiceLineMutation({
 *   variables: {
 *      visitTypeId: // value for 'visitTypeId'
 *      serviceLineId: // value for 'serviceLineId'
 *   },
 * });
 */
export function useCreateVisitTypeServiceLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitTypeServiceLineMutation, CreateVisitTypeServiceLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitTypeServiceLineMutation, CreateVisitTypeServiceLineMutationVariables>(CreateVisitTypeServiceLineDocument, options);
      }
export type CreateVisitTypeServiceLineMutationHookResult = ReturnType<typeof useCreateVisitTypeServiceLineMutation>;
export type CreateVisitTypeServiceLineMutationOptions = Apollo.BaseMutationOptions<CreateVisitTypeServiceLineMutation, CreateVisitTypeServiceLineMutationVariables>;
export const DeleteVisitTypeServiceLineDocument = gql`
    mutation DeleteVisitTypeServiceLine($visitTypeServiceLineId: Int!) @permission(requires: manageOrgConfig) {
  deleteVisitTypeServiceLine(id: $visitTypeServiceLineId) {
    id
    deleted
  }
}
    `;
export type DeleteVisitTypeServiceLineMutationFn = Apollo.MutationFunction<DeleteVisitTypeServiceLineMutation, DeleteVisitTypeServiceLineMutationVariables>;

/**
 * __useDeleteVisitTypeServiceLineMutation__
 *
 * To run a mutation, you first call `useDeleteVisitTypeServiceLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisitTypeServiceLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVisitTypeServiceLineMutation, { data, loading, error }] = useDeleteVisitTypeServiceLineMutation({
 *   variables: {
 *      visitTypeServiceLineId: // value for 'visitTypeServiceLineId'
 *   },
 * });
 */
export function useDeleteVisitTypeServiceLineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVisitTypeServiceLineMutation, DeleteVisitTypeServiceLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVisitTypeServiceLineMutation, DeleteVisitTypeServiceLineMutationVariables>(DeleteVisitTypeServiceLineDocument, options);
      }
export type DeleteVisitTypeServiceLineMutationHookResult = ReturnType<typeof useDeleteVisitTypeServiceLineMutation>;
export type DeleteVisitTypeServiceLineMutationOptions = Apollo.BaseMutationOptions<DeleteVisitTypeServiceLineMutation, DeleteVisitTypeServiceLineMutationVariables>;
export const CreateErrandTypeServiceLineDocument = gql`
    mutation CreateErrandTypeServiceLine($errandTypeId: Int!, $serviceLineId: Int!) @permission(requires: manageOrgConfig) {
  createErrandTypeServiceLine(
    errandTypeId: $errandTypeId
    serviceLineId: $serviceLineId
  ) {
    id
    errandTypeId
    serviceLineId
  }
}
    `;
export type CreateErrandTypeServiceLineMutationFn = Apollo.MutationFunction<CreateErrandTypeServiceLineMutation, CreateErrandTypeServiceLineMutationVariables>;

/**
 * __useCreateErrandTypeServiceLineMutation__
 *
 * To run a mutation, you first call `useCreateErrandTypeServiceLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrandTypeServiceLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrandTypeServiceLineMutation, { data, loading, error }] = useCreateErrandTypeServiceLineMutation({
 *   variables: {
 *      errandTypeId: // value for 'errandTypeId'
 *      serviceLineId: // value for 'serviceLineId'
 *   },
 * });
 */
export function useCreateErrandTypeServiceLineMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrandTypeServiceLineMutation, CreateErrandTypeServiceLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrandTypeServiceLineMutation, CreateErrandTypeServiceLineMutationVariables>(CreateErrandTypeServiceLineDocument, options);
      }
export type CreateErrandTypeServiceLineMutationHookResult = ReturnType<typeof useCreateErrandTypeServiceLineMutation>;
export type CreateErrandTypeServiceLineMutationOptions = Apollo.BaseMutationOptions<CreateErrandTypeServiceLineMutation, CreateErrandTypeServiceLineMutationVariables>;
export const DeleteErrandTypeServiceLineDocument = gql`
    mutation DeleteErrandTypeServiceLine($errandTypeServiceLineId: Int!) @permission(requires: manageOrgConfig) {
  deleteErrandTypeServiceLine(id: $errandTypeServiceLineId) {
    id
    deleted
  }
}
    `;
export type DeleteErrandTypeServiceLineMutationFn = Apollo.MutationFunction<DeleteErrandTypeServiceLineMutation, DeleteErrandTypeServiceLineMutationVariables>;

/**
 * __useDeleteErrandTypeServiceLineMutation__
 *
 * To run a mutation, you first call `useDeleteErrandTypeServiceLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErrandTypeServiceLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErrandTypeServiceLineMutation, { data, loading, error }] = useDeleteErrandTypeServiceLineMutation({
 *   variables: {
 *      errandTypeServiceLineId: // value for 'errandTypeServiceLineId'
 *   },
 * });
 */
export function useDeleteErrandTypeServiceLineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErrandTypeServiceLineMutation, DeleteErrandTypeServiceLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErrandTypeServiceLineMutation, DeleteErrandTypeServiceLineMutationVariables>(DeleteErrandTypeServiceLineDocument, options);
      }
export type DeleteErrandTypeServiceLineMutationHookResult = ReturnType<typeof useDeleteErrandTypeServiceLineMutation>;
export type DeleteErrandTypeServiceLineMutationOptions = Apollo.BaseMutationOptions<DeleteErrandTypeServiceLineMutation, DeleteErrandTypeServiceLineMutationVariables>;
export const CreateServiceDocument = gql`
    mutation CreateService($name: String!, $description: String, $duration: Int!, $active: Boolean) @permission(requires: manageOrgConfig) {
  createService(
    name: $name
    description: $description
    duration: $duration
    active: $active
  ) {
    id
  }
}
    `;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      duration: // value for 'duration'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation UpdateService($id: Int!, $name: String, $description: String, $duration: Int, $active: Boolean) @permission(requires: manageOrgConfig) {
  updateService(
    id: $id
    name: $name
    description: $description
    duration: $duration
    active: $active
  ) {
    id
    name
    description
    duration
    active
  }
}
    `;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      duration: // value for 'duration'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const CreateShiftCenterDocument = gql`
    mutation CreateShiftCenter($name: String!, $organizationalUnitId: Int, $addressStreet: String!, $addressCity: String, $addressState: String, $addressZip: String) @permission(requires: manageOrgConfig) {
  createShiftCenter(
    name: $name
    organizationalUnitId: $organizationalUnitId
    addressStreet: $addressStreet
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
  ) {
    id
    name
    organizationalUnitId
    addressStreet
    addressCity
    addressState
    addressZip
    addressCoordinates
  }
}
    `;
export type CreateShiftCenterMutationFn = Apollo.MutationFunction<CreateShiftCenterMutation, CreateShiftCenterMutationVariables>;

/**
 * __useCreateShiftCenterMutation__
 *
 * To run a mutation, you first call `useCreateShiftCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShiftCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShiftCenterMutation, { data, loading, error }] = useCreateShiftCenterMutation({
 *   variables: {
 *      name: // value for 'name'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      addressStreet: // value for 'addressStreet'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *   },
 * });
 */
export function useCreateShiftCenterMutation(baseOptions?: Apollo.MutationHookOptions<CreateShiftCenterMutation, CreateShiftCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShiftCenterMutation, CreateShiftCenterMutationVariables>(CreateShiftCenterDocument, options);
      }
export type CreateShiftCenterMutationHookResult = ReturnType<typeof useCreateShiftCenterMutation>;
export type CreateShiftCenterMutationOptions = Apollo.BaseMutationOptions<CreateShiftCenterMutation, CreateShiftCenterMutationVariables>;
export const UpdateShiftCenterDocument = gql`
    mutation UpdateShiftCenter($id: Int!, $name: String, $organizationalUnitId: Int, $addressStreet: String, $addressCity: String, $addressState: String, $addressZip: String) @permission(requires: manageOrgConfig) {
  updateShiftCenter(
    id: $id
    name: $name
    organizationalUnitId: $organizationalUnitId
    addressStreet: $addressStreet
    addressCity: $addressCity
    addressState: $addressState
    addressZip: $addressZip
  ) {
    id
    name
    organizationalUnitId
    addressStreet
    addressCity
    addressState
    addressZip
    addressCoordinates
  }
}
    `;
export type UpdateShiftCenterMutationFn = Apollo.MutationFunction<UpdateShiftCenterMutation, UpdateShiftCenterMutationVariables>;

/**
 * __useUpdateShiftCenterMutation__
 *
 * To run a mutation, you first call `useUpdateShiftCenterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShiftCenterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShiftCenterMutation, { data, loading, error }] = useUpdateShiftCenterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      organizationalUnitId: // value for 'organizationalUnitId'
 *      addressStreet: // value for 'addressStreet'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressZip: // value for 'addressZip'
 *   },
 * });
 */
export function useUpdateShiftCenterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShiftCenterMutation, UpdateShiftCenterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShiftCenterMutation, UpdateShiftCenterMutationVariables>(UpdateShiftCenterDocument, options);
      }
export type UpdateShiftCenterMutationHookResult = ReturnType<typeof useUpdateShiftCenterMutation>;
export type UpdateShiftCenterMutationOptions = Apollo.BaseMutationOptions<UpdateShiftCenterMutation, UpdateShiftCenterMutationVariables>;
export const CreateSupplyChangeReasonDocument = gql`
    mutation CreateSupplyChangeReason($label: String!, $eventType: SupplyChangeReasonEventTypeEnum!) @permission(requires: manageOrgConfig) {
  createSupplyChangeReason(label: $label, eventType: $eventType) {
    id
  }
}
    `;
export type CreateSupplyChangeReasonMutationFn = Apollo.MutationFunction<CreateSupplyChangeReasonMutation, CreateSupplyChangeReasonMutationVariables>;

/**
 * __useCreateSupplyChangeReasonMutation__
 *
 * To run a mutation, you first call `useCreateSupplyChangeReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyChangeReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyChangeReasonMutation, { data, loading, error }] = useCreateSupplyChangeReasonMutation({
 *   variables: {
 *      label: // value for 'label'
 *      eventType: // value for 'eventType'
 *   },
 * });
 */
export function useCreateSupplyChangeReasonMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplyChangeReasonMutation, CreateSupplyChangeReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplyChangeReasonMutation, CreateSupplyChangeReasonMutationVariables>(CreateSupplyChangeReasonDocument, options);
      }
export type CreateSupplyChangeReasonMutationHookResult = ReturnType<typeof useCreateSupplyChangeReasonMutation>;
export type CreateSupplyChangeReasonMutationOptions = Apollo.BaseMutationOptions<CreateSupplyChangeReasonMutation, CreateSupplyChangeReasonMutationVariables>;
export const UpdateSupplyChangeReasonDocument = gql`
    mutation UpdateSupplyChangeReason($id: Int!, $label: String!, $active: Boolean!) @permission(requires: manageOrgConfig) {
  updateSupplyChangeReason(id: $id, label: $label, active: $active) {
    id
    label
    active
  }
}
    `;
export type UpdateSupplyChangeReasonMutationFn = Apollo.MutationFunction<UpdateSupplyChangeReasonMutation, UpdateSupplyChangeReasonMutationVariables>;

/**
 * __useUpdateSupplyChangeReasonMutation__
 *
 * To run a mutation, you first call `useUpdateSupplyChangeReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplyChangeReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplyChangeReasonMutation, { data, loading, error }] = useUpdateSupplyChangeReasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      label: // value for 'label'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateSupplyChangeReasonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplyChangeReasonMutation, UpdateSupplyChangeReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplyChangeReasonMutation, UpdateSupplyChangeReasonMutationVariables>(UpdateSupplyChangeReasonDocument, options);
      }
export type UpdateSupplyChangeReasonMutationHookResult = ReturnType<typeof useUpdateSupplyChangeReasonMutation>;
export type UpdateSupplyChangeReasonMutationOptions = Apollo.BaseMutationOptions<UpdateSupplyChangeReasonMutation, UpdateSupplyChangeReasonMutationVariables>;
export const OrganizationalUnitsDocument = gql`
    query OrganizationalUnits @permission(requires: manageOrgConfig) {
  organizationalUnit(orderBy: {name: {direction: asc, priority: 1}}) {
    id
    name
    active
  }
}
    `;

/**
 * __useOrganizationalUnitsQuery__
 *
 * To run a query within a React component, call `useOrganizationalUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationalUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationalUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationalUnitsQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>(OrganizationalUnitsDocument, options);
      }
export function useOrganizationalUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>(OrganizationalUnitsDocument, options);
        }
// @ts-ignore
export function useOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>;
export function useOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationalUnitsQuery | undefined, OrganizationalUnitsQueryVariables>;
export function useOrganizationalUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationalUnitsQuery, OrganizationalUnitsQueryVariables>(OrganizationalUnitsDocument, options);
        }
export type OrganizationalUnitsQueryHookResult = ReturnType<typeof useOrganizationalUnitsQuery>;
export type OrganizationalUnitsLazyQueryHookResult = ReturnType<typeof useOrganizationalUnitsLazyQuery>;
export type OrganizationalUnitsSuspenseQueryHookResult = ReturnType<typeof useOrganizationalUnitsSuspenseQuery>;
export const TeamsDocument = gql`
    query Teams @permission(requires: manageTeams) {
  team {
    id
    name
    teamProviders {
      provider {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
// @ts-ignore
export function useTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>): Apollo.UseSuspenseQueryResult<TeamsQuery, TeamsQueryVariables>;
export function useTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>): Apollo.UseSuspenseQueryResult<TeamsQuery | undefined, TeamsQueryVariables>;
export function useTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsSuspenseQueryHookResult = ReturnType<typeof useTeamsSuspenseQuery>;
export const CreateProviderTypeDocument = gql`
    mutation CreateProviderType($name: String!) @permission(requires: manageOrgConfig) {
  createProviderType(name: $name) {
    id
    name
    requireStateLicense
  }
}
    `;
export type CreateProviderTypeMutationFn = Apollo.MutationFunction<CreateProviderTypeMutation, CreateProviderTypeMutationVariables>;

/**
 * __useCreateProviderTypeMutation__
 *
 * To run a mutation, you first call `useCreateProviderTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderTypeMutation, { data, loading, error }] = useCreateProviderTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateProviderTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderTypeMutation, CreateProviderTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderTypeMutation, CreateProviderTypeMutationVariables>(CreateProviderTypeDocument, options);
      }
export type CreateProviderTypeMutationHookResult = ReturnType<typeof useCreateProviderTypeMutation>;
export type CreateProviderTypeMutationOptions = Apollo.BaseMutationOptions<CreateProviderTypeMutation, CreateProviderTypeMutationVariables>;
export const UpdateProviderTypeDocument = gql`
    mutation UpdateProviderType($providerTypeId: Int!, $name: String, $requireStateLicense: Boolean) @permission(requires: manageOrgConfig) {
  updateProviderType(
    id: $providerTypeId
    name: $name
    requireStateLicense: $requireStateLicense
  ) {
    id
    name
    requireStateLicense
  }
}
    `;
export type UpdateProviderTypeMutationFn = Apollo.MutationFunction<UpdateProviderTypeMutation, UpdateProviderTypeMutationVariables>;

/**
 * __useUpdateProviderTypeMutation__
 *
 * To run a mutation, you first call `useUpdateProviderTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderTypeMutation, { data, loading, error }] = useUpdateProviderTypeMutation({
 *   variables: {
 *      providerTypeId: // value for 'providerTypeId'
 *      name: // value for 'name'
 *      requireStateLicense: // value for 'requireStateLicense'
 *   },
 * });
 */
export function useUpdateProviderTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderTypeMutation, UpdateProviderTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderTypeMutation, UpdateProviderTypeMutationVariables>(UpdateProviderTypeDocument, options);
      }
export type UpdateProviderTypeMutationHookResult = ReturnType<typeof useUpdateProviderTypeMutation>;
export type UpdateProviderTypeMutationOptions = Apollo.BaseMutationOptions<UpdateProviderTypeMutation, UpdateProviderTypeMutationVariables>;
export const UpdateOrganizationSettingsDocument = gql`
    mutation UpdateOrganizationSettings($enableMobileNotifications: Boolean!, $mobileNotificationsWindow: Int!, $enableLocationBasedStatusUpdates: Boolean!, $shufflerLeadTime: Int!) @permission(requires: manageOrgConfig) {
  updateOrganizationSettings(
    enableMobileNotifications: $enableMobileNotifications
    mobileNotificationsWindow: $mobileNotificationsWindow
    enableLocationBasedStatusUpdates: $enableLocationBasedStatusUpdates
    shufflerLeadTime: $shufflerLeadTime
  ) {
    id
  }
}
    `;
export type UpdateOrganizationSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingsMutation, { data, loading, error }] = useUpdateOrganizationSettingsMutation({
 *   variables: {
 *      enableMobileNotifications: // value for 'enableMobileNotifications'
 *      mobileNotificationsWindow: // value for 'mobileNotificationsWindow'
 *      enableLocationBasedStatusUpdates: // value for 'enableLocationBasedStatusUpdates'
 *      shufflerLeadTime: // value for 'shufflerLeadTime'
 *   },
 * });
 */
export function useUpdateOrganizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>(UpdateOrganizationSettingsDocument, options);
      }
export type UpdateOrganizationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;
export const UpdateVisitResourceRequirementDocument = gql`
    mutation UpdateVisitResourceRequirement($visitResourceRequirement: Int!, $duration: Int!, $inHome: Boolean!, $invitedToVisit: Boolean!, $offset: Int!, $requiresContinuityOfCare: Boolean!, $preserveAutoschedulerGroup: Boolean!, $providerTypeIds: [Int!]!) @permission(requires: manageOrgConfig) {
  updateVisitResourceRequirement(
    id: $visitResourceRequirement
    duration: $duration
    inHome: $inHome
    invitedToVisit: $invitedToVisit
    offset: $offset
    requiresContinuityOfCare: $requiresContinuityOfCare
    preserveAutoschedulerGroup: $preserveAutoschedulerGroup
    providerTypeIds: $providerTypeIds
  ) {
    id
  }
}
    `;
export type UpdateVisitResourceRequirementMutationFn = Apollo.MutationFunction<UpdateVisitResourceRequirementMutation, UpdateVisitResourceRequirementMutationVariables>;

/**
 * __useUpdateVisitResourceRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateVisitResourceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitResourceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitResourceRequirementMutation, { data, loading, error }] = useUpdateVisitResourceRequirementMutation({
 *   variables: {
 *      visitResourceRequirement: // value for 'visitResourceRequirement'
 *      duration: // value for 'duration'
 *      inHome: // value for 'inHome'
 *      invitedToVisit: // value for 'invitedToVisit'
 *      offset: // value for 'offset'
 *      requiresContinuityOfCare: // value for 'requiresContinuityOfCare'
 *      preserveAutoschedulerGroup: // value for 'preserveAutoschedulerGroup'
 *      providerTypeIds: // value for 'providerTypeIds'
 *   },
 * });
 */
export function useUpdateVisitResourceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitResourceRequirementMutation, UpdateVisitResourceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitResourceRequirementMutation, UpdateVisitResourceRequirementMutationVariables>(UpdateVisitResourceRequirementDocument, options);
      }
export type UpdateVisitResourceRequirementMutationHookResult = ReturnType<typeof useUpdateVisitResourceRequirementMutation>;
export type UpdateVisitResourceRequirementMutationOptions = Apollo.BaseMutationOptions<UpdateVisitResourceRequirementMutation, UpdateVisitResourceRequirementMutationVariables>;
export const CreateVisitResourceRequirementDocument = gql`
    mutation CreateVisitResourceRequirement($visitTypeId: Int!, $duration: Int!, $providerTypeIds: [Int!]!) @permission(requires: manageOrgConfig) {
  createVisitResourceRequirement(
    visitTypeId: $visitTypeId
    duration: $duration
    providerTypeIds: $providerTypeIds
  ) {
    id
  }
}
    `;
export type CreateVisitResourceRequirementMutationFn = Apollo.MutationFunction<CreateVisitResourceRequirementMutation, CreateVisitResourceRequirementMutationVariables>;

/**
 * __useCreateVisitResourceRequirementMutation__
 *
 * To run a mutation, you first call `useCreateVisitResourceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitResourceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitResourceRequirementMutation, { data, loading, error }] = useCreateVisitResourceRequirementMutation({
 *   variables: {
 *      visitTypeId: // value for 'visitTypeId'
 *      duration: // value for 'duration'
 *      providerTypeIds: // value for 'providerTypeIds'
 *   },
 * });
 */
export function useCreateVisitResourceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitResourceRequirementMutation, CreateVisitResourceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitResourceRequirementMutation, CreateVisitResourceRequirementMutationVariables>(CreateVisitResourceRequirementDocument, options);
      }
export type CreateVisitResourceRequirementMutationHookResult = ReturnType<typeof useCreateVisitResourceRequirementMutation>;
export type CreateVisitResourceRequirementMutationOptions = Apollo.BaseMutationOptions<CreateVisitResourceRequirementMutation, CreateVisitResourceRequirementMutationVariables>;
export const DeleteVisitResourceRequirementDocument = gql`
    mutation DeleteVisitResourceRequirement($visitResourceRequirementId: Int!) @permission(requires: manageOrgConfig) {
  deleteVisitResourceRequirement(id: $visitResourceRequirementId) {
    id
    deleted
  }
}
    `;
export type DeleteVisitResourceRequirementMutationFn = Apollo.MutationFunction<DeleteVisitResourceRequirementMutation, DeleteVisitResourceRequirementMutationVariables>;

/**
 * __useDeleteVisitResourceRequirementMutation__
 *
 * To run a mutation, you first call `useDeleteVisitResourceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisitResourceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVisitResourceRequirementMutation, { data, loading, error }] = useDeleteVisitResourceRequirementMutation({
 *   variables: {
 *      visitResourceRequirementId: // value for 'visitResourceRequirementId'
 *   },
 * });
 */
export function useDeleteVisitResourceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVisitResourceRequirementMutation, DeleteVisitResourceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVisitResourceRequirementMutation, DeleteVisitResourceRequirementMutationVariables>(DeleteVisitResourceRequirementDocument, options);
      }
export type DeleteVisitResourceRequirementMutationHookResult = ReturnType<typeof useDeleteVisitResourceRequirementMutation>;
export type DeleteVisitResourceRequirementMutationOptions = Apollo.BaseMutationOptions<DeleteVisitResourceRequirementMutation, DeleteVisitResourceRequirementMutationVariables>;
export const CreateVisitTypeServiceDocument = gql`
    mutation CreateVisitTypeService($visitTypeId: Int!, $serviceId: Int!, $selectedByDefault: Boolean) @permission(requires: manageOrgConfig) {
  createVisitTypeService(
    visitTypeId: $visitTypeId
    serviceId: $serviceId
    selectedByDefault: $selectedByDefault
  ) {
    id
  }
}
    `;
export type CreateVisitTypeServiceMutationFn = Apollo.MutationFunction<CreateVisitTypeServiceMutation, CreateVisitTypeServiceMutationVariables>;

/**
 * __useCreateVisitTypeServiceMutation__
 *
 * To run a mutation, you first call `useCreateVisitTypeServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVisitTypeServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVisitTypeServiceMutation, { data, loading, error }] = useCreateVisitTypeServiceMutation({
 *   variables: {
 *      visitTypeId: // value for 'visitTypeId'
 *      serviceId: // value for 'serviceId'
 *      selectedByDefault: // value for 'selectedByDefault'
 *   },
 * });
 */
export function useCreateVisitTypeServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateVisitTypeServiceMutation, CreateVisitTypeServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVisitTypeServiceMutation, CreateVisitTypeServiceMutationVariables>(CreateVisitTypeServiceDocument, options);
      }
export type CreateVisitTypeServiceMutationHookResult = ReturnType<typeof useCreateVisitTypeServiceMutation>;
export type CreateVisitTypeServiceMutationOptions = Apollo.BaseMutationOptions<CreateVisitTypeServiceMutation, CreateVisitTypeServiceMutationVariables>;
export const UpdateVisitTypeServiceDocument = gql`
    mutation UpdateVisitTypeService($id: Int!, $selectedByDefault: Boolean!) @permission(requires: manageOrgConfig) {
  updateVisitTypeService(id: $id, selectedByDefault: $selectedByDefault) {
    id
    selectedByDefault
  }
}
    `;
export type UpdateVisitTypeServiceMutationFn = Apollo.MutationFunction<UpdateVisitTypeServiceMutation, UpdateVisitTypeServiceMutationVariables>;

/**
 * __useUpdateVisitTypeServiceMutation__
 *
 * To run a mutation, you first call `useUpdateVisitTypeServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitTypeServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitTypeServiceMutation, { data, loading, error }] = useUpdateVisitTypeServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      selectedByDefault: // value for 'selectedByDefault'
 *   },
 * });
 */
export function useUpdateVisitTypeServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitTypeServiceMutation, UpdateVisitTypeServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitTypeServiceMutation, UpdateVisitTypeServiceMutationVariables>(UpdateVisitTypeServiceDocument, options);
      }
export type UpdateVisitTypeServiceMutationHookResult = ReturnType<typeof useUpdateVisitTypeServiceMutation>;
export type UpdateVisitTypeServiceMutationOptions = Apollo.BaseMutationOptions<UpdateVisitTypeServiceMutation, UpdateVisitTypeServiceMutationVariables>;
export const DeleteVisitTypeServiceDocument = gql`
    mutation DeleteVisitTypeService($id: Int!) @permission(requires: manageOrgConfig) {
  deleteVisitTypeService(id: $id) {
    id
    deleted
  }
}
    `;
export type DeleteVisitTypeServiceMutationFn = Apollo.MutationFunction<DeleteVisitTypeServiceMutation, DeleteVisitTypeServiceMutationVariables>;

/**
 * __useDeleteVisitTypeServiceMutation__
 *
 * To run a mutation, you first call `useDeleteVisitTypeServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVisitTypeServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVisitTypeServiceMutation, { data, loading, error }] = useDeleteVisitTypeServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVisitTypeServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVisitTypeServiceMutation, DeleteVisitTypeServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVisitTypeServiceMutation, DeleteVisitTypeServiceMutationVariables>(DeleteVisitTypeServiceDocument, options);
      }
export type DeleteVisitTypeServiceMutationHookResult = ReturnType<typeof useDeleteVisitTypeServiceMutation>;
export type DeleteVisitTypeServiceMutationOptions = Apollo.BaseMutationOptions<DeleteVisitTypeServiceMutation, DeleteVisitTypeServiceMutationVariables>;
export const ListActiveHospitalAtHomeEpisodesDocument = gql`
    query ListActiveHospitalAtHomeEpisodes($serviceLineIds: [Int!]!) @permission(requires: useWebApp) {
  episode(
    where: {active: {eq: true}, deleted: {eq: false}, serviceLineId: {inArray: $serviceLineIds}}
  ) {
    id
    patientId
  }
}
    `;

/**
 * __useListActiveHospitalAtHomeEpisodesQuery__
 *
 * To run a query within a React component, call `useListActiveHospitalAtHomeEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveHospitalAtHomeEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveHospitalAtHomeEpisodesQuery({
 *   variables: {
 *      serviceLineIds: // value for 'serviceLineIds'
 *   },
 * });
 */
export function useListActiveHospitalAtHomeEpisodesQuery(baseOptions: Apollo.QueryHookOptions<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables> & ({ variables: ListActiveHospitalAtHomeEpisodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables>(ListActiveHospitalAtHomeEpisodesDocument, options);
      }
export function useListActiveHospitalAtHomeEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables>(ListActiveHospitalAtHomeEpisodesDocument, options);
        }
// @ts-ignore
export function useListActiveHospitalAtHomeEpisodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables>;
export function useListActiveHospitalAtHomeEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables>): Apollo.UseSuspenseQueryResult<ListActiveHospitalAtHomeEpisodesQuery | undefined, ListActiveHospitalAtHomeEpisodesQueryVariables>;
export function useListActiveHospitalAtHomeEpisodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActiveHospitalAtHomeEpisodesQuery, ListActiveHospitalAtHomeEpisodesQueryVariables>(ListActiveHospitalAtHomeEpisodesDocument, options);
        }
export type ListActiveHospitalAtHomeEpisodesQueryHookResult = ReturnType<typeof useListActiveHospitalAtHomeEpisodesQuery>;
export type ListActiveHospitalAtHomeEpisodesLazyQueryHookResult = ReturnType<typeof useListActiveHospitalAtHomeEpisodesLazyQuery>;
export type ListActiveHospitalAtHomeEpisodesSuspenseQueryHookResult = ReturnType<typeof useListActiveHospitalAtHomeEpisodesSuspenseQuery>;
export const ListActivePatientsDocument = gql`
    query ListActivePatients($offset: Int!, $orderBy: ActivePatientOrderBy!) @permission(requires: useWebApp) {
  activePatients(offset: $offset, limit: 50, orderBy: $orderBy) {
    id
    firstName
    lastName
    addressCity
    addressState
    addressZip
    addressTimezone
    dateOfBirth
    phone
    nextVisit {
      startTime
      providers {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useListActivePatientsQuery__
 *
 * To run a query within a React component, call `useListActivePatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActivePatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActivePatientsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListActivePatientsQuery(baseOptions: Apollo.QueryHookOptions<ListActivePatientsQuery, ListActivePatientsQueryVariables> & ({ variables: ListActivePatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListActivePatientsQuery, ListActivePatientsQueryVariables>(ListActivePatientsDocument, options);
      }
export function useListActivePatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListActivePatientsQuery, ListActivePatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListActivePatientsQuery, ListActivePatientsQueryVariables>(ListActivePatientsDocument, options);
        }
// @ts-ignore
export function useListActivePatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListActivePatientsQuery, ListActivePatientsQueryVariables>): Apollo.UseSuspenseQueryResult<ListActivePatientsQuery, ListActivePatientsQueryVariables>;
export function useListActivePatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivePatientsQuery, ListActivePatientsQueryVariables>): Apollo.UseSuspenseQueryResult<ListActivePatientsQuery | undefined, ListActivePatientsQueryVariables>;
export function useListActivePatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListActivePatientsQuery, ListActivePatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListActivePatientsQuery, ListActivePatientsQueryVariables>(ListActivePatientsDocument, options);
        }
export type ListActivePatientsQueryHookResult = ReturnType<typeof useListActivePatientsQuery>;
export type ListActivePatientsLazyQueryHookResult = ReturnType<typeof useListActivePatientsLazyQuery>;
export type ListActivePatientsSuspenseQueryHookResult = ReturnType<typeof useListActivePatientsSuspenseQuery>;
export const WorlistPatientsDocument = gql`
    query WorlistPatients($offset: Int!, $orderBy: ActivePatientOrderBy!, $providerId: Int!) @permission(requires: useWebApp) {
  activePatients(
    offset: $offset
    limit: 50
    orderBy: $orderBy
    providerId: $providerId
  ) {
    id
    firstName
    lastName
    addressCity
    addressState
    addressZip
    addressTimezone
    dateOfBirth
    phone
    nextVisit {
      startTime
      providers {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useWorlistPatientsQuery__
 *
 * To run a query within a React component, call `useWorlistPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorlistPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorlistPatientsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useWorlistPatientsQuery(baseOptions: Apollo.QueryHookOptions<WorlistPatientsQuery, WorlistPatientsQueryVariables> & ({ variables: WorlistPatientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorlistPatientsQuery, WorlistPatientsQueryVariables>(WorlistPatientsDocument, options);
      }
export function useWorlistPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorlistPatientsQuery, WorlistPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorlistPatientsQuery, WorlistPatientsQueryVariables>(WorlistPatientsDocument, options);
        }
// @ts-ignore
export function useWorlistPatientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WorlistPatientsQuery, WorlistPatientsQueryVariables>): Apollo.UseSuspenseQueryResult<WorlistPatientsQuery, WorlistPatientsQueryVariables>;
export function useWorlistPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorlistPatientsQuery, WorlistPatientsQueryVariables>): Apollo.UseSuspenseQueryResult<WorlistPatientsQuery | undefined, WorlistPatientsQueryVariables>;
export function useWorlistPatientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorlistPatientsQuery, WorlistPatientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorlistPatientsQuery, WorlistPatientsQueryVariables>(WorlistPatientsDocument, options);
        }
export type WorlistPatientsQueryHookResult = ReturnType<typeof useWorlistPatientsQuery>;
export type WorlistPatientsLazyQueryHookResult = ReturnType<typeof useWorlistPatientsLazyQuery>;
export type WorlistPatientsSuspenseQueryHookResult = ReturnType<typeof useWorlistPatientsSuspenseQuery>;
export const PatientDetailScreenDocument = gql`
    query PatientDetailScreen($patientId: Int) @permission(requires: useWebApp) {
  patientSingle(where: {id: {eq: $patientId}}) {
    id
    firstName
    lastName
    phone
    preferredLanguage
    sex
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressCoordinates
    addressTimezone
    dateOfBirth
    patientNotes
    serviceInstructions
    patientIdentifiers {
      identifier
      identifier_type
    }
    episodes {
      id
      active
      serviceLineId
      organizationalUnitId
      updatedAt
      precautions {
        id
        precautionId
      }
    }
    careTeamProviders(where: {deleted: {eq: false}}) {
      id
      allowAutomaticUpdates
      providerId
      providerTypeId
      provider {
        id
        firstName
        lastName
        providerTypeId
      }
    }
  }
  visit(where: {patientId: {eq: $patientId}}) {
    id
    startTime
    endTime
    eventStatus
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressCoordinates
    addressTimezone
    serviceInstructions
    arrivalWindowStartTime
    arrivalWindowEndTime
    episode {
      serviceLineId
    }
    visitResources {
      providerId
      provider {
        id
        firstName
        lastName
      }
    }
    visitType {
      id
      name
    }
    visitServices {
      id
      serviceId
      service {
        id
        name
      }
    }
    cancellationReason {
      id
      description
    }
  }
}
    `;

/**
 * __usePatientDetailScreenQuery__
 *
 * To run a query within a React component, call `usePatientDetailScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientDetailScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientDetailScreenQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientDetailScreenQuery(baseOptions?: Apollo.QueryHookOptions<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>(PatientDetailScreenDocument, options);
      }
export function usePatientDetailScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>(PatientDetailScreenDocument, options);
        }
// @ts-ignore
export function usePatientDetailScreenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>): Apollo.UseSuspenseQueryResult<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>;
export function usePatientDetailScreenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>): Apollo.UseSuspenseQueryResult<PatientDetailScreenQuery | undefined, PatientDetailScreenQueryVariables>;
export function usePatientDetailScreenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PatientDetailScreenQuery, PatientDetailScreenQueryVariables>(PatientDetailScreenDocument, options);
        }
export type PatientDetailScreenQueryHookResult = ReturnType<typeof usePatientDetailScreenQuery>;
export type PatientDetailScreenLazyQueryHookResult = ReturnType<typeof usePatientDetailScreenLazyQuery>;
export type PatientDetailScreenSuspenseQueryHookResult = ReturnType<typeof usePatientDetailScreenSuspenseQuery>;
export const UpdateProgramDocument = gql`
    mutation UpdateProgram($programId: Int!, $name: String!, $serviceLineId: Int!) @permission(requires: manageOrgConfig) {
  updateProgram(id: $programId, name: $name, serviceLineId: $serviceLineId) {
    id
    name
  }
}
    `;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      name: // value for 'name'
 *      serviceLineId: // value for 'serviceLineId'
 *   },
 * });
 */
export function useUpdateProgramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, options);
      }
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<UpdateProgramMutation, UpdateProgramMutationVariables>;
export const CreateProgramDocument = gql`
    mutation CreateProgram($name: String!, $serviceLineId: Int!) @permission(requires: manageOrgConfig) {
  createProgram(name: $name, serviceLineId: $serviceLineId) {
    id
    name
    serviceLineId
  }
}
    `;
export type CreateProgramMutationFn = Apollo.MutationFunction<CreateProgramMutation, CreateProgramMutationVariables>;

/**
 * __useCreateProgramMutation__
 *
 * To run a mutation, you first call `useCreateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramMutation, { data, loading, error }] = useCreateProgramMutation({
 *   variables: {
 *      name: // value for 'name'
 *      serviceLineId: // value for 'serviceLineId'
 *   },
 * });
 */
export function useCreateProgramMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramMutation, CreateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramMutation, CreateProgramMutationVariables>(CreateProgramDocument, options);
      }
export type CreateProgramMutationHookResult = ReturnType<typeof useCreateProgramMutation>;
export type CreateProgramMutationOptions = Apollo.BaseMutationOptions<CreateProgramMutation, CreateProgramMutationVariables>;
export const CreateProgramEligibilityQuestionDocument = gql`
    mutation CreateProgramEligibilityQuestion($programEligibilityQuestions: [ProgramEligibilityQuestionProgramInput!]!, $question: String!, $answerFormatType: EligibilityQuestionAnswerFormatTypeEnum!, $answerModule: EligibilityQuestionAnswerModuleEnum, $answerModulePredicate: String, $answerOptions: [CreateAnswerOption!], $useForPreScoreCheck: Boolean!) @permission(requires: manageOrgConfig) {
  createProgramEligibilityQuestion(
    programEligibilityQuestions: $programEligibilityQuestions
    question: $question
    answerFormatType: $answerFormatType
    answerModule: $answerModule
    answerModulePredicate: $answerModulePredicate
    answerOptions: $answerOptions
    useForPreScoreCheck: $useForPreScoreCheck
  ) {
    id
  }
}
    `;
export type CreateProgramEligibilityQuestionMutationFn = Apollo.MutationFunction<CreateProgramEligibilityQuestionMutation, CreateProgramEligibilityQuestionMutationVariables>;

/**
 * __useCreateProgramEligibilityQuestionMutation__
 *
 * To run a mutation, you first call `useCreateProgramEligibilityQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramEligibilityQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramEligibilityQuestionMutation, { data, loading, error }] = useCreateProgramEligibilityQuestionMutation({
 *   variables: {
 *      programEligibilityQuestions: // value for 'programEligibilityQuestions'
 *      question: // value for 'question'
 *      answerFormatType: // value for 'answerFormatType'
 *      answerModule: // value for 'answerModule'
 *      answerModulePredicate: // value for 'answerModulePredicate'
 *      answerOptions: // value for 'answerOptions'
 *      useForPreScoreCheck: // value for 'useForPreScoreCheck'
 *   },
 * });
 */
export function useCreateProgramEligibilityQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramEligibilityQuestionMutation, CreateProgramEligibilityQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramEligibilityQuestionMutation, CreateProgramEligibilityQuestionMutationVariables>(CreateProgramEligibilityQuestionDocument, options);
      }
export type CreateProgramEligibilityQuestionMutationHookResult = ReturnType<typeof useCreateProgramEligibilityQuestionMutation>;
export type CreateProgramEligibilityQuestionMutationOptions = Apollo.BaseMutationOptions<CreateProgramEligibilityQuestionMutation, CreateProgramEligibilityQuestionMutationVariables>;
export const UpdateProgramEligibilityQuestionDocument = gql`
    mutation UpdateProgramEligibilityQuestion($id: Int!, $programEligibilityQuestions: [ProgramEligibilityQuestionProgramInput!]!, $question: String!, $answerModule: EligibilityQuestionAnswerModuleEnum, $answerModulePredicate: String, $answerOptions: [UpdateAnswerOption!], $useForPreScoreCheck: Boolean!) @permission(requires: manageOrgConfig) {
  updateProgramEligibilityQuestion(
    id: $id
    programEligibilityQuestions: $programEligibilityQuestions
    question: $question
    answerModule: $answerModule
    answerModulePredicate: $answerModulePredicate
    answerOptions: $answerOptions
    useForPreScoreCheck: $useForPreScoreCheck
  ) {
    id
  }
}
    `;
export type UpdateProgramEligibilityQuestionMutationFn = Apollo.MutationFunction<UpdateProgramEligibilityQuestionMutation, UpdateProgramEligibilityQuestionMutationVariables>;

/**
 * __useUpdateProgramEligibilityQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateProgramEligibilityQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramEligibilityQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramEligibilityQuestionMutation, { data, loading, error }] = useUpdateProgramEligibilityQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      programEligibilityQuestions: // value for 'programEligibilityQuestions'
 *      question: // value for 'question'
 *      answerModule: // value for 'answerModule'
 *      answerModulePredicate: // value for 'answerModulePredicate'
 *      answerOptions: // value for 'answerOptions'
 *      useForPreScoreCheck: // value for 'useForPreScoreCheck'
 *   },
 * });
 */
export function useUpdateProgramEligibilityQuestionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramEligibilityQuestionMutation, UpdateProgramEligibilityQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramEligibilityQuestionMutation, UpdateProgramEligibilityQuestionMutationVariables>(UpdateProgramEligibilityQuestionDocument, options);
      }
export type UpdateProgramEligibilityQuestionMutationHookResult = ReturnType<typeof useUpdateProgramEligibilityQuestionMutation>;
export type UpdateProgramEligibilityQuestionMutationOptions = Apollo.BaseMutationOptions<UpdateProgramEligibilityQuestionMutation, UpdateProgramEligibilityQuestionMutationVariables>;
export const DeleteProgramEligibilityQuestionDocument = gql`
    mutation DeleteProgramEligibilityQuestion($eligibilityQuestionId: Int!) @permission(requires: manageOrgConfig) {
  deleteProgramEligibilityQuestion(id: $eligibilityQuestionId) {
    id
    deleted
  }
}
    `;
export type DeleteProgramEligibilityQuestionMutationFn = Apollo.MutationFunction<DeleteProgramEligibilityQuestionMutation, DeleteProgramEligibilityQuestionMutationVariables>;

/**
 * __useDeleteProgramEligibilityQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteProgramEligibilityQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramEligibilityQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProgramEligibilityQuestionMutation, { data, loading, error }] = useDeleteProgramEligibilityQuestionMutation({
 *   variables: {
 *      eligibilityQuestionId: // value for 'eligibilityQuestionId'
 *   },
 * });
 */
export function useDeleteProgramEligibilityQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramEligibilityQuestionMutation, DeleteProgramEligibilityQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramEligibilityQuestionMutation, DeleteProgramEligibilityQuestionMutationVariables>(DeleteProgramEligibilityQuestionDocument, options);
      }
export type DeleteProgramEligibilityQuestionMutationHookResult = ReturnType<typeof useDeleteProgramEligibilityQuestionMutation>;
export type DeleteProgramEligibilityQuestionMutationOptions = Apollo.BaseMutationOptions<DeleteProgramEligibilityQuestionMutation, DeleteProgramEligibilityQuestionMutationVariables>;
export const ProviderLocationDocument = gql`
    query ProviderLocation($providerId: Int!, $start: String!, $end: String!) @permission(requires: viewProviderLocations) {
  location(
    where: {providerId: {eq: $providerId}, timestamp: {gte: $start, lt: $end}}
    orderBy: {timestamp: {direction: asc, priority: 1}}
  ) {
    latitude
    longitude
    timestamp
  }
  latestProviderLocations(providerId: $providerId) {
    clockStatus
    timestamp
  }
}
    `;

/**
 * __useProviderLocationQuery__
 *
 * To run a query within a React component, call `useProviderLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderLocationQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useProviderLocationQuery(baseOptions: Apollo.QueryHookOptions<ProviderLocationQuery, ProviderLocationQueryVariables> & ({ variables: ProviderLocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderLocationQuery, ProviderLocationQueryVariables>(ProviderLocationDocument, options);
      }
export function useProviderLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderLocationQuery, ProviderLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderLocationQuery, ProviderLocationQueryVariables>(ProviderLocationDocument, options);
        }
// @ts-ignore
export function useProviderLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProviderLocationQuery, ProviderLocationQueryVariables>): Apollo.UseSuspenseQueryResult<ProviderLocationQuery, ProviderLocationQueryVariables>;
export function useProviderLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderLocationQuery, ProviderLocationQueryVariables>): Apollo.UseSuspenseQueryResult<ProviderLocationQuery | undefined, ProviderLocationQueryVariables>;
export function useProviderLocationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderLocationQuery, ProviderLocationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderLocationQuery, ProviderLocationQueryVariables>(ProviderLocationDocument, options);
        }
export type ProviderLocationQueryHookResult = ReturnType<typeof useProviderLocationQuery>;
export type ProviderLocationLazyQueryHookResult = ReturnType<typeof useProviderLocationLazyQuery>;
export type ProviderLocationSuspenseQueryHookResult = ReturnType<typeof useProviderLocationSuspenseQuery>;
export const PatientDetailDocument = gql`
    query PatientDetail($patientId: Int) @permission(requires: useWebApp) {
  patientSingle(where: {id: {eq: $patientId}}) {
    id
    firstName
    lastName
    phone
    preferredLanguage
    sex
    addressStreet
    addressLineTwo
    addressCity
    addressState
    addressZip
    addressCoordinates
    addressTimezone
    dateOfBirth
    patientNotes
    serviceInstructions
    organizationId
    updatedAt
    episodes {
      id
      active
      serviceLineId
      organizationalUnitId
      updatedAt
      precautions {
        id
        precautionId
      }
    }
    patientIdentifiers {
      identifier
      identifier_type
    }
    visits {
      id
      startTime
      endTime
      eventStatus
      addressStreet
      addressLineTwo
      addressCity
      addressState
      addressZip
      addressCoordinates
      addressTimezone
      serviceInstructions
      episode {
        serviceLineId
      }
      visitResources {
        providerId
        provider {
          id
          firstName
          lastName
        }
      }
      visitType {
        id
        name
      }
      visitServices {
        id
        serviceId
        service {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __usePatientDetailQuery__
 *
 * To run a query within a React component, call `usePatientDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientDetailQuery({
 *   variables: {
 *      patientId: // value for 'patientId'
 *   },
 * });
 */
export function usePatientDetailQuery(baseOptions?: Apollo.QueryHookOptions<PatientDetailQuery, PatientDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientDetailQuery, PatientDetailQueryVariables>(PatientDetailDocument, options);
      }
export function usePatientDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientDetailQuery, PatientDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientDetailQuery, PatientDetailQueryVariables>(PatientDetailDocument, options);
        }
// @ts-ignore
export function usePatientDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PatientDetailQuery, PatientDetailQueryVariables>): Apollo.UseSuspenseQueryResult<PatientDetailQuery, PatientDetailQueryVariables>;
export function usePatientDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatientDetailQuery, PatientDetailQueryVariables>): Apollo.UseSuspenseQueryResult<PatientDetailQuery | undefined, PatientDetailQueryVariables>;
export function usePatientDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PatientDetailQuery, PatientDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PatientDetailQuery, PatientDetailQueryVariables>(PatientDetailDocument, options);
        }
export type PatientDetailQueryHookResult = ReturnType<typeof usePatientDetailQuery>;
export type PatientDetailLazyQueryHookResult = ReturnType<typeof usePatientDetailLazyQuery>;
export type PatientDetailSuspenseQueryHookResult = ReturnType<typeof usePatientDetailSuspenseQuery>;
export const SchedulerScreenVisitDocument = gql`
    query SchedulerScreenVisit($visitId: Int) @permission(requires: manageAnyVisit) {
  visitSingle(where: {id: {eq: $visitId}}) {
    id
    startTime
    endTime
    arrivalWindowStartTime
    arrivalWindowEndTime
    serviceInstructions
    visitTypeId
    createdAt
    patient {
      id
      firstName
      lastName
      dateOfBirth
      sex
      patientNotes
      serviceInstructions
      addressStreet
      addressCity
      addressState
      addressZip
      addressTimezone
      phone
      updatedAt
      episodes {
        id
        active
        serviceLineId
        organizationalUnitId
        updatedAt
        precautions {
          id
          precautionId
        }
      }
      patientIdentifiers {
        identifier
        identifier_type
      }
    }
    visitResources {
      id
      provider {
        id
        firstName
        lastName
      }
    }
    visitServices {
      id
      service {
        id
        name
      }
    }
    episode {
      id
      serviceLineId
      organizationalUnitId
    }
  }
}
    `;

/**
 * __useSchedulerScreenVisitQuery__
 *
 * To run a query within a React component, call `useSchedulerScreenVisitQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchedulerScreenVisitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchedulerScreenVisitQuery({
 *   variables: {
 *      visitId: // value for 'visitId'
 *   },
 * });
 */
export function useSchedulerScreenVisitQuery(baseOptions?: Apollo.QueryHookOptions<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>(SchedulerScreenVisitDocument, options);
      }
export function useSchedulerScreenVisitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>(SchedulerScreenVisitDocument, options);
        }
// @ts-ignore
export function useSchedulerScreenVisitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>;
export function useSchedulerScreenVisitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>): Apollo.UseSuspenseQueryResult<SchedulerScreenVisitQuery | undefined, SchedulerScreenVisitQueryVariables>;
export function useSchedulerScreenVisitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchedulerScreenVisitQuery, SchedulerScreenVisitQueryVariables>(SchedulerScreenVisitDocument, options);
        }
export type SchedulerScreenVisitQueryHookResult = ReturnType<typeof useSchedulerScreenVisitQuery>;
export type SchedulerScreenVisitLazyQueryHookResult = ReturnType<typeof useSchedulerScreenVisitLazyQuery>;
export type SchedulerScreenVisitSuspenseQueryHookResult = ReturnType<typeof useSchedulerScreenVisitSuspenseQuery>;
export const CreateUserRoleDocument = gql`
    mutation CreateUserRole($name: String!, $permissions: [PermissionEnum!]!) @permission(requires: manageOrgConfig) {
  createUserRole(name: $name, permissions: $permissions) {
    id
    name
    permissions
  }
}
    `;
export type CreateUserRoleMutationFn = Apollo.MutationFunction<CreateUserRoleMutation, CreateUserRoleMutationVariables>;

/**
 * __useCreateUserRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserRoleMutation, { data, loading, error }] = useCreateUserRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useCreateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserRoleMutation, CreateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserRoleMutation, CreateUserRoleMutationVariables>(CreateUserRoleDocument, options);
      }
export type CreateUserRoleMutationHookResult = ReturnType<typeof useCreateUserRoleMutation>;
export type CreateUserRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserRoleMutation, CreateUserRoleMutationVariables>;
export const UpdateUserRoleDocument = gql`
    mutation UpdateUserRole($id: Int!, $name: String!, $permissions: [PermissionEnum!]!) @permission(requires: manageOrgConfig) {
  updateUserRole(id: $id, name: $name, permissions: $permissions) {
    id
    name
    permissions
  }
}
    `;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      permissions: // value for 'permissions'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>(UpdateUserRoleDocument, options);
      }
export type UpdateUserRoleMutationHookResult = ReturnType<typeof useUpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserRoleMutation, UpdateUserRoleMutationVariables>;
export const UserRolesDocument = gql`
    query UserRoles @permission(requires: manageOrgConfig) {
  userRole {
    id
    name
    permissions
  }
}
    `;

/**
 * __useUserRolesQuery__
 *
 * To run a query within a React component, call `useUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
      }
export function useUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
// @ts-ignore
export function useUserRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>): Apollo.UseSuspenseQueryResult<UserRolesQuery, UserRolesQueryVariables>;
export function useUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>): Apollo.UseSuspenseQueryResult<UserRolesQuery | undefined, UserRolesQueryVariables>;
export function useUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export type UserRolesQueryHookResult = ReturnType<typeof useUserRolesQuery>;
export type UserRolesLazyQueryHookResult = ReturnType<typeof useUserRolesLazyQuery>;
export type UserRolesSuspenseQueryHookResult = ReturnType<typeof useUserRolesSuspenseQuery>;
export const UpdateOrganizationTimeoutsDocument = gql`
    mutation UpdateOrganizationTimeouts($idleSessionTimeoutMinutes: Int!, $mobileIdleLockTimeoutMinutes: Int!, $mobileIdleSignOutMinutes: Int!, $mobileUnlockMethod: MobileUnlockMethodEnum!) @permission(requires: manageOrgConfig) {
  updateOrganizationSettings(
    idleSessionTimeoutMinutes: $idleSessionTimeoutMinutes
    mobileIdleLockTimeoutMinutes: $mobileIdleLockTimeoutMinutes
    mobileIdleSignOutMinutes: $mobileIdleSignOutMinutes
    mobileUnlockMethod: $mobileUnlockMethod
  ) {
    id
  }
}
    `;
export type UpdateOrganizationTimeoutsMutationFn = Apollo.MutationFunction<UpdateOrganizationTimeoutsMutation, UpdateOrganizationTimeoutsMutationVariables>;

/**
 * __useUpdateOrganizationTimeoutsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationTimeoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationTimeoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationTimeoutsMutation, { data, loading, error }] = useUpdateOrganizationTimeoutsMutation({
 *   variables: {
 *      idleSessionTimeoutMinutes: // value for 'idleSessionTimeoutMinutes'
 *      mobileIdleLockTimeoutMinutes: // value for 'mobileIdleLockTimeoutMinutes'
 *      mobileIdleSignOutMinutes: // value for 'mobileIdleSignOutMinutes'
 *      mobileUnlockMethod: // value for 'mobileUnlockMethod'
 *   },
 * });
 */
export function useUpdateOrganizationTimeoutsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationTimeoutsMutation, UpdateOrganizationTimeoutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationTimeoutsMutation, UpdateOrganizationTimeoutsMutationVariables>(UpdateOrganizationTimeoutsDocument, options);
      }
export type UpdateOrganizationTimeoutsMutationHookResult = ReturnType<typeof useUpdateOrganizationTimeoutsMutation>;
export type UpdateOrganizationTimeoutsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationTimeoutsMutation, UpdateOrganizationTimeoutsMutationVariables>;
export const HistoricalSosAlertsDocument = gql`
    query HistoricalSosAlerts($since: String!) @permission(requires: manageSosAlerts) {
  sosAlert(
    where: {createdAt: {gte: $since}}
    orderBy: {createdAt: {direction: desc, priority: 1}}
    limit: 200
  ) {
    ...SosAlertDetail
  }
}
    ${SosAlertDetailFragmentDoc}`;

/**
 * __useHistoricalSosAlertsQuery__
 *
 * To run a query within a React component, call `useHistoricalSosAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoricalSosAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoricalSosAlertsQuery({
 *   variables: {
 *      since: // value for 'since'
 *   },
 * });
 */
export function useHistoricalSosAlertsQuery(baseOptions: Apollo.QueryHookOptions<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables> & ({ variables: HistoricalSosAlertsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables>(HistoricalSosAlertsDocument, options);
      }
export function useHistoricalSosAlertsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables>(HistoricalSosAlertsDocument, options);
        }
// @ts-ignore
export function useHistoricalSosAlertsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables>;
export function useHistoricalSosAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables>): Apollo.UseSuspenseQueryResult<HistoricalSosAlertsQuery | undefined, HistoricalSosAlertsQueryVariables>;
export function useHistoricalSosAlertsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HistoricalSosAlertsQuery, HistoricalSosAlertsQueryVariables>(HistoricalSosAlertsDocument, options);
        }
export type HistoricalSosAlertsQueryHookResult = ReturnType<typeof useHistoricalSosAlertsQuery>;
export type HistoricalSosAlertsLazyQueryHookResult = ReturnType<typeof useHistoricalSosAlertsLazyQuery>;
export type HistoricalSosAlertsSuspenseQueryHookResult = ReturnType<typeof useHistoricalSosAlertsSuspenseQuery>;
export const CreateSupplyItemDocument = gql`
    mutation CreateSupplyItem($label: String!, $barcode: String!, $currentStock: Int!) @permission(requires: manageSupplies) {
  createSupplyItem(label: $label, barcode: $barcode, currentStock: $currentStock) {
    id
  }
}
    `;
export type CreateSupplyItemMutationFn = Apollo.MutationFunction<CreateSupplyItemMutation, CreateSupplyItemMutationVariables>;

/**
 * __useCreateSupplyItemMutation__
 *
 * To run a mutation, you first call `useCreateSupplyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSupplyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSupplyItemMutation, { data, loading, error }] = useCreateSupplyItemMutation({
 *   variables: {
 *      label: // value for 'label'
 *      barcode: // value for 'barcode'
 *      currentStock: // value for 'currentStock'
 *   },
 * });
 */
export function useCreateSupplyItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateSupplyItemMutation, CreateSupplyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSupplyItemMutation, CreateSupplyItemMutationVariables>(CreateSupplyItemDocument, options);
      }
export type CreateSupplyItemMutationHookResult = ReturnType<typeof useCreateSupplyItemMutation>;
export type CreateSupplyItemMutationOptions = Apollo.BaseMutationOptions<CreateSupplyItemMutation, CreateSupplyItemMutationVariables>;
export const UpdateSupplyItemDocument = gql`
    mutation UpdateSupplyItem($supplyItemId: Int!, $label: String!, $barcode: String!, $active: Boolean!) @permission(requires: manageSupplies) {
  updateSupplyItem(
    id: $supplyItemId
    label: $label
    barcode: $barcode
    active: $active
  ) {
    id
    label
    barcode
    currentStock
    active
  }
}
    `;
export type UpdateSupplyItemMutationFn = Apollo.MutationFunction<UpdateSupplyItemMutation, UpdateSupplyItemMutationVariables>;

/**
 * __useUpdateSupplyItemMutation__
 *
 * To run a mutation, you first call `useUpdateSupplyItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplyItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplyItemMutation, { data, loading, error }] = useUpdateSupplyItemMutation({
 *   variables: {
 *      supplyItemId: // value for 'supplyItemId'
 *      label: // value for 'label'
 *      barcode: // value for 'barcode'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateSupplyItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupplyItemMutation, UpdateSupplyItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupplyItemMutation, UpdateSupplyItemMutationVariables>(UpdateSupplyItemDocument, options);
      }
export type UpdateSupplyItemMutationHookResult = ReturnType<typeof useUpdateSupplyItemMutation>;
export type UpdateSupplyItemMutationOptions = Apollo.BaseMutationOptions<UpdateSupplyItemMutation, UpdateSupplyItemMutationVariables>;
export const SupplyItemDetailsDocument = gql`
    query SupplyItemDetails($supplyItemId: Int!, $offset: Int!, $orderBy: SupplyEventOrderBy!) @permission(requires: useSupplies) {
  supplyItemSingle(where: {id: {eq: $supplyItemId}}) {
    id
    label
    barcode
    currentStock
    needsRecount
    active
    supplyEvents(limit: 50, offset: $offset, orderBy: $orderBy) {
      id
      supplyChangeReasonId
      note
      amount
      scannedBarcode
      createdAt
      createdByUser {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useSupplyItemDetailsQuery__
 *
 * To run a query within a React component, call `useSupplyItemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplyItemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplyItemDetailsQuery({
 *   variables: {
 *      supplyItemId: // value for 'supplyItemId'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSupplyItemDetailsQuery(baseOptions: Apollo.QueryHookOptions<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables> & ({ variables: SupplyItemDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables>(SupplyItemDetailsDocument, options);
      }
export function useSupplyItemDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables>(SupplyItemDetailsDocument, options);
        }
// @ts-ignore
export function useSupplyItemDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables>;
export function useSupplyItemDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<SupplyItemDetailsQuery | undefined, SupplyItemDetailsQueryVariables>;
export function useSupplyItemDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplyItemDetailsQuery, SupplyItemDetailsQueryVariables>(SupplyItemDetailsDocument, options);
        }
export type SupplyItemDetailsQueryHookResult = ReturnType<typeof useSupplyItemDetailsQuery>;
export type SupplyItemDetailsLazyQueryHookResult = ReturnType<typeof useSupplyItemDetailsLazyQuery>;
export type SupplyItemDetailsSuspenseQueryHookResult = ReturnType<typeof useSupplyItemDetailsSuspenseQuery>;
export const SupplyEventDocument = gql`
    mutation SupplyEvent($supplyItemId: Int!, $supplyChangeReasonId: Int!, $note: String!, $amount: Int!) @permission(requires: useSupplies) {
  supplyEvent(
    supplyItemId: $supplyItemId
    supplyChangeReasonId: $supplyChangeReasonId
    note: $note
    amount: $amount
  ) {
    id
  }
}
    `;
export type SupplyEventMutationFn = Apollo.MutationFunction<SupplyEventMutation, SupplyEventMutationVariables>;

/**
 * __useSupplyEventMutation__
 *
 * To run a mutation, you first call `useSupplyEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplyEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplyEventMutation, { data, loading, error }] = useSupplyEventMutation({
 *   variables: {
 *      supplyItemId: // value for 'supplyItemId'
 *      supplyChangeReasonId: // value for 'supplyChangeReasonId'
 *      note: // value for 'note'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useSupplyEventMutation(baseOptions?: Apollo.MutationHookOptions<SupplyEventMutation, SupplyEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupplyEventMutation, SupplyEventMutationVariables>(SupplyEventDocument, options);
      }
export type SupplyEventMutationHookResult = ReturnType<typeof useSupplyEventMutation>;
export type SupplyEventMutationOptions = Apollo.BaseMutationOptions<SupplyEventMutation, SupplyEventMutationVariables>;
export const SupplyItemsPageDocument = gql`
    query SupplyItemsPage($offset: Int!, $orderBy: SupplyItemOrderBy!, $hideInactive: Boolean) @permission(requires: useSupplies) {
  supplyItem(
    offset: $offset
    limit: 50
    orderBy: $orderBy
    where: {active: {eq: $hideInactive}}
  ) {
    id
    label
    barcode
    currentStock
    needsRecount
    active
    updatedAt
    supplyEvents(limit: 3, orderBy: {id: {direction: desc, priority: 1}}) {
      id
      supplyChangeReasonId
      amount
      createdAt
      createdByUser {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useSupplyItemsPageQuery__
 *
 * To run a query within a React component, call `useSupplyItemsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplyItemsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplyItemsPageQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      hideInactive: // value for 'hideInactive'
 *   },
 * });
 */
export function useSupplyItemsPageQuery(baseOptions: Apollo.QueryHookOptions<SupplyItemsPageQuery, SupplyItemsPageQueryVariables> & ({ variables: SupplyItemsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupplyItemsPageQuery, SupplyItemsPageQueryVariables>(SupplyItemsPageDocument, options);
      }
export function useSupplyItemsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupplyItemsPageQuery, SupplyItemsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupplyItemsPageQuery, SupplyItemsPageQueryVariables>(SupplyItemsPageDocument, options);
        }
// @ts-ignore
export function useSupplyItemsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupplyItemsPageQuery, SupplyItemsPageQueryVariables>): Apollo.UseSuspenseQueryResult<SupplyItemsPageQuery, SupplyItemsPageQueryVariables>;
export function useSupplyItemsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplyItemsPageQuery, SupplyItemsPageQueryVariables>): Apollo.UseSuspenseQueryResult<SupplyItemsPageQuery | undefined, SupplyItemsPageQueryVariables>;
export function useSupplyItemsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupplyItemsPageQuery, SupplyItemsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupplyItemsPageQuery, SupplyItemsPageQueryVariables>(SupplyItemsPageDocument, options);
        }
export type SupplyItemsPageQueryHookResult = ReturnType<typeof useSupplyItemsPageQuery>;
export type SupplyItemsPageLazyQueryHookResult = ReturnType<typeof useSupplyItemsPageLazyQuery>;
export type SupplyItemsPageSuspenseQueryHookResult = ReturnType<typeof useSupplyItemsPageSuspenseQuery>;
export const UserDetailDocument = gql`
    query UserDetail($userId: Int) @permission(requires: manageUsers) {
  userDetails(id: $userId) {
    id
    deleted
    user {
      id
      email
      firstName
      lastName
    }
    roles {
      userRoleId
    }
    serviceLineOrgUsers {
      serviceLineId
    }
    organizationalUnitOrgUsers {
      organizationalUnitId
    }
    providers {
      id
      active
      providerTypeId
      addressStreet
      addressLineTwo
      addressCity
      addressState
      addressZip
      external
      identifier
      teamProviders {
        teamId
      }
      traits {
        trait
        value
      }
    }
  }
}
    `;

/**
 * __useUserDetailQuery__
 *
 * To run a query within a React component, call `useUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDetailQuery(baseOptions?: Apollo.QueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
      }
export function useUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
        }
// @ts-ignore
export function useUserDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>): Apollo.UseSuspenseQueryResult<UserDetailQuery, UserDetailQueryVariables>;
export function useUserDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>): Apollo.UseSuspenseQueryResult<UserDetailQuery | undefined, UserDetailQueryVariables>;
export function useUserDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
        }
export type UserDetailQueryHookResult = ReturnType<typeof useUserDetailQuery>;
export type UserDetailLazyQueryHookResult = ReturnType<typeof useUserDetailLazyQuery>;
export type UserDetailSuspenseQueryHookResult = ReturnType<typeof useUserDetailSuspenseQuery>;
export const OrganizationProviderConfigDocument = gql`
    query OrganizationProviderConfig @permission(requires: manageUsers) {
  organizationSingle {
    teams {
      id
      name
    }
    serviceLines {
      id
      name
    }
    organizationalUnits {
      id
      name
      active
    }
    providerTypes {
      id
      name
      requireStateLicense
    }
    roles {
      id
      name
    }
  }
}
    `;

/**
 * __useOrganizationProviderConfigQuery__
 *
 * To run a query within a React component, call `useOrganizationProviderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationProviderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationProviderConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationProviderConfigQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>(OrganizationProviderConfigDocument, options);
      }
export function useOrganizationProviderConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>(OrganizationProviderConfigDocument, options);
        }
// @ts-ignore
export function useOrganizationProviderConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>;
export function useOrganizationProviderConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationProviderConfigQuery | undefined, OrganizationProviderConfigQueryVariables>;
export function useOrganizationProviderConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationProviderConfigQuery, OrganizationProviderConfigQueryVariables>(OrganizationProviderConfigDocument, options);
        }
export type OrganizationProviderConfigQueryHookResult = ReturnType<typeof useOrganizationProviderConfigQuery>;
export type OrganizationProviderConfigLazyQueryHookResult = ReturnType<typeof useOrganizationProviderConfigLazyQuery>;
export type OrganizationProviderConfigSuspenseQueryHookResult = ReturnType<typeof useOrganizationProviderConfigSuspenseQuery>;
export const VisitWorklistWarningsDocument = gql`
    query VisitWorklistWarnings($start: String!, $end: String!) @permission(requires: useVisitWorklist) {
  visitWorklistWarnings(start: $start, end: $end) {
    visit {
      id
      startTime
      endTime
      visitType {
        id
        name
      }
      patient {
        id
        firstName
        lastName
      }
      addressTimezone
      episode {
        id
        serviceLineId
      }
    }
    visitWarnings {
      severity
      category
      warning
    }
    visitResources {
      visitResource {
        id
        provider {
          id
          firstName
          lastName
        }
      }
      warnings {
        severity
        category
        warning
      }
    }
  }
}
    `;

/**
 * __useVisitWorklistWarningsQuery__
 *
 * To run a query within a React component, call `useVisitWorklistWarningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitWorklistWarningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitWorklistWarningsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useVisitWorklistWarningsQuery(baseOptions: Apollo.QueryHookOptions<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables> & ({ variables: VisitWorklistWarningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables>(VisitWorklistWarningsDocument, options);
      }
export function useVisitWorklistWarningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables>(VisitWorklistWarningsDocument, options);
        }
// @ts-ignore
export function useVisitWorklistWarningsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables>): Apollo.UseSuspenseQueryResult<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables>;
export function useVisitWorklistWarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables>): Apollo.UseSuspenseQueryResult<VisitWorklistWarningsQuery | undefined, VisitWorklistWarningsQueryVariables>;
export function useVisitWorklistWarningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisitWorklistWarningsQuery, VisitWorklistWarningsQueryVariables>(VisitWorklistWarningsDocument, options);
        }
export type VisitWorklistWarningsQueryHookResult = ReturnType<typeof useVisitWorklistWarningsQuery>;
export type VisitWorklistWarningsLazyQueryHookResult = ReturnType<typeof useVisitWorklistWarningsLazyQuery>;
export type VisitWorklistWarningsSuspenseQueryHookResult = ReturnType<typeof useVisitWorklistWarningsSuspenseQuery>;
export const VisitLocationsDocument = gql`
    query VisitLocations($start: String!, $end: String!) @permission(requires: useWebApp) {
  visitResource(where: {startTime: {gte: $start, lt: $end}}) {
    startTime
    endTime
    visitId
    addressCoordinates
    resourceRequirement {
      inHome
    }
    provider {
      id
      firstName
      lastName
      addressCoordinates
    }
    visit {
      addressCoordinates
      eventStatus
      patient {
        id
        firstName
        lastName
      }
    }
  }
  shift(where: {startTime: {gte: $start, lt: $end}}) {
    startTime
    endTime
    providerId
    addressCoordinates
    useShiftCenterDriveTimes
    shiftCenter {
      addressCoordinates
    }
  }
}
    `;

/**
 * __useVisitLocationsQuery__
 *
 * To run a query within a React component, call `useVisitLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitLocationsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useVisitLocationsQuery(baseOptions: Apollo.QueryHookOptions<VisitLocationsQuery, VisitLocationsQueryVariables> & ({ variables: VisitLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitLocationsQuery, VisitLocationsQueryVariables>(VisitLocationsDocument, options);
      }
export function useVisitLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitLocationsQuery, VisitLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitLocationsQuery, VisitLocationsQueryVariables>(VisitLocationsDocument, options);
        }
// @ts-ignore
export function useVisitLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VisitLocationsQuery, VisitLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<VisitLocationsQuery, VisitLocationsQueryVariables>;
export function useVisitLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisitLocationsQuery, VisitLocationsQueryVariables>): Apollo.UseSuspenseQueryResult<VisitLocationsQuery | undefined, VisitLocationsQueryVariables>;
export function useVisitLocationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VisitLocationsQuery, VisitLocationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VisitLocationsQuery, VisitLocationsQueryVariables>(VisitLocationsDocument, options);
        }
export type VisitLocationsQueryHookResult = ReturnType<typeof useVisitLocationsQuery>;
export type VisitLocationsLazyQueryHookResult = ReturnType<typeof useVisitLocationsLazyQuery>;
export type VisitLocationsSuspenseQueryHookResult = ReturnType<typeof useVisitLocationsSuspenseQuery>;